/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 986:
/***/ (function(module) {

/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __nested_webpack_require_112__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_112__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_112__.o(definition, key) && !__nested_webpack_require_112__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__nested_webpack_require_112__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__nested_webpack_require_112__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__nested_webpack_require_112__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__nested_webpack_require_112__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__nested_webpack_require_112__.r(__webpack_exports__);

// EXPORTS
__nested_webpack_require_112__.d(__webpack_exports__, {
  AuthEvents: function() { return /* reexport */ AuthEvents; },
  AuthGuard: function() { return /* reexport */ AuthGuard; },
  LimitTotalPermission: function() { return /* reexport */ LimitTotalPermission; },
  accountExists: function() { return /* reexport */ accountExists; },
  "default": function() { return /* binding */ entry_lib; },
  emailNotVerified: function() { return /* reexport */ emailNotVerified; },
  emailVerified: function() { return /* reexport */ emailVerified; },
  getAccountIdFromClaims: function() { return /* reexport */ getAccountIdFromClaims; },
  getAuthInstance: function() { return /* reexport */ getAuthInstance; },
  getPermissionsInstance: function() { return /* reexport */ getPermissionsInstance; },
  getUserDataFromClaims: function() { return /* reexport */ getUserDataFromClaims; },
  getUserIdFromClaims: function() { return /* reexport */ getUserIdFromClaims; },
  hasTSIEmail: function() { return /* reexport */ hasTSIEmail; },
  isAuthorized: function() { return /* reexport */ isAuthorized; },
  isNotAuthorized: function() { return /* reexport */ isNotAuthorized; },
  logInAsSecurity: function() { return /* reexport */ logInAsSecurity; },
  routeHasPermission: function() { return /* reexport */ routeHasPermission; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_112__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./node_modules/@auth0/auth0-spa-js/dist/auth0-spa-js.production.esm.js
function e(e,t){var i={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(i[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(o=Object.getOwnPropertySymbols(e);n<o.length;n++)t.indexOf(o[n])<0&&Object.prototype.propertyIsEnumerable.call(e,o[n])&&(i[o[n]]=e[o[n]])}return i}var t="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __nested_webpack_require_112__.g?__nested_webpack_require_112__.g:"undefined"!=typeof self?self:{};function i(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}function o(e,t){return e(t={exports:{}},t.exports),t.exports}var n=o((function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(){var e=this;this.locked=new Map,this.addToLocked=function(t,i){var o=e.locked.get(t);void 0===o?void 0===i?e.locked.set(t,[]):e.locked.set(t,[i]):void 0!==i&&(o.unshift(i),e.locked.set(t,o))},this.isLocked=function(t){return e.locked.has(t)},this.lock=function(t){return new Promise((function(i,o){e.isLocked(t)?e.addToLocked(t,i):(e.addToLocked(t),i())}))},this.unlock=function(t){var i=e.locked.get(t);if(void 0!==i&&0!==i.length){var o=i.pop();e.locked.set(t,i),void 0!==o&&setTimeout(o,0)}else e.locked.delete(t)}}return e.getInstance=function(){return void 0===e.instance&&(e.instance=new e),e.instance},e}();t.default=function(){return i.getInstance()}}));i(n);var a=i(o((function(e,i){var o=t&&t.__awaiter||function(e,t,i,o){return new(i||(i=Promise))((function(n,a){function s(e){try{c(o.next(e))}catch(e){a(e)}}function r(e){try{c(o.throw(e))}catch(e){a(e)}}function c(e){e.done?n(e.value):new i((function(t){t(e.value)})).then(s,r)}c((o=o.apply(e,t||[])).next())}))},a=t&&t.__generator||function(e,t){var i,o,n,a,s={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return a={next:r(0),throw:r(1),return:r(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function r(a){return function(r){return function(a){if(i)throw new TypeError("Generator is already executing.");for(;s;)try{if(i=1,o&&(n=2&a[0]?o.return:a[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,a[1])).done)return n;switch(o=0,n&&(a=[2&a[0],n.value]),a[0]){case 0:case 1:n=a;break;case 4:return s.label++,{value:a[1],done:!1};case 5:s.label++,o=a[1],a=[0];continue;case 7:a=s.ops.pop(),s.trys.pop();continue;default:if(!(n=s.trys,(n=n.length>0&&n[n.length-1])||6!==a[0]&&2!==a[0])){s=0;continue}if(3===a[0]&&(!n||a[1]>n[0]&&a[1]<n[3])){s.label=a[1];break}if(6===a[0]&&s.label<n[1]){s.label=n[1],n=a;break}if(n&&s.label<n[2]){s.label=n[2],s.ops.push(a);break}n[2]&&s.ops.pop(),s.trys.pop();continue}a=t.call(e,s)}catch(e){a=[6,e],o=0}finally{i=n=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,r])}}};Object.defineProperty(i,"__esModule",{value:!0});var s="browser-tabs-lock-key";function r(e){return new Promise((function(t){return setTimeout(t,e)}))}function c(e){for(var t="0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz",i="",o=0;o<e;o++){i+=t[Math.floor(Math.random()*t.length)]}return i}var d=function(){function e(){this.acquiredIatSet=new Set,this.id=Date.now().toString()+c(15),this.acquireLock=this.acquireLock.bind(this),this.releaseLock=this.releaseLock.bind(this),this.releaseLock__private__=this.releaseLock__private__.bind(this),this.waitForSomethingToChange=this.waitForSomethingToChange.bind(this),this.refreshLockWhileAcquired=this.refreshLockWhileAcquired.bind(this),void 0===e.waiters&&(e.waiters=[])}return e.prototype.acquireLock=function(t,i){return void 0===i&&(i=5e3),o(this,void 0,void 0,(function(){var o,n,d,u,l,h;return a(this,(function(a){switch(a.label){case 0:o=Date.now()+c(4),n=Date.now()+i,d=s+"-"+t,u=window.localStorage,a.label=1;case 1:return Date.now()<n?[4,r(30)]:[3,8];case 2:return a.sent(),null!==u.getItem(d)?[3,5]:(l=this.id+"-"+t+"-"+o,[4,r(Math.floor(25*Math.random()))]);case 3:return a.sent(),u.setItem(d,JSON.stringify({id:this.id,iat:o,timeoutKey:l,timeAcquired:Date.now(),timeRefreshed:Date.now()})),[4,r(30)];case 4:return a.sent(),null!==(h=u.getItem(d))&&(h=JSON.parse(h)).id===this.id&&h.iat===o?(this.acquiredIatSet.add(o),this.refreshLockWhileAcquired(d,o),[2,!0]):[3,7];case 5:return e.lockCorrector(),[4,this.waitForSomethingToChange(n)];case 6:a.sent(),a.label=7;case 7:return o=Date.now()+c(4),[3,1];case 8:return[2,!1]}}))}))},e.prototype.refreshLockWhileAcquired=function(e,t){return o(this,void 0,void 0,(function(){var i=this;return a(this,(function(s){return setTimeout((function(){return o(i,void 0,void 0,(function(){var i,o;return a(this,(function(a){switch(a.label){case 0:return[4,n.default().lock(t)];case 1:return a.sent(),this.acquiredIatSet.has(t)?(i=window.localStorage,null===(o=i.getItem(e))?(n.default().unlock(t),[2]):((o=JSON.parse(o)).timeRefreshed=Date.now(),i.setItem(e,JSON.stringify(o)),n.default().unlock(t),this.refreshLockWhileAcquired(e,t),[2])):(n.default().unlock(t),[2])}}))}))}),1e3),[2]}))}))},e.prototype.waitForSomethingToChange=function(t){return o(this,void 0,void 0,(function(){return a(this,(function(i){switch(i.label){case 0:return[4,new Promise((function(i){var o=!1,n=Date.now(),a=!1;function s(){if(a||(window.removeEventListener("storage",s),e.removeFromWaiting(s),clearTimeout(r),a=!0),!o){o=!0;var t=50-(Date.now()-n);t>0?setTimeout(i,t):i()}}window.addEventListener("storage",s),e.addToWaiting(s);var r=setTimeout(s,Math.max(0,t-Date.now()))}))];case 1:return i.sent(),[2]}}))}))},e.addToWaiting=function(t){this.removeFromWaiting(t),void 0!==e.waiters&&e.waiters.push(t)},e.removeFromWaiting=function(t){void 0!==e.waiters&&(e.waiters=e.waiters.filter((function(e){return e!==t})))},e.notifyWaiters=function(){void 0!==e.waiters&&e.waiters.slice().forEach((function(e){return e()}))},e.prototype.releaseLock=function(e){return o(this,void 0,void 0,(function(){return a(this,(function(t){switch(t.label){case 0:return[4,this.releaseLock__private__(e)];case 1:return[2,t.sent()]}}))}))},e.prototype.releaseLock__private__=function(t){return o(this,void 0,void 0,(function(){var i,o,r;return a(this,(function(a){switch(a.label){case 0:return i=window.localStorage,o=s+"-"+t,null===(r=i.getItem(o))?[2]:(r=JSON.parse(r)).id!==this.id?[3,2]:[4,n.default().lock(r.iat)];case 1:a.sent(),this.acquiredIatSet.delete(r.iat),i.removeItem(o),n.default().unlock(r.iat),e.notifyWaiters(),a.label=2;case 2:return[2]}}))}))},e.lockCorrector=function(){for(var t=Date.now()-5e3,i=window.localStorage,o=Object.keys(i),n=!1,a=0;a<o.length;a++){var r=o[a];if(r.includes(s)){var c=i.getItem(r);null!==c&&(void 0===(c=JSON.parse(c)).timeRefreshed&&c.timeAcquired<t||void 0!==c.timeRefreshed&&c.timeRefreshed<t)&&(i.removeItem(r),n=!0)}}n&&e.notifyWaiters()},e.waiters=void 0,e}();i.default=d})));const s={timeoutInSeconds:60},r={name:"auth0-spa-js",version:"2.0.5"},c=()=>Date.now();class d extends Error{constructor(e,t){super(t),this.error=e,this.error_description=t,Object.setPrototypeOf(this,d.prototype)}static fromPayload({error:e,error_description:t}){return new d(e,t)}}class u extends d{constructor(e,t,i,o=null){super(e,t),this.state=i,this.appState=o,Object.setPrototypeOf(this,u.prototype)}}class l extends d{constructor(){super("timeout","Timeout"),Object.setPrototypeOf(this,l.prototype)}}class h extends l{constructor(e){super(),this.popup=e,Object.setPrototypeOf(this,h.prototype)}}class p extends d{constructor(e){super("cancelled","Popup closed"),this.popup=e,Object.setPrototypeOf(this,p.prototype)}}class m extends d{constructor(e,t,i){super(e,t),this.mfa_token=i,Object.setPrototypeOf(this,m.prototype)}}class f extends d{constructor(e,t){super("missing_refresh_token",`Missing Refresh Token (audience: '${g(e,["default"])}', scope: '${g(t)}')`),this.audience=e,this.scope=t,Object.setPrototypeOf(this,f.prototype)}}function g(e,t=[]){return e&&!t.includes(e)?e:""}const w=()=>window.crypto,y=()=>{const e="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";let t="";return Array.from(w().getRandomValues(new Uint8Array(43))).forEach((i=>t+=e[i%e.length])),t},k=e=>btoa(e),b=t=>{var{clientId:i}=t,o=e(t,["clientId"]);return new URLSearchParams((e=>Object.keys(e).filter((t=>void 0!==e[t])).reduce(((t,i)=>Object.assign(Object.assign({},t),{[i]:e[i]})),{}))(Object.assign({client_id:i},o))).toString()},v=e=>(e=>decodeURIComponent(atob(e).split("").map((e=>"%"+("00"+e.charCodeAt(0).toString(16)).slice(-2))).join("")))(e.replace(/_/g,"/").replace(/-/g,"+")),_=async(e,t)=>{const i=await fetch(e,t);return{ok:i.ok,json:await i.json()}},I=async(e,t,i)=>{const o=new AbortController;let n;return t.signal=o.signal,Promise.race([_(e,t),new Promise(((e,t)=>{n=setTimeout((()=>{o.abort(),t(new Error("Timeout when executing 'fetch'"))}),i)}))]).finally((()=>{clearTimeout(n)}))},S=async(e,t,i,o,n,a,s)=>{return r={auth:{audience:t,scope:i},timeout:n,fetchUrl:e,fetchOptions:o,useFormData:s},c=a,new Promise((function(e,t){const i=new MessageChannel;i.port1.onmessage=function(o){o.data.error?t(new Error(o.data.error)):e(o.data),i.port1.close()},c.postMessage(r,[i.port2])}));var r,c},T=async(e,t,i,o,n,a,s=1e4)=>n?S(e,t,i,o,s,n,a):I(e,o,s);async function O(t,i){var{baseUrl:o,timeout:n,audience:a,scope:s,auth0Client:c,useFormData:u}=t,l=e(t,["baseUrl","timeout","audience","scope","auth0Client","useFormData"]);const h=u?b(l):JSON.stringify(l);return await async function(t,i,o,n,a,s,r){let c,u=null;for(let e=0;e<3;e++)try{c=await T(t,o,n,a,s,r,i),u=null;break}catch(e){u=e}if(u)throw u;const l=c.json,{error:h,error_description:p}=l,g=e(l,["error","error_description"]),{ok:w}=c;if(!w){const e=p||`HTTP error. Unable to fetch ${t}`;if("mfa_required"===h)throw new m(h,e,g.mfa_token);if("missing_refresh_token"===h)throw new f(o,n);throw new d(h||"request_error",e)}return g}(`${o}/oauth/token`,n,a||"default",s,{method:"POST",body:h,headers:{"Content-Type":u?"application/x-www-form-urlencoded":"application/json","Auth0-Client":btoa(JSON.stringify(c||r))}},i,u)}const j=(...e)=>{return(t=e.filter(Boolean).join(" ").trim().split(/\s+/),Array.from(new Set(t))).join(" ");var t};class C{constructor(e,t="@@auth0spajs@@",i){this.prefix=t,this.suffix=i,this.clientId=e.clientId,this.scope=e.scope,this.audience=e.audience}toKey(){return[this.prefix,this.clientId,this.audience,this.scope,this.suffix].filter(Boolean).join("::")}static fromKey(e){const[t,i,o,n]=e.split("::");return new C({clientId:i,scope:n,audience:o},t)}static fromCacheEntry(e){const{scope:t,audience:i,client_id:o}=e;return new C({scope:t,audience:i,clientId:o})}}class z{set(e,t){localStorage.setItem(e,JSON.stringify(t))}get(e){const t=window.localStorage.getItem(e);if(t)try{return JSON.parse(t)}catch(e){return}}remove(e){localStorage.removeItem(e)}allKeys(){return Object.keys(window.localStorage).filter((e=>e.startsWith("@@auth0spajs@@")))}}class x{constructor(){this.enclosedCache=function(){let e={};return{set(t,i){e[t]=i},get(t){const i=e[t];if(i)return i},remove(t){delete e[t]},allKeys:()=>Object.keys(e)}}()}}class P{constructor(e,t,i){this.cache=e,this.keyManifest=t,this.nowProvider=i||c}async setIdToken(e,t,i){var o;const n=this.getIdTokenCacheKey(e);await this.cache.set(n,{id_token:t,decodedToken:i}),await(null===(o=this.keyManifest)||void 0===o?void 0:o.add(n))}async getIdToken(e){const t=await this.cache.get(this.getIdTokenCacheKey(e.clientId));if(!t&&e.scope&&e.audience){const t=await this.get(e);if(!t)return;if(!t.id_token||!t.decodedToken)return;return{id_token:t.id_token,decodedToken:t.decodedToken}}if(t)return{id_token:t.id_token,decodedToken:t.decodedToken}}async get(e,t=0){var i;let o=await this.cache.get(e.toKey());if(!o){const t=await this.getCacheKeys();if(!t)return;const i=this.matchExistingCacheKey(e,t);i&&(o=await this.cache.get(i))}if(!o)return;const n=await this.nowProvider(),a=Math.floor(n/1e3);return o.expiresAt-t<a?o.body.refresh_token?(o.body={refresh_token:o.body.refresh_token},await this.cache.set(e.toKey(),o),o.body):(await this.cache.remove(e.toKey()),void await(null===(i=this.keyManifest)||void 0===i?void 0:i.remove(e.toKey()))):o.body}async set(e){var t;const i=new C({clientId:e.client_id,scope:e.scope,audience:e.audience}),o=await this.wrapCacheEntry(e);await this.cache.set(i.toKey(),o),await(null===(t=this.keyManifest)||void 0===t?void 0:t.add(i.toKey()))}async clear(e){var t;const i=await this.getCacheKeys();i&&(await i.filter((t=>!e||t.includes(e))).reduce((async(e,t)=>{await e,await this.cache.remove(t)}),Promise.resolve()),await(null===(t=this.keyManifest)||void 0===t?void 0:t.clear()))}async wrapCacheEntry(e){const t=await this.nowProvider();return{body:e,expiresAt:Math.floor(t/1e3)+e.expires_in}}async getCacheKeys(){var e;return this.keyManifest?null===(e=await this.keyManifest.get())||void 0===e?void 0:e.keys:this.cache.allKeys?this.cache.allKeys():void 0}getIdTokenCacheKey(e){return new C({clientId:e},"@@auth0spajs@@","@@user@@").toKey()}matchExistingCacheKey(e,t){return t.filter((t=>{var i;const o=C.fromKey(t),n=new Set(o.scope&&o.scope.split(" ")),a=(null===(i=e.scope)||void 0===i?void 0:i.split(" "))||[],s=o.scope&&a.reduce(((e,t)=>e&&n.has(t)),!0);return"@@auth0spajs@@"===o.prefix&&o.clientId===e.clientId&&o.audience===e.audience&&s}))[0]}}class Z{constructor(e,t){this.storage=e,this.clientId=t,this.storageKey=`a0.spajs.txs.${this.clientId}`,this.transaction=this.storage.get(this.storageKey)}create(e){this.transaction=e,this.storage.save(this.storageKey,e,{daysUntilExpire:1})}get(){return this.transaction}remove(){delete this.transaction,this.storage.remove(this.storageKey)}}const K=e=>"number"==typeof e,L=["iss","aud","exp","nbf","iat","jti","azp","nonce","auth_time","at_hash","c_hash","acr","amr","sub_jwk","cnf","sip_from_tag","sip_date","sip_callid","sip_cseq_num","sip_via_branch","orig","dest","mky","events","toe","txn","rph","sid","vot","vtm"],E=e=>{if(!e.id_token)throw new Error("ID token is required but missing");const t=(e=>{const t=e.split("."),[i,o,n]=t;if(3!==t.length||!i||!o||!n)throw new Error("ID token could not be decoded");const a=JSON.parse(v(o)),s={__raw:e},r={};return Object.keys(a).forEach((e=>{s[e]=a[e],L.includes(e)||(r[e]=a[e])})),{encoded:{header:i,payload:o,signature:n},header:JSON.parse(v(i)),claims:s,user:r}})(e.id_token);if(!t.claims.iss)throw new Error("Issuer (iss) claim must be a string present in the ID token");if(t.claims.iss!==e.iss)throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);if(!t.user.sub)throw new Error("Subject (sub) claim must be a string present in the ID token");if("RS256"!==t.header.alg)throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);if(!t.claims.aud||"string"!=typeof t.claims.aud&&!Array.isArray(t.claims.aud))throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");if(Array.isArray(t.claims.aud)){if(!t.claims.aud.includes(e.aud))throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);if(t.claims.aud.length>1){if(!t.claims.azp)throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");if(t.claims.azp!==e.aud)throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`)}}else if(t.claims.aud!==e.aud)throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);if(e.nonce){if(!t.claims.nonce)throw new Error("Nonce (nonce) claim must be a string present in the ID token");if(t.claims.nonce!==e.nonce)throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`)}if(e.max_age&&!K(t.claims.auth_time))throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");if(null==t.claims.exp||!K(t.claims.exp))throw new Error("Expiration Time (exp) claim must be a number present in the ID token");if(!K(t.claims.iat))throw new Error("Issued At (iat) claim must be a number present in the ID token");const i=e.leeway||60,o=new Date(e.now||Date.now()),n=new Date(0);if(n.setUTCSeconds(t.claims.exp+i),o>n)throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);if(null!=t.claims.nbf&&K(t.claims.nbf)){const e=new Date(0);if(e.setUTCSeconds(t.claims.nbf-i),o<e)throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`)}if(null!=t.claims.auth_time&&K(t.claims.auth_time)){const n=new Date(0);if(n.setUTCSeconds(parseInt(t.claims.auth_time)+e.max_age+i),o>n)throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`)}if(e.organizationId){if(!t.claims.org_id)throw new Error("Organization ID (org_id) claim must be a string present in the ID token");if(e.organizationId!==t.claims.org_id)throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e.organizationId}", found "${t.claims.org_id}"`)}return t};var U=o((function(e,i){var o=t&&t.__assign||function(){return o=Object.assign||function(e){for(var t,i=1,o=arguments.length;i<o;i++)for(var n in t=arguments[i])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},o.apply(this,arguments)};function n(e,t){if(!t)return"";var i="; "+e;return!0===t?i:i+"="+t}function a(e,t,i){return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/\(/g,"%28").replace(/\)/g,"%29")+"="+encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent)+function(e){if("number"==typeof e.expires){var t=new Date;t.setMilliseconds(t.getMilliseconds()+864e5*e.expires),e.expires=t}return n("Expires",e.expires?e.expires.toUTCString():"")+n("Domain",e.domain)+n("Path",e.path)+n("Secure",e.secure)+n("SameSite",e.sameSite)}(i)}function s(e){for(var t={},i=e?e.split("; "):[],o=/(%[\dA-F]{2})+/gi,n=0;n<i.length;n++){var a=i[n].split("="),s=a.slice(1).join("=");'"'===s.charAt(0)&&(s=s.slice(1,-1));try{t[a[0].replace(o,decodeURIComponent)]=s.replace(o,decodeURIComponent)}catch(e){}}return t}function r(){return s(document.cookie)}function c(e,t,i){document.cookie=a(e,t,o({path:"/"},i))}i.__esModule=!0,i.encode=a,i.parse=s,i.getAll=r,i.get=function(e){return r()[e]},i.set=c,i.remove=function(e,t){c(e,"",o(o({},t),{expires:-1}))}}));i(U),U.encode,U.parse,U.getAll;var W=U.get,X=U.set,N=U.remove;const R={get(e){const t=W(e);if(void 0!==t)return JSON.parse(t)},save(e,t,i){let o={};"https:"===window.location.protocol&&(o={secure:!0,sameSite:"none"}),(null==i?void 0:i.daysUntilExpire)&&(o.expires=i.daysUntilExpire),(null==i?void 0:i.cookieDomain)&&(o.domain=i.cookieDomain),X(e,JSON.stringify(t),o)},remove(e,t){let i={};(null==t?void 0:t.cookieDomain)&&(i.domain=t.cookieDomain),N(e,i)}},V={get(e){const t=R.get(e);return t||R.get(`_legacy_${e}`)},save(e,t,i){let o={};"https:"===window.location.protocol&&(o={secure:!0}),(null==i?void 0:i.daysUntilExpire)&&(o.expires=i.daysUntilExpire),(null==i?void 0:i.cookieDomain)&&(o.domain=i.cookieDomain),X(`_legacy_${e}`,JSON.stringify(t),o),R.save(e,t,i)},remove(e,t){let i={};(null==t?void 0:t.cookieDomain)&&(i.domain=t.cookieDomain),N(e,i),R.remove(e,t),R.remove(`_legacy_${e}`,t)}},D={get(e){if("undefined"==typeof sessionStorage)return;const t=sessionStorage.getItem(e);return null!=t?JSON.parse(t):void 0},save(e,t){sessionStorage.setItem(e,JSON.stringify(t))},remove(e){sessionStorage.removeItem(e)}};function J(e,t,i){var o=void 0===t?null:t,n=function(e,t){var i=atob(e);if(t){for(var o=new Uint8Array(i.length),n=0,a=i.length;n<a;++n)o[n]=i.charCodeAt(n);return String.fromCharCode.apply(null,new Uint16Array(o.buffer))}return i}(e,void 0!==i&&i),a=n.indexOf("\n",10)+1,s=n.substring(a)+(o?"//# sourceMappingURL="+o:""),r=new Blob([s],{type:"application/javascript"});return URL.createObjectURL(r)}var F,H,G,M,A=(F="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",H=null,G=!1,function(e){return M=M||J(F,H,G),new Worker(M,e)});const Y={};class B{constructor(e,t){this.cache=e,this.clientId=t,this.manifestKey=this.createManifestKeyFrom(this.clientId)}async add(e){var t;const i=new Set((null===(t=await this.cache.get(this.manifestKey))||void 0===t?void 0:t.keys)||[]);i.add(e),await this.cache.set(this.manifestKey,{keys:[...i]})}async remove(e){const t=await this.cache.get(this.manifestKey);if(t){const i=new Set(t.keys);return i.delete(e),i.size>0?await this.cache.set(this.manifestKey,{keys:[...i]}):await this.cache.remove(this.manifestKey)}}get(){return this.cache.get(this.manifestKey)}clear(){return this.cache.remove(this.manifestKey)}createManifestKeyFrom(e){return`@@auth0spajs@@::${e}`}}const $={memory:()=>(new x).enclosedCache,localstorage:()=>new z},q=e=>$[e],Q=t=>{const{openUrl:i,onRedirect:o}=t,n=e(t,["openUrl","onRedirect"]);return Object.assign(Object.assign({},n),{openUrl:!1===i||i?i:o})},ee=new a;class te{constructor(e){let t,i;if(this.userCache=(new x).enclosedCache,this.defaultOptions={authorizationParams:{scope:"openid profile email"},useRefreshTokensFallback:!1,useFormData:!0},this._releaseLockOnPageHide=async()=>{await ee.releaseLock("auth0.lock.getTokenSilently"),window.removeEventListener("pagehide",this._releaseLockOnPageHide)},this.options=Object.assign(Object.assign(Object.assign({},this.defaultOptions),e),{authorizationParams:Object.assign(Object.assign({},this.defaultOptions.authorizationParams),e.authorizationParams)}),"undefined"!=typeof window&&(()=>{if(!w())throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");if(void 0===w().subtle)throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/master/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ")})(),e.cache&&e.cacheLocation&&console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."),e.cache)i=e.cache;else{if(t=e.cacheLocation||"memory",!q(t))throw new Error(`Invalid cache location "${t}"`);i=q(t)()}this.httpTimeoutMs=e.httpTimeoutInSeconds?1e3*e.httpTimeoutInSeconds:1e4,this.cookieStorage=!1===e.legacySameSiteCookie?R:V,this.orgHintCookieName=`auth0.${this.options.clientId}.organization_hint`,this.isAuthenticatedCookieName=(e=>`auth0.${e}.is.authenticated`)(this.options.clientId),this.sessionCheckExpiryDays=e.sessionCheckExpiryDays||1;const o=e.useCookiesForTransactions?this.cookieStorage:D;var n;this.scope=j("openid",this.options.authorizationParams.scope,this.options.useRefreshTokens?"offline_access":""),this.transactionManager=new Z(o,this.options.clientId),this.nowProvider=this.options.nowProvider||c,this.cacheManager=new P(i,i.allKeys?void 0:new B(i,this.options.clientId),this.nowProvider),this.domainUrl=(n=this.options.domain,/^https?:\/\//.test(n)?n:`https://${n}`),this.tokenIssuer=((e,t)=>e?e.startsWith("https://")?e:`https://${e}/`:`${t}/`)(this.options.issuer,this.domainUrl),"undefined"!=typeof window&&window.Worker&&this.options.useRefreshTokens&&"memory"===t&&(this.worker=new A)}_url(e){const t=encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client||r)));return`${this.domainUrl}${e}&auth0Client=${t}`}_authorizeUrl(e){return this._url(`/authorize?${b(e)}`)}async _verifyIdToken(e,t,i){const o=await this.nowProvider();return E({iss:this.tokenIssuer,aud:this.options.clientId,id_token:e,nonce:t,organizationId:i,leeway:this.options.leeway,max_age:(n=this.options.authorizationParams.max_age,"string"!=typeof n?n:parseInt(n,10)||void 0),now:o});var n}_processOrgIdHint(e){e?this.cookieStorage.save(this.orgHintCookieName,e,{daysUntilExpire:this.sessionCheckExpiryDays,cookieDomain:this.options.cookieDomain}):this.cookieStorage.remove(this.orgHintCookieName,{cookieDomain:this.options.cookieDomain})}async _prepareAuthorizeUrl(e,t,i){const o=k(y()),n=k(y()),a=y(),s=(e=>{const t=new Uint8Array(e);return(e=>{const t={"+":"-","/":"_","=":""};return e.replace(/[+/=]/g,(e=>t[e]))})(window.btoa(String.fromCharCode(...Array.from(t))))})(await(async e=>{const t=w().subtle.digest({name:"SHA-256"},(new TextEncoder).encode(e));return await t})(a)),r=((e,t,i,o,n,a,s,r)=>Object.assign(Object.assign(Object.assign({client_id:e.clientId},e.authorizationParams),i),{scope:j(t,i.scope),response_type:"code",response_mode:r||"query",state:o,nonce:n,redirect_uri:s||e.authorizationParams.redirect_uri,code_challenge:a,code_challenge_method:"S256"}))(this.options,this.scope,e,o,n,s,e.redirect_uri||this.options.authorizationParams.redirect_uri||i,null==t?void 0:t.response_mode),c=this._authorizeUrl(r);return{nonce:n,code_verifier:a,scope:r.scope,audience:r.audience||"default",redirect_uri:r.redirect_uri,state:o,url:c}}async loginWithPopup(e,t){var i;if(e=e||{},!(t=t||{}).popup&&(t.popup=(e=>{const t=window.screenX+(window.innerWidth-400)/2,i=window.screenY+(window.innerHeight-600)/2;return window.open(e,"auth0:authorize:popup",`left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`)})(""),!t.popup))throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");const o=await this._prepareAuthorizeUrl(e.authorizationParams||{},{response_mode:"web_message"},window.location.origin);t.popup.location.href=o.url;const n=await(e=>new Promise(((t,i)=>{let o;const n=setInterval((()=>{e.popup&&e.popup.closed&&(clearInterval(n),clearTimeout(a),window.removeEventListener("message",o,!1),i(new p(e.popup)))}),1e3),a=setTimeout((()=>{clearInterval(n),i(new h(e.popup)),window.removeEventListener("message",o,!1)}),1e3*(e.timeoutInSeconds||60));o=function(s){if(s.data&&"authorization_response"===s.data.type){if(clearTimeout(a),clearInterval(n),window.removeEventListener("message",o,!1),e.popup.close(),s.data.response.error)return i(d.fromPayload(s.data.response));t(s.data.response)}},window.addEventListener("message",o)})))(Object.assign(Object.assign({},t),{timeoutInSeconds:t.timeoutInSeconds||this.options.authorizeTimeoutInSeconds||60}));if(o.state!==n.state)throw new Error("Invalid state");const a=(null===(i=e.authorizationParams)||void 0===i?void 0:i.organization)||this.options.authorizationParams.organization;await this._requestToken({audience:o.audience,scope:o.scope,code_verifier:o.code_verifier,grant_type:"authorization_code",code:n.code,redirect_uri:o.redirect_uri},{nonceIn:o.nonce,organizationId:a})}async getUser(){var e;const t=await this._getIdTokenFromCache();return null===(e=null==t?void 0:t.decodedToken)||void 0===e?void 0:e.user}async getIdTokenClaims(){var e;const t=await this._getIdTokenFromCache();return null===(e=null==t?void 0:t.decodedToken)||void 0===e?void 0:e.claims}async loginWithRedirect(t={}){var i;const o=Q(t),{openUrl:n,fragment:a,appState:s}=o,r=e(o,["openUrl","fragment","appState"]),c=(null===(i=r.authorizationParams)||void 0===i?void 0:i.organization)||this.options.authorizationParams.organization,d=await this._prepareAuthorizeUrl(r.authorizationParams||{}),{url:u}=d,l=e(d,["url"]);this.transactionManager.create(Object.assign(Object.assign(Object.assign({},l),{appState:s}),c&&{organizationId:c}));const h=a?`${u}#${a}`:u;n?await n(h):window.location.assign(h)}async handleRedirectCallback(e=window.location.href){const t=e.split("?").slice(1);if(0===t.length)throw new Error("There are no query params available for parsing.");const{state:i,code:o,error:n,error_description:a}=(e=>{e.indexOf("#")>-1&&(e=e.substring(0,e.indexOf("#")));const t=new URLSearchParams(e);return{state:t.get("state"),code:t.get("code")||void 0,error:t.get("error")||void 0,error_description:t.get("error_description")||void 0}})(t.join("")),s=this.transactionManager.get();if(!s)throw new d("missing_transaction","Invalid state");if(this.transactionManager.remove(),n)throw new u(n,a||n,i,s.appState);if(!s.code_verifier||s.state&&s.state!==i)throw new d("state_mismatch","Invalid state");const r=s.organizationId,c=s.nonce,l=s.redirect_uri;return await this._requestToken(Object.assign({audience:s.audience,scope:s.scope,code_verifier:s.code_verifier,grant_type:"authorization_code",code:o},l?{redirect_uri:l}:{}),{nonceIn:c,organizationId:r}),{appState:s.appState}}async checkSession(e){if(!this.cookieStorage.get(this.isAuthenticatedCookieName)){if(!this.cookieStorage.get("auth0.is.authenticated"))return;this.cookieStorage.save(this.isAuthenticatedCookieName,!0,{daysUntilExpire:this.sessionCheckExpiryDays,cookieDomain:this.options.cookieDomain}),this.cookieStorage.remove("auth0.is.authenticated")}try{await this.getTokenSilently(e)}catch(e){}}async getTokenSilently(e={}){var t;const i=Object.assign(Object.assign({cacheMode:"on"},e),{authorizationParams:Object.assign(Object.assign(Object.assign({},this.options.authorizationParams),e.authorizationParams),{scope:j(this.scope,null===(t=e.authorizationParams)||void 0===t?void 0:t.scope)})}),o=await((e,t)=>{let i=Y[t];return i||(i=e().finally((()=>{delete Y[t],i=null})),Y[t]=i),i})((()=>this._getTokenSilently(i)),`${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);return e.detailedResponse?o:null==o?void 0:o.access_token}async _getTokenSilently(t){const{cacheMode:i}=t,o=e(t,["cacheMode"]);if("off"!==i){const e=await this._getEntryFromCache({scope:o.authorizationParams.scope,audience:o.authorizationParams.audience||"default",clientId:this.options.clientId});if(e)return e}if("cache-only"!==i){if(!await(async(e,t=3)=>{for(let i=0;i<t;i++)if(await e())return!0;return!1})((()=>ee.acquireLock("auth0.lock.getTokenSilently",5e3)),10))throw new l;try{if(window.addEventListener("pagehide",this._releaseLockOnPageHide),"off"!==i){const e=await this._getEntryFromCache({scope:o.authorizationParams.scope,audience:o.authorizationParams.audience||"default",clientId:this.options.clientId});if(e)return e}const e=this.options.useRefreshTokens?await this._getTokenUsingRefreshToken(o):await this._getTokenFromIFrame(o),{id_token:t,access_token:n,oauthTokenScope:a,expires_in:s}=e;return Object.assign(Object.assign({id_token:t,access_token:n},a?{scope:a}:null),{expires_in:s})}finally{await ee.releaseLock("auth0.lock.getTokenSilently"),window.removeEventListener("pagehide",this._releaseLockOnPageHide)}}}async getTokenWithPopup(e={},t={}){var i;const o=Object.assign(Object.assign({},e),{authorizationParams:Object.assign(Object.assign(Object.assign({},this.options.authorizationParams),e.authorizationParams),{scope:j(this.scope,null===(i=e.authorizationParams)||void 0===i?void 0:i.scope)})});t=Object.assign(Object.assign({},s),t),await this.loginWithPopup(o,t);return(await this.cacheManager.get(new C({scope:o.authorizationParams.scope,audience:o.authorizationParams.audience||"default",clientId:this.options.clientId}))).access_token}async isAuthenticated(){return!!await this.getUser()}_buildLogoutUrl(t){null!==t.clientId?t.clientId=t.clientId||this.options.clientId:delete t.clientId;const i=t.logoutParams||{},{federated:o}=i,n=e(i,["federated"]),a=o?"&federated":"";return this._url(`/v2/logout?${b(Object.assign({clientId:t.clientId},n))}`)+a}async logout(t={}){const i=Q(t),{openUrl:o}=i,n=e(i,["openUrl"]);null===t.clientId?await this.cacheManager.clear():await this.cacheManager.clear(t.clientId||this.options.clientId),this.cookieStorage.remove(this.orgHintCookieName,{cookieDomain:this.options.cookieDomain}),this.cookieStorage.remove(this.isAuthenticatedCookieName,{cookieDomain:this.options.cookieDomain}),this.userCache.remove("@@user@@");const a=this._buildLogoutUrl(n);o?await o(a):!1!==o&&window.location.assign(a)}async _getTokenFromIFrame(e){const t=Object.assign(Object.assign({},e.authorizationParams),{prompt:"none"}),i=this.cookieStorage.get(this.orgHintCookieName);i&&!t.organization&&(t.organization=i);const{url:o,state:n,nonce:a,code_verifier:s,redirect_uri:r,scope:c,audience:u}=await this._prepareAuthorizeUrl(t,{response_mode:"web_message"},window.location.origin);try{if(window.crossOriginIsolated)throw new d("login_required","The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");const t=e.timeoutInSeconds||this.options.authorizeTimeoutInSeconds,i=await((e,t,i=60)=>new Promise(((o,n)=>{const a=window.document.createElement("iframe");a.setAttribute("width","0"),a.setAttribute("height","0"),a.style.display="none";const s=()=>{window.document.body.contains(a)&&(window.document.body.removeChild(a),window.removeEventListener("message",r,!1))};let r;const c=setTimeout((()=>{n(new l),s()}),1e3*i);r=function(e){if(e.origin!=t)return;if(!e.data||"authorization_response"!==e.data.type)return;const i=e.source;i&&i.close(),e.data.response.error?n(d.fromPayload(e.data.response)):o(e.data.response),clearTimeout(c),window.removeEventListener("message",r,!1),setTimeout(s,2e3)},window.addEventListener("message",r,!1),window.document.body.appendChild(a),a.setAttribute("src",e)})))(o,this.domainUrl,t);if(n!==i.state)throw new Error("Invalid state");const h=await this._requestToken(Object.assign(Object.assign({},e.authorizationParams),{code_verifier:s,code:i.code,grant_type:"authorization_code",redirect_uri:r,timeout:e.authorizationParams.timeout||this.httpTimeoutMs}),{nonceIn:a});return Object.assign(Object.assign({},h),{scope:c,oauthTokenScope:h.scope,audience:u})}catch(e){throw"login_required"===e.error&&this.logout({openUrl:!1}),e}}async _getTokenUsingRefreshToken(e){const t=await this.cacheManager.get(new C({scope:e.authorizationParams.scope,audience:e.authorizationParams.audience||"default",clientId:this.options.clientId}));if(!(t&&t.refresh_token||this.worker)){if(this.options.useRefreshTokensFallback)return await this._getTokenFromIFrame(e);throw new f(e.authorizationParams.audience||"default",e.authorizationParams.scope)}const i=e.authorizationParams.redirect_uri||this.options.authorizationParams.redirect_uri||window.location.origin,o="number"==typeof e.timeoutInSeconds?1e3*e.timeoutInSeconds:null;try{const n=await this._requestToken(Object.assign(Object.assign(Object.assign({},e.authorizationParams),{grant_type:"refresh_token",refresh_token:t&&t.refresh_token,redirect_uri:i}),o&&{timeout:o}));return Object.assign(Object.assign({},n),{scope:e.authorizationParams.scope,oauthTokenScope:n.scope,audience:e.authorizationParams.audience||"default"})}catch(t){if((t.message.indexOf("Missing Refresh Token")>-1||t.message&&t.message.indexOf("invalid refresh token")>-1)&&this.options.useRefreshTokensFallback)return await this._getTokenFromIFrame(e);throw t}}async _saveEntryInCache(t){const{id_token:i,decodedToken:o}=t,n=e(t,["id_token","decodedToken"]);this.userCache.set("@@user@@",{id_token:i,decodedToken:o}),await this.cacheManager.setIdToken(this.options.clientId,t.id_token,t.decodedToken),await this.cacheManager.set(n)}async _getIdTokenFromCache(){const e=this.options.authorizationParams.audience||"default",t=await this.cacheManager.getIdToken(new C({clientId:this.options.clientId,audience:e,scope:this.scope})),i=this.userCache.get("@@user@@");return t&&t.id_token===(null==i?void 0:i.id_token)?i:(this.userCache.set("@@user@@",t),t)}async _getEntryFromCache({scope:e,audience:t,clientId:i}){const o=await this.cacheManager.get(new C({scope:e,audience:t,clientId:i}),60);if(o&&o.access_token){const{access_token:e,oauthTokenScope:t,expires_in:i}=o,n=await this._getIdTokenFromCache();return n&&Object.assign(Object.assign({id_token:n.id_token,access_token:e},t?{scope:t}:null),{expires_in:i})}}async _requestToken(e,t){const{nonceIn:i,organizationId:o}=t||{},n=await O(Object.assign({baseUrl:this.domainUrl,client_id:this.options.clientId,auth0Client:this.options.auth0Client,useFormData:this.options.useFormData,timeout:this.httpTimeoutMs},e),this.worker),a=await this._verifyIdToken(n.id_token,i,o);return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({},n),{decodedToken:a,scope:e.scope,audience:e.audience||"default"}),n.scope?{oauthTokenScope:n.scope}:null),{client_id:this.options.clientId})),this.cookieStorage.save(this.isAuthenticatedCookieName,!0,{daysUntilExpire:this.sessionCheckExpiryDays,cookieDomain:this.options.cookieDomain}),this._processOrgIdHint(a.claims.org_id),Object.assign(Object.assign({},n),{decodedToken:a})}}class ie{}async function oe(e){const t=new te(e);return await t.checkSession(),t}
//# sourceMappingURL=auth0-spa-js.production.esm.js.map

;// CONCATENATED MODULE: ./src/auth/errors.ts
var AuthErrors;
(function (AuthErrors) {
  AuthErrors["claimsMissing"] = "claims_missing";
  AuthErrors["loginRequired"] = "login_required";
  AuthErrors["missingRefreshToken"] = "missing_refresh_token";
})(AuthErrors || (AuthErrors = {}));
;// CONCATENATED MODULE: ./src/auth/utils.ts

const metaDataPath = 'https://tsi.com/user_metadata';
function getAccountIdFromClaims(claims) {
  var _claims$metaDataPath;
  if (!claims) throw new Error(AuthErrors.claimsMissing);
  return ((_claims$metaDataPath = claims[metaDataPath]) === null || _claims$metaDataPath === void 0 ? void 0 : _claims$metaDataPath.account_id) || '';
}
function getUserIdFromClaims(claims) {
  var _claims$metaDataPath2;
  return ((_claims$metaDataPath2 = claims[metaDataPath]) === null || _claims$metaDataPath2 === void 0 ? void 0 : _claims$metaDataPath2.user_id) || '';
}
function getUserDataFromClaims(claims) {
  var _claims$metaDataPath3, _claims$metaDataPath4, _claims$metaDataPath5;
  const userData = {
    email: claims.email,
    emailVerified: claims.email_verified,
    firstName: (_claims$metaDataPath3 = claims[metaDataPath]) === null || _claims$metaDataPath3 === void 0 ? void 0 : _claims$metaDataPath3.given_name,
    lastName: (_claims$metaDataPath4 = claims[metaDataPath]) === null || _claims$metaDataPath4 === void 0 ? void 0 : _claims$metaDataPath4.family_name,
    termsAcceptedAt: (_claims$metaDataPath5 = claims[metaDataPath]) === null || _claims$metaDataPath5 === void 0 ? void 0 : _claims$metaDataPath5.terms_accepted_at
  };
  return userData;
}
;// CONCATENATED MODULE: ./src/auth/directives/AuthorizedButton.ts
const authBtnDirective = {
  bind: async function (el, binding, vnode) {
    const vm = vnode.context;
    if (!vm.$permissions.isAllowed(binding.value)) {
      el.classList.add('disabled');
    }
  }
};
;// CONCATENATED MODULE: ./src/permissions/Permission.ts
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


class Permission {
  constructor(slug, propertyName) {
    _defineProperty(this, "_slug", void 0);
    _defineProperty(this, "_propertyName", void 0);
    this._slug = slug;
    this._propertyName = propertyName;
  }
  get slug() {
    return this._slug;
  }
  get propertyName() {
    return this._propertyName;
  }
  isAllowed(options) {
    const auth = getAuthInstance();
    if (auth && auth.isAuthenticated) {
      const permissionsManager = getPermissionsInstance();
      return permissionsManager.allowDeveloperAccess || permissionsManager.slugs.includes(this._slug);
    }
    return false;
  }
}
;// CONCATENATED MODULE: ./src/permissions/LimitTotalPermission.ts
function LimitTotalPermission_defineProperty(obj, key, value) { key = LimitTotalPermission_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function LimitTotalPermission_toPropertyKey(arg) { var key = LimitTotalPermission_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function LimitTotalPermission_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

class LimitTotalPermission extends Permission {
  constructor(slug, {
    maxFree,
    maxPaid
  }) {
    super(slug);
    LimitTotalPermission_defineProperty(this, "_maxFree", void 0);
    LimitTotalPermission_defineProperty(this, "_maxPaid", void 0);
    this._maxFree = maxFree;
    this._maxPaid = maxPaid;
  }
  getMaximum() {
    return super.isAllowed() ? this._maxPaid : this._maxFree;
  }
  isAllowed({
    total
  }) {
    const isAllowed = super.isAllowed();
    const maximum = this.getMaximum();
    return isAllowed && total < maximum;
  }
}
;// CONCATENATED MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
function jwt_decode_esm_e(e){this.message=e}jwt_decode_esm_e.prototype=new Error,jwt_decode_esm_e.prototype.name="InvalidCharacterError";var jwt_decode_esm_r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new jwt_decode_esm_e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function jwt_decode_esm_t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(jwt_decode_esm_r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return jwt_decode_esm_r(t)}}function jwt_decode_esm_n(e){this.message=e}function jwt_decode_esm_o(e,r){if("string"!=typeof e)throw new jwt_decode_esm_n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(jwt_decode_esm_t(e.split(".")[o]))}catch(e){throw new jwt_decode_esm_n("Invalid token specified: "+e.message)}}jwt_decode_esm_n.prototype=new Error,jwt_decode_esm_n.prototype.name="InvalidTokenError";/* harmony default export */ var jwt_decode_esm = (jwt_decode_esm_o);
//# sourceMappingURL=jwt-decode.esm.js.map

;// CONCATENATED MODULE: ./src/permissions/PermissionsManager.ts

let _permissionsManager;
const DEVELOPER_ACCESS_SLUG = 'tsi:developer:access';
const usePermissionsManager = () => {
  if (_permissionsManager) return _permissionsManager;
  _permissionsManager = new Vue({
    data() {
      return {
        slugs: [],
        flags: {},
        permissionDefinitions: new Map()
      };
    },
    computed: {
      allowDeveloperAccess() {
        const typedThis = this;
        return typedThis.slugs.includes(DEVELOPER_ACCESS_SLUG);
      }
    },
    methods: {
      add(permission) {
        const typedThis = this;
        typedThis.permissionDefinitions.set(permission.slug, permission);
      },
      clear() {
        const typedThis = this;
        typedThis.permissionDefinitions.clear();
      },
      get(slug) {
        const typedThis = this;
        const permission = typedThis.permissionDefinitions.get(slug);
        return permission;
      },
      async reauthorize(token) {
        if (!token) return;
        const typedThis = this;
        const decodedJwtData = jwt_decode_esm(token);
        const slugs = decodedJwtData ? decodedJwtData.permissions : [];
        Vue.set(this, 'slugs', slugs);
        const permissions = typedThis.permissionDefinitions.values();
        for (const permission of permissions) {
          if (permission.propertyName) {
            Vue.set(typedThis.flags, permission.propertyName, permission.isAllowed());
          }
        }
      },
      isAllowed(slugs = [], options = []) {
        const typedThis = this;
        if (typedThis.allowDeveloperAccess) {
          return true;
        }
        if (!Array.isArray(slugs)) {
          slugs = [slugs];
        }
        if (!Array.isArray(options)) {
          options = [options];
        }
        if (slugs.length == 0) {
          return true;
        }
        return slugs.every((slug, index) => {
          const permission = typedThis.permissionDefinitions.get(slug);
          if (!permission) {
            console.warn(`Permission '${slug}' is not implemented by the manager.`);
            return false;
          }
          return permission.isAllowed(options[index]);
        });
      }
    }
  });
  return _permissionsManager;
};
;// CONCATENATED MODULE: ./src/permissions/index.ts



let _initialized = false;
function initializePermissionsManager(options) {
  const permissionsManager = usePermissionsManager();
  if (options !== null && options !== void 0 && options.defaultSlugs) {
    Vue.set(permissionsManager, 'slugs', options.defaultSlugs);
  }
  if (options !== null && options !== void 0 && options.simple) {
    options.simple.forEach(item => {
      permissionsManager.add(new Permission(item.slug, item.propertyName));
      Vue.set(permissionsManager.flags, item.propertyName, false);
    });
  }
  if (options !== null && options !== void 0 && options.limit) {
    options.limit.forEach(item => {
      permissionsManager.add(new LimitTotalPermission(item.slug, item.options));
    });
  }
  if (options !== null && options !== void 0 && options.custom) {
    options.custom.forEach(item => {
      permissionsManager.add(item);
    });
  }
  _initialized = true;
  return permissionsManager;
}
function getPermissionsInstance() {
  if (!_initialized) {
    throw new Error('You must first initialize the permissions manager.');
  }
  return usePermissionsManager();
}
;// CONCATENATED MODULE: ./src/events.ts
const AuthEvents = {
  ACCESS_TOKEN_EXPIRED: 'accessTokenExpired',
  ACCESS_TOKEN_UPDATED: 'accessTokenUpdated',
  AUTH_CHANGED: 'authenticationChanged',
  ID_TOKEN_EXPIRED: 'idTokenExpired',
  ID_TOKEN_UPDATED: 'idTokenUpdated'
};
;// CONCATENATED MODULE: ./src/auth/service.ts






const DEFAULT_REDIRECT_CALLBACK = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
let authInstance;
const getAuthInstance = () => {
  return authInstance;
};
const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  accountsHost,
  audience,
  clientID,
  cacheLocation,
  domain,
  redirectSuffix = '/home',
  redirectURI = window.location.origin,
  useRefreshTokens,
  loginMode = 'redirect',
  openUrl
}) => {
  if (authInstance) return authInstance;
  authInstance = new Vue({
    data() {
      return {
        loading: false,
        isAuthenticated: false,
        user: ie,
        auth0Client: null,
        popupOpen: false,
        error: null,
        claims: undefined,
        idToken: undefined,
        token: undefined,
        redirecting: false
      };
    },
    methods: {
      updateAxiosHeaders() {
        var _axios, _axios$defaults;
        const typedThis = this;
        if (!typedThis.token) {
          console.warn('Token is missing, cannot set axios headers.');
          return;
        }
        if ((_axios = axios) !== null && _axios !== void 0 && (_axios$defaults = _axios.defaults) !== null && _axios$defaults !== void 0 && _axios$defaults.headers) {
          axios.defaults.headers.Accept = 'application/json';
          axios.defaults.headers.Authorization = `Bearer ${typedThis.token}`;
          axios.defaults.headers['Content-Type'] = 'application/json';
          axios.defaults.validateStatus = () => {
            return true;
          };
        } else {
          console.warn('Axios is not loaded; cannot set Authorization headers.');
        }
      },
      async handleRedirectCallback(url) {
        const typedThis = this;
        typedThis.loading = true;
        try {
          var _typedThis$auth0Clien, _typedThis$auth0Clien2, _typedThis$auth0Clien3;
          await ((_typedThis$auth0Clien = typedThis.auth0Client) === null || _typedThis$auth0Clien === void 0 ? void 0 : _typedThis$auth0Clien.handleRedirectCallback(url));
          typedThis.token = await ((_typedThis$auth0Clien2 = typedThis.auth0Client) === null || _typedThis$auth0Clien2 === void 0 ? void 0 : _typedThis$auth0Clien2.getTokenSilently());
          await typedThis.getIdTokenClaims();
          typedThis.user = await ((_typedThis$auth0Clien3 = typedThis.auth0Client) === null || _typedThis$auth0Clien3 === void 0 ? void 0 : _typedThis$auth0Clien3.getUser());
          typedThis.error = null;
          typedThis.isAuthenticated = true;
        } catch (e) {
          typedThis.error = e;
          typedThis.isAuthenticated = false;
        } finally {
          typedThis.loading = false;
        }
      },
      loginWithPopup(opts, config = {
        timeoutInSeconds: 30
      }) {
        var _typedThis$auth0Clien4;
        const typedThis = this;
        return (_typedThis$auth0Clien4 = typedThis.auth0Client) === null || _typedThis$auth0Clien4 === void 0 ? void 0 : _typedThis$auth0Clien4.loginWithPopup(opts, config);
      },
      loginWithRedirect(opts) {
        var _typedThis$auth0Clien5;
        const typedThis = this;
        return (_typedThis$auth0Clien5 = typedThis.auth0Client) === null || _typedThis$auth0Clien5 === void 0 ? void 0 : _typedThis$auth0Clien5.loginWithRedirect(opts);
      },
      async getIdTokenClaims() {
        var _typedThis$auth0Clien6;
        const typedThis = this;
        typedThis.claims = await ((_typedThis$auth0Clien6 = typedThis.auth0Client) === null || _typedThis$auth0Clien6 === void 0 ? void 0 : _typedThis$auth0Clien6.getIdTokenClaims());
        if (typedThis.claims) {
          var _typedThis$claims;
          typedThis.idToken = (_typedThis$claims = typedThis.claims) === null || _typedThis$claims === void 0 ? void 0 : _typedThis$claims.__raw;
          typedThis.$emit(AuthEvents.ID_TOKEN_UPDATED, typedThis.idToken);
          const decodedJwt = jwt_decode_esm(typedThis.idToken);
          const expiresIn = decodedJwt.exp - decodedJwt.iat;
          setTimeout(async () => {
            typedThis.$emit(AuthEvents.ID_TOKEN_EXPIRED, typedThis.idToken);
          }, expiresIn * 1000);
        }
        return typedThis.claims;
      },
      async getTokenSilently(opts) {
        const typedThis = this;
        const permissionsManager = getPermissionsInstance();
        try {
          var _typedThis$auth0Clien7;
          typedThis.token = await ((_typedThis$auth0Clien7 = typedThis.auth0Client) === null || _typedThis$auth0Clien7 === void 0 ? void 0 : _typedThis$auth0Clien7.getTokenSilently(opts));
          await typedThis.getIdTokenClaims();
          if (typedThis.token) {
            var _typedThis$auth0Clien8;
            typedThis.$emit(AuthEvents.ACCESS_TOKEN_UPDATED, typedThis.token);
            await permissionsManager.reauthorize(typedThis.token, opts);
            typedThis.user = await ((_typedThis$auth0Clien8 = typedThis.auth0Client) === null || _typedThis$auth0Clien8 === void 0 ? void 0 : _typedThis$auth0Clien8.getUser());
            typedThis.isAuthenticated = true;
            const decodedJwt = jwt_decode_esm(typedThis.token);
            const expiresIn = decodedJwt.exp - decodedJwt.iat;
            setTimeout(async () => {
              typedThis.$emit(AuthEvents.ACCESS_TOKEN_EXPIRED, typedThis.token);
              await typedThis.getTokenSilently({
                cacheMode: 'on'
              });
            }, expiresIn * 1000);
          }
        } catch (err) {
          if (err.error) {
            const options = {
              appState: {
                targetUrl: window.location.pathname
              },
              authorizationParams: {
                audience,
                redirect_uri: redirectURI + redirectSuffix
              },
              openUrl
            };
            if (loginMode === 'redirect') {
              typedThis.loginWithRedirect(options);
            } else {
              typedThis.loginWithPopup(options, {
                timeoutInSeconds: 30
              });
            }
            typedThis.redirecting = true;
          }
        }
        return typedThis.token;
      },
      logout(opts = {}) {
        var _typedThis$auth0Clien9;
        if (!(opts !== null && opts !== void 0 && opts.logoutParams)) {
          opts.logoutParams = {
            returnTo: window.location.origin + '/'
          };
        }
        const typedThis = this;
        (_typedThis$auth0Clien9 = typedThis.auth0Client) === null || _typedThis$auth0Clien9 === void 0 ? void 0 : _typedThis$auth0Clien9.logout(opts);
        typedThis.isAuthenticated = false;
        typedThis.token = undefined;
        typedThis.user = undefined;
        typedThis.idToken = undefined;
        typedThis.claims = undefined;
      },
      async getAccountId() {
        const typedThis = this;
        const claims = typedThis.claims;
        if (!claims) return '';
        const accountId = getAccountIdFromClaims(claims);
        return accountId;
      },
      async getUserId() {
        const typedThis = this;
        const claims = typedThis.claims;
        if (!claims) return '';
        const userId = getUserIdFromClaims(claims);
        return userId;
      }
    },
    watch: {
      isAuthenticated: {
        immediate: true,
        handler: function (isAuthenticated) {
          this.$emit(AuthEvents.AUTH_CHANGED, isAuthenticated);
        }
      },
      token: function (newToken, oldToken) {
        if (newToken !== oldToken) {
          const typedThis = this;
          typedThis.updateAxiosHeaders();
        }
      }
    },
    async created() {
      const typedThis = this;
      typedThis.loading = true;
      const aco = {
        cacheLocation,
        domain,
        clientId: clientID,
        useRefreshTokens,
        authorizationParams: {
          audience,
          redirect_uri: redirectURI + redirectSuffix
        }
      };
      typedThis.auth0Client = await oe(aco);
      async function setup() {
        var _typedThis$auth0Clien10;
        const isAuthenticated = (await ((_typedThis$auth0Clien10 = typedThis.auth0Client) === null || _typedThis$auth0Clien10 === void 0 ? void 0 : _typedThis$auth0Clien10.isAuthenticated())) || false;
        if (isAuthenticated) {
          await typedThis.getTokenSilently({
            cacheMode: 'on'
          });
        }
        return isAuthenticated;
      }
      let isAuthenticated = false;
      try {
        if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
          var _typedThis$auth0Clien11;
          const results = await ((_typedThis$auth0Clien11 = typedThis.auth0Client) === null || _typedThis$auth0Clien11 === void 0 ? void 0 : _typedThis$auth0Clien11.handleRedirectCallback());
          onRedirectCallback(results === null || results === void 0 ? void 0 : results.appState);
          isAuthenticated = await setup();
          const userId = getUserIdFromClaims(typedThis.claims);
          if (accountsHost && userId) {
            axios.post(`${accountsHost}/update-login/${userId}`);
          }
        } else {
          isAuthenticated = await setup();
        }
      } catch (e) {
        console.error('Auth0Error: ', e);
        typedThis.error = e;
      } finally {
        typedThis.isAuthenticated = isAuthenticated;
        typedThis.loading = false;
      }
    }
  });
  return authInstance;
};
/* harmony default export */ var service = ({
  install(vue, options) {
    vue.prototype.$auth = useAuth0(options);
    vue.prototype.$permissions = initializePermissionsManager(options.permissionsOptions);
    vue.directive('auth-btn', authBtnDirective);
  }
});
;// CONCATENATED MODULE: ./src/auth/middleware/auth.ts


const logInAsPermission = 'tsi:webapp:Administration:execute_menu_choice:Log_In_As';
const AuthGuard = (to, from, next) => {
  const authService = getAuthInstance();
  const fn = async () => {
    if (authService.isAuthenticated) {
      return next();
    }
    authService.loading = true;
    const resp = await authService.getTokenSilently({
      cacheMode: 'on'
    });
    authService.loading = false;
    if (resp) {
      window.location.reload();
    }
  };
  if (!authService.loading) {
    return fn();
  }
  authService.$watch('loading', loading => {
    if (loading === false && !authService.redirecting) {
      return fn();
    }
  });
};
const isAuthorized = {
  beforeRouteEnter: AuthGuard
};
const AccountExistsGuard = (to, from, next) => {
  const authService = getAuthInstance();
  const fn = async () => {
    try {
      const accountId = await authService.getAccountId();
      if (accountId) {
        return next();
      }
      next('/user-create');
    } catch (e) {
      next('/');
    }
  };
  if (!authService.loading) {
    return fn();
  }
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
const accountExists = {
  beforeRouteEnter: AccountExistsGuard
};
const HasPermissionGuard = permissions => {
  return (to, from, next) => {
    const permissionsManager = getPermissionsInstance();
    const authService = getAuthInstance();
    const fn = async () => {
      try {
        const isAllowed = permissionsManager.isAllowed(permissions);
        if (isAllowed) {
          return next();
        }
        next('/');
      } catch (e) {
        next('/');
      }
    };
    if (!authService.loading) {
      return fn();
    }
    authService.$watch('loading', loading => {
      if (loading === false) {
        return fn();
      }
    });
  };
};
const routeHasPermission = permission => {
  return {
    beforeRouteEnter: HasPermissionGuard(permission)
  };
};
const PublicGuard = (to, from, next) => {
  const authService = getAuthInstance();
  const fn = () => {
    if (!authService.isAuthenticated) {
      return next();
    }
    next('/home');
  };
  if (!authService.loading) {
    return fn();
  }
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
const isNotAuthorized = {
  beforeRouteEnter: PublicGuard
};
const LogInAsSecurityGuard = (to, from, next) => {
  const authService = getAuthInstance();
  const permissionsManager = getPermissionsInstance();
  const fn = () => {
    const currentQueryString = window.location.search;
    if (currentQueryString.includes('accountID') || currentQueryString.includes('userID') || currentQueryString.includes('sapID')) {
      if (permissionsManager.slugs.includes(logInAsPermission)) {
        return next();
      } else {
        next('/user-sync');
        next('/home');
      }
    }
    return next();
  };
  if (!authService.loading) {
    return fn();
  }
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
const logInAsSecurity = {
  beforeRouteEnter: LogInAsSecurityGuard
};

;// CONCATENATED MODULE: ./src/auth/middleware/email.ts

const EmailVerifiedGuard = (to, from, next) => {
  const authService = getAuthInstance();
  const fn = () => {
    var _authService$user;
    if ((_authService$user = authService.user) !== null && _authService$user !== void 0 && _authService$user.email_verified) {
      return next();
    }
    return next('/non-verified');
  };
  if (!authService.loading) {
    return fn();
  }
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
const emailVerified = {
  beforeRouteEnter: EmailVerifiedGuard
};
const EmailNotVerifiedGuard = (to, from, next) => {
  const authService = getAuthInstance();
  const fn = () => {
    var _authService$user2;
    if (!((_authService$user2 = authService.user) !== null && _authService$user2 !== void 0 && _authService$user2.email_verified)) {
      return next();
    }
    return next('/home');
  };
  if (!authService.loading) {
    return fn();
  }
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
const emailNotVerified = {
  beforeRouteEnter: EmailNotVerifiedGuard
};
const TSIEmailGuard = (to, from, next) => {
  const authService = getAuthInstance();
  const fn = () => {
    var _authService$user3, _authService$user3$em;
    if ((_authService$user3 = authService.user) !== null && _authService$user3 !== void 0 && (_authService$user3$em = _authService$user3.email) !== null && _authService$user3$em !== void 0 && _authService$user3$em.includes('@tsi.com')) {
      return next();
    }
    return next('/home');
  };
  if (!authService.loading) {
    return fn();
  }
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
const hasTSIEmail = {
  beforeRouteEnter: TSIEmailGuard
};

;// CONCATENATED MODULE: ./src/main.ts







/* harmony default export */ var main = (service);

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (main);


module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=fusion-auth.common.js.map

/***/ }),

/***/ 678:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
     true ? factory(exports) :
    0;
})(this, (function (exports) { 'use strict';

    var UnitOfMeasure;
    (function (UnitOfMeasure) {
        UnitOfMeasure[UnitOfMeasure["NA"] = 0] = "NA";
        UnitOfMeasure[UnitOfMeasure["PERCENT"] = 10] = "PERCENT";
        UnitOfMeasure[UnitOfMeasure["DEGREES_F"] = 100] = "DEGREES_F";
        UnitOfMeasure[UnitOfMeasure["DEGREES_C"] = 101] = "DEGREES_C";
        UnitOfMeasure[UnitOfMeasure["DEGREES_K"] = 102] = "DEGREES_K";
        UnitOfMeasure[UnitOfMeasure["PASCAL"] = 210] = "PASCAL";
        UnitOfMeasure[UnitOfMeasure["HECTOPASCAL"] = 211] = "HECTOPASCAL";
        UnitOfMeasure[UnitOfMeasure["KILOPASCAL"] = 212] = "KILOPASCAL";
        UnitOfMeasure[UnitOfMeasure["MEGAPASCAL"] = 213] = "MEGAPASCAL";
        UnitOfMeasure[UnitOfMeasure["GIGAPASCAL"] = 214] = "GIGAPASCAL";
        UnitOfMeasure[UnitOfMeasure["BAR"] = 220] = "BAR";
        UnitOfMeasure[UnitOfMeasure["MILLIBAR"] = 221] = "MILLIBAR";
        UnitOfMeasure[UnitOfMeasure["CENTIBAR"] = 222] = "CENTIBAR";
        UnitOfMeasure[UnitOfMeasure["DECIBAR"] = 223] = "DECIBAR";
        UnitOfMeasure[UnitOfMeasure["KILOBAR"] = 224] = "KILOBAR";
        UnitOfMeasure[UnitOfMeasure["MEGABAR"] = 225] = "MEGABAR";
        UnitOfMeasure[UnitOfMeasure["ATM"] = 230] = "ATM";
        UnitOfMeasure[UnitOfMeasure["INCH_MERCURY"] = 240] = "INCH_MERCURY";
        UnitOfMeasure[UnitOfMeasure["MILLIMETER_MERCURY"] = 241] = "MILLIMETER_MERCURY";
        UnitOfMeasure[UnitOfMeasure["CENTIMETER_MERCURY"] = 242] = "CENTIMETER_MERCURY";
        UnitOfMeasure[UnitOfMeasure["TORR"] = 250] = "TORR";
        UnitOfMeasure[UnitOfMeasure["MILLITORR"] = 251] = "MILLITORR";
        UnitOfMeasure[UnitOfMeasure["INCH_WATER"] = 260] = "INCH_WATER";
        UnitOfMeasure[UnitOfMeasure["MILLIMETER_WATER"] = 261] = "MILLIMETER_WATER";
        UnitOfMeasure[UnitOfMeasure["CENTIMETER_WATER"] = 262] = "CENTIMETER_WATER";
        UnitOfMeasure[UnitOfMeasure["POUND_SQUARE_INCH"] = 270] = "POUND_SQUARE_INCH";
        UnitOfMeasure[UnitOfMeasure["CUBIC_FEET_PER_MINUTE"] = 300] = "CUBIC_FEET_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["CUBIC_FEET_PER_SECOND"] = 301] = "CUBIC_FEET_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["CUBIC_FEET_PER_HOUR"] = 302] = "CUBIC_FEET_PER_HOUR";
        UnitOfMeasure[UnitOfMeasure["CUBIC_METERS_PER_SECOND"] = 310] = "CUBIC_METERS_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["CUBIC_METERS_PER_MINUTE"] = 311] = "CUBIC_METERS_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["CUBIC_METERS_PER_HOUR"] = 312] = "CUBIC_METERS_PER_HOUR";
        UnitOfMeasure[UnitOfMeasure["LITERS_PER_SECOND"] = 320] = "LITERS_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["LITERS_PER_MINUTE"] = 321] = "LITERS_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["LITERS_PER_HOUR"] = 322] = "LITERS_PER_HOUR";
        UnitOfMeasure[UnitOfMeasure["US_GALLON_PER_SECOND"] = 330] = "US_GALLON_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["US_GALLON_PER_MINUTE"] = 331] = "US_GALLON_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["US_GALLON_PER_HOUR"] = 332] = "US_GALLON_PER_HOUR";
        UnitOfMeasure[UnitOfMeasure["FEET_PER_SECOND"] = 400] = "FEET_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["FEET_PER_MINUTE"] = 401] = "FEET_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["METERS_PER_SECOND"] = 410] = "METERS_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["METERS_PER_MINUTE"] = 411] = "METERS_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["PARTS_PER_MILLION"] = 500] = "PARTS_PER_MILLION";
        UnitOfMeasure[UnitOfMeasure["PARTS_PER_BILLION"] = 501] = "PARTS_PER_BILLION";
        UnitOfMeasure[UnitOfMeasure["PARTS_PER_TRILLION"] = 502] = "PARTS_PER_TRILLION";
        UnitOfMeasure[UnitOfMeasure["PARTS_PER_QUADRILLION"] = 503] = "PARTS_PER_QUADRILLION";
        UnitOfMeasure[UnitOfMeasure["COUNT"] = 510] = "COUNT";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_CUBIC_CENTIMETER"] = 511] = "COUNT_PER_CUBIC_CENTIMETER";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_CUBIC_METER"] = 512] = "COUNT_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_CUBIC_FOOT"] = 513] = "COUNT_PER_CUBIC_FOOT";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_DECILITER"] = 514] = "COUNT_PER_DECILITER";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_LITER"] = 515] = "COUNT_PER_LITER";
        UnitOfMeasure[UnitOfMeasure["MILLIGRAMS_PER_CUBIC_METER"] = 600] = "MILLIGRAMS_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["KILOGRAMS_PER_CUBIC_METER"] = 601] = "KILOGRAMS_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["MICROGRAMS_PER_CUBIC_METER"] = 602] = "MICROGRAMS_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["KILOGRAMS_PER_LITER"] = 610] = "KILOGRAMS_PER_LITER";
        UnitOfMeasure[UnitOfMeasure["GRAMS_PER_MILLILITER"] = 620] = "GRAMS_PER_MILLILITER";
        UnitOfMeasure[UnitOfMeasure["METRIC_TON_PER_CUBIC_METER"] = 630] = "METRIC_TON_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["GRAMS_PER_CUBIC_CENTIMETER"] = 640] = "GRAMS_PER_CUBIC_CENTIMETER";
        UnitOfMeasure[UnitOfMeasure["PARTICLE_SIZE"] = 700] = "PARTICLE_SIZE";
        UnitOfMeasure[UnitOfMeasure["SPECTRUM"] = 800] = "SPECTRUM";
        UnitOfMeasure[UnitOfMeasure["MILLIVOLT"] = 900] = "MILLIVOLT";
        UnitOfMeasure[UnitOfMeasure["VOLT"] = 901] = "VOLT";
        UnitOfMeasure[UnitOfMeasure["KILOVOLT"] = 902] = "KILOVOLT";
        UnitOfMeasure[UnitOfMeasure["MILLIAMP"] = 910] = "MILLIAMP";
        UnitOfMeasure[UnitOfMeasure["AMP"] = 911] = "AMP";
        UnitOfMeasure[UnitOfMeasure["KILOAMP"] = 912] = "KILOAMP";
        UnitOfMeasure[UnitOfMeasure["NANOMETER"] = 1000] = "NANOMETER";
        UnitOfMeasure[UnitOfMeasure["MICROMETER"] = 1001] = "MICROMETER";
        UnitOfMeasure[UnitOfMeasure["MILLIMETER"] = 1002] = "MILLIMETER";
        UnitOfMeasure[UnitOfMeasure["CENTIMETER"] = 1003] = "CENTIMETER";
        UnitOfMeasure[UnitOfMeasure["METER"] = 1004] = "METER";
        UnitOfMeasure[UnitOfMeasure["KILOMETER"] = 1005] = "KILOMETER";
        UnitOfMeasure[UnitOfMeasure["NANOSECOND"] = 1100] = "NANOSECOND";
        UnitOfMeasure[UnitOfMeasure["MILLISECOND"] = 1101] = "MILLISECOND";
        UnitOfMeasure[UnitOfMeasure["SECOND"] = 1102] = "SECOND";
        UnitOfMeasure[UnitOfMeasure["LITER"] = 1200] = "LITER";
        UnitOfMeasure[UnitOfMeasure["MILLILITER"] = 1201] = "MILLILITER";
        UnitOfMeasure[UnitOfMeasure["CUBIC_FEET"] = 1210] = "CUBIC_FEET";
        UnitOfMeasure[UnitOfMeasure["RELATIVE_HUMIDITY"] = 1300] = "RELATIVE_HUMIDITY";
        UnitOfMeasure[UnitOfMeasure["RELATIVE_HUMIDITY_PERCENT"] = 1301] = "RELATIVE_HUMIDITY_PERCENT";
        UnitOfMeasure[UnitOfMeasure["DECIBELS"] = 1400] = "DECIBELS";
    })(UnitOfMeasure || (UnitOfMeasure = {}));
    var UnitOfMeasure$1 = UnitOfMeasure;

    var _a;
    var UnitOfMeasureProperties = Object.freeze((_a = {},
        _a[UnitOfMeasure$1.NA] = { name: 'N/A', value: UnitOfMeasure$1.NA, code: 'na' },
        _a[UnitOfMeasure$1.PERCENT] = { name: 'Percent', value: UnitOfMeasure$1.PERCENT, code: '%' },
        _a[UnitOfMeasure$1.DEGREES_F] = { name: 'Degrees Fahrenheit', value: UnitOfMeasure$1.DEGREES_F, code: '°F' },
        _a[UnitOfMeasure$1.DEGREES_C] = { name: 'Degrees Celsius', value: UnitOfMeasure$1.DEGREES_C, code: '°C' },
        _a[UnitOfMeasure$1.DEGREES_K] = { name: 'Degrees Kelvin', value: UnitOfMeasure$1.DEGREES_K, code: '°K' },
        _a[UnitOfMeasure$1.PASCAL] = { name: 'Pascal', value: UnitOfMeasure$1.PASCAL, code: 'Pa' },
        _a[UnitOfMeasure$1.HECTOPASCAL] = { name: 'Hectopascal', value: UnitOfMeasure$1.HECTOPASCAL, code: 'hPa' },
        _a[UnitOfMeasure$1.KILOPASCAL] = { name: 'Kilopascal', value: UnitOfMeasure$1.KILOPASCAL, code: 'kPa' },
        _a[UnitOfMeasure$1.MEGAPASCAL] = { name: 'Megapascal', value: UnitOfMeasure$1.MEGAPASCAL, code: 'MPa' },
        _a[UnitOfMeasure$1.GIGAPASCAL] = { name: 'Gigapascal', value: UnitOfMeasure$1.GIGAPASCAL, code: 'GPa' },
        _a[UnitOfMeasure$1.BAR] = { name: 'Bar', value: UnitOfMeasure$1.BAR, code: 'bar' },
        _a[UnitOfMeasure$1.MILLIBAR] = { name: 'Millibar', value: UnitOfMeasure$1.MILLIBAR, code: 'mbar' },
        _a[UnitOfMeasure$1.CENTIBAR] = { name: 'Centibar', value: UnitOfMeasure$1.CENTIBAR, code: 'cbar' },
        _a[UnitOfMeasure$1.DECIBAR] = { name: 'Decibar', value: UnitOfMeasure$1.DECIBAR, code: 'dbar' },
        _a[UnitOfMeasure$1.KILOBAR] = { name: 'Kilobar', value: UnitOfMeasure$1.KILOBAR, code: 'kbar' },
        _a[UnitOfMeasure$1.MEGABAR] = { name: 'Megabar', value: UnitOfMeasure$1.MEGABAR, code: 'Mbar' },
        _a[UnitOfMeasure$1.ATM] = { name: 'Standard atmosphere', value: UnitOfMeasure$1.ATM, code: 'atm' },
        _a[UnitOfMeasure$1.INCH_MERCURY] = { name: 'Inches of mercury', value: UnitOfMeasure$1.INCH_MERCURY, code: 'inHg' },
        _a[UnitOfMeasure$1.MILLIMETER_MERCURY] = { name: 'Millimeters of mercury', value: UnitOfMeasure$1.MILLIMETER_MERCURY, code: 'mmHg' },
        _a[UnitOfMeasure$1.CENTIMETER_MERCURY] = { name: 'Centimeters of mercury', value: UnitOfMeasure$1.CENTIMETER_MERCURY, code: 'cmHg' },
        _a[UnitOfMeasure$1.TORR] = { name: 'Torr', value: UnitOfMeasure$1.TORR, code: 'Torr' },
        _a[UnitOfMeasure$1.MILLITORR] = { name: 'Millitorr', value: UnitOfMeasure$1.MILLITORR, code: 'mTorr' },
        _a[UnitOfMeasure$1.INCH_WATER] = { name: 'Inches of water', value: UnitOfMeasure$1.INCH_WATER, code: 'inH₂O' },
        _a[UnitOfMeasure$1.MILLIMETER_WATER] = { name: 'Millimeters of water', value: UnitOfMeasure$1.MILLIMETER_WATER, code: 'mmH₂O' },
        _a[UnitOfMeasure$1.CENTIMETER_WATER] = { name: 'Centimeters of water', value: UnitOfMeasure$1.CENTIMETER_WATER, code: 'cmH₂O' },
        _a[UnitOfMeasure$1.POUND_SQUARE_INCH] = { name: 'Pounds per square inch', value: UnitOfMeasure$1.POUND_SQUARE_INCH, code: 'psi' },
        _a[UnitOfMeasure$1.CUBIC_FEET_PER_MINUTE] = { name: 'Cubic feet per minute', value: UnitOfMeasure$1.CUBIC_FEET_PER_MINUTE, code: 'ft³/min' },
        _a[UnitOfMeasure$1.CUBIC_FEET_PER_SECOND] = { name: 'Cubic feet per second', value: UnitOfMeasure$1.CUBIC_FEET_PER_SECOND, code: 'ft³/s' },
        _a[UnitOfMeasure$1.CUBIC_FEET_PER_HOUR] = { name: 'Cubic feet per hour', value: UnitOfMeasure$1.CUBIC_FEET_PER_HOUR, code: 'ft³/hour' },
        _a[UnitOfMeasure$1.CUBIC_METERS_PER_SECOND] = { name: 'Cubic meters per second', value: UnitOfMeasure$1.CUBIC_METERS_PER_SECOND, code: 'm³/s' },
        _a[UnitOfMeasure$1.CUBIC_METERS_PER_MINUTE] = { name: 'Cubic meters per minute', value: UnitOfMeasure$1.CUBIC_METERS_PER_MINUTE, code: 'm³/min' },
        _a[UnitOfMeasure$1.CUBIC_METERS_PER_HOUR] = { name: 'Cubic meters per hour', value: UnitOfMeasure$1.CUBIC_METERS_PER_HOUR, code: 'm³/hour' },
        _a[UnitOfMeasure$1.LITERS_PER_SECOND] = { name: 'Liters per second', value: UnitOfMeasure$1.LITERS_PER_SECOND, code: 'l/s' },
        _a[UnitOfMeasure$1.LITERS_PER_MINUTE] = { name: 'Liters per minute', value: UnitOfMeasure$1.LITERS_PER_MINUTE, code: 'l/min' },
        _a[UnitOfMeasure$1.LITERS_PER_HOUR] = { name: 'Liters per hour', value: UnitOfMeasure$1.LITERS_PER_HOUR, code: 'l/hour' },
        _a[UnitOfMeasure$1.US_GALLON_PER_SECOND] = { name: 'U.S. gallons per second', value: UnitOfMeasure$1.US_GALLON_PER_SECOND, code: 'gps' },
        _a[UnitOfMeasure$1.US_GALLON_PER_MINUTE] = { name: 'U.S. gallons per minute', value: UnitOfMeasure$1.US_GALLON_PER_MINUTE, code: 'gpm' },
        _a[UnitOfMeasure$1.US_GALLON_PER_HOUR] = { name: 'U.S. gallons per hour', value: UnitOfMeasure$1.US_GALLON_PER_HOUR, code: 'gph' },
        _a[UnitOfMeasure$1.FEET_PER_SECOND] = { name: 'Feet per second', value: UnitOfMeasure$1.FEET_PER_SECOND, code: 'ft/s' },
        _a[UnitOfMeasure$1.FEET_PER_MINUTE] = { name: 'Feet per minute', value: UnitOfMeasure$1.FEET_PER_MINUTE, code: 'ft/min' },
        _a[UnitOfMeasure$1.METERS_PER_SECOND] = { name: 'Meters per second', value: UnitOfMeasure$1.METERS_PER_SECOND, code: 'm/s' },
        _a[UnitOfMeasure$1.METERS_PER_MINUTE] = { name: 'Meters per minute', value: UnitOfMeasure$1.METERS_PER_MINUTE, code: 'm/min' },
        _a[UnitOfMeasure$1.PARTS_PER_MILLION] = { name: 'Parts per million', value: UnitOfMeasure$1.PARTS_PER_MILLION, code: 'ppm' },
        _a[UnitOfMeasure$1.PARTS_PER_BILLION] = { name: 'Parts per billion', value: UnitOfMeasure$1.PARTS_PER_BILLION, code: 'ppb' },
        _a[UnitOfMeasure$1.PARTS_PER_TRILLION] = { name: 'Parts per trillion', value: UnitOfMeasure$1.PARTS_PER_TRILLION, code: 'ppt' },
        _a[UnitOfMeasure$1.PARTS_PER_QUADRILLION] = { name: 'Parts per quadrillion', value: UnitOfMeasure$1.PARTS_PER_QUADRILLION, code: 'ppq' },
        _a[UnitOfMeasure$1.COUNT] = { name: 'Count', value: UnitOfMeasure$1.COUNT, code: '#' },
        _a[UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER] = { name: 'Count per cubic centimeter', value: UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER, code: '#/cm³' },
        _a[UnitOfMeasure$1.COUNT_PER_CUBIC_METER] = { name: 'Count per cubic meter', value: UnitOfMeasure$1.COUNT_PER_CUBIC_METER, code: '#/m³' },
        _a[UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT] = { name: 'Count per cubic foot', value: UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT, code: '#/ft³' },
        _a[UnitOfMeasure$1.COUNT_PER_DECILITER] = { name: 'Count per deciliter', value: UnitOfMeasure$1.COUNT_PER_DECILITER, code: '#/dL' },
        _a[UnitOfMeasure$1.COUNT_PER_LITER] = { name: 'Count per liter', value: UnitOfMeasure$1.COUNT_PER_LITER, code: '#/L' },
        _a[UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER] = { name: 'Milligrams per cubic meter', value: UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER, code: 'mg/m³' },
        _a[UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER] = { name: 'Kilograms per cubic meter', value: UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER, code: 'kg/m³' },
        _a[UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER] = { name: 'Micrograms per cubic meter', value: UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER, code: 'µg/m³' },
        _a[UnitOfMeasure$1.KILOGRAMS_PER_LITER] = { name: 'Kilograms per liter', value: UnitOfMeasure$1.KILOGRAMS_PER_LITER, code: 'kg/l' },
        _a[UnitOfMeasure$1.GRAMS_PER_MILLILITER] = { name: 'grams per milliliter', value: UnitOfMeasure$1.GRAMS_PER_MILLILITER, code: 'g/ml' },
        _a[UnitOfMeasure$1.METRIC_TON_PER_CUBIC_METER] = { name: 'Metric ton per cubic meter', value: UnitOfMeasure$1.METRIC_TON_PER_CUBIC_METER, code: 't/m³' },
        _a[UnitOfMeasure$1.GRAMS_PER_CUBIC_CENTIMETER] = { name: 'Grams per cubic centimeter', value: UnitOfMeasure$1.GRAMS_PER_CUBIC_CENTIMETER, code: 'g/cm³' },
        _a[UnitOfMeasure$1.PARTICLE_SIZE] = { name: 'Particle Size', value: UnitOfMeasure$1.PARTICLE_SIZE, code: '' },
        _a[UnitOfMeasure$1.SPECTRUM] = { name: 'Spectrum', value: UnitOfMeasure$1.SPECTRUM, code: '' },
        _a[UnitOfMeasure$1.MILLIVOLT] = { name: 'Millivolt', value: UnitOfMeasure$1.MILLIVOLT, code: 'mV' },
        _a[UnitOfMeasure$1.VOLT] = { name: 'Volt', value: UnitOfMeasure$1.VOLT, code: 'V' },
        _a[UnitOfMeasure$1.KILOVOLT] = { name: 'Kilovolt', value: UnitOfMeasure$1.KILOVOLT, code: 'kV' },
        _a[UnitOfMeasure$1.MILLIAMP] = { name: 'Milliamp', value: UnitOfMeasure$1.MILLIAMP, code: 'mA' },
        _a[UnitOfMeasure$1.AMP] = { name: 'Amp', value: UnitOfMeasure$1.AMP, code: 'A' },
        _a[UnitOfMeasure$1.KILOAMP] = { name: 'KiloAmp', value: UnitOfMeasure$1.KILOAMP, code: 'kA' },
        _a[UnitOfMeasure$1.NANOMETER] = { name: 'Nanometer', value: UnitOfMeasure$1.NANOMETER, code: 'nm' },
        _a[UnitOfMeasure$1.MICROMETER] = { name: 'Micrometer', value: UnitOfMeasure$1.MICROMETER, code: 'µm' },
        _a[UnitOfMeasure$1.MILLIMETER] = { name: 'Millimeter', value: UnitOfMeasure$1.MILLIMETER, code: 'mm' },
        _a[UnitOfMeasure$1.CENTIMETER] = { name: 'Centimeter', value: UnitOfMeasure$1.CENTIMETER, code: 'cm' },
        _a[UnitOfMeasure$1.METER] = { name: 'Meter', value: UnitOfMeasure$1.METER, code: 'm' },
        _a[UnitOfMeasure$1.KILOMETER] = { name: 'Kilometer', value: UnitOfMeasure$1.KILOMETER, code: 'km' },
        _a[UnitOfMeasure$1.NANOSECOND] = { name: 'Nanosecond', value: UnitOfMeasure$1.NANOSECOND, code: 'ns' },
        _a[UnitOfMeasure$1.MILLISECOND] = { name: 'Millisecond', value: UnitOfMeasure$1.MILLISECOND, code: 'ms' },
        _a[UnitOfMeasure$1.SECOND] = { name: 'Second', value: UnitOfMeasure$1.SECOND, code: 's' },
        _a[UnitOfMeasure$1.LITER] = { name: 'Liter', value: UnitOfMeasure$1.LITER, code: 'L' },
        _a[UnitOfMeasure$1.MILLILITER] = { name: 'Milliliter', value: UnitOfMeasure$1.MILLILITER, code: 'mL' },
        _a[UnitOfMeasure$1.CUBIC_FEET] = { name: 'Cubic feet', value: UnitOfMeasure$1.CUBIC_FEET, code: 'ft³' },
        _a[UnitOfMeasure$1.RELATIVE_HUMIDITY] = { name: 'Relative humidity', value: UnitOfMeasure$1.RELATIVE_HUMIDITY, code: 'RH' },
        _a[UnitOfMeasure$1.RELATIVE_HUMIDITY_PERCENT] = { name: 'Relative humidity', value: UnitOfMeasure$1.RELATIVE_HUMIDITY_PERCENT, code: '%RH' },
        _a[UnitOfMeasure$1.DECIBELS] = { name: 'Decibels', value: UnitOfMeasure$1.DECIBELS, code: 'dB' },
        _a));

    var MeasurementTypes = Object.freeze({
        nh3_ppm: {
            aliases: ['nh3_ppm', 'Ammonia', 'Ammonia (ppm)', 'Ammonia (Parts per million)'],
            name: 'nh3_ppm'
        },
        nh3_mgm3: {
            aliases: ['nh3_mgm3', 'Ammonia Mass Concentration', 'Ammonia (mg/m³)', 'Ammonia (Milligrams per cubic meter)'],
            name: 'nh3_mgm3'
        },
        baro_inhg: {
            aliases: ['Barometric Pressure', 'BP', 'baro_inhg'],
            name: 'baro_inhg'
        },
        Date: {
            aliases: ['Date'],
            name: 'Date'
        },
        DateTime: {
            aliases: ['Date/Time', 'datetime'],
            name: 'DateTime'
        },
        dewpoint: {
            aliases: ['Dew Point', 'dewpoint'],
            name: 'dewpoint'
        },
        mcpm1x0: {
            aliases: ['PM 1.0', 'PM1', 'pm1', 'PM1_Concentration', 'mcpm1x0', 'PM1.0'],
            name: 'mcpm1x0'
        },
        mcpm2x5: {
            aliases: ['PM 2.5', 'pm2.5', 'PM2.5', 'PM2p5_Concentration', 'Concentration', 'mcpm2x5'],
            name: 'mcpm2x5'
        },
        mcpm4x0: {
            aliases: ['PM 4.0', 'pm4.0', 'PM4.0', 'mcpm4x0'],
            name: 'mcpm4x0'
        },
        mcpm10: {
            aliases: ['PM 10', 'PM10', 'PM10.0', 'PM 10.0', 'PM10_Concentration', 'mcpm10', 'pm10'],
            name: 'mcpm10'
        },
        mcpm1x0_min: {
            aliases: ['mcpm1x0_min'],
            name: 'mcpm1x0_min'
        },
        mcpm1x0_max: {
            aliases: ['mcpm1x0_max'],
            name: 'mcpm1x0_max'
        },
        mcpm1x0_avg: {
            aliases: ['mcpm1x0_avg'],
            name: 'mcpm1x0_avg'
        },
        mcpm1x0_twa: {
            aliases: ['mcpm1x0_twa'],
            name: 'mcpm1x0_twa'
        },
        mcpm2x5_min: {
            aliases: ['mcpm2x5_min'],
            name: 'mcpm2x5_min'
        },
        mcpm2x5_max: {
            aliases: ['mcpm2x5_max'],
            name: 'mcpm2x5_max'
        },
        mcpm2x5_avg: {
            aliases: ['mcpm2x5_avg'],
            name: 'mcpm2x5_avg'
        },
        mcpm2x5_twa: {
            aliases: ['mcpm2x5_twa'],
            name: 'mcpm2x5_twa'
        },
        mcpm4x0_min: {
            aliases: ['mcpm4x0_min'],
            name: 'mcpm4x0_min'
        },
        mcpm4x0_max: {
            aliases: ['mcpm4x0_max'],
            name: 'mcpm4x0_max'
        },
        mcpm4x0_avg: {
            aliases: ['mcpm4x0_avg'],
            name: 'mcpm4x0_avg'
        },
        mcpm4x0_twa: {
            aliases: ['mcpm4x0_twa'],
            name: 'mcpm4x0_twa'
        },
        mcpm10_min: {
            aliases: ['mcpm10_min'],
            name: 'mcpm10_min'
        },
        mcpm10_max: {
            aliases: ['mcpm10_max'],
            name: 'mcpm10_max'
        },
        mcpm10_avg: {
            aliases: ['mcpm10_avg'],
            name: 'mcpm10_avg'
        },
        mcpm10_twa: {
            aliases: ['mcpm10_twa'],
            name: 'mcpm10_twa'
        },
        mcpm_total: {
            aliases: ['mcpm_total'],
            name: 'mcpm_total'
        },
        mcpm_total_min: {
            aliases: ['mcpm_total_min'],
            name: 'mcpm_total_min'
        },
        mcpm_total_max: {
            aliases: ['mcpm_total_max'],
            name: 'mcpm_total_max'
        },
        mcpm_total_avg: {
            aliases: ['mcpm_total_avg'],
            name: 'mcpm_total_avg'
        },
        mcpm_total_twa: {
            aliases: ['mcpm_total_twa'],
            name: 'mcpm_total_twa'
        },
        ncpm0x3: {
            aliases: ['Particle Conc. 0.3', 'CountsPM_0p3um', 'numberCount_0.3', 'Ch1 Cumul', 'Particle Concentration 0.3', 'ncpm0x3'],
            name: 'ncpm0x3'
        },
        ncpm0x5: {
            aliases: ['PN 0.3-0.5µm', 'Particle Conc. 0.5', 'CountsPM_0p5um', 'numberCount_0.5', 'Ch2 Cumul', 'ncpm0x5', 'NC 0.3-0.5µm', 'Particle Concentration 0.5', 'NC0.5'],
            name: 'ncpm0x5'
        },
        ncpm1x0: {
            aliases: ['PN 0.5-1.0µm', 'Particle Conc. 1.0', 'CountsPM_1um', 'numberCount_1', 'Ch3 Cumul', 'ncpm1x0', 'NC 0.5-1.0µm', 'Particle Concentration 1.0', 'NC1.0'],
            name: 'ncpm1x0'
        },
        ncpm2x5: {
            aliases: ['PN 1.0-2.5µm', 'Particle Conc. 2.5', 'CountsPM_2p5um', 'ncpm2x5', 'NC 1.0-2.5µm', 'numberCount_2.5', 'Particle Concentration 2.5', 'NC2.5'],
            name: 'ncpm2x5'
        },
        ncpm4x0: {
            aliases: ['PN 2.5-4.0µm', 'ncpm4x0', 'numberCount_4', 'NC 2.5-4.0µm', 'NC4'],
            name: 'ncpm4x0'
        },
        ncpm5x0: {
            aliases: ['ncpm5x0', 'Particle Conc. 5.0', 'CountsPM_5um', 'numberCount_5', 'Ch4 Cumul', 'Particle Concentration 5.0'],
            name: 'ncpm5x0'
        },
        ncpm10: {
            aliases: ['PN 4.0-10µm', 'Particle Conc. 10.0', 'CountsPM_10um', 'numberCount_10', 'Ch5 Cumul', 'Particle Concentration 10.0', 'ncpm10', 'NC 4.0-10.0µm', 'NC 4.0-10µm', 'NC10'],
            name: 'ncpm10'
        },
        rh_percent: {
            aliases: ['H', 'Relative Humidity', 'rh_percent'],
            name: 'rh_percent'
        },
        temp_c: {
            aliases: ['T', 'Temperature', 'temp_c'],
            name: 'temp_c'
        },
        Time: {
            aliases: ['Time', 'Duration (min)'],
            name: 'Time'
        },
        voc_ppm: {
            aliases: ['Total VOC Low (Parts per million)', 'TVOC', 'tvoc (PARTS_PER_MILLION)', 'voc_ppm', 'tvoc_ppm', 'VOC High', 'VOC High (ppm)'],
            name: 'voc_ppm'
        },
        voc_ppb: {
            aliases: ['gas_voc', 'VOC', 'Total VOC Low (Parts per billion)', 'tvoc (PARTS_PER_BILLION)', 'voc_ppb', 'tvoc_ppb', 'qt_gas', 'VOC Low', 'VOC Low (ppb)'],
            name: 'voc_ppb'
        },
        voc_ugm3: {
            aliases: ['tvoc (MICROGRAMS_PER_CUBIC_METER)'],
            name: 'voc_ugm3'
        },
        voc_mgm3: {
            aliases: ['Total VOC Low (Milligrams per cubic meter)', 'tvoc (MILLIGRAMS_PER_CUBIC_METER)'],
            name: 'voc_mgm3'
        },
        wetbulb: {
            aliases: ['Wet Bulb', 'wetbulb'],
            name: 'wetbulb'
        },
        TVOCErrorStatus: {
            aliases: ['TVOC Sensor Error Status', 'tvocStatus', 'VOC High Sensor Error Status', 'VOC Low Sensor Error Status'],
            name: 'TVOCErrorStatus'
        },
        PMErrorStatus: {
            aliases: ['PM Sensor Error Status'],
            name: 'PMErrorStatus'
        },
        ch2o_ppb: {
            aliases: ['ch2o_ppb', 'Formaldehyde (Parts per billion)', 'Formaldehyde (ppb)'],
            name: 'ch2o_ppb'
        },
        ch2o_inhg: {
            aliases: ['ch2o_inhg'],
            name: 'ch2o_inhg'
        },
        ch2o_ppm: {
            aliases: ['ch2o_ppm', 'Formaldehyde', 'CH2O', 'Formaldehyde (Parts per million)', 'Formaldehyde (ppm)'],
            name: 'ch2o_ppm'
        },
        ch2o_mgm3: {
            aliases: ['ch2o_mgm3', 'Formaldehyde Mass Concentration', 'Formaldehyde (Milligrams per cubic meter)'],
            name: 'ch2o_mgm3'
        },
        so2_ppb: {
            aliases: ['so2_ppb'],
            name: 'so2_ppb'
        },
        no2_ppm: {
            aliases: ['no2_ppm', 'Nitrogen Dioxide (ppm)', 'Nitrogen Dioxide (Parts per million)'],
            name: 'no2_ppm'
        },
        no2_mgm3: {
            aliases: ['no2_mgm3', 'Nitrogen Dioxide (mg/m³)', 'Nitrogen Dioxide (Milligrams per cubic meter)'],
            name: 'no2_mgm3'
        },
        co2_ppm: {
            aliases: ['CO2', 'co2_ppm', 'Carbon Dioxide', 'Carbon Dioxide (ppm)', 'Carbon Dioxide (Parts per million)'],
            name: 'co2_ppm'
        },
        co2_mgm3: {
            aliases: ['co2_mgm3', 'Carbon Dioxide Mass Concentration', 'Carbon Dioxide (mg/m³)', 'Carbon Dioxide (Milligrams per cubic meter)'],
            name: 'co2_mgm3'
        },
        co_ppm: {
            aliases: ['co_ppm', 'Carbon Monoxide', 'CO', 'Carbon Monoxide (ppm)', 'Carbon Monoxide (Parts per million)'],
            name: 'co_ppm'
        },
        co_mgm3: {
            aliases: ['co_mgm3', 'Carbon Monoxide Mass Concentration', 'Carbon Monoxide (mg/m³)', 'Carbon Monoxide (Milligrams per cubic meter)'],
            name: 'co_mgm3'
        },
        o3_ppb: {
            aliases: ['o3_ppb', 'Ozone (O3)', 'Ozone (Parts per billion)'],
            name: 'o3_ppb'
        },
        o3_ppm: {
            aliases: ['o3_ppm', 'Ozone', 'Ozone (Parts per million)', 'Ozone (ppm)'],
            name: 'o3_ppm'
        },
        o3_mgm3: {
            aliases: ['o3_mgm3', 'Ozone (Milligrams per cubic meter)'],
            name: 'o3_mgm3'
        },
        cl_ppm: {
            aliases: ['cl_ppm', 'Chlorine (Parts per million)', 'Chlorine (ppm)'],
            name: 'cl_ppm'
        },
        cl_mgm3: {
            aliases: ['cl_mgm3', 'Chlorine (Milligrams per cubic meter)'],
            name: 'cl_mgm3'
        },
        cl2_ppm: {
            aliases: ['cl2_ppm', 'Chlorine'],
            name: 'cl2_ppm'
        },
        h2s_ppm: {
            aliases: ['h2s_ppm', 'Hydrogen Sulfide'],
            name: 'h2s_ppm'
        },
        no_ppm: {
            aliases: ['no_ppm', 'Nitric Oxide'],
            name: 'no_ppm'
        },
        lzs_max: {
            aliases: ['lzs_max', 'Broadband-LZSmax', 'LZSmax'],
            name: 'lzs_max'
        },
        lzf_max: {
            aliases: ['lzf_max', 'Broadband-LZFmax', 'LZFmax'],
            name: 'lzf_max'
        },
        lzi_max: {
            aliases: ['lzi_max', 'Broadband-LZImax', 'LZImax'],
            name: 'lzi_max'
        },
        lzs_min: {
            aliases: ['lzs_min', 'Broadband-LZSmin', 'LZSmin'],
            name: 'lzs_min'
        },
        lzf_min: {
            aliases: ['lzf_min', 'Broadband-LZFmin', 'LZFmin'],
            name: 'lzf_min'
        },
        lzi_min: {
            aliases: ['lzi_min', 'Broadband-LZImin', 'LZImin'],
            name: 'lzi_min'
        },
        lzeq: {
            aliases: ['lzeq', 'Broadband-LZeq', 'LZEQ'],
            name: 'lzeq'
        },
        lzpeak: {
            aliases: ['lzpeak', 'Broadband-LZpeak', 'LZPk'],
            name: 'lzpeak'
        },
        lcs_max: {
            aliases: ['lcs_max', 'Broadband-LCSmax', 'LCSmax'],
            name: 'lcs_max'
        },
        lcf_max: {
            aliases: ['lcf_max', 'Broadband-LCFmax', 'LCFmax'],
            name: 'lcf_max'
        },
        lci_max: {
            aliases: ['lci_max', 'Broadband-LCImax', 'LCImax'],
            name: 'lci_max'
        },
        lcs_min: {
            aliases: ['lcs_min', 'Broadband-LCSmin', 'LCSmin'],
            name: 'lcs_min'
        },
        lcf_min: {
            aliases: ['lcf_min', 'Broadband-LCFmin', 'LCFmin'],
            name: 'lcf_min'
        },
        lci_min: {
            aliases: ['lci_min', 'Broadband-LCImin', 'LCImin'],
            name: 'lci_min'
        },
        lceq: {
            aliases: ['lceq', 'Broadband-LCeq', 'LCEQ'],
            name: 'lceq'
        },
        lcpeak: {
            aliases: ['lcpeak', 'Broadband-LCpeak', 'LCPk'],
            name: 'lcpeak'
        },
        las_max: {
            aliases: ['las_max', 'Broadband-LASmax', 'LASmax'],
            name: 'las_max'
        },
        laf_max: {
            aliases: ['laf_max', 'Broadband-LAFmax', 'LAFmax'],
            name: 'laf_max'
        },
        lai_max: {
            aliases: ['lai_max', 'Broadband-LAImax', 'LAImax'],
            name: 'lai_max'
        },
        las_min: {
            aliases: ['las_min', 'Broadband-LASmin', 'LASmin'],
            name: 'las_min'
        },
        laf_min: {
            aliases: ['laf_min', 'Broadband-LAFmin', 'LAFmin'],
            name: 'laf_min'
        },
        lai_min: {
            aliases: ['lai_min', 'Broadband-LAImin', 'LAImin'],
            name: 'lai_min'
        },
        laeq: {
            aliases: ['laeq', 'Broadband-LAeq', 'LAEQ'],
            name: 'laeq'
        },
        lapeak: {
            aliases: ['lapeak', 'Broadband-LApeak', 'LAPk'],
            name: 'lapeak'
        },
        lzf_max_16: {
            aliases: ['lzf_max_16', 'Octave LZFmax-16Hz'],
            name: 'lzf_max_16'
        },
        lzf_max_32: {
            aliases: ['lzf_max_32', 'Octave LZFmax-31.5Hz'],
            name: 'lzf_max_32'
        },
        lzf_max_64: {
            aliases: ['lzf_max_64', 'Octave LZFmax-64Hz'],
            name: 'lzf_max_64'
        },
        lzf_max_125: {
            aliases: ['lzf_max_125', 'Octave LZFmax-125Hz'],
            name: 'lzf_max_125'
        },
        lzf_max_250: {
            aliases: ['lzf_max_250', 'Octave LZFmax-250Hz'],
            name: 'lzf_max_250'
        },
        lzf_max_500: {
            aliases: ['lzf_max_500', 'Octave LZFmax-500Hz'],
            name: 'lzf_max_500'
        },
        lzf_max_1K: {
            aliases: ['lzf_max_1K', 'Octave LZFmax-1KHz'],
            name: 'lzf_max_1K'
        },
        lzf_max_2K: {
            aliases: ['lzf_max_2K', 'Octave LZFmax-2KHz'],
            name: 'lzf_max_2K'
        },
        lzf_max_4K: {
            aliases: ['lzf_max_4K', 'Octave LZFmax-4KHz'],
            name: 'lzf_max_4K'
        },
        lzf_max_8K: {
            aliases: ['lzf_max_8K', 'Octave LZFmax-8KHz'],
            name: 'lzf_max_8K'
        },
        lzf_max_16K: {
            aliases: ['lzf_max_16K', 'Octave LZFmax-16KHz'],
            name: 'lzf_max_16K'
        },
        lzs_max_16: {
            aliases: ['lzs_max_16', 'Octave LZSmax-16Hz'],
            name: 'lzs_max_16'
        },
        lzs_max_32: {
            aliases: ['lzs_max_32', 'Octave LZSmax-31.5Hz'],
            name: 'lzs_max_32'
        },
        lzs_max_64: {
            aliases: ['lzs_max_64', 'Octave LZSmax-64Hz'],
            name: 'lzs_max_64'
        },
        lzs_max_125: {
            aliases: ['lzs_max_125', 'Octave LZSmax-125Hz'],
            name: 'lzs_max_125'
        },
        lzs_max_250: {
            aliases: ['lzs_max_250', 'Octave LZSmax-250Hz'],
            name: 'lzs_max_250'
        },
        lzs_max_500: {
            aliases: ['lzs_max_500', 'Octave LZSmax-500Hz'],
            name: 'lzs_max_500'
        },
        lzs_max_1K: {
            aliases: ['lzs_max_1K', 'Octave LZSmax-1KHz'],
            name: 'lzs_max_1K'
        },
        lzs_max_2K: {
            aliases: ['lzs_max_2K', 'Octave LZSmax-2KHz'],
            name: 'lzs_max_2K'
        },
        lzs_max_4K: {
            aliases: ['lzs_max_4K', 'Octave LZSmax-4KHz'],
            name: 'lzs_max_4K'
        },
        lzs_max_8K: {
            aliases: ['lzs_max_8K', 'Octave LZSmax-8KHz'],
            name: 'lzs_max_8K'
        },
        lzs_max_16K: {
            aliases: ['lzs_max_16K', 'Octave LZSmax-16KHz'],
            name: 'lzs_max_16K'
        },
        lzeq_16: {
            aliases: ['lzeq_16', 'Octave LZeq-16Hz'],
            name: 'lzeq_16'
        },
        lzeq_32: {
            aliases: ['lzeq_32', 'Octave LZeq-31.5Hz'],
            name: 'lzeq_32'
        },
        lzeq_64: {
            aliases: ['lzeq_64', 'Octave LZeq-64Hz'],
            name: 'lzeq_64'
        },
        lzeq_125: {
            aliases: ['lzeq_125', 'Octave LZeq-125Hz'],
            name: 'lzeq_125'
        },
        lzeq_250: {
            aliases: ['lzeq_250', 'Octave LZeq-250Hz'],
            name: 'lzeq_250'
        },
        lzeq_500: {
            aliases: ['lzeq_500', 'Octave LZeq-500Hz'],
            name: 'lzeq_500'
        },
        lzeq_1K: {
            aliases: ['lzeq_1K', 'Octave LZeq-1KHz'],
            name: 'lzeq_1K'
        },
        lzeq_2K: {
            aliases: ['lzeq_2K', 'Octave LZeq-2KHz'],
            name: 'lzeq_2K'
        },
        lzeq_4K: {
            aliases: ['lzeq_4K', 'Octave LZeq-4KHz'],
            name: 'lzeq_4K'
        },
        lzeq_8K: {
            aliases: ['lzeq_8K', 'Octave LZeq-8KHz'],
            name: 'lzeq_8K'
        },
        lzeq_16K: {
            aliases: ['lzeq_16K', 'Octave LZeq-16KHz'],
            name: 'lzeq_16K'
        },
        lzs: {
            aliases: ['lzs', 'LZS'],
            name: 'lzs'
        },
        lzf: {
            aliases: ['lzf', 'LZF'],
            name: 'lzf'
        },
        lzi: {
            aliases: ['lzi', 'LZI'],
            name: 'lzi'
        },
        lcs: {
            aliases: ['lcs', 'LCS'],
            name: 'lcs'
        },
        lcf: {
            aliases: ['lcf', 'LCF'],
            name: 'lcf'
        },
        lci: {
            aliases: ['lci', 'LCI'],
            name: 'lci'
        },
        las: {
            aliases: ['las', 'LAS'],
            name: 'las'
        },
        laf: {
            aliases: ['laf', 'LAF'],
            name: 'laf'
        },
        lai: {
            aliases: ['lai', 'LAI'],
            name: 'lai'
        },
        laieq: {
            aliases: ['laieq', 'LAIEQ'],
            name: 'laieq'
        },
        lae: {
            aliases: ['lae', 'LAE'],
            name: 'lae'
        },
        laeq_t80: {
            aliases: ['laeq_t80', 'LAEQT80'],
            name: 'laeq_t80'
        },
        laft_m3: {
            aliases: ['laft_m3', 'LAFTm3'],
            name: 'laft_m3'
        },
        laft_m5: {
            aliases: ['laft_m5', 'LAFTm5'],
            name: 'laft_m5'
        },
        lait_m3: {
            aliases: ['lait_m3', 'LAITm3'],
            name: 'lait_m3'
        },
        lait_m5: {
            aliases: ['lait_m5', 'LAITm5'],
            name: 'lait_m5'
        },
        lavg_1_t1nn_q1n: {
            aliases: ['lavg_1_t1nn_q1n'],
            name: 'lavg_1_t1nn_q1n'
        },
        lavg_2_t2nn_q2n: {
            aliases: ['lavg_2_t2nn_q2n'],
            name: 'lavg_2_t2nn_q2n'
        },
        lceq_laeq: {
            aliases: ['lceq_laeq', 'LCEQ - LAEQ'],
            name: 'lceq_laeq'
        },
        lex_8hr: {
            aliases: ['lex_8hr', 'LEX, 8Hr'],
            name: 'lex_8hr'
        },
        lep_d: {
            aliases: ['lep_d', 'LEP,d'],
            name: 'lep_d'
        },
        proj_lex_8hr: {
            aliases: ['proj_lex_8hr', 'Proj. LEX, 8hr'],
            name: 'proj_lex_8hr'
        },
        proj_lep_d: {
            aliases: ['proj_lep_d', 'Proj. LEP,d'],
            name: 'proj_lep_d'
        },
        twa_8hr: {
            aliases: ['twa_8hr', 'TWA (8hr)'],
            name: 'twa_8hr'
        },
        proj_twa_8hr: {
            aliases: ['proj_twa_8hr', 'Projected TWA (8hr)'],
            name: 'proj_twa_8hr'
        },
        dose_percent: {
            aliases: ['dose_percent', 'Dose %'],
            name: 'dose_percent'
        },
        proj_dose_percent: {
            aliases: ['proj_dose_percent', 'Projected Dose %'],
            name: 'proj_dose_percent'
        }
    });
    var ParamMeasurementTypes = Object.freeze({
        lavg_1_t1nn_q1n: {
            aliases: ['LAVG 1 \\((T=\\d+, Q=\\d+)\\)'],
            name: 'lavg_1_t1nn_q1n',
        },
        lavg_2_t2nn_q2n: {
            aliases: ['LAVG 2 \\((T=\\d+, Q=\\d+)\\)'],
            name: 'lavg_2_t2nn_q2n'
        }
    });

    function setPrecision(value, numDecimals) {
        var isNegative = (value < 0);
        var multiplier = Math.pow(10, numDecimals);
        var result = Math.round(Math.abs(value) * multiplier) / multiplier;
        if (numDecimals <= 0) {
            result = Math.round(result);
        }
        if (isNegative && result !== 0) {
            result = -result;
        }
        return result;
    }

    var Temperature;
    (function (Temperature) {
        var F_MOD = 1.8;
        var K_MOD = 273.15;
        var THIRTY_TWO = 32.0;
        var CtoF = (function () {
            function CtoF() {
            }
            CtoF.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_C;
            };
            CtoF.getTo = function () {
                return UnitOfMeasure$1.DEGREES_F;
            };
            CtoF.convert = function (value, precision) {
                var exactVal = (value * F_MOD) + THIRTY_TWO;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            CtoF.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return CtoF;
        }());
        Temperature.CtoF = CtoF;
        var CtoK = (function () {
            function CtoK() {
            }
            CtoK.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_C;
            };
            CtoK.getTo = function () {
                return UnitOfMeasure$1.DEGREES_K;
            };
            CtoK.convert = function (value, precision) {
                var exactVal = value + K_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            CtoK.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return CtoK;
        }());
        Temperature.CtoK = CtoK;
        var FtoC = (function () {
            function FtoC() {
            }
            FtoC.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_F;
            };
            FtoC.getTo = function () {
                return UnitOfMeasure$1.DEGREES_C;
            };
            FtoC.convert = function (value, precision) {
                var exactVal = (value - THIRTY_TWO) / F_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            FtoC.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return FtoC;
        }());
        Temperature.FtoC = FtoC;
        var FtoK = (function () {
            function FtoK() {
            }
            FtoK.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_F;
            };
            FtoK.getTo = function () {
                return UnitOfMeasure$1.DEGREES_K;
            };
            FtoK.convert = function (value, precision) {
                var exactVal = ((value - THIRTY_TWO) / F_MOD) + K_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    var final = setPrecision(exactVal, precision);
                    return final;
                }
            };
            FtoK.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return FtoK;
        }());
        Temperature.FtoK = FtoK;
        var KtoF = (function () {
            function KtoF() {
            }
            KtoF.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_K;
            };
            KtoF.getTo = function () {
                return UnitOfMeasure$1.DEGREES_F;
            };
            KtoF.convert = function (value, precision) {
                var exactVal = ((value - K_MOD) * F_MOD) + THIRTY_TWO;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            KtoF.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return KtoF;
        }());
        Temperature.KtoF = KtoF;
        var KtoC = (function () {
            function KtoC() {
            }
            KtoC.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_K;
            };
            KtoC.getTo = function () {
                return UnitOfMeasure$1.DEGREES_C;
            };
            KtoC.convert = function (value, precision) {
                var exactVal = value - K_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            KtoC.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return KtoC;
        }());
        Temperature.KtoC = KtoC;
    })(Temperature || (Temperature = {}));

    var Pressure;
    (function (Pressure) {
        var kPa_to_hPa = 10;
        var kPa_to_P = 1000;
        var kPa_to_mBar = 10;
        var kPa_to_cmH2O = 10.1974428892;
        var kPa_to_inH2O = 4.01865;
        var kPa_to_mmHg = 7.5006375541921;
        var kPa_to_cmHg = 0.75006375541921;
        var kPa_to_inHg = 0.2952998751;
        var kPa_to_PSI = 0.14503773773022;
        var hPa_to_kPa = 0.1;
        var hPa_to_P = 100;
        var hPa_to_mBar = 1;
        var hPa_to_cmH2O = 1.01974428892;
        var hPa_to_inH2O = 0.401865;
        var hPa_to_mmHg = 0.75006375541921;
        var hPa_to_cmHg = 0.075006375541921;
        var hPa_to_inHg = 0.02952998751;
        var hPa_to_PSI = 0.014503773773022;
        var P_to_kPa = 0.001;
        var P_to_hPa = 0.01;
        var P_to_mBar = 0.01;
        var P_to_cmH2O = 0.0101974428892;
        var P_to_inH2O = 0.00401865;
        var P_to_mmHg = 0.0075006375541921;
        var P_to_cmHg = 0.00075006375541921;
        var P_to_inHg = 0.0002952998751;
        var P_to_PSI = 0.00014503773773022;
        var mBar_to_kPa = 0.1;
        var mBar_to_hPa = 1;
        var mBar_to_P = 100;
        var mBar_to_cmH2O = 1.01974428892;
        var mBar_to_inH2O = 0.401865;
        var mBar_to_mmHg = 0.75006375541921;
        var mBar_to_cmHg = 0.075006375541921;
        var mBar_to_inHg = 0.02952998751;
        var mBar_to_PSI = 0.014503773773022;
        var cmH2O_to_kPa = 0.09806613580198487;
        var cmH2O_to_hPa = 0.9806613580198486;
        var cmH2O_to_P = 98.06613580198486;
        var cmH2O_to_mBar = 0.9806613580198486;
        var cmH2O_to_inH2O = 0.3940934766406464;
        var cmH2O_to_mmHg = 0.73555854099087;
        var cmH2O_to_cmHg = 0.073553888590369;
        var cmH2O_to_inHg = 0.028958220688763;
        var cmH2O_to_PSI = 0.014223290484664416;
        var inH2O_to_kPa = 0.249088875;
        var inH2O_to_hPa = 2.49088875;
        var inH2O_to_P = 249.088875;
        var inH2O_to_mBar = 2.49088875;
        var inH2O_to_cmH2O = 2.53746;
        var inH2O_to_mmHg = 1.86645;
        var inH2O_to_cmHg = 0.186645;
        var inH2O_to_inHg = 0.0735559124636824;
        var inH2O_to_PSI = 0.0360912;
        var mmHg_to_kPa = 0.133322;
        var mmHg_to_hPa = 1.33322;
        var mmHg_to_P = 133.322;
        var mmHg_to_mBar = 1.33322;
        var mmHg_to_cmH2O = 1.35951;
        var mmHg_to_inH2O = 0.535776474055024;
        var mmHg_to_cmHg = 0.1;
        var mmHg_to_inHg = 0.0393700791974456;
        var mmHg_to_PSI = 0.0193368;
        var cmHg_to_kPa = 1.33322;
        var cmHg_to_hPa = 13.3322;
        var cmHg_to_P = 1333.22;
        var cmHg_to_mBar = 13.3322;
        var cmHg_to_cmH2O = 13.5951;
        var cmHg_to_inH2O = 5.35776474055024;
        var cmHg_to_mmHg = 10;
        var cmHg_to_inHg = 0.393700791974456;
        var cmHg_to_PSI = 0.193368;
        var inHg_to_kPa = 3.3863886666667;
        var inHg_to_hPa = 33.863886666667;
        var inHg_to_P = 3386.3886666667;
        var inHg_to_mBar = 33.863886666667;
        var inHg_to_cmH2O = 34.531554268447;
        var inHg_to_inH2O = 13.595100196653;
        var inHg_to_mmHg = 25.399999704976;
        var inHg_to_cmHg = 2.5399999704976;
        var inHg_to_PSI = 0.49115415222661;
        var PSI_to_kPa = 6.89476;
        var PSI_to_hPa = 68.9476;
        var PSI_to_P = 6894.76;
        var PSI_to_mBar = 68.9476;
        var PSI_to_cmH2O = 70.3072190698913;
        var PSI_to_inH2O = 27.7075852285322;
        var PSI_to_mmHg = 51.7148649207728;
        var PSI_to_cmHg = 5.17148649207728;
        var PSI_to_inHg = 2.03602065760124;
        var kPaTohPa = (function () {
            function kPaTohPa() {
            }
            kPaTohPa.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            kPaTohPa.convert = function (value, precision) {
                var exactVal = value * kPa_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTohPa;
        }());
        Pressure.kPaTohPa = kPaTohPa;
        var kPaToP = (function () {
            function kPaToP() {
            }
            kPaToP.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            kPaToP.convert = function (value, precision) {
                var exactVal = value * kPa_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaToP;
        }());
        Pressure.kPaToP = kPaToP;
        var kPaTomBar = (function () {
            function kPaTomBar() {
            }
            kPaTomBar.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            kPaTomBar.convert = function (value, precision) {
                var exactVal = value * kPa_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTomBar;
        }());
        Pressure.kPaTomBar = kPaTomBar;
        var kPaTocmH20 = (function () {
            function kPaTocmH20() {
            }
            kPaTocmH20.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            kPaTocmH20.convert = function (value, precision) {
                var exactVal = value * kPa_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTocmH20;
        }());
        Pressure.kPaTocmH20 = kPaTocmH20;
        var kPaToinH20 = (function () {
            function kPaToinH20() {
            }
            kPaToinH20.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            kPaToinH20.convert = function (value, precision) {
                var exactVal = value * kPa_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaToinH20;
        }());
        Pressure.kPaToinH20 = kPaToinH20;
        var kPaTommHg = (function () {
            function kPaTommHg() {
            }
            kPaTommHg.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            kPaTommHg.convert = function (value, precision) {
                var exactVal = value * kPa_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTommHg;
        }());
        Pressure.kPaTommHg = kPaTommHg;
        var kPaTocmHg = (function () {
            function kPaTocmHg() {
            }
            kPaTocmHg.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            kPaTocmHg.convert = function (value, precision) {
                var exactVal = value * kPa_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTocmHg;
        }());
        Pressure.kPaTocmHg = kPaTocmHg;
        var kPaToinHg = (function () {
            function kPaToinHg() {
            }
            kPaToinHg.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            kPaToinHg.convert = function (value, precision) {
                var exactVal = value * kPa_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaToinHg;
        }());
        Pressure.kPaToinHg = kPaToinHg;
        var kPaToPSI = (function () {
            function kPaToPSI() {
            }
            kPaToPSI.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            kPaToPSI.convert = function (value, precision) {
                var exactVal = value * kPa_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaToPSI;
        }());
        Pressure.kPaToPSI = kPaToPSI;
        var hPaTokPa = (function () {
            function hPaTokPa() {
            }
            hPaTokPa.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            hPaTokPa.convert = function (value, precision) {
                var exactVal = value * hPa_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTokPa;
        }());
        Pressure.hPaTokPa = hPaTokPa;
        var hPaToP = (function () {
            function hPaToP() {
            }
            hPaToP.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            hPaToP.convert = function (value, precision) {
                var exactVal = value * hPa_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaToP;
        }());
        Pressure.hPaToP = hPaToP;
        var hPaTomBar = (function () {
            function hPaTomBar() {
            }
            hPaTomBar.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            hPaTomBar.convert = function (value, precision) {
                var exactVal = value * hPa_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTomBar;
        }());
        Pressure.hPaTomBar = hPaTomBar;
        var hPaTocmH20 = (function () {
            function hPaTocmH20() {
            }
            hPaTocmH20.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            hPaTocmH20.convert = function (value, precision) {
                var exactVal = value * hPa_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTocmH20;
        }());
        Pressure.hPaTocmH20 = hPaTocmH20;
        var hPaToinH20 = (function () {
            function hPaToinH20() {
            }
            hPaToinH20.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            hPaToinH20.convert = function (value, precision) {
                var exactVal = value * hPa_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaToinH20;
        }());
        Pressure.hPaToinH20 = hPaToinH20;
        var hPaTommHg = (function () {
            function hPaTommHg() {
            }
            hPaTommHg.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            hPaTommHg.convert = function (value, precision) {
                var exactVal = value * hPa_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTommHg;
        }());
        Pressure.hPaTommHg = hPaTommHg;
        var hPaTocmHg = (function () {
            function hPaTocmHg() {
            }
            hPaTocmHg.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            hPaTocmHg.convert = function (value, precision) {
                var exactVal = value * hPa_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTocmHg;
        }());
        Pressure.hPaTocmHg = hPaTocmHg;
        var hPaToinHg = (function () {
            function hPaToinHg() {
            }
            hPaToinHg.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            hPaToinHg.convert = function (value, precision) {
                var exactVal = value * hPa_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaToinHg;
        }());
        Pressure.hPaToinHg = hPaToinHg;
        var hPaToPSI = (function () {
            function hPaToPSI() {
            }
            hPaToPSI.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            hPaToPSI.convert = function (value, precision) {
                var exactVal = value * hPa_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaToPSI;
        }());
        Pressure.hPaToPSI = hPaToPSI;
        var PTokPa = (function () {
            function PTokPa() {
            }
            PTokPa.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            PTokPa.convert = function (value, precision) {
                var exactVal = value * P_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTokPa;
        }());
        Pressure.PTokPa = PTokPa;
        var PTohPa = (function () {
            function PTohPa() {
            }
            PTohPa.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            PTohPa.convert = function (value, precision) {
                var exactVal = value * P_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTohPa;
        }());
        Pressure.PTohPa = PTohPa;
        var PTomBar = (function () {
            function PTomBar() {
            }
            PTomBar.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            PTomBar.convert = function (value, precision) {
                var exactVal = value * P_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTomBar;
        }());
        Pressure.PTomBar = PTomBar;
        var PTocmH20 = (function () {
            function PTocmH20() {
            }
            PTocmH20.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            PTocmH20.convert = function (value, precision) {
                var exactVal = value * P_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTocmH20;
        }());
        Pressure.PTocmH20 = PTocmH20;
        var PToinH20 = (function () {
            function PToinH20() {
            }
            PToinH20.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            PToinH20.convert = function (value, precision) {
                var exactVal = value * P_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PToinH20;
        }());
        Pressure.PToinH20 = PToinH20;
        var PTommHg = (function () {
            function PTommHg() {
            }
            PTommHg.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            PTommHg.convert = function (value, precision) {
                var exactVal = value * P_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTommHg;
        }());
        Pressure.PTommHg = PTommHg;
        var PTocmHg = (function () {
            function PTocmHg() {
            }
            PTocmHg.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            PTocmHg.convert = function (value, precision) {
                var exactVal = value * P_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTocmHg;
        }());
        Pressure.PTocmHg = PTocmHg;
        var PToinHg = (function () {
            function PToinHg() {
            }
            PToinHg.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            PToinHg.convert = function (value, precision) {
                var exactVal = value * P_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PToinHg;
        }());
        Pressure.PToinHg = PToinHg;
        var PToPSI = (function () {
            function PToPSI() {
            }
            PToPSI.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PToPSI.convert = function (value, precision) {
                var exactVal = value * P_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PToPSI;
        }());
        Pressure.PToPSI = PToPSI;
        var mBarTokPa = (function () {
            function mBarTokPa() {
            }
            mBarTokPa.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            mBarTokPa.convert = function (value, precision) {
                var exactVal = value * mBar_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTokPa;
        }());
        Pressure.mBarTokPa = mBarTokPa;
        var mBarTohPa = (function () {
            function mBarTohPa() {
            }
            mBarTohPa.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            mBarTohPa.convert = function (value, precision) {
                var exactVal = value * mBar_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTohPa;
        }());
        Pressure.mBarTohPa = mBarTohPa;
        var mBarToP = (function () {
            function mBarToP() {
            }
            mBarToP.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            mBarToP.convert = function (value, precision) {
                var exactVal = value * mBar_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarToP;
        }());
        Pressure.mBarToP = mBarToP;
        var mBarTocmH20 = (function () {
            function mBarTocmH20() {
            }
            mBarTocmH20.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            mBarTocmH20.convert = function (value, precision) {
                var exactVal = value * mBar_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTocmH20;
        }());
        Pressure.mBarTocmH20 = mBarTocmH20;
        var mBarToinH20 = (function () {
            function mBarToinH20() {
            }
            mBarToinH20.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            mBarToinH20.convert = function (value, precision) {
                var exactVal = value * mBar_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarToinH20;
        }());
        Pressure.mBarToinH20 = mBarToinH20;
        var mBarTommHg = (function () {
            function mBarTommHg() {
            }
            mBarTommHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mBarTommHg.convert = function (value, precision) {
                var exactVal = value * mBar_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTommHg;
        }());
        Pressure.mBarTommHg = mBarTommHg;
        var mBarTocmHg = (function () {
            function mBarTocmHg() {
            }
            mBarTocmHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            mBarTocmHg.convert = function (value, precision) {
                var exactVal = value * mBar_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTocmHg;
        }());
        Pressure.mBarTocmHg = mBarTocmHg;
        var mBarToinHg = (function () {
            function mBarToinHg() {
            }
            mBarToinHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            mBarToinHg.convert = function (value, precision) {
                var exactVal = value * mBar_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarToinHg;
        }());
        Pressure.mBarToinHg = mBarToinHg;
        var mBarToPSI = (function () {
            function mBarToPSI() {
            }
            mBarToPSI.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            mBarToPSI.convert = function (value, precision) {
                var exactVal = value * mBar_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarToPSI;
        }());
        Pressure.mBarToPSI = mBarToPSI;
        var cmH20TokPa = (function () {
            function cmH20TokPa() {
            }
            cmH20TokPa.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            cmH20TokPa.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TokPa;
        }());
        Pressure.cmH20TokPa = cmH20TokPa;
        var cmH20TohPa = (function () {
            function cmH20TohPa() {
            }
            cmH20TohPa.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            cmH20TohPa.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TohPa;
        }());
        Pressure.cmH20TohPa = cmH20TohPa;
        var cmH20ToP = (function () {
            function cmH20ToP() {
            }
            cmH20ToP.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20ToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            cmH20ToP.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20ToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20ToP;
        }());
        Pressure.cmH20ToP = cmH20ToP;
        var cmH20TomBar = (function () {
            function cmH20TomBar() {
            }
            cmH20TomBar.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            cmH20TomBar.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TomBar;
        }());
        Pressure.cmH20TomBar = cmH20TomBar;
        var cmH20ToinH20 = (function () {
            function cmH20ToinH20() {
            }
            cmH20ToinH20.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20ToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            cmH20ToinH20.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20ToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20ToinH20;
        }());
        Pressure.cmH20ToinH20 = cmH20ToinH20;
        var cmH20TommHg = (function () {
            function cmH20TommHg() {
            }
            cmH20TommHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            cmH20TommHg.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TommHg;
        }());
        Pressure.cmH20TommHg = cmH20TommHg;
        var cmH20TocmHg = (function () {
            function cmH20TocmHg() {
            }
            cmH20TocmHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmH20TocmHg.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TocmHg;
        }());
        Pressure.cmH20TocmHg = cmH20TocmHg;
        var cmH20ToinHg = (function () {
            function cmH20ToinHg() {
            }
            cmH20ToinHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20ToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            cmH20ToinHg.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20ToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20ToinHg;
        }());
        Pressure.cmH20ToinHg = cmH20ToinHg;
        var cmH20ToPSI = (function () {
            function cmH20ToPSI() {
            }
            cmH20ToPSI.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20ToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            cmH20ToPSI.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20ToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20ToPSI;
        }());
        Pressure.cmH20ToPSI = cmH20ToPSI;
        var inH20TokPa = (function () {
            function inH20TokPa() {
            }
            inH20TokPa.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            inH20TokPa.convert = function (value, precision) {
                var exactVal = value * inH2O_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TokPa;
        }());
        Pressure.inH20TokPa = inH20TokPa;
        var inH20TohPa = (function () {
            function inH20TohPa() {
            }
            inH20TohPa.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            inH20TohPa.convert = function (value, precision) {
                var exactVal = value * inH2O_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TohPa;
        }());
        Pressure.inH20TohPa = inH20TohPa;
        var inH20ToP = (function () {
            function inH20ToP() {
            }
            inH20ToP.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20ToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            inH20ToP.convert = function (value, precision) {
                var exactVal = value * inH2O_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20ToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20ToP;
        }());
        Pressure.inH20ToP = inH20ToP;
        var inH20TomBar = (function () {
            function inH20TomBar() {
            }
            inH20TomBar.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            inH20TomBar.convert = function (value, precision) {
                var exactVal = value * inH2O_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TomBar;
        }());
        Pressure.inH20TomBar = inH20TomBar;
        var inH20TocmH20 = (function () {
            function inH20TocmH20() {
            }
            inH20TocmH20.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            inH20TocmH20.convert = function (value, precision) {
                var exactVal = value * inH2O_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TocmH20;
        }());
        Pressure.inH20TocmH20 = inH20TocmH20;
        var inH20TommHg = (function () {
            function inH20TommHg() {
            }
            inH20TommHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            inH20TommHg.convert = function (value, precision) {
                var exactVal = value * inH2O_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TommHg;
        }());
        Pressure.inH20TommHg = inH20TommHg;
        var inH20TocmHg = (function () {
            function inH20TocmHg() {
            }
            inH20TocmHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            inH20TocmHg.convert = function (value, precision) {
                var exactVal = value * inH2O_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TocmHg;
        }());
        Pressure.inH20TocmHg = inH20TocmHg;
        var inH20ToinHg = (function () {
            function inH20ToinHg() {
            }
            inH20ToinHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20ToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inH20ToinHg.convert = function (value, precision) {
                var exactVal = value * inH2O_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20ToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20ToinHg;
        }());
        Pressure.inH20ToinHg = inH20ToinHg;
        var inH20ToPSI = (function () {
            function inH20ToPSI() {
            }
            inH20ToPSI.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20ToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            inH20ToPSI.convert = function (value, precision) {
                var exactVal = value * inH2O_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20ToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20ToPSI;
        }());
        Pressure.inH20ToPSI = inH20ToPSI;
        var mmHgTokPa = (function () {
            function mmHgTokPa() {
            }
            mmHgTokPa.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            mmHgTokPa.convert = function (value, precision) {
                var exactVal = value * mmHg_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTokPa;
        }());
        Pressure.mmHgTokPa = mmHgTokPa;
        var mmHgTohPa = (function () {
            function mmHgTohPa() {
            }
            mmHgTohPa.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            mmHgTohPa.convert = function (value, precision) {
                var exactVal = value * mmHg_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTohPa;
        }());
        Pressure.mmHgTohPa = mmHgTohPa;
        var mmHgToP = (function () {
            function mmHgToP() {
            }
            mmHgToP.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            mmHgToP.convert = function (value, precision) {
                var exactVal = value * mmHg_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgToP;
        }());
        Pressure.mmHgToP = mmHgToP;
        var mmHgTomBar = (function () {
            function mmHgTomBar() {
            }
            mmHgTomBar.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mmHgTomBar.convert = function (value, precision) {
                var exactVal = value * mmHg_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTomBar;
        }());
        Pressure.mmHgTomBar = mmHgTomBar;
        var mmHgTocmH20 = (function () {
            function mmHgTocmH20() {
            }
            mmHgTocmH20.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            mmHgTocmH20.convert = function (value, precision) {
                var exactVal = value * mmHg_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTocmH20;
        }());
        Pressure.mmHgTocmH20 = mmHgTocmH20;
        var mmHgToinH20 = (function () {
            function mmHgToinH20() {
            }
            mmHgToinH20.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            mmHgToinH20.convert = function (value, precision) {
                var exactVal = value * mmHg_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgToinH20;
        }());
        Pressure.mmHgToinH20 = mmHgToinH20;
        var mmHgTocmHg = (function () {
            function mmHgTocmHg() {
            }
            mmHgTocmHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            mmHgTocmHg.convert = function (value, precision) {
                var exactVal = value * mmHg_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTocmHg;
        }());
        Pressure.mmHgTocmHg = mmHgTocmHg;
        var mmHgToinHg = (function () {
            function mmHgToinHg() {
            }
            mmHgToinHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            mmHgToinHg.convert = function (value, precision) {
                var exactVal = value * mmHg_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgToinHg;
        }());
        Pressure.mmHgToinHg = mmHgToinHg;
        var mmHgToPSI = (function () {
            function mmHgToPSI() {
            }
            mmHgToPSI.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            mmHgToPSI.convert = function (value, precision) {
                var exactVal = value * mmHg_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgToPSI;
        }());
        Pressure.mmHgToPSI = mmHgToPSI;
        var cmHgTokPa = (function () {
            function cmHgTokPa() {
            }
            cmHgTokPa.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            cmHgTokPa.convert = function (value, precision) {
                var exactVal = value * cmHg_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTokPa;
        }());
        Pressure.cmHgTokPa = cmHgTokPa;
        var cmHgTohPa = (function () {
            function cmHgTohPa() {
            }
            cmHgTohPa.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            cmHgTohPa.convert = function (value, precision) {
                var exactVal = value * cmHg_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTohPa;
        }());
        Pressure.cmHgTohPa = cmHgTohPa;
        var cmHgToP = (function () {
            function cmHgToP() {
            }
            cmHgToP.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            cmHgToP.convert = function (value, precision) {
                var exactVal = value * cmHg_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgToP;
        }());
        Pressure.cmHgToP = cmHgToP;
        var cmHgTomBar = (function () {
            function cmHgTomBar() {
            }
            cmHgTomBar.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            cmHgTomBar.convert = function (value, precision) {
                var exactVal = value * cmHg_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTomBar;
        }());
        Pressure.cmHgTomBar = cmHgTomBar;
        var cmHgTocmH20 = (function () {
            function cmHgTocmH20() {
            }
            cmHgTocmH20.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmHgTocmH20.convert = function (value, precision) {
                var exactVal = value * cmHg_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTocmH20;
        }());
        Pressure.cmHgTocmH20 = cmHgTocmH20;
        var cmHgToinH20 = (function () {
            function cmHgToinH20() {
            }
            cmHgToinH20.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            cmHgToinH20.convert = function (value, precision) {
                var exactVal = value * cmHg_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgToinH20;
        }());
        Pressure.cmHgToinH20 = cmHgToinH20;
        var cmHgTommHg = (function () {
            function cmHgTommHg() {
            }
            cmHgTommHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            cmHgTommHg.convert = function (value, precision) {
                var exactVal = value * cmHg_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTommHg;
        }());
        Pressure.cmHgTommHg = cmHgTommHg;
        var cmHgToinHg = (function () {
            function cmHgToinHg() {
            }
            cmHgToinHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            cmHgToinHg.convert = function (value, precision) {
                var exactVal = value * cmHg_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgToinHg;
        }());
        Pressure.cmHgToinHg = cmHgToinHg;
        var cmHgToPSI = (function () {
            function cmHgToPSI() {
            }
            cmHgToPSI.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            cmHgToPSI.convert = function (value, precision) {
                var exactVal = value * cmHg_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgToPSI;
        }());
        Pressure.cmHgToPSI = cmHgToPSI;
        var inHgTokPa = (function () {
            function inHgTokPa() {
            }
            inHgTokPa.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            inHgTokPa.convert = function (value, precision) {
                var exactVal = value * inHg_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTokPa;
        }());
        Pressure.inHgTokPa = inHgTokPa;
        var inHgTohPa = (function () {
            function inHgTohPa() {
            }
            inHgTohPa.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            inHgTohPa.convert = function (value, precision) {
                var exactVal = value * inHg_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTohPa;
        }());
        Pressure.inHgTohPa = inHgTohPa;
        var inHgToP = (function () {
            function inHgToP() {
            }
            inHgToP.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            inHgToP.convert = function (value, precision) {
                var exactVal = value * inHg_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgToP;
        }());
        Pressure.inHgToP = inHgToP;
        var inHgTomBar = (function () {
            function inHgTomBar() {
            }
            inHgTomBar.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            inHgTomBar.convert = function (value, precision) {
                var exactVal = value * inHg_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTomBar;
        }());
        Pressure.inHgTomBar = inHgTomBar;
        var inHgTocmH20 = (function () {
            function inHgTocmH20() {
            }
            inHgTocmH20.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            inHgTocmH20.convert = function (value, precision) {
                var exactVal = value * inHg_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTocmH20;
        }());
        Pressure.inHgTocmH20 = inHgTocmH20;
        var inHgToinH20 = (function () {
            function inHgToinH20() {
            }
            inHgToinH20.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inHgToinH20.convert = function (value, precision) {
                var exactVal = value * inHg_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgToinH20;
        }());
        Pressure.inHgToinH20 = inHgToinH20;
        var inHgTommHg = (function () {
            function inHgTommHg() {
            }
            inHgTommHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            inHgTommHg.convert = function (value, precision) {
                var exactVal = value * inHg_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTommHg;
        }());
        Pressure.inHgTommHg = inHgTommHg;
        var inHgTocmHg = (function () {
            function inHgTocmHg() {
            }
            inHgTocmHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            inHgTocmHg.convert = function (value, precision) {
                var exactVal = value * inHg_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTocmHg;
        }());
        Pressure.inHgTocmHg = inHgTocmHg;
        var inHgToPSI = (function () {
            function inHgToPSI() {
            }
            inHgToPSI.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            inHgToPSI.convert = function (value, precision) {
                var exactVal = value * inHg_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgToPSI;
        }());
        Pressure.inHgToPSI = inHgToPSI;
        var PSITokPa = (function () {
            function PSITokPa() {
            }
            PSITokPa.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            PSITokPa.convert = function (value, precision) {
                var exactVal = value * PSI_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITokPa;
        }());
        Pressure.PSITokPa = PSITokPa;
        var PSITohPa = (function () {
            function PSITohPa() {
            }
            PSITohPa.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            PSITohPa.convert = function (value, precision) {
                var exactVal = value * PSI_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITohPa;
        }());
        Pressure.PSITohPa = PSITohPa;
        var PSIToP = (function () {
            function PSIToP() {
            }
            PSIToP.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSIToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PSIToP.convert = function (value, precision) {
                var exactVal = value * PSI_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSIToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSIToP;
        }());
        Pressure.PSIToP = PSIToP;
        var PSITomBar = (function () {
            function PSITomBar() {
            }
            PSITomBar.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            PSITomBar.convert = function (value, precision) {
                var exactVal = value * PSI_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITomBar;
        }());
        Pressure.PSITomBar = PSITomBar;
        var PSITocmH20 = (function () {
            function PSITocmH20() {
            }
            PSITocmH20.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            PSITocmH20.convert = function (value, precision) {
                var exactVal = value * PSI_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITocmH20;
        }());
        Pressure.PSITocmH20 = PSITocmH20;
        var PSIToinH20 = (function () {
            function PSIToinH20() {
            }
            PSIToinH20.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSIToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            PSIToinH20.convert = function (value, precision) {
                var exactVal = value * PSI_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSIToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSIToinH20;
        }());
        Pressure.PSIToinH20 = PSIToinH20;
        var PSITommHg = (function () {
            function PSITommHg() {
            }
            PSITommHg.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            PSITommHg.convert = function (value, precision) {
                var exactVal = value * PSI_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITommHg;
        }());
        Pressure.PSITommHg = PSITommHg;
        var PSITocmHg = (function () {
            function PSITocmHg() {
            }
            PSITocmHg.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            PSITocmHg.convert = function (value, precision) {
                var exactVal = value * PSI_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITocmHg;
        }());
        Pressure.PSITocmHg = PSITocmHg;
        var PSIToinHg = (function () {
            function PSIToinHg() {
            }
            PSIToinHg.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSIToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            PSIToinHg.convert = function (value, precision) {
                var exactVal = value * PSI_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSIToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSIToinHg;
        }());
        Pressure.PSIToinHg = PSIToinHg;
    })(Pressure || (Pressure = {}));

    var ParticleConcentration;
    (function (ParticleConcentration) {
        var L_MOD = 1000;
        var DECIL_MOD = 100;
        var M3_MOD = 1000000;
        var FT3_MOD = 28316.8465919997;
        var Cm3ToL = (function () {
            function Cm3ToL() {
            }
            Cm3ToL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Cm3ToL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            Cm3ToL.convert = function (value, precision) {
                var exactVal = value * L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Cm3ToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Cm3ToL;
        }());
        ParticleConcentration.Cm3ToL = Cm3ToL;
        var Cm3ToDeciL = (function () {
            function Cm3ToDeciL() {
            }
            Cm3ToDeciL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Cm3ToDeciL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            Cm3ToDeciL.convert = function (value, precision) {
                var exactVal = value * DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Cm3ToDeciL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Cm3ToDeciL;
        }());
        ParticleConcentration.Cm3ToDeciL = Cm3ToDeciL;
        var Cm3ToM3 = (function () {
            function Cm3ToM3() {
            }
            Cm3ToM3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Cm3ToM3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            Cm3ToM3.convert = function (value, precision) {
                var exactVal = value * M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Cm3ToM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Cm3ToM3;
        }());
        ParticleConcentration.Cm3ToM3 = Cm3ToM3;
        var Cm3ToFt3 = (function () {
            function Cm3ToFt3() {
            }
            Cm3ToFt3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Cm3ToFt3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Cm3ToFt3.convert = function (value, precision) {
                var exactVal = value * FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Cm3ToFt3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Cm3ToFt3;
        }());
        ParticleConcentration.Cm3ToFt3 = Cm3ToFt3;
        var LToCm3 = (function () {
            function LToCm3() {
            }
            LToCm3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            LToCm3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            LToCm3.convert = function (value, precision) {
                var exactVal = value / L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToCm3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToCm3;
        }());
        ParticleConcentration.LToCm3 = LToCm3;
        var LToDeciL = (function () {
            function LToDeciL() {
            }
            LToDeciL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            LToDeciL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            LToDeciL.convert = function (value, precision) {
                var exactVal = (value * DECIL_MOD) / L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToDeciL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToDeciL;
        }());
        ParticleConcentration.LToDeciL = LToDeciL;
        var LToM3 = (function () {
            function LToM3() {
            }
            LToM3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            LToM3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            LToM3.convert = function (value, precision) {
                var exactVal = (value * M3_MOD) / L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToM3;
        }());
        ParticleConcentration.LToM3 = LToM3;
        var LToFt3 = (function () {
            function LToFt3() {
            }
            LToFt3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            LToFt3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            LToFt3.convert = function (value, precision) {
                var exactVal = (value * FT3_MOD) / L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToFt3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToFt3;
        }());
        ParticleConcentration.LToFt3 = LToFt3;
        var DeciLToCm3 = (function () {
            function DeciLToCm3() {
            }
            DeciLToCm3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            DeciLToCm3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            DeciLToCm3.convert = function (value, precision) {
                var exactVal = value / DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            DeciLToCm3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return DeciLToCm3;
        }());
        ParticleConcentration.DeciLToCm3 = DeciLToCm3;
        var DeciLToL = (function () {
            function DeciLToL() {
            }
            DeciLToL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            DeciLToL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            DeciLToL.convert = function (value, precision) {
                var exactVal = (value * L_MOD) / DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            DeciLToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return DeciLToL;
        }());
        ParticleConcentration.DeciLToL = DeciLToL;
        var DeciLToM3 = (function () {
            function DeciLToM3() {
            }
            DeciLToM3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            DeciLToM3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            DeciLToM3.convert = function (value, precision) {
                var exactVal = (value * M3_MOD) / DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            DeciLToM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return DeciLToM3;
        }());
        ParticleConcentration.DeciLToM3 = DeciLToM3;
        var DeciLToFt3 = (function () {
            function DeciLToFt3() {
            }
            DeciLToFt3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            DeciLToFt3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            DeciLToFt3.convert = function (value, precision) {
                var exactVal = (value * FT3_MOD) / DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            DeciLToFt3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return DeciLToFt3;
        }());
        ParticleConcentration.DeciLToFt3 = DeciLToFt3;
        var M3ToCm3 = (function () {
            function M3ToCm3() {
            }
            M3ToCm3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            M3ToCm3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            M3ToCm3.convert = function (value, precision) {
                var exactVal = value / M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            M3ToCm3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return M3ToCm3;
        }());
        ParticleConcentration.M3ToCm3 = M3ToCm3;
        var M3ToL = (function () {
            function M3ToL() {
            }
            M3ToL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            M3ToL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            M3ToL.convert = function (value, precision) {
                var exactVal = (value * L_MOD) / M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            M3ToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return M3ToL;
        }());
        ParticleConcentration.M3ToL = M3ToL;
        var M3ToDeciL = (function () {
            function M3ToDeciL() {
            }
            M3ToDeciL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            M3ToDeciL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            M3ToDeciL.convert = function (value, precision) {
                var exactVal = (value * DECIL_MOD) / M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            M3ToDeciL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return M3ToDeciL;
        }());
        ParticleConcentration.M3ToDeciL = M3ToDeciL;
        var M3ToFt3 = (function () {
            function M3ToFt3() {
            }
            M3ToFt3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            M3ToFt3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            M3ToFt3.convert = function (value, precision) {
                var exactVal = (value * FT3_MOD) / M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            M3ToFt3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return M3ToFt3;
        }());
        ParticleConcentration.M3ToFt3 = M3ToFt3;
        var Ft3ToCm3 = (function () {
            function Ft3ToCm3() {
            }
            Ft3ToCm3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Ft3ToCm3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Ft3ToCm3.convert = function (value, precision) {
                var exactVal = value / FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Ft3ToCm3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Ft3ToCm3;
        }());
        ParticleConcentration.Ft3ToCm3 = Ft3ToCm3;
        var Ft3ToL = (function () {
            function Ft3ToL() {
            }
            Ft3ToL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Ft3ToL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            Ft3ToL.convert = function (value, precision) {
                var exactVal = (value * L_MOD) / FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Ft3ToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Ft3ToL;
        }());
        ParticleConcentration.Ft3ToL = Ft3ToL;
        var Ft3ToDeciL = (function () {
            function Ft3ToDeciL() {
            }
            Ft3ToDeciL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Ft3ToDeciL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            Ft3ToDeciL.convert = function (value, precision) {
                var exactVal = (value * DECIL_MOD) / FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Ft3ToDeciL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Ft3ToDeciL;
        }());
        ParticleConcentration.Ft3ToDeciL = Ft3ToDeciL;
        var Ft3ToM3 = (function () {
            function Ft3ToM3() {
            }
            Ft3ToM3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Ft3ToM3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            Ft3ToM3.convert = function (value, precision) {
                var exactVal = (value * M3_MOD) / FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Ft3ToM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Ft3ToM3;
        }());
        ParticleConcentration.Ft3ToM3 = Ft3ToM3;
    })(ParticleConcentration || (ParticleConcentration = {}));

    var ParticleMass;
    (function (ParticleMass) {
        var mG_to_uG = 1000;
        var kG_to_mG = 1000000;
        var kG_to_uG = 1000000000;
        var mGtouG = (function () {
            function mGtouG() {
            }
            mGtouG.getFrom = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            mGtouG.getTo = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            mGtouG.convert = function (value, precision) {
                var exactVal = value * mG_to_uG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mGtouG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mGtouG;
        }());
        ParticleMass.mGtouG = mGtouG;
        var uGtomG = (function () {
            function uGtomG() {
            }
            uGtomG.getFrom = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            uGtomG.getTo = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            uGtomG.convert = function (value, precision) {
                var exactVal = value / mG_to_uG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            uGtomG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return uGtomG;
        }());
        ParticleMass.uGtomG = uGtomG;
        var kGtomG = (function () {
            function kGtomG() {
            }
            kGtomG.getFrom = function () {
                return UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER;
            };
            kGtomG.getTo = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            kGtomG.convert = function (value, precision) {
                var exactVal = value * kG_to_mG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kGtomG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kGtomG;
        }());
        ParticleMass.kGtomG = kGtomG;
        var mGtokG = (function () {
            function mGtokG() {
            }
            mGtokG.getFrom = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            mGtokG.getTo = function () {
                return UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER;
            };
            mGtokG.convert = function (value, precision) {
                var exactVal = value / kG_to_mG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mGtokG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mGtokG;
        }());
        ParticleMass.mGtokG = mGtokG;
        var kGtouG = (function () {
            function kGtouG() {
            }
            kGtouG.getFrom = function () {
                return UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER;
            };
            kGtouG.getTo = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            kGtouG.convert = function (value, precision) {
                var exactVal = value * kG_to_uG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kGtouG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kGtouG;
        }());
        ParticleMass.kGtouG = kGtouG;
        var uGtokG = (function () {
            function uGtokG() {
            }
            uGtokG.getFrom = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            uGtokG.getTo = function () {
                return UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER;
            };
            uGtokG.convert = function (value, precision) {
                var exactVal = value / kG_to_uG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            uGtokG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return uGtokG;
        }());
        ParticleMass.uGtokG = uGtokG;
    })(ParticleMass || (ParticleMass = {}));

    var Gas;
    (function (Gas) {
        var MG_TO_UG = 1000;
        var PPM_TO_PPB = 1000;
        var PPM_TO_PPT = 1000000;
        var PPM_TO_PPQ = 1000000000;
        var PPB_TO_PPT = 1000;
        var PPB_TO_PPQ = 1000000;
        var PPT_TO_PPQ = 1000;
        var PpmToPpb = (function () {
            function PpmToPpb() {
            }
            PpmToPpb.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpmToPpb.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpmToPpb.convert = function (value, precision) {
                var exactVal = value * PPM_TO_PPB;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpmToPpb.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpmToPpb;
        }());
        Gas.PpmToPpb = PpmToPpb;
        var PpmToPpt = (function () {
            function PpmToPpt() {
            }
            PpmToPpt.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpmToPpt.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PpmToPpt.convert = function (value, precision) {
                var exactVal = value * PPM_TO_PPT;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpmToPpt.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpmToPpt;
        }());
        Gas.PpmToPpt = PpmToPpt;
        var PpmToPpq = (function () {
            function PpmToPpq() {
            }
            PpmToPpq.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpmToPpq.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpmToPpq.convert = function (value, precision) {
                var exactVal = value * PPM_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpmToPpq.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpmToPpq;
        }());
        Gas.PpmToPpq = PpmToPpq;
        var PpbToPpm = (function () {
            function PpbToPpm() {
            }
            PpbToPpm.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpbToPpm.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpbToPpm.convert = function (value, precision) {
                var exactVal = value / PPM_TO_PPB;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpbToPpm.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpbToPpm;
        }());
        Gas.PpbToPpm = PpbToPpm;
        var PpbToPpt = (function () {
            function PpbToPpt() {
            }
            PpbToPpt.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpbToPpt.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PpbToPpt.convert = function (value, precision) {
                var exactVal = value * PPB_TO_PPT;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpbToPpt.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpbToPpt;
        }());
        Gas.PpbToPpt = PpbToPpt;
        var PpbToPpq = (function () {
            function PpbToPpq() {
            }
            PpbToPpq.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpbToPpq.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpbToPpq.convert = function (value, precision) {
                var exactVal = value * PPB_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpbToPpq.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpbToPpq;
        }());
        Gas.PpbToPpq = PpbToPpq;
        var PptToPpm = (function () {
            function PptToPpm() {
            }
            PptToPpm.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PptToPpm.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PptToPpm.convert = function (value, precision) {
                var exactVal = value / PPM_TO_PPT;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PptToPpm.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PptToPpm;
        }());
        Gas.PptToPpm = PptToPpm;
        var PptToPpb = (function () {
            function PptToPpb() {
            }
            PptToPpb.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PptToPpb.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PptToPpb.convert = function (value, precision) {
                var exactVal = value / PPB_TO_PPT;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PptToPpb.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PptToPpb;
        }());
        Gas.PptToPpb = PptToPpb;
        var PptToPpq = (function () {
            function PptToPpq() {
            }
            PptToPpq.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PptToPpq.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PptToPpq.convert = function (value, precision) {
                var exactVal = value * PPT_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PptToPpq.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PptToPpq;
        }());
        Gas.PptToPpq = PptToPpq;
        var PpqToPpm = (function () {
            function PpqToPpm() {
            }
            PpqToPpm.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpqToPpm.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpqToPpm.convert = function (value, precision) {
                var exactVal = value / PPM_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpqToPpm.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpqToPpm;
        }());
        Gas.PpqToPpm = PpqToPpm;
        var PpqToPpb = (function () {
            function PpqToPpb() {
            }
            PpqToPpb.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpqToPpb.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpqToPpb.convert = function (value, precision) {
                var exactVal = value / PPB_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpqToPpb.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpqToPpb;
        }());
        Gas.PpqToPpb = PpqToPpb;
        var PpqToPpt = (function () {
            function PpqToPpt() {
            }
            PpqToPpt.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpqToPpt.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PpqToPpt.convert = function (value, precision) {
                var exactVal = value / PPT_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpqToPpt.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpqToPpt;
        }());
        Gas.PpqToPpt = PpqToPpt;
        var MgM3ToUgM3 = (function () {
            function MgM3ToUgM3() {
            }
            MgM3ToUgM3.getFrom = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            MgM3ToUgM3.getTo = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            MgM3ToUgM3.convert = function (value, precision) {
                var exactVal = value * MG_TO_UG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            MgM3ToUgM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return MgM3ToUgM3;
        }());
        Gas.MgM3ToUgM3 = MgM3ToUgM3;
        var UgM3ToMgM3 = (function () {
            function UgM3ToMgM3() {
            }
            UgM3ToMgM3.getFrom = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            UgM3ToMgM3.getTo = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            UgM3ToMgM3.convert = function (value, precision) {
                var exactVal = value / MG_TO_UG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            UgM3ToMgM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return UgM3ToMgM3;
        }());
        Gas.UgM3ToMgM3 = UgM3ToMgM3;
    })(Gas || (Gas = {}));

    var Volume;
    (function (Volume) {
        var L_to_mL = 1000;
        var L_to_ft3 = 0.035314666721489;
        var mL_to_L = 0.001;
        var mL_to_ft3 = 0.000035314666721489;
        var ft3_to_L = 28.3168465919997;
        var ft3_to_mL = 28316.8465919997;
        var LTomL = (function () {
            function LTomL() {
            }
            LTomL.getFrom = function () {
                return UnitOfMeasure$1.LITER;
            };
            LTomL.getTo = function () {
                return UnitOfMeasure$1.MILLILITER;
            };
            LTomL.convert = function (value, precision) {
                var exactVal = value * L_to_mL;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LTomL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LTomL;
        }());
        Volume.LTomL = LTomL;
        var LToft3 = (function () {
            function LToft3() {
            }
            LToft3.getFrom = function () {
                return UnitOfMeasure$1.LITER;
            };
            LToft3.getTo = function () {
                return UnitOfMeasure$1.CUBIC_FEET;
            };
            LToft3.convert = function (value, precision) {
                var exactVal = value * L_to_ft3;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToft3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToft3;
        }());
        Volume.LToft3 = LToft3;
        var mLToL = (function () {
            function mLToL() {
            }
            mLToL.getFrom = function () {
                return UnitOfMeasure$1.MILLILITER;
            };
            mLToL.getTo = function () {
                return UnitOfMeasure$1.LITER;
            };
            mLToL.convert = function (value, precision) {
                var exactVal = value * mL_to_L;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mLToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mLToL;
        }());
        Volume.mLToL = mLToL;
        var mLToft3 = (function () {
            function mLToft3() {
            }
            mLToft3.getFrom = function () {
                return UnitOfMeasure$1.MILLILITER;
            };
            mLToft3.getTo = function () {
                return UnitOfMeasure$1.CUBIC_FEET;
            };
            mLToft3.convert = function (value, precision) {
                var exactVal = value * mL_to_ft3;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mLToft3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mLToft3;
        }());
        Volume.mLToft3 = mLToft3;
        var ft3ToL = (function () {
            function ft3ToL() {
            }
            ft3ToL.getFrom = function () {
                return UnitOfMeasure$1.CUBIC_FEET;
            };
            ft3ToL.getTo = function () {
                return UnitOfMeasure$1.LITER;
            };
            ft3ToL.convert = function (value, precision) {
                var exactVal = value * ft3_to_L;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            ft3ToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return ft3ToL;
        }());
        Volume.ft3ToL = ft3ToL;
        var ft3TomL = (function () {
            function ft3TomL() {
            }
            ft3TomL.getFrom = function () {
                return UnitOfMeasure$1.CUBIC_FEET;
            };
            ft3TomL.getTo = function () {
                return UnitOfMeasure$1.MILLILITER;
            };
            ft3TomL.convert = function (value, precision) {
                var exactVal = value * ft3_to_mL;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            ft3TomL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return ft3TomL;
        }());
        Volume.ft3TomL = ft3TomL;
    })(Volume || (Volume = {}));

    var hash = [
        {
            models: ['7565'],
            data: {
                co2_ppm: {
                    resolution: 1,
                    unit: 500,
                    llod: 0,
                    ulod: 5000
                },
                temp_c: {
                    resolution: 0.1,
                    unit: 101,
                    llod: 0,
                    ulod: 60
                },
                rh_percent: {
                    resolution: 0.1,
                    unit: 1301,
                    llod: 0,
                    ulod: 95
                },
                baro_inhg: {
                    resolution: 0.01,
                    unit: 240,
                    llod: 20.36,
                    ulod: 36.648
                },
                voc_ppb: {
                    resolution: 0.01,
                    unit: 501,
                    llod: 0,
                    ulod: 20000
                },
                cl2_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                },
                co_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 500
                }
            }
        },
        {
            models: ['7580', '7585'],
            data: {
                nh3_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 100
                },
                nh3_mgm3: {
                    resolution: 0.1,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                baro_inhg: {
                    resolution: 0.01,
                    unit: 240,
                    llod: 7.7,
                    ulod: 37.2
                },
                ch2o_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 10
                },
                ch2o_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                cl_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: undefined,
                    ulod: undefined
                },
                cl_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                co2_ppm: {
                    resolution: 1,
                    unit: 500,
                    llod: 0,
                    ulod: 5000
                },
                co2_mgm3: {
                    resolution: 1,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                co_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 400
                },
                co_mgm3: {
                    resolution: 0.1,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                dewpoint: {
                    resolution: 0.1,
                    unit: 101,
                    llod: undefined,
                    ulod: undefined
                },
                h2s_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 50
                },
                h2s_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                ncpm0x3: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm0x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm1x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm2x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm4x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm10: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                mcpm1x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 500
                },
                mcpm2x5: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 500
                },
                mcpm10: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 500
                },
                no_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                },
                no_mgm3: {
                    resolution: 0.1,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                no2_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                },
                no2_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                o3_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                },
                o3_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                rh_percent: {
                    resolution: 0.1,
                    unit: 1301,
                    llod: 0,
                    ulod: 100
                },
                temp_c: {
                    resolution: 0.1,
                    unit: 101,
                    llod: 0,
                    ulod: 60
                },
                voc_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 2000
                },
                voc_ppb: {
                    resolution: 10,
                    unit: 501,
                    llod: 0,
                    ulod: 20000
                },
                voc_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: 0,
                    ulod: 1885
                },
                cl2_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                }
            }
        },
        {
            models: ['8143'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: -40,
                    ulod: 50,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    unit: 1301
                }
            }
        },
        {
            models: ['8145'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: -40,
                    ulod: 50,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    unit: 1301
                },
                baro_inhg: {
                    resolution: 0.01,
                    llod: 8,
                    ulod: 35,
                    unit: 240
                },
                co2_ppm: {
                    resolution: 1,
                    llod: 0,
                    ulod: 10000,
                    unit: 500
                },
                co_ppm: {
                    resolution: 0.001,
                    llod: 0,
                    ulod: 20,
                    unit: 500
                },
                o3_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 5000,
                    unit: 501
                },
                no2_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 5000,
                    unit: 501
                },
                so2_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 5000,
                    unit: 501
                }
            }
        },
        {
            models: ['8144-02'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 60,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    unit: 1301
                },
                baro_inhg: {
                    resolution: 0.01,
                    llod: 7.7,
                    ulod: 37.2,
                    unit: 240
                },
                co2_ppm: {
                    resolution: 1,
                    llod: 400,
                    ulod: 10000,
                    unit: 500
                },
                voc_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1.885,
                    unit: 501
                },
                voc_mgm3: {
                    resolution: 0.001,
                    llod: 0,
                    ulod: 1885,
                    unit: 600
                }
            }
        },
        {
            models: ['8144-04'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 60,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    unit: 1301
                },
                baro_inhg: {
                    resolution: 0.01,
                    llod: 7.7,
                    ulod: 37.2,
                    unit: 240
                },
                co2_ppm: {
                    resolution: 1,
                    llod: 400,
                    ulod: 10000,
                    unit: 500
                },
                voc_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1885000,
                    unit: 501
                },
                voc_mgm3: {
                    resolution: 0.001,
                    llod: 0,
                    ulod: 1885,
                    unit: 600
                },
                co_ppm: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 1000,
                    unit: 500
                },
                ch2o_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 501
                }
            }
        },
        {
            models: ['8144-06'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 60,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    unit: 1301
                },
                baro_inhg: {
                    resolution: 0.01,
                    llod: 7.7,
                    ulod: 37.2,
                    unit: 240
                },
                co2_ppm: {
                    resolution: 1,
                    llod: 400,
                    ulod: 10000,
                    unit: 500
                },
                voc_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1885000,
                    unit: 501
                },
                voc_mgm3: {
                    resolution: 0.001,
                    llod: 0,
                    ulod: 1885,
                    unit: 600
                },
                co_ppm: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 1000,
                    unit: 500
                },
                no2_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 20000,
                    unit: 501
                },
                so2_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 10000,
                    unit: 501
                },
                o3_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 20000,
                    unit: 501
                }
            }
        },
        {
            models: ['CEL620-A'],
            data: {
                lzs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lceq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lapeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                }
            }
        },
        {
            models: ['CEL620-B'],
            data: {
                lzs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lceq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lapeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_16: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_32: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_64: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_125: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_250: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_500: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_1k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_2k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_4k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_8k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_16k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_16: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_32: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_64: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_125: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_250: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_500: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_1k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_2k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_4k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_8k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_16k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_16: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_32: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_64: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_125: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_250: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_500: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_1k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_2k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_4k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_8k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_16k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                }
            }
        },
        {
            models: ['7591-01'],
            data: {
                ncpm0x3: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm0x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm1x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm2x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm4x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm10: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                mcpm1x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000
                },
                mcpm2x5: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000
                },
                mcpm4x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000
                },
                mcpm10: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000
                }
            }
        },
        {
            models: ['7591-02'],
            data: {
                voc_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 2000
                }
            }
        },
        {
            models: ['7591-03'],
            data: {
                voc_ppb: {
                    resolution: 0.1,
                    unit: 501,
                    llod: 0,
                    ulod: 2500
                }
            }
        },
        {
            models: ['7591-04'],
            data: {
                ncpm0x3: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm0x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm1x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm2x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm4x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm10: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                mcpm1x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000
                },
                mcpm2x5: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000
                },
                mcpm4x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000
                },
                mcpm10: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000
                },
                voc_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 2000
                }
            }
        },
        {
            models: ['7591-06'],
            data: {
                co_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 2,
                    ulod: 4500
                }
            }
        },
        {
            models: ['7591-07'],
            data: {
                ch2o_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 5,
                    ulod: 1300
                }
            }
        },
        {
            models: ['7591-08'],
            data: {
                o3_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 2,
                    ulod: 2500
                }
            }
        },
        {
            models: ['7591-09'],
            data: {
                lzs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lceq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lapeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laieq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lae: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laeq_t80: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laft_m3: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laft_m5: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lait_m3: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lait_m5: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lavg_1_t1nn_q1n: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lavg_2_t2nn_q2n: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lceq_laeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lex_8hr: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lep_d: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                proj_lex_8hr: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                proj_lep_d: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                twa_8hr: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                proj_twa_8hr: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                dose_percent: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                proj_dose_percent: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                }
            }
        },
        {
            models: ['7591-10'],
            data: {
                cl_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 1,
                    ulod: 2500
                }
            }
        },
        {
            models: ['7591-11'],
            data: {
                nh3_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 5,
                    ulod: 1100
                }
            }
        },
        {
            models: ['8530', '8531', '8530EP', '8540', '8540-M', '8542-M'],
            data: {
                mcpm_total: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                mcpm_total_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                mcpm_total_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                mcpm_total_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                mcpm_total_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                volumetric_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                standard_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                absolute_inlet_pressure: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 210,
                    llod: 0,
                    ulod: 210,
                    unit: 212
                },
                inlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                outlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                external_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                }
            }
        },
        {
            models: ['8532'],
            data: {
                mcpm_total: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                volumetric_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                standard_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                absolute_inlet_pressure: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 210,
                    llod: 0,
                    ulod: 210,
                    unit: 212
                },
                inlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                outlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                external_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                }
            }
        },
        {
            models: ['8533', '8533EP', '8534', '8543', '8543-M'],
            data: {
                mcpm1x0: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm1x0_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm1x0_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm1x0_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm1x0_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                volumetric_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                standard_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                absolute_inlet_pressure: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 210,
                    llod: 0,
                    ulod: 210,
                    unit: 212
                },
                inlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                outlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                external_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                }
            }
        }
    ];
    function getModelsMetrology(model) {
        var hashItem = hash.find(function (item) {
            var models = item.models.map(function (model) { return model.toLowerCase(); });
            return (models.indexOf(model.toLowerCase()) >= 0);
        });
        return hashItem === null || hashItem === void 0 ? void 0 : hashItem.data;
    }
    function getMetrology(model, measurementType) {
        var deviceMetrology = getModelsMetrology(model);
        if (deviceMetrology != undefined) {
            var measurementMetrology = deviceMetrology[measurementType];
            return measurementMetrology;
        }
        return undefined;
    }

    var __extends = ( false) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null)
                throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var UnitConversionError = (function (_super) {
        __extends(UnitConversionError, _super);
        function UnitConversionError(message) {
            var _this = _super.call(this, message) || this;
            Object.setPrototypeOf(_this, UnitConversionError.prototype);
            return _this;
        }
        return UnitConversionError;
    }(Error));

    var __spreadArray = ( false) || function (to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };
    function _getSigDigitsLeftOfDecimalPoint(resolution) {
        var digits = 0;
        while (resolution >= 10) {
            digits++;
            resolution = resolution / 10;
        }
        if (resolution !== 1) {
            digits--;
        }
        return digits;
    }
    function _getSigDigitsRightOfDecimalPoint(resolution) {
        var digits = 0;
        while (resolution < 1) {
            digits++;
            resolution = 10 * resolution;
        }
        return digits;
    }
    function numberPrecision(value) {
        if (!isFinite(value) || value === 1) {
            return 0;
        }
        return (value >= 1) ? -_getSigDigitsLeftOfDecimalPoint(value) : _getSigDigitsRightOfDecimalPoint(value);
    }
    var Units = (function () {
        function Units() {
            this._unitsConvertMap = new Map();
            this._populateExportsMap();
        }
        Units.getInstance = function () {
            if (!Units.instance) {
                Units.instance = new Units();
            }
            return Units.instance;
        };
        Units.prototype.setPrecision = function (value, numDecimals, pad) {
            if (pad === void 0) { pad = true; }
            var precisionVal;
            precisionVal = setPrecision(value, numDecimals);
            if (numDecimals < 1) {
                precisionVal = precisionVal.toFixed(0);
            }
            else {
                precisionVal = (pad) ? precisionVal.toFixed(numDecimals) : precisionVal.toString();
            }
            return precisionVal;
        };
        Units.prototype._convert = function (from, to, value, precision) {
            if (precision === void 0) { precision = null; }
            var convertToFunction = this.getConvertFunction(from, to);
            if (convertToFunction !== null) {
                return convertToFunction(value, precision);
            }
            return null;
        };
        Units.prototype._convertBatch = function (from, to, values, precision) {
            if (precision === void 0) { precision = null; }
            var result = __spreadArray([], values, true);
            var convertToFunction = this.getConvertFunction(from, to, true);
            if (convertToFunction !== null) {
                convertToFunction(result, precision);
            }
            return result;
        };
        Units.prototype.convertResolution = function (fromUnit, toUnit, resolution) {
            if (isNaN(resolution) || resolution < 0) {
                throw new UnitConversionError('Resolution must be a positive value (>=0)');
            }
            var toResolution = resolution;
            if (fromUnit !== toUnit) {
                var val1 = this._convert(fromUnit, toUnit, resolution);
                var val2 = this._convert(fromUnit, toUnit, 0);
                if (val1 !== null && val2 !== null) {
                    toResolution = Math.abs(val1 - val2);
                }
            }
            return toResolution;
        };
        Units.prototype.convertUnit = function (fromUnit, toUnit, value, resolution, isAverage) {
            var result = value;
            if (fromUnit !== toUnit) {
                var converted = this._convert(fromUnit, toUnit, value);
                result = (converted !== null) ? converted : result;
            }
            if (resolution) {
                var toResolution = this.convertResolution(fromUnit, toUnit, resolution);
                var precision = numberPrecision(toResolution);
                if (isAverage) {
                    precision++;
                }
                result = Number(this.setPrecision(result, precision));
            }
            return result;
        };
        Units.prototype.convertUnitBatch = function (fromUnit, toUnit, values, resolution, isAverage) {
            var result = values;
            if (fromUnit !== toUnit) {
                result = this._convertBatch(fromUnit, toUnit, values);
            }
            if (resolution) {
                var toResolution = this.convertResolution(fromUnit, toUnit, resolution);
                var precision = numberPrecision(toResolution);
                if (isAverage) {
                    precision++;
                }
                for (var i = 0; i < values.length; i++) {
                    result[i] = Number(this.setPrecision(result[i], precision));
                }
            }
            return result;
        };
        Units.prototype.getConvertFunction = function (fromUnit, toUnit, batch) {
            var _a, _b;
            if (batch === void 0) { batch = false; }
            var convertFromMap = this._unitsConvertMap.get(fromUnit);
            if (convertFromMap !== undefined) {
                var converter = convertFromMap.get(toUnit);
                if (converter !== undefined) {
                    if (batch) {
                        return converter.convertBatchFunction;
                    }
                    else {
                        return converter.convertFunction;
                    }
                }
            }
            var fromUnitName = "".concat((_a = UnitOfMeasureProperties[fromUnit]) === null || _a === void 0 ? void 0 : _a.name, " (").concat(fromUnit, ")");
            var toUnitName = "".concat((_b = UnitOfMeasureProperties[toUnit]) === null || _b === void 0 ? void 0 : _b.name, " (").concat(toUnit, ")");
            throw new Error("FAILED TO FIND REQUESTED CONVERSION - FROM: ".concat(fromUnitName, " TO: ").concat(toUnitName));
        };
        Units.prototype.getMeasurementType = function (alias) {
            var paramMeasurement = this.getParamMeasurementType(alias);
            if (paramMeasurement)
                return paramMeasurement;
            for (var key in MeasurementTypes) {
                var measurement = MeasurementTypes[key];
                if (measurement.aliases.includes(alias)) {
                    return measurement;
                }
            }
        };
        Units.prototype.getParamMeasurementType = function (alias) {
            for (var key in ParamMeasurementTypes) {
                var measurement = ParamMeasurementTypes[key];
                if (alias.match(new RegExp(measurement.aliases[0], 'g'))) {
                    return measurement;
                }
            }
        };
        Units.prototype.getMetrology = function (model, measurementTypeName) {
            return getMetrology(model, measurementTypeName);
        };
        Units.prototype.getModelsMetrology = function (model) {
            return getModelsMetrology(model);
        };
        Units.prototype.convertUnitByMetrology = function (fromUnit, toUnit, value, metrology) {
            if (fromUnit === toUnit) {
                return Number(value);
            }
            var baseUnitResolution = metrology.resolution;
            var baseUnit = metrology.unit;
            var fromUnitResolution = baseUnitResolution;
            var convertedValue = value;
            if (fromUnit !== baseUnit) {
                fromUnitResolution = this.convertResolution(baseUnit, fromUnit, baseUnitResolution);
            }
            convertedValue = this.convertUnit(fromUnit, toUnit, Number(value), fromUnitResolution);
            return Number(convertedValue);
        };
        Units.prototype.convertPrecision = function (fromUnit, toUnit, resolution) {
            var toResolution = this.convertResolution(fromUnit, toUnit, resolution);
            return numberPrecision(toResolution);
        };
        Units.prototype._populateExportsMap = function () {
            var exportArray = [Temperature, Pressure, ParticleConcentration, ParticleMass, Gas, Volume];
            for (var _i = 0, exportArray_1 = exportArray; _i < exportArray_1.length; _i++) {
                var unitNamespace = exportArray_1[_i];
                var _loop_1 = function (convertClassName) {
                    var convertClass = unitNamespace[convertClassName];
                    var from = convertClass.getFrom();
                    var to = convertClass.getTo();
                    var currentToMap = this_1._unitsConvertMap.get(from);
                    var convertFunction = function (value, precision) {
                        return convertClass.convert(value, precision);
                    };
                    var convertBatchFunction = function (values, precision) {
                        convertClass.convertBatch(values, precision);
                    };
                    var converter = { convertFunction: convertFunction, convertBatchFunction: convertBatchFunction };
                    if (currentToMap !== undefined) {
                        currentToMap.set(to, converter);
                    }
                    else {
                        var newToMap = new Map();
                        newToMap.set(to, converter);
                        this_1._unitsConvertMap.set(from, newToMap);
                    }
                };
                var this_1 = this;
                for (var convertClassName in unitNamespace) {
                    _loop_1(convertClassName);
                }
            }
        };
        return Units;
    }());
    function getInstance() {
        return Units.getInstance();
    }

    exports.MeasurementTypes = MeasurementTypes;
    exports.UnitConversionError = UnitConversionError;
    exports.UnitOfMeasure = UnitOfMeasure$1;
    exports.UnitOfMeasureProperties = UnitOfMeasureProperties;
    exports.getInstance = getInstance;

}));
//# sourceMappingURL=units.js.map


/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v10.3.2 (2022-11-28)

 (c) 2009-2021 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(f){ true&&module.exports?(f["default"]=f,module.exports=f): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(912)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(l){f(l);f.Highcharts=l;return f}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0})(function(f){function l(f,h,n,l){f.hasOwnProperty(h)||(f[h]=l.apply(null,n),"function"===typeof CustomEvent&&window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:h,module:f[h]}})))}f=f?f._modules:{};
l(f,"Core/Axis/BrokenAxis.js",[f["Core/Axis/Stacking/StackItem.js"],f["Core/Utilities.js"]],function(f,h){var n=h.addEvent,l=h.find,x=h.fireEvent,z=h.isArray,m=h.isNumber,u=h.pick,v;(function(h){function v(){"undefined"!==typeof this.brokenAxis&&this.brokenAxis.setBreaks(this.options.breaks,!1)}function A(){this.brokenAxis&&this.brokenAxis.hasBreaks&&(this.options.ordinal=!1)}function B(){var c=this.brokenAxis;if(c&&c.hasBreaks){for(var b=this.tickPositions,g=this.tickPositions.info,e=[],a=0;a<b.length;a++)c.isInAnyBreak(b[a])||
e.push(b[a]);this.tickPositions=e;this.tickPositions.info=g}}function C(){this.brokenAxis||(this.brokenAxis=new y(this))}function D(){var c=this.options.connectNulls,b=this.points,g=this.xAxis,e=this.yAxis;if(this.isDirty)for(var a=b.length;a--;){var d=b[a],f=!(null===d.y&&!1===c)&&(g&&g.brokenAxis&&g.brokenAxis.isInAnyBreak(d.x,!0)||e&&e.brokenAxis&&e.brokenAxis.isInAnyBreak(d.y,!0));d.visible=f?!1:!1!==d.options.visible}}function E(){this.drawBreaks(this.xAxis,["x"]);this.drawBreaks(this.yAxis,
u(this.pointArrayMap,["y"]))}function F(c,b){var g=this,e=g.points,a,d,f,k;if(c&&c.brokenAxis&&c.brokenAxis.hasBreaks){var h=c.brokenAxis;b.forEach(function(b){a=h&&h.breakArray||[];d=c.isXAxis?c.min:u(g.options.threshold,c.min);e.forEach(function(e){k=u(e["stack"+b.toUpperCase()],e[b]);a.forEach(function(a){if(m(d)&&m(k)){f=!1;if(d<a.from&&k>a.to||d>a.from&&k<a.from)f="pointBreak";else if(d<a.from&&k>a.from&&k<a.to||d>a.from&&k>a.to&&k<a.from)f="pointInBreak";f&&x(c,f,{point:e,brk:a})}})})})}}function G(){var c=
this.currentDataGrouping,b=c&&c.gapSize;c=this.points.slice();var g=this.yAxis,e=this.options.gapSize,a=c.length-1,d;if(e&&0<a)for("value"!==this.options.gapUnit&&(e*=this.basePointRange),b&&b>e&&b>=this.basePointRange&&(e=b),d=void 0;a--;)d&&!1!==d.visible||(d=c[a+1]),b=c[a],!1!==d.visible&&!1!==b.visible&&(d.x-b.x>e&&(d=(b.x+d.x)/2,c.splice(a+1,0,{isNull:!0,x:d}),g.stacking&&this.options.stacking&&(d=g.stacking.stacks[this.stackKey][d]=new f(g,g.options.stackLabels,!1,d,this.stack),d.total=0)),
d=b);return this.getGraphPath(c)}var w=[];h.compose=function(c,b){-1===w.indexOf(c)&&(w.push(c),c.keepProps.push("brokenAxis"),n(c,"init",C),n(c,"afterInit",v),n(c,"afterSetTickPositions",B),n(c,"afterSetOptions",A));if(-1===w.indexOf(b)){w.push(b);var g=b.prototype;g.drawBreaks=F;g.gappedPath=G;n(b,"afterGeneratePoints",D);n(b,"afterRender",E)}return c};var y=function(){function c(b){this.hasBreaks=!1;this.axis=b}c.isInBreak=function(b,c){var e=b.repeat||Infinity,a=b.from,d=b.to-b.from;c=c>=a?(c-
a)%e:e-(a-c)%e;return b.inclusive?c<=d:c<d&&0!==c};c.lin2Val=function(b){var g=this.brokenAxis;g=g&&g.breakArray;if(!g||!m(b))return b;var e;for(e=0;e<g.length;e++){var a=g[e];if(a.from>=b)break;else a.to<b?b+=a.len:c.isInBreak(a,b)&&(b+=a.len)}return b};c.val2Lin=function(b){var g=this.brokenAxis;g=g&&g.breakArray;if(!g||!m(b))return b;var e=b,a;for(a=0;a<g.length;a++){var d=g[a];if(d.to<=b)e-=d.len;else if(d.from>=b)break;else if(c.isInBreak(d,b)){e-=b-d.from;break}}return e};c.prototype.findBreakAt=
function(b,c){return l(c,function(c){return c.from<b&&b<c.to})};c.prototype.isInAnyBreak=function(b,g){var e=this.axis,a=e.options.breaks||[],d=a.length,f;if(d&&m(b)){for(;d--;)if(c.isInBreak(a[d],b)){var k=!0;f||(f=u(a[d].showPoints,!e.isXAxis))}var h=k&&g?k&&!f:k}return h};c.prototype.setBreaks=function(b,f){var e=this,a=e.axis,d=z(b)&&!!b.length;a.isDirty=e.hasBreaks!==d;e.hasBreaks=d;a.options.breaks=a.userOptions.breaks=b;a.forceRedraw=!0;a.series.forEach(function(a){a.isDirty=!0});d||a.val2lin!==
c.val2Lin||(delete a.val2lin,delete a.lin2val);d&&(a.userOptions.ordinal=!1,a.lin2val=c.lin2Val,a.val2lin=c.val2Lin,a.setExtremes=function(b,c,d,f,g){if(e.hasBreaks){for(var h=this.options.breaks||[],k;k=e.findBreakAt(b,h);)b=k.to;for(;k=e.findBreakAt(c,h);)c=k.from;c<b&&(c=b)}a.constructor.prototype.setExtremes.call(this,b,c,d,f,g)},a.setAxisTranslation=function(){a.constructor.prototype.setAxisTranslation.call(this);e.unitLength=void 0;if(e.hasBreaks){var b=a.options.breaks||[],d=[],f=[],g=u(a.pointRangePadding,
0),h=0,r,p=a.userMin||a.min,t=a.userMax||a.max,l;b.forEach(function(a){r=a.repeat||Infinity;m(p)&&m(t)&&(c.isInBreak(a,p)&&(p+=a.to%r-p%r),c.isInBreak(a,t)&&(t-=t%r-a.from%r))});b.forEach(function(a){q=a.from;r=a.repeat||Infinity;if(m(p)&&m(t)){for(;q-r>p;)q-=r;for(;q<p;)q+=r;for(l=q;l<t;l+=r)d.push({value:l,move:"in"}),d.push({value:l+a.to-a.from,move:"out",size:a.breakSize})}});d.sort(function(a,b){return a.value===b.value?("in"===a.move?0:1)-("in"===b.move?0:1):a.value-b.value});var n=0;var q=
p;d.forEach(function(a){n+="in"===a.move?1:-1;1===n&&"in"===a.move&&(q=a.value);0===n&&m(q)&&(f.push({from:q,to:a.value,len:a.value-q-(a.size||0)}),h+=a.value-q-(a.size||0))});e.breakArray=f;m(p)&&m(t)&&m(a.min)&&(e.unitLength=t-p-h+g,x(a,"afterBreaks"),a.staticScale?a.transA=a.staticScale:e.unitLength&&(a.transA*=(t-a.min+g)/e.unitLength),g&&(a.minPixelPadding=a.transA*(a.minPointOffset||0)),a.min=p,a.max=t)}});u(f,!0)&&a.chart.redraw()};return c}();h.Additions=y})(v||(v={}));return v});l(f,"masters/modules/broken-axis.src.js",
[f["Core/Globals.js"],f["Core/Axis/BrokenAxis.js"]],function(f,h){h.compose(f.Axis,f.Series)})});
//# sourceMappingURL=broken-axis.js.map

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v10.3.2 (2022-11-28)

 Plugin for displaying a message when there is no data visible in chart.

 (c) 2010-2021 Highsoft AS
 Author: Oystein Moseng

 License: www.highcharts.com/license
*/
(function(a){ true&&module.exports?(a["default"]=a,module.exports=a): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(912)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(b){a(b);a.Highcharts=b;return a}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0})(function(a){function b(a,c,b,e){a.hasOwnProperty(c)||(a[c]=e.apply(null,b),"function"===typeof CustomEvent&&window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:c,module:a[c]}})))}a=a?a._modules:
{};b(a,"Extensions/NoDataToDisplay.js",[a["Core/Renderer/HTML/AST.js"],a["Core/Chart/Chart.js"],a["Core/Defaults.js"],a["Core/Utilities.js"]],function(a,b,f,e){var c=f.getOptions;f=e.addEvent;var g=e.extend;e=b.prototype;c=c();g(c.lang,{noData:"No data to display"});c.noData={attr:{zIndex:1},position:{x:0,y:0,align:"center",verticalAlign:"middle"},style:{fontWeight:"bold",fontSize:"12px",color:"#666666"}};e.showNoData=function(b){var d=this.options;b=b||d&&d.lang.noData||"";d=d&&(d.noData||{});this.renderer&&
(this.noDataLabel||(this.noDataLabel=this.renderer.label(b,0,0,void 0,void 0,void 0,d.useHTML,void 0,"no-data").add()),this.styledMode||this.noDataLabel.attr(a.filterUserAttributes(d.attr||{})).css(d.style||{}),this.noDataLabel.align(g(this.noDataLabel.getBBox(),d.position||{}),!1,"plotBox"))};e.hideNoData=function(){this.noDataLabel&&(this.noDataLabel=this.noDataLabel.destroy())};e.hasData=function(){for(var a=this.series||[],b=a.length;b--;)if(a[b].hasData()&&!a[b].options.isInternal)return!0;return this.loadingShown};
f(b,"render",function(){this.hasData()?this.hideNoData():this.showNoData()})});b(a,"masters/modules/no-data-to-display.src.js",[],function(){})});
//# sourceMappingURL=no-data-to-display.js.map

/***/ }),

/***/ 705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(705),
    getRawTag = __webpack_require__(607),
    objectToString = __webpack_require__(333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(218),
    now = __webpack_require__(771),
    toNumber = __webpack_require__(841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 5:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(239),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(279),
    isObject = __webpack_require__(218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(561),
    isObject = __webpack_require__(218),
    isSymbol = __webpack_require__(448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 671:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var charsets = (__webpack_require__(121).charsets);

var upperCase         = charsets.upperCase;
var lowerCase         = charsets.lowerCase;
var numbers           = charsets.numbers;
var specialCharacters = charsets.specialCharacters;

var PasswordPolicy = __webpack_require__(658);

var none =  new PasswordPolicy({
  length: { minLength: 1 }
});

var low = new PasswordPolicy({
  length: { minLength: 6 }
});

var fair = new PasswordPolicy({
  length: { minLength: 8 },
  contains: {
    expressions: [lowerCase, upperCase, numbers]
  }
});

var good = new PasswordPolicy({
  length: { minLength: 8 },
  containsAtLeast: {
    atLeast: 3,
    expressions: [lowerCase, upperCase, numbers, specialCharacters]
  }
});

var excellent = new PasswordPolicy({
  length: { minLength: 10 },
  containsAtLeast: {
    atLeast: 3,
    expressions: [lowerCase, upperCase, numbers, specialCharacters]
  },
  identicalChars: { max: 2 }
});

var policiesByName = {
  none:       none,
  low:        low,
  fair:       fair,
  good:       good,
  excellent:  excellent
};

/**
 * Creates a password policy.
 *
 * @param {String} policyName Name of policy to use.
 */
module.exports = function (policyName) {
  var policy = policiesByName[policyName] || policiesByName.none;

  return {
    /**
     * Checks that a password meets this policy
     *
     * @method check
     * @param {String} password
     */
    check: function (password) {
      return policy.check(password);
    },
    /**
     * @method assert
     * Asserts that a passord meets this policy else throws an exception.
     *
     * @param {String} password
     */
    assert: function (password) {
      return policy.assert(password);
    },

    missing: function (password) {
      return policy.missing(password);
    },

    missingAsMarkdown: function (password) {
      return policy.missingAsMarkdown(password);
    },

    explain: function () {
      return policy.explain();
    },

    /**
     * Friendly string representation of the policy
     * @method toString
     */
    toString: function () {
      return policy.toString();
    }
  };
};

module.exports.PasswordPolicy = PasswordPolicy;

module.exports.charsets = charsets;

// module.exports.rulesToApply = rulesToApply;


/***/ }),

/***/ 341:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _ = {};
var root = typeof self == 'object' && self.self === self && self ||
            typeof __webpack_require__.g == 'object' && __webpack_require__.g.global === __webpack_require__.g && __webpack_require__.g ||
            this ||
            {};
var nativeIsArray = Array.isArray;
var nativeKeys = Object.keys;
var ObjProto = Object.prototype;
var toString = ObjProto.toString;

var shallowProperty = function(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
};

var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
var getLength = shallowProperty('length');
var isArrayLike = function(collection) {
  var length = getLength(collection);
  return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
};

// Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
var typeNames = ['Arguments', 'Function', 'String', 'Number'];
function loopAsign(name) {
  _['is' + name] = function(obj) {
    return toString.call(obj) === '[object ' + name + ']';
  };
}
for (var a = 0; a < typeNames.length; a++) {
  loopAsign(typeNames[a]);
}

var nodelist = root.document && root.document.childNodes;
if ( true && typeof Int8Array != 'object' && typeof nodelist != 'function') {
  _.isFunction = function(obj) {
    return typeof obj == 'function' || false;
  };
}

_.identity = function(value) {
  return value;
};

_.keys = function(obj) {
  if (!_.isObject(obj)) return [];
  if (nativeKeys) return nativeKeys(obj);
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};

_.isObject = function(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
};

_.isArray = nativeIsArray || function(obj) {
  return toString.call(obj) === '[object Array]';
};

_.isEmpty = function(obj) {
  if (obj == null) return true;
  if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
  return _.keys(obj).length === 0;
};

_.isNaN = function(obj) {
  return _.isNumber(obj) && isNaN(obj);
};

// Code attribution
// Inlined and modified from https://github.com/browserify/node-util/blob/e37ce41f4063bcd7bc27e01470d6654053bdcd14/util.js#L33-L69
// Copyright Joyent, Inc. and other Node contributors.
// Please see LICENSE for full copyright and license attribution.
var formatRegExp = /%[sdj%]/g;

_.format = function (f) {
  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s':
        return String(args[i++]);
      case '%d':
        return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (x === null || !_.isObject(x)) {
      str += ' ' + x;
    } else if (x !== null) {
      str += ' ' + JSON.stringify(x);
    }
  }
  return str;
}
// End code attribution

module.exports = _;

/***/ }),

/***/ 658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var format = (__webpack_require__(341).format);

var PasswordPolicyError = __webpack_require__(950);

function isString(value) {
  return typeof value === 'string' || value instanceof String;
}

var defaultRuleset = {
  length:           __webpack_require__(484),
  contains:         __webpack_require__(121),
  containsAtLeast:  __webpack_require__(212),
  identicalChars:   __webpack_require__(899),
};

function flatDescriptions (descriptions, index) {
  if (!descriptions.length) {
    return '';
  }

  function flatSingleDescription (description, index) {
    var spaces = (new Array(index+1)).join(' ');
    var result = spaces + '* ';
    if (description.format) {
      result += format.apply(null, [description.message].concat(description.format));
    } else {
      result += description.message;
    }

    if (description.items) {
      result += '\n' + spaces + flatDescriptions(description.items, index + 1);
    }
    return result;
  }

  var firstDescription = flatSingleDescription(descriptions[0], index);

  descriptions = descriptions.slice(1).reduce(function (result, description) {
    result += '\n' + flatSingleDescription(description, index);

    return result;
  }, firstDescription);

  return descriptions;
}

/**
 * Creates a PasswordPolicy which is a set of rules.
 *
 * @class PasswordPolicy
 * @constructor
 */
function PasswordPolicy(rules, ruleset) {
  this.rules = rules;
  this.ruleset = ruleset || defaultRuleset;

  this._reduce(function (result, ruleOptions, rule) {
    rule.validate(ruleOptions);
  });
}

PasswordPolicy.prototype = {};

PasswordPolicy.prototype._reduce = function (fn, value) {
  var self = this;
  return Object.keys(this.rules).reduce(function (result, ruleName) {
    var ruleOptions = self.rules[ruleName];
    var rule = self.ruleset[ruleName];

    return fn(result, ruleOptions, rule);

  }, value);
};

PasswordPolicy.prototype._applyRules = function (password) {
  return this._reduce(function (result, ruleOptions, rule) {
    // If previous result was false as this an &&, then nothing to do here!
    if (!result) {
      return false;
    }

    if (!rule) {
      return false;
    }

    return rule.assert(ruleOptions, password);
  }, true);
};

PasswordPolicy.prototype.missing = function (password) {
  return this._reduce(function (result, ruleOptions, rule) {
    var missingRule = rule.missing(ruleOptions, password);
    result.rules.push(missingRule);
    result.verified = result.verified && !!missingRule.verified;
    return result;
  }, {rules: [], verified: true});
};

PasswordPolicy.prototype.explain = function () {
  return this._reduce(function (result, ruleOptions, rule) {
    result.push(rule.explain(ruleOptions));
    return result;
  }, []);
};

PasswordPolicy.prototype.missingAsMarkdown = function (password) {
  return flatDescriptions(this.missing(password), 1);
};

PasswordPolicy.prototype.toString = function () {
  var descriptions = this.explain();
  return flatDescriptions(descriptions, 0);
};

PasswordPolicy.prototype.check = function (password) {
  if (!isString(password)) {
    return false;
  }

  return this._applyRules(password);
};

PasswordPolicy.prototype.assert = function (password) {
  if (!this.check(password)) {
    throw new PasswordPolicyError('Password does not meet password policy');
  }
};

module.exports = PasswordPolicy;


/***/ }),

/***/ 950:
/***/ (function(module) {

/**
 * Error thrown when asserting a policy against a password.
 *
 * @class PasswordPolicyError
 * @constructor
 *
 * @param {String} msg Descriptive message of the error
 */
function PasswordPolicyError(msg) {
  var err = Error.call(this, msg);
  err.name = 'PasswordPolicyError';
  return err;
}

module.exports = PasswordPolicyError;


/***/ }),

/***/ 121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _ = __webpack_require__(341);

/* OWASP Special Characters: https://www.owasp.org/index.php/Password_special_characters */
var specialCharacters = [' ', '!', '"', '#', '\\$', '%', '&', '\'', '\\(', '\\)', '\\*', '\\+', ',', '-', '\\.', '/', ':', ';', '<', '=', '>', '\\?', '@', '\\[', '\\\\', '\\]', '\\^', '_','`','{','\\|', '}','~'].join('|');

var specialCharactersRegexp = new RegExp(specialCharacters);

module.exports = {
  validate: function (options) {
    if (!_.isObject(options)) {
      throw new Error('options should be an object');
    }

    if (!_.isArray(options.expressions) || _.isEmpty(options.expressions)) {
      throw new Error('contains expects expressions to be a non-empty array');
    }

    var ok = options.expressions.every(function (expression) {
      return _.isFunction(expression.explain) && _.isFunction(expression.test);
    });

    if (!ok) {
      throw new Error('contains expressions are invalid: An explain and a test function should be provided');
    }
    return true;
  },
  explain: function (options) {
    return {
      message: 'Should contain:',
      code: 'shouldContain',
      items: options.expressions.map(function (expression) {
        return expression.explain();
      })
    };
  },
  missing: function (options, password) {
    var expressions = options.expressions.map(function (expression) {
      var explained = expression.explain();
      explained.verified = expression.test(password);
      return explained;
    });

    var verified = expressions.every(function (expression) {
      return expression.verified;
    });

    return {
      message: 'Should contain:',
      code: 'shouldContain',
      verified: verified,
      items: expressions
    };
  },
  assert: function (options, password) {
    if (!password) {
      return false;
    }

    return options.expressions.every(function (expression) {
      var result = expression.test(password);
      return result;
    });
  },
  charsets: {
    upperCase: {
      explain: function () { return {
        message: 'upper case letters (A-Z)',
        code: 'upperCase'
      }; },
      test: function (password) { return /[A-Z]/.test(password); }
    },
    lowerCase: {
      explain: function () { return {
        message: 'lower case letters (a-z)',
        code: 'lowerCase'
      }; },
      test: function (password) { return /[a-z]/.test(password); }
    },
    specialCharacters: {
      explain: function () { return {
        message: 'special characters (e.g. !@#$%^&*)',
        code: 'specialCharacters'
      }; },
      test: function (password) { return specialCharactersRegexp.test(password); }
    },
    numbers: {
      explain: function () { return {
        message: 'numbers (i.e. 0-9)',
        code: 'numbers'
      }; },
      test: function (password) { return /\d/.test(password); }
    }
  }
};


/***/ }),

/***/ 212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _ = __webpack_require__(341);

var contains = __webpack_require__(121);

function createIntroMessage() {
  return 'At least %d of the following %d types of characters:';
}

module.exports = {
  // TODO validate atLeast to be a number > 0 and expressions to be a list of at least 1
  validate: function (options) {
    if (!_.isObject(options)) {
      throw new Error('options should be an object');
    }

    if (!_.isNumber(options.atLeast) || _.isNaN(options.atLeast) || options.atLeast < 1) {
      throw new Error('atLeast should be a valid, non-NaN number, greater than 0');
    }

    if (!_.isArray(options.expressions) || _.isEmpty(options.expressions)) {
      throw new Error('expressions should be an non-empty array');
    }

    if (options.expressions.length < options.atLeast) {
      throw new Error('expressions length should be greater than atLeast');
    }

    var ok = options.expressions.every(function (expression) {
      return _.isFunction(expression.explain) && _.isFunction(expression.test);
    });

    if (!ok) {
      throw new Error('containsAtLeast expressions are invalid: An explain and a test function should be provided');
    }

    return true;
  },
  explain: function (options) {
    return {
      message: createIntroMessage(),
      code: 'containsAtLeast',
      format: [options.atLeast, options.expressions.length],
      items: options.expressions.map(function (x) { return x.explain(); })
    };
  },
  missing: function (options, password) {
    var expressions = options.expressions && options.expressions.map(function (expression) {
      var explained = expression.explain();
      explained.verified = expression.test(password);
      return explained;
    });

    var verifiedCount = expressions.reduce(function (val, ex) { return val + !!ex.verified; }, 0);
    var verified = verifiedCount >= options.atLeast;

    return {
      message: createIntroMessage(),
      code: 'containsAtLeast',
      format: [options.atLeast, options.expressions.length],
      items: expressions,
      verified: verified
    };
  },
  assert: function (options, password) {
    if (!password) {
      return false;
    }

    var workingExpressions = options.expressions.filter(function (expression) {
      return expression.test(password);
    });

    return workingExpressions.length >= options.atLeast;
  },
  charsets: contains.charsets
};


/***/ }),

/***/ 899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _ = __webpack_require__(341);

function assert(options, password) {
  if (!password) {
    return false;
  }

  var i, current = {c: null, count: 0};

  for (i = 0; i < password.length; i++) {
    if (current.c !== password[i]) {
      current.c = password[i];
      current.count = 1;
    } else {
      current.count++;
    }

    if (current.count > options.max) {
      return false;
    }
  }

  return true;
}
function explain (options, verified) {
    var example = (new Array(options.max+2)).join('a');
    var d = {
      message: 'No more than %d identical characters in a row (e.g., "%s" not allowed)',
      code: 'identicalChars',
      format: [options.max, example]
    };
    if (verified !== undefined) {
      d.verified = verified;
    }
    return d;
  }

module.exports = {
  validate: function (options) {
    if (!_.isObject(options)) {
      throw new Error('options should be an object');
    }

    if (!_.isNumber(options.max) || _.isNaN(options.max) || options.max < 1 ) {
      throw new Error('max should be a number greater than 1');
    }

    return true;
  },
  explain: explain,
  missing: function (options, password) {
    return explain(options, assert(options, password));
  },
  assert: assert
};


/***/ }),

/***/ 484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _ = __webpack_require__(341);

/* A rule should contain explain and rule methods */
// TODO explain explain
// TODO explain missing
// TODO explain assert

function assert (options, password) {
  return !!password && options.minLength <= password.length;
}

function explain(options) {
  if (options.minLength === 1) {
    return {
      message: 'Non-empty password required',
      code: 'nonEmpty'
    };
  }

  return {
    message: 'At least %d characters in length',
    format: [options.minLength],
    code: 'lengthAtLeast'
  };
}

module.exports = {
  validate: function (options) {
    if (!_.isObject(options)) {
      throw new Error('options should be an object');
    }

    if (!_.isNumber(options.minLength) || _.isNaN(options.minLength)) {
      throw new Error('length expects minLength to be a non-zero number');
    }

    return true;
  },
  explain: explain,
  missing: function (options, password) {
    var explained = explain(options);
    explained.verified = !!assert(options, password);
    return explained;
  },
  assert: assert
};


/***/ }),

/***/ 773:
/***/ (function() {



/***/ }),

/***/ 328:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_187__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_187__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_187__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_187__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_187__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_187__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_187__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_187__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_187__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_187__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_187__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_187__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_187__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_187__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_187__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_187__(__nested_webpack_require_187__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "014b":
/***/ (function(module, exports, __nested_webpack_require_3663__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __nested_webpack_require_3663__("e53d");
var has = __nested_webpack_require_3663__("07e3");
var DESCRIPTORS = __nested_webpack_require_3663__("8e60");
var $export = __nested_webpack_require_3663__("63b6");
var redefine = __nested_webpack_require_3663__("9138");
var META = __nested_webpack_require_3663__("ebfd").KEY;
var $fails = __nested_webpack_require_3663__("294c");
var shared = __nested_webpack_require_3663__("dbdb");
var setToStringTag = __nested_webpack_require_3663__("45f2");
var uid = __nested_webpack_require_3663__("62a0");
var wks = __nested_webpack_require_3663__("5168");
var wksExt = __nested_webpack_require_3663__("ccb9");
var wksDefine = __nested_webpack_require_3663__("6718");
var enumKeys = __nested_webpack_require_3663__("47ee");
var isArray = __nested_webpack_require_3663__("9003");
var anObject = __nested_webpack_require_3663__("e4ae");
var isObject = __nested_webpack_require_3663__("f772");
var toObject = __nested_webpack_require_3663__("241e");
var toIObject = __nested_webpack_require_3663__("36c3");
var toPrimitive = __nested_webpack_require_3663__("1bc3");
var createDesc = __nested_webpack_require_3663__("aebd");
var _create = __nested_webpack_require_3663__("a159");
var gOPNExt = __nested_webpack_require_3663__("0395");
var $GOPD = __nested_webpack_require_3663__("bf0b");
var $GOPS = __nested_webpack_require_3663__("9aa9");
var $DP = __nested_webpack_require_3663__("d9f6");
var $keys = __nested_webpack_require_3663__("c3a1");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __nested_webpack_require_3663__("6abf").f = gOPNExt.f = $getOwnPropertyNames;
  __nested_webpack_require_3663__("355d").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__nested_webpack_require_3663__("b8e3")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __nested_webpack_require_3663__("35e8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "01f9":
/***/ (function(module, exports, __nested_webpack_require_13165__) {

"use strict";

var LIBRARY = __nested_webpack_require_13165__("2d00");
var $export = __nested_webpack_require_13165__("5ca1");
var redefine = __nested_webpack_require_13165__("2aba");
var hide = __nested_webpack_require_13165__("32e9");
var Iterators = __nested_webpack_require_13165__("84f2");
var $iterCreate = __nested_webpack_require_13165__("41a0");
var setToStringTag = __nested_webpack_require_13165__("7f20");
var getPrototypeOf = __nested_webpack_require_13165__("38fd");
var ITERATOR = __nested_webpack_require_13165__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "0395":
/***/ (function(module, exports, __nested_webpack_require_16071__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __nested_webpack_require_16071__("36c3");
var gOPN = __nested_webpack_require_16071__("6abf").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "0750":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgrey: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370d8',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#d87093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
    transparent: 'transparent'
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "07e3":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "0a49":
/***/ (function(module, exports, __nested_webpack_require_20851__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __nested_webpack_require_20851__("9b43");
var IObject = __nested_webpack_require_20851__("626a");
var toObject = __nested_webpack_require_20851__("4bf8");
var toLength = __nested_webpack_require_20851__("9def");
var asc = __nested_webpack_require_20851__("cd1c");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __nested_webpack_require_22446__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __nested_webpack_require_22446__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __nested_webpack_require_22905__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __nested_webpack_require_22905__("ce10");
var enumBugKeys = __nested_webpack_require_22905__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "0fc9":
/***/ (function(module, exports, __nested_webpack_require_23204__) {

var toInteger = __nested_webpack_require_23204__("3a38");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "1169":
/***/ (function(module, exports, __nested_webpack_require_23514__) {

// 7.2.2 IsArray(argument)
var cof = __nested_webpack_require_23514__("2d95");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "1173":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "11e9":
/***/ (function(module, exports, __nested_webpack_require_24055__) {

var pIE = __nested_webpack_require_24055__("52a7");
var createDesc = __nested_webpack_require_24055__("4630");
var toIObject = __nested_webpack_require_24055__("6821");
var toPrimitive = __nested_webpack_require_24055__("6a99");
var has = __nested_webpack_require_24055__("69a8");
var IE8_DOM_DEFINE = __nested_webpack_require_24055__("c69a");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __nested_webpack_require_24055__("9e1e") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __nested_webpack_require_24734__) {

var dP = __nested_webpack_require_24734__("86cc");
var anObject = __nested_webpack_require_24734__("cb7c");
var getKeys = __nested_webpack_require_24734__("0d58");

module.exports = __nested_webpack_require_24734__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "1654":
/***/ (function(module, exports, __nested_webpack_require_25234__) {

"use strict";

var $at = __nested_webpack_require_25234__("71c1")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__nested_webpack_require_25234__("30f1")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "1691":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "1af6":
/***/ (function(module, exports, __nested_webpack_require_26079__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __nested_webpack_require_26079__("63b6");

$export($export.S, 'Array', { isArray: __nested_webpack_require_26079__("9003") });


/***/ }),

/***/ "1bc3":
/***/ (function(module, exports, __nested_webpack_require_26320__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __nested_webpack_require_26320__("f772");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "1c15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (hex, coef = 1) => {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        let c = hex.substring(1).split('');
        if (c.length === 3)
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        const color = `0x${c.join("")}`; // eslint-disable-line
        return `rgba(${[(color >> 16) & 255, (color >> 8) & 255, color & 255].join(', ')}, ${coef})`;
    }
    throw new Error('Bad Hex');
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "1ec9":
/***/ (function(module, exports, __nested_webpack_require_27678__) {

var isObject = __nested_webpack_require_27678__("f772");
var document = __nested_webpack_require_27678__("e53d").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "20d6":
/***/ (function(module, exports, __nested_webpack_require_28062__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __nested_webpack_require_28062__("5ca1");
var $find = __nested_webpack_require_28062__("0a49")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__nested_webpack_require_28062__("9c6c")(KEY);


/***/ }),

/***/ "20fd":
/***/ (function(module, exports, __nested_webpack_require_28696__) {

"use strict";

var $defineProperty = __nested_webpack_require_28696__("d9f6");
var createDesc = __nested_webpack_require_28696__("aebd");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __nested_webpack_require_29056__) {

var isObject = __nested_webpack_require_29056__("d3f4");
var document = __nested_webpack_require_29056__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "241e":
/***/ (function(module, exports, __nested_webpack_require_29440__) {

// 7.1.13 ToObject(argument)
var defined = __nested_webpack_require_29440__("25eb");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "24c5":
/***/ (function(module, exports, __nested_webpack_require_29662__) {

"use strict";

var LIBRARY = __nested_webpack_require_29662__("b8e3");
var global = __nested_webpack_require_29662__("e53d");
var ctx = __nested_webpack_require_29662__("d864");
var classof = __nested_webpack_require_29662__("40c3");
var $export = __nested_webpack_require_29662__("63b6");
var isObject = __nested_webpack_require_29662__("f772");
var aFunction = __nested_webpack_require_29662__("79aa");
var anInstance = __nested_webpack_require_29662__("1173");
var forOf = __nested_webpack_require_29662__("a22a");
var speciesConstructor = __nested_webpack_require_29662__("f201");
var task = __nested_webpack_require_29662__("4178").set;
var microtask = __nested_webpack_require_29662__("aba2")();
var newPromiseCapabilityModule = __nested_webpack_require_29662__("656e");
var perform = __nested_webpack_require_29662__("4439");
var userAgent = __nested_webpack_require_29662__("bc13");
var promiseResolve = __nested_webpack_require_29662__("cd78");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__nested_webpack_require_29662__("5168")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __nested_webpack_require_29662__("5c95")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__nested_webpack_require_29662__("45f2")($Promise, PROMISE);
__nested_webpack_require_29662__("4c95")(PROMISE);
Wrapper = __nested_webpack_require_29662__("584a")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __nested_webpack_require_29662__("4ee1")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "252c":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_39648__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony export (binding) */ __nested_webpack_require_39648__.d(__webpack_exports__, "a", function() { return ResizeObserver; });
function getInternetExplorerVersion() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// other browser
	return -1;
}

var isIE = void 0;

function initCompat() {
	if (!initCompat.init) {
		initCompat.init = true;
		isIE = getInternetExplorerVersion() !== -1;
	}
}

var ResizeObserver = { render: function render() {
		var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "resize-observer", attrs: { "tabindex": "-1" } });
	}, staticRenderFns: [], _scopeId: 'data-v-b329ee4c',
	name: 'resize-observer',

	methods: {
		compareAndNotify: function compareAndNotify() {
			if (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) {
				this._w = this.$el.offsetWidth;
				this._h = this.$el.offsetHeight;
				this.$emit('notify');
			}
		},
		addResizeHandlers: function addResizeHandlers() {
			this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.compareAndNotify);
			this.compareAndNotify();
		},
		removeResizeHandlers: function removeResizeHandlers() {
			if (this._resizeObject && this._resizeObject.onload) {
				if (!isIE && this._resizeObject.contentDocument) {
					this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.compareAndNotify);
				}
				delete this._resizeObject.onload;
			}
		}
	},

	mounted: function mounted() {
		var _this = this;

		initCompat();
		this.$nextTick(function () {
			_this._w = _this.$el.offsetWidth;
			_this._h = _this.$el.offsetHeight;
		});
		var object = document.createElement('object');
		this._resizeObject = object;
		object.setAttribute('aria-hidden', 'true');
		object.setAttribute('tabindex', -1);
		object.onload = this.addResizeHandlers;
		object.type = 'text/html';
		if (isIE) {
			this.$el.appendChild(object);
		}
		object.data = 'about:blank';
		if (!isIE) {
			this.$el.appendChild(object);
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.removeResizeHandlers();
	}
};

// Install the components
function install(Vue) {
	Vue.component('resize-observer', ResizeObserver);
	Vue.component('ResizeObserver', ResizeObserver);
}

// Plugin
var plugin = {
	// eslint-disable-next-line no-undef
	version: "0.4.5",
	install: install
};

// Auto-install
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}


/* unused harmony default export */ var _unused_webpack_default_export = (plugin);

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_39648__("c8ba")))

/***/ }),

/***/ "25eb":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "292a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (color, percent) => {
    if (color.length < 7)
        throw new Error(`[shade-color] color must be formatted "#FFFFFF" not like this "#FFF" - (${color})`);
    if (!color.includes('#'))
        throw new Error(`[shade-color] color must be an HEX - ex: "#FFFFFF" - (${color})`);
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);
    R = parseInt(String((R * (100 + percent)) / 100));
    G = parseInt(String((G * (100 + percent)) / 100));
    B = parseInt(String((B * (100 + percent)) / 100));
    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;
    const RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16);
    const GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16);
    const BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16);
    return '#' + RR + GG + BB;
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "294c":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __nested_webpack_require_44729__) {

var global = __nested_webpack_require_44729__("7726");
var hide = __nested_webpack_require_44729__("32e9");
var has = __nested_webpack_require_44729__("69a8");
var SRC = __nested_webpack_require_44729__("ca5a")('src');
var $toString = __nested_webpack_require_44729__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__nested_webpack_require_44729__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __nested_webpack_require_45903__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __nested_webpack_require_45903__("cb7c");
var dPs = __nested_webpack_require_45903__("1495");
var enumBugKeys = __nested_webpack_require_45903__("e11e");
var IE_PROTO = __nested_webpack_require_45903__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __nested_webpack_require_45903__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __nested_webpack_require_45903__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __nested_webpack_require_47514__) {

var store = __nested_webpack_require_47514__("5537")('wks');
var uid = __nested_webpack_require_47514__("ca5a");
var Symbol = __nested_webpack_require_47514__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __nested_webpack_require_48236__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __nested_webpack_require_48236__("5ca1");
var context = __nested_webpack_require_48236__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __nested_webpack_require_48236__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "3024":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "30f1":
/***/ (function(module, exports, __nested_webpack_require_49568__) {

"use strict";

var LIBRARY = __nested_webpack_require_49568__("b8e3");
var $export = __nested_webpack_require_49568__("63b6");
var redefine = __nested_webpack_require_49568__("9138");
var hide = __nested_webpack_require_49568__("35e8");
var Iterators = __nested_webpack_require_49568__("481b");
var $iterCreate = __nested_webpack_require_49568__("8f60");
var setToStringTag = __nested_webpack_require_49568__("45f2");
var getPrototypeOf = __nested_webpack_require_49568__("53e2");
var ITERATOR = __nested_webpack_require_49568__("5168")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __nested_webpack_require_52474__) {

var dP = __nested_webpack_require_52474__("86cc");
var createDesc = __nested_webpack_require_52474__("4630");
module.exports = __nested_webpack_require_52474__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "32fc":
/***/ (function(module, exports, __nested_webpack_require_52850__) {

var document = __nested_webpack_require_52850__("e53d").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "335c":
/***/ (function(module, exports, __nested_webpack_require_53042__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __nested_webpack_require_53042__("6b4c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "355d":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "35e8":
/***/ (function(module, exports, __nested_webpack_require_53525__) {

var dP = __nested_webpack_require_53525__("d9f6");
var createDesc = __nested_webpack_require_53525__("aebd");
module.exports = __nested_webpack_require_53525__("8e60") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "36c3":
/***/ (function(module, exports, __nested_webpack_require_53901__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __nested_webpack_require_53901__("335c");
var defined = __nested_webpack_require_53901__("25eb");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "3702":
/***/ (function(module, exports, __nested_webpack_require_54214__) {

// check on default Array iterator
var Iterators = __nested_webpack_require_54214__("481b");
var ITERATOR = __nested_webpack_require_54214__("5168")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "3846":
/***/ (function(module, exports, __nested_webpack_require_54591__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__nested_webpack_require_54591__("9e1e") && /./g.flags != 'g') __nested_webpack_require_54591__("86cc").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __nested_webpack_require_54591__("0bfb")
});


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __nested_webpack_require_54890__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __nested_webpack_require_54890__("69a8");
var toObject = __nested_webpack_require_54890__("4bf8");
var IE_PROTO = __nested_webpack_require_54890__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "3a38":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "3c11":
/***/ (function(module, exports, __nested_webpack_require_55708__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __nested_webpack_require_55708__("63b6");
var core = __nested_webpack_require_55708__("584a");
var global = __nested_webpack_require_55708__("e53d");
var speciesConstructor = __nested_webpack_require_55708__("f201");
var promiseResolve = __nested_webpack_require_55708__("cd78");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "40c3":
/***/ (function(module, exports, __nested_webpack_require_56571__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __nested_webpack_require_56571__("6b4c");
var TAG = __nested_webpack_require_56571__("5168")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "4178":
/***/ (function(module, exports, __nested_webpack_require_57393__) {

var ctx = __nested_webpack_require_57393__("d864");
var invoke = __nested_webpack_require_57393__("3024");
var html = __nested_webpack_require_57393__("32fc");
var cel = __nested_webpack_require_57393__("1ec9");
var global = __nested_webpack_require_57393__("e53d");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__nested_webpack_require_57393__("6b4c")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __nested_webpack_require_60007__) {

"use strict";

var create = __nested_webpack_require_60007__("2aeb");
var descriptor = __nested_webpack_require_60007__("4630");
var setToStringTag = __nested_webpack_require_60007__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__nested_webpack_require_60007__("32e9")(IteratorPrototype, __nested_webpack_require_60007__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "43fc":
/***/ (function(module, exports, __nested_webpack_require_60633__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __nested_webpack_require_60633__("63b6");
var newPromiseCapability = __nested_webpack_require_60633__("656e");
var perform = __nested_webpack_require_60633__("4439");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "4439":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "454f":
/***/ (function(module, exports, __nested_webpack_require_61394__) {

__nested_webpack_require_61394__("46a7");
var $Object = __nested_webpack_require_61394__("584a").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __nested_webpack_require_61666__) {

// 19.1.2.14 Object.keys(O)
var toObject = __nested_webpack_require_61666__("4bf8");
var $keys = __nested_webpack_require_61666__("0d58");

__nested_webpack_require_61666__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "45d0":
/***/ (function(module, exports, __nested_webpack_require_62208__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _constantes_1 = __importDefault(__nested_webpack_require_62208__("0750"));
exports.default = (color) => {
    if (!color)
        throw new Error('is-color-name: No color provided');
    const colorsList = Object.keys(_constantes_1.default);
    return colorsList.includes(color);
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "45f2":
/***/ (function(module, exports, __nested_webpack_require_62819__) {

var def = __nested_webpack_require_62819__("d9f6").f;
var has = __nested_webpack_require_62819__("07e3");
var TAG = __nested_webpack_require_62819__("5168")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "46a7":
/***/ (function(module, exports, __nested_webpack_require_63425__) {

var $export = __nested_webpack_require_63425__("63b6");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__nested_webpack_require_63425__("8e60"), 'Object', { defineProperty: __nested_webpack_require_63425__("d9f6").f });


/***/ }),

/***/ "47ee":
/***/ (function(module, exports, __nested_webpack_require_63739__) {

// all enumerable object keys, includes symbols
var getKeys = __nested_webpack_require_63739__("c3a1");
var gOPS = __nested_webpack_require_63739__("9aa9");
var pIE = __nested_webpack_require_63739__("355d");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "481b":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __nested_webpack_require_64383__) {

// 7.1.13 ToObject(argument)
var defined = __nested_webpack_require_64383__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "4c95":
/***/ (function(module, exports, __nested_webpack_require_64605__) {

"use strict";

var global = __nested_webpack_require_64605__("e53d");
var core = __nested_webpack_require_64605__("584a");
var dP = __nested_webpack_require_64605__("d9f6");
var DESCRIPTORS = __nested_webpack_require_64605__("8e60");
var SPECIES = __nested_webpack_require_64605__("5168")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "4ee1":
/***/ (function(module, exports, __nested_webpack_require_65157__) {

var ITERATOR = __nested_webpack_require_65157__("5168")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "50ed":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __nested_webpack_require_66045__) {

var MATCH = __nested_webpack_require_66045__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "5168":
/***/ (function(module, exports, __nested_webpack_require_66390__) {

var store = __nested_webpack_require_66390__("dbdb")('wks');
var uid = __nested_webpack_require_66390__("62a0");
var Symbol = __nested_webpack_require_66390__("e53d").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "53e2":
/***/ (function(module, exports, __nested_webpack_require_66956__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __nested_webpack_require_66956__("07e3");
var toObject = __nested_webpack_require_66956__("241e");
var IE_PROTO = __nested_webpack_require_66956__("5559")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "549b":
/***/ (function(module, exports, __nested_webpack_require_67550__) {

"use strict";

var ctx = __nested_webpack_require_67550__("d864");
var $export = __nested_webpack_require_67550__("63b6");
var toObject = __nested_webpack_require_67550__("241e");
var call = __nested_webpack_require_67550__("b0dc");
var isArrayIter = __nested_webpack_require_67550__("3702");
var toLength = __nested_webpack_require_67550__("b447");
var createProperty = __nested_webpack_require_67550__("20fd");
var getIterFn = __nested_webpack_require_67550__("7cd6");

$export($export.S + $export.F * !__nested_webpack_require_67550__("4ee1")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "54a1":
/***/ (function(module, exports, __nested_webpack_require_69289__) {

__nested_webpack_require_69289__("6c1c");
__nested_webpack_require_69289__("1654");
module.exports = __nested_webpack_require_69289__("95d5");


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __nested_webpack_require_69477__) {

var core = __nested_webpack_require_69477__("8378");
var global = __nested_webpack_require_69477__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __nested_webpack_require_69477__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5559":
/***/ (function(module, exports, __nested_webpack_require_70010__) {

var shared = __nested_webpack_require_70010__("dbdb")('keys');
var uid = __nested_webpack_require_70010__("62a0");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "584a":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "5b4e":
/***/ (function(module, exports, __nested_webpack_require_70456__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __nested_webpack_require_70456__("36c3");
var toLength = __nested_webpack_require_70456__("b447");
var toAbsoluteIndex = __nested_webpack_require_70456__("0fc9");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "5c95":
/***/ (function(module, exports, __nested_webpack_require_71467__) {

var hide = __nested_webpack_require_71467__("35e8");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __nested_webpack_require_71777__) {

var global = __nested_webpack_require_71777__("7726");
var core = __nested_webpack_require_71777__("8378");
var hide = __nested_webpack_require_71777__("32e9");
var redefine = __nested_webpack_require_71777__("2aba");
var ctx = __nested_webpack_require_71777__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5dbc":
/***/ (function(module, exports, __nested_webpack_require_73502__) {

var isObject = __nested_webpack_require_73502__("d3f4");
var setPrototypeOf = __nested_webpack_require_73502__("8b97").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __nested_webpack_require_73931__) {

// most Object methods by ES6 should accept primitives
var $export = __nested_webpack_require_73931__("5ca1");
var core = __nested_webpack_require_73931__("8378");
var fails = __nested_webpack_require_73931__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "6038":
/***/ (function(module, exports, __nested_webpack_require_74409__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgba = exports.colorNameToHex = exports.isColorName = exports.shadeColor = void 0;
const shade_color_1 = __importDefault(__nested_webpack_require_74409__("292a"));
exports.shadeColor = shade_color_1.default;
const is_color_name_1 = __importDefault(__nested_webpack_require_74409__("45d0"));
exports.isColorName = is_color_name_1.default;
const hex_to_rgba_1 = __importDefault(__nested_webpack_require_74409__("1c15"));
exports.hexToRgba = hex_to_rgba_1.default;
const color_name_to_hex_1 = __importDefault(__nested_webpack_require_74409__("c3b0"));
exports.colorNameToHex = color_name_to_hex_1.default;
//# sourceMappingURL=app.js.map

/***/ }),

/***/ "613b":
/***/ (function(module, exports, __nested_webpack_require_75305__) {

var shared = __nested_webpack_require_75305__("5537")('keys');
var uid = __nested_webpack_require_75305__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __nested_webpack_require_75565__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __nested_webpack_require_75565__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "62a0":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "63b6":
/***/ (function(module, exports, __nested_webpack_require_76173__) {

var global = __nested_webpack_require_76173__("e53d");
var core = __nested_webpack_require_76173__("584a");
var ctx = __nested_webpack_require_76173__("d864");
var hide = __nested_webpack_require_76173__("35e8");
var has = __nested_webpack_require_76173__("07e3");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "656e":
/***/ (function(module, exports, __nested_webpack_require_78651__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __nested_webpack_require_78651__("79aa");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "6718":
/***/ (function(module, exports, __nested_webpack_require_79243__) {

var global = __nested_webpack_require_79243__("e53d");
var core = __nested_webpack_require_79243__("584a");
var LIBRARY = __nested_webpack_require_79243__("b8e3");
var wksExt = __nested_webpack_require_79243__("ccb9");
var defineProperty = __nested_webpack_require_79243__("d9f6").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __nested_webpack_require_79776__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __nested_webpack_require_79776__("5ca1");
var $includes = __nested_webpack_require_79776__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__nested_webpack_require_79776__("9c6c")('includes');


/***/ }),

/***/ "67bb":
/***/ (function(module, exports, __nested_webpack_require_80241__) {

module.exports = __nested_webpack_require_80241__("f921");

/***/ }),

/***/ "6821":
/***/ (function(module, exports, __nested_webpack_require_80370__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __nested_webpack_require_80370__("626a");
var defined = __nested_webpack_require_80370__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "696e":
/***/ (function(module, exports, __nested_webpack_require_80683__) {

__nested_webpack_require_80683__("c207");
__nested_webpack_require_80683__("1654");
__nested_webpack_require_80683__("6c1c");
__nested_webpack_require_80683__("24c5");
__nested_webpack_require_80683__("3c11");
__nested_webpack_require_80683__("43fc");
module.exports = __nested_webpack_require_80683__("584a").Promise;


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "69d3":
/***/ (function(module, exports, __nested_webpack_require_81178__) {

__nested_webpack_require_81178__("6718")('asyncIterator');


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __nested_webpack_require_81308__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __nested_webpack_require_81308__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "6abf":
/***/ (function(module, exports, __nested_webpack_require_82051__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __nested_webpack_require_82051__("e6f3");
var hiddenKeys = __nested_webpack_require_82051__("1691").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "6b4c":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "6b54":
/***/ (function(module, exports, __nested_webpack_require_82585__) {

"use strict";

__nested_webpack_require_82585__("3846");
var anObject = __nested_webpack_require_82585__("cb7c");
var $flags = __nested_webpack_require_82585__("0bfb");
var DESCRIPTORS = __nested_webpack_require_82585__("9e1e");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __nested_webpack_require_82585__("2aba")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__nested_webpack_require_82585__("79e5")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "6c1c":
/***/ (function(module, exports, __nested_webpack_require_83521__) {

__nested_webpack_require_83521__("c367");
var global = __nested_webpack_require_83521__("e53d");
var hide = __nested_webpack_require_83521__("35e8");
var Iterators = __nested_webpack_require_83521__("481b");
var TO_STRING_TAG = __nested_webpack_require_83521__("5168")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "71c1":
/***/ (function(module, exports, __nested_webpack_require_84600__) {

var toInteger = __nested_webpack_require_84600__("3a38");
var defined = __nested_webpack_require_84600__("25eb");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "7514":
/***/ (function(module, exports, __nested_webpack_require_85313__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __nested_webpack_require_85313__("5ca1");
var $find = __nested_webpack_require_85313__("0a49")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__nested_webpack_require_85313__("9c6c")(KEY);


/***/ }),

/***/ "765d":
/***/ (function(module, exports, __nested_webpack_require_85927__) {

__nested_webpack_require_85927__("6718")('observable');


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "774e":
/***/ (function(module, exports, __nested_webpack_require_86486__) {

module.exports = __nested_webpack_require_86486__("d2d5");

/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __nested_webpack_require_86615__) {

var toInteger = __nested_webpack_require_86615__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "794b":
/***/ (function(module, exports, __nested_webpack_require_86925__) {

module.exports = !__nested_webpack_require_86925__("8e60") && !__nested_webpack_require_86925__("294c")(function () {
  return Object.defineProperty(__nested_webpack_require_86925__("1ec9")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "795b":
/***/ (function(module, exports, __nested_webpack_require_87221__) {

module.exports = __nested_webpack_require_87221__("696e");

/***/ }),

/***/ "79aa":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7cd6":
/***/ (function(module, exports, __nested_webpack_require_87705__) {

var classof = __nested_webpack_require_87705__("40c3");
var ITERATOR = __nested_webpack_require_87705__("5168")('iterator');
var Iterators = __nested_webpack_require_87705__("481b");
module.exports = __nested_webpack_require_87705__("584a").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "7e90":
/***/ (function(module, exports, __nested_webpack_require_88115__) {

var dP = __nested_webpack_require_88115__("d9f6");
var anObject = __nested_webpack_require_88115__("e4ae");
var getKeys = __nested_webpack_require_88115__("c3a1");

module.exports = __nested_webpack_require_88115__("8e60") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __nested_webpack_require_88615__) {

var def = __nested_webpack_require_88615__("86cc").f;
var has = __nested_webpack_require_88615__("69a8");
var TAG = __nested_webpack_require_88615__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __nested_webpack_require_88985__) {

var dP = __nested_webpack_require_88985__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __nested_webpack_require_88985__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "8436":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "85f2":
/***/ (function(module, exports, __nested_webpack_require_89932__) {

module.exports = __nested_webpack_require_89932__("454f");

/***/ }),

/***/ "85fe":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_90073__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __nested_webpack_require_90073__.d(__webpack_exports__, "a", function() { return ObserveVisibility; });
/* unused harmony export install */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function processOptions(value) {
  var options;

  if (typeof value === 'function') {
    // Simple options (callback-only)
    options = {
      callback: value
    };
  } else {
    // Options object
    options = value;
  }

  return options;
}
function throttle(callback, delay) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout;
  var lastState;
  var currentArgs;

  var throttled = function throttled(state) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    currentArgs = args;
    if (timeout && state === lastState) return;
    var leading = options.leading;

    if (typeof leading === 'function') {
      leading = leading(state, lastState);
    }

    if ((!timeout || state !== lastState) && leading) {
      callback.apply(void 0, [state].concat(_toConsumableArray(currentArgs)));
    }

    lastState = state;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      callback.apply(void 0, [state].concat(_toConsumableArray(currentArgs)));
      timeout = 0;
    }, delay);
  };

  throttled._clear = function () {
    clearTimeout(timeout);
    timeout = null;
  };

  return throttled;
}
function deepEqual(val1, val2) {
  if (val1 === val2) return true;

  if (_typeof(val1) === 'object') {
    for (var key in val1) {
      if (!deepEqual(val1[key], val2[key])) {
        return false;
      }
    }

    return true;
  }

  return false;
}

var VisibilityState =
/*#__PURE__*/
function () {
  function VisibilityState(el, options, vnode) {
    _classCallCheck(this, VisibilityState);

    this.el = el;
    this.observer = null;
    this.frozen = false;
    this.createObserver(options, vnode);
  }

  _createClass(VisibilityState, [{
    key: "createObserver",
    value: function createObserver(options, vnode) {
      var _this = this;

      if (this.observer) {
        this.destroyObserver();
      }

      if (this.frozen) return;
      this.options = processOptions(options);

      this.callback = function (result, entry) {
        _this.options.callback(result, entry);

        if (result && _this.options.once) {
          _this.frozen = true;

          _this.destroyObserver();
        }
      }; // Throttle


      if (this.callback && this.options.throttle) {
        var _ref = this.options.throttleOptions || {},
            _leading = _ref.leading;

        this.callback = throttle(this.callback, this.options.throttle, {
          leading: function leading(state) {
            return _leading === 'both' || _leading === 'visible' && state || _leading === 'hidden' && !state;
          }
        });
      }

      this.oldResult = undefined;
      this.observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];

        if (entries.length > 1) {
          var intersectingEntry = entries.find(function (e) {
            return e.isIntersecting;
          });

          if (intersectingEntry) {
            entry = intersectingEntry;
          }
        }

        if (_this.callback) {
          // Use isIntersecting if possible because browsers can report isIntersecting as true, but intersectionRatio as 0, when something very slowly enters the viewport.
          var result = entry.isIntersecting && entry.intersectionRatio >= _this.threshold;
          if (result === _this.oldResult) return;
          _this.oldResult = result;

          _this.callback(result, entry);
        }
      }, this.options.intersection); // Wait for the element to be in document

      vnode.context.$nextTick(function () {
        if (_this.observer) {
          _this.observer.observe(_this.el);
        }
      });
    }
  }, {
    key: "destroyObserver",
    value: function destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      } // Cancel throttled call


      if (this.callback && this.callback._clear) {
        this.callback._clear();

        this.callback = null;
      }
    }
  }, {
    key: "threshold",
    get: function get() {
      return this.options.intersection && this.options.intersection.threshold || 0;
    }
  }]);

  return VisibilityState;
}();

function bind(el, _ref2, vnode) {
  var value = _ref2.value;
  if (!value) return;

  if (typeof IntersectionObserver === 'undefined') {
    console.warn('[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill');
  } else {
    var state = new VisibilityState(el, value, vnode);
    el._vue_visibilityState = state;
  }
}

function update(el, _ref3, vnode) {
  var value = _ref3.value,
      oldValue = _ref3.oldValue;
  if (deepEqual(value, oldValue)) return;
  var state = el._vue_visibilityState;

  if (!value) {
    unbind(el);
    return;
  }

  if (state) {
    state.createObserver(value, vnode);
  } else {
    bind(el, {
      value: value
    }, vnode);
  }
}

function unbind(el) {
  var state = el._vue_visibilityState;

  if (state) {
    state.destroyObserver();
    delete el._vue_visibilityState;
  }
}

var ObserveVisibility = {
  bind: bind,
  update: update,
  unbind: unbind
};

function install(Vue) {
  Vue.directive('observe-visibility', ObserveVisibility);
  /* -- Add more components here -- */
}
/* -- Plugin definition & Auto-install -- */

/* You shouldn't have to modify the code below */
// Plugin

var plugin = {
  // eslint-disable-next-line no-undef
  version: "0.4.6",
  install: install
};

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* unused harmony default export */ var _unused_webpack_default_export = (plugin);


/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_90073__("c8ba")))

/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __nested_webpack_require_98052__) {

var anObject = __nested_webpack_require_98052__("cb7c");
var IE8_DOM_DEFINE = __nested_webpack_require_98052__("c69a");
var toPrimitive = __nested_webpack_require_98052__("6a99");
var dP = Object.defineProperty;

exports.f = __nested_webpack_require_98052__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    if (document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8b97":
/***/ (function(module, exports, __nested_webpack_require_101654__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __nested_webpack_require_101654__("d3f4");
var anObject = __nested_webpack_require_101654__("cb7c");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __nested_webpack_require_101654__("9b43")(Function.call, __nested_webpack_require_101654__("11e9").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __webpack_require__(697);

/***/ }),

/***/ "8e60":
/***/ (function(module, exports, __nested_webpack_require_102759__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__nested_webpack_require_102759__("294c")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "8e6e":
/***/ (function(module, exports, __nested_webpack_require_103035__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __nested_webpack_require_103035__("5ca1");
var ownKeys = __nested_webpack_require_103035__("990b");
var toIObject = __nested_webpack_require_103035__("6821");
var gOPD = __nested_webpack_require_103035__("11e9");
var createProperty = __nested_webpack_require_103035__("f1ae");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "8f60":
/***/ (function(module, exports, __nested_webpack_require_103824__) {

"use strict";

var create = __nested_webpack_require_103824__("a159");
var descriptor = __nested_webpack_require_103824__("aebd");
var setToStringTag = __nested_webpack_require_103824__("45f2");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__nested_webpack_require_103824__("35e8")(IteratorPrototype, __nested_webpack_require_103824__("5168")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "9003":
/***/ (function(module, exports, __nested_webpack_require_104450__) {

// 7.2.2 IsArray(argument)
var cof = __nested_webpack_require_104450__("6b4c");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "9093":
/***/ (function(module, exports, __nested_webpack_require_104691__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __nested_webpack_require_104691__("ce10");
var hiddenKeys = __nested_webpack_require_104691__("e11e").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "9138":
/***/ (function(module, exports, __nested_webpack_require_105056__) {

module.exports = __nested_webpack_require_105056__("35e8");


/***/ }),

/***/ "95d5":
/***/ (function(module, exports, __nested_webpack_require_105186__) {

var classof = __nested_webpack_require_105186__("40c3");
var ITERATOR = __nested_webpack_require_105186__("5168")('iterator');
var Iterators = __nested_webpack_require_105186__("481b");
module.exports = __nested_webpack_require_105186__("584a").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
    true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "990b":
/***/ (function(module, exports, __nested_webpack_require_130585__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __nested_webpack_require_130585__("9093");
var gOPS = __nested_webpack_require_130585__("2621");
var anObject = __nested_webpack_require_130585__("cb7c");
var Reflect = __nested_webpack_require_130585__("7726").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "9aa9":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __nested_webpack_require_131198__) {

// optional / simple context binding
var aFunction = __nested_webpack_require_131198__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __nested_webpack_require_131805__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __nested_webpack_require_131805__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __nested_webpack_require_131805__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __nested_webpack_require_132205__) {

// 7.1.15 ToLength
var toInteger = __nested_webpack_require_132205__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __nested_webpack_require_132507__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__nested_webpack_require_132507__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a159":
/***/ (function(module, exports, __nested_webpack_require_132783__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __nested_webpack_require_132783__("e4ae");
var dPs = __nested_webpack_require_132783__("7e90");
var enumBugKeys = __nested_webpack_require_132783__("1691");
var IE_PROTO = __nested_webpack_require_132783__("5559")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __nested_webpack_require_132783__("1ec9")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __nested_webpack_require_132783__("32fc").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "a22a":
/***/ (function(module, exports, __nested_webpack_require_134394__) {

var ctx = __nested_webpack_require_134394__("d864");
var call = __nested_webpack_require_134394__("b0dc");
var isArrayIter = __nested_webpack_require_134394__("3702");
var anObject = __nested_webpack_require_134394__("e4ae");
var toLength = __nested_webpack_require_134394__("b447");
var getIterFn = __nested_webpack_require_134394__("7cd6");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "a745":
/***/ (function(module, exports, __nested_webpack_require_135666__) {

module.exports = __nested_webpack_require_135666__("f410");

/***/ }),

/***/ "aa77":
/***/ (function(module, exports, __nested_webpack_require_135795__) {

var $export = __nested_webpack_require_135795__("5ca1");
var defined = __nested_webpack_require_135795__("be13");
var fails = __nested_webpack_require_135795__("79e5");
var spaces = __nested_webpack_require_135795__("fdef");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __nested_webpack_require_136803__) {

// 7.2.8 IsRegExp(argument)
var isObject = __nested_webpack_require_136803__("d3f4");
var cof = __nested_webpack_require_136803__("2d95");
var MATCH = __nested_webpack_require_136803__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "aba2":
/***/ (function(module, exports, __nested_webpack_require_137200__) {

var global = __nested_webpack_require_137200__("e53d");
var macrotask = __nested_webpack_require_137200__("4178").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __nested_webpack_require_137200__("6b4c")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __nested_webpack_require_139292__) {

var $iterators = __nested_webpack_require_139292__("cadf");
var getKeys = __nested_webpack_require_139292__("0d58");
var redefine = __nested_webpack_require_139292__("2aba");
var global = __nested_webpack_require_139292__("7726");
var hide = __nested_webpack_require_139292__("32e9");
var Iterators = __nested_webpack_require_139292__("84f2");
var wks = __nested_webpack_require_139292__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "aebd":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "b0dc":
/***/ (function(module, exports, __nested_webpack_require_141455__) {

// call something on iterator step with safe closing on error
var anObject = __nested_webpack_require_141455__("e4ae");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "b447":
/***/ (function(module, exports, __nested_webpack_require_141953__) {

// 7.1.15 ToLength
var toInteger = __nested_webpack_require_141953__("3a38");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "b8e3":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "bc13":
/***/ (function(module, exports, __nested_webpack_require_142341__) {

var global = __nested_webpack_require_142341__("e53d");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "bf0b":
/***/ (function(module, exports, __nested_webpack_require_142784__) {

var pIE = __nested_webpack_require_142784__("355d");
var createDesc = __nested_webpack_require_142784__("aebd");
var toIObject = __nested_webpack_require_142784__("36c3");
var toPrimitive = __nested_webpack_require_142784__("1bc3");
var has = __nested_webpack_require_142784__("07e3");
var IE8_DOM_DEFINE = __nested_webpack_require_142784__("794b");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __nested_webpack_require_142784__("8e60") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "c207":
/***/ (function(module, exports) {



/***/ }),

/***/ "c366":
/***/ (function(module, exports, __nested_webpack_require_143526__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __nested_webpack_require_143526__("6821");
var toLength = __nested_webpack_require_143526__("9def");
var toAbsoluteIndex = __nested_webpack_require_143526__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c367":
/***/ (function(module, exports, __nested_webpack_require_144537__) {

"use strict";

var addToUnscopables = __nested_webpack_require_144537__("8436");
var step = __nested_webpack_require_144537__("50ed");
var Iterators = __nested_webpack_require_144537__("481b");
var toIObject = __nested_webpack_require_144537__("36c3");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __nested_webpack_require_144537__("30f1")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "c3a1":
/***/ (function(module, exports, __nested_webpack_require_145746__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __nested_webpack_require_145746__("e6f3");
var enumBugKeys = __nested_webpack_require_145746__("1691");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "c3b0":
/***/ (function(module, exports, __nested_webpack_require_146045__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _constantes_1 = __importDefault(__nested_webpack_require_146045__("0750"));
exports.default = (color) => {
    if (!color)
        throw new Error('color-name-to-hex: No color name provided');
    const colorFound = _constantes_1.default[color.toLowerCase()];
    if (typeof colorFound !== 'undefined')
        return colorFound;
    throw new Error(`No hex found for ${color}`);
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "c50b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c5f6":
/***/ (function(module, exports, __nested_webpack_require_146877__) {

"use strict";

var global = __nested_webpack_require_146877__("7726");
var has = __nested_webpack_require_146877__("69a8");
var cof = __nested_webpack_require_146877__("2d95");
var inheritIfRequired = __nested_webpack_require_146877__("5dbc");
var toPrimitive = __nested_webpack_require_146877__("6a99");
var fails = __nested_webpack_require_146877__("79e5");
var gOPN = __nested_webpack_require_146877__("9093").f;
var gOPD = __nested_webpack_require_146877__("11e9").f;
var dP = __nested_webpack_require_146877__("86cc").f;
var $trim = __nested_webpack_require_146877__("aa77").trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__nested_webpack_require_146877__("2aeb")(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __nested_webpack_require_146877__("9e1e") ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __nested_webpack_require_146877__("2aba")(global, NUMBER, $Number);
}


/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __nested_webpack_require_149802__) {

module.exports = !__nested_webpack_require_149802__("9e1e") && !__nested_webpack_require_149802__("79e5")(function () {
  return Object.defineProperty(__nested_webpack_require_149802__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8bb":
/***/ (function(module, exports, __nested_webpack_require_150633__) {

module.exports = __nested_webpack_require_150633__("54a1");

/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __nested_webpack_require_150987__) {

"use strict";

var addToUnscopables = __nested_webpack_require_150987__("9c6c");
var step = __nested_webpack_require_150987__("d53b");
var Iterators = __nested_webpack_require_150987__("84f2");
var toIObject = __nested_webpack_require_150987__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __nested_webpack_require_150987__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __nested_webpack_require_152196__) {

var isObject = __nested_webpack_require_152196__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ccb9":
/***/ (function(module, exports, __nested_webpack_require_152438__) {

exports.f = __nested_webpack_require_152438__("5168");


/***/ }),

/***/ "cd1c":
/***/ (function(module, exports, __nested_webpack_require_152563__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __nested_webpack_require_152563__("e853");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "cd78":
/***/ (function(module, exports, __nested_webpack_require_152858__) {

var anObject = __nested_webpack_require_152858__("e4ae");
var isObject = __nested_webpack_require_152858__("f772");
var newPromiseCapability = __nested_webpack_require_152858__("656e");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __nested_webpack_require_153338__) {

var has = __nested_webpack_require_153338__("69a8");
var toIObject = __nested_webpack_require_153338__("6821");
var arrayIndexOf = __nested_webpack_require_153338__("c366")(false);
var IE_PROTO = __nested_webpack_require_153338__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __nested_webpack_require_153974__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __nested_webpack_require_153974__("aae3");
var defined = __nested_webpack_require_153974__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d2d5":
/***/ (function(module, exports, __nested_webpack_require_154382__) {

__nested_webpack_require_154382__("1654");
__nested_webpack_require_154382__("549b");
module.exports = __nested_webpack_require_154382__("584a").Array.from;


/***/ }),

/***/ "d391":
/***/ (function(module) {

module.exports = JSON.parse("{\"AC\":\"40123\",\"AD\":\"312345\",\"AE\":\"501234567\",\"AF\":\"701234567\",\"AG\":\"2684641234\",\"AI\":\"2642351234\",\"AL\":\"672123456\",\"AM\":\"77123456\",\"AO\":\"923123456\",\"AR\":\"91123456789\",\"AS\":\"6847331234\",\"AT\":\"664123456\",\"AU\":\"412345678\",\"AW\":\"5601234\",\"AX\":\"412345678\",\"AZ\":\"401234567\",\"BA\":\"61123456\",\"BB\":\"2462501234\",\"BD\":\"1812345678\",\"BE\":\"470123456\",\"BF\":\"70123456\",\"BG\":\"43012345\",\"BH\":\"36001234\",\"BI\":\"79561234\",\"BJ\":\"90011234\",\"BL\":\"690001234\",\"BM\":\"4413701234\",\"BN\":\"7123456\",\"BO\":\"71234567\",\"BQ\":\"3181234\",\"BR\":\"11961234567\",\"BS\":\"2423591234\",\"BT\":\"17123456\",\"BW\":\"71123456\",\"BY\":\"294911911\",\"BZ\":\"6221234\",\"CA\":\"5062345678\",\"CC\":\"412345678\",\"CD\":\"991234567\",\"CF\":\"70012345\",\"CG\":\"061234567\",\"CH\":\"781234567\",\"CI\":\"0123456789\",\"CK\":\"71234\",\"CL\":\"221234567\",\"CM\":\"671234567\",\"CN\":\"13123456789\",\"CO\":\"3211234567\",\"CR\":\"83123456\",\"CU\":\"51234567\",\"CV\":\"9911234\",\"CW\":\"95181234\",\"CX\":\"412345678\",\"CY\":\"96123456\",\"CZ\":\"601123456\",\"DE\":\"15123456789\",\"DJ\":\"77831001\",\"DK\":\"32123456\",\"DM\":\"7672251234\",\"DO\":\"8092345678\",\"DZ\":\"551234567\",\"EC\":\"991234567\",\"EE\":\"51234567\",\"EG\":\"1001234567\",\"EH\":\"650123456\",\"ER\":\"7123456\",\"ES\":\"612345678\",\"ET\":\"911234567\",\"FI\":\"412345678\",\"FJ\":\"7012345\",\"FK\":\"51234\",\"FM\":\"3501234\",\"FO\":\"211234\",\"FR\":\"612345678\",\"GA\":\"06031234\",\"GB\":\"7400123456\",\"GD\":\"4734031234\",\"GE\":\"555123456\",\"GF\":\"694201234\",\"GG\":\"7781123456\",\"GH\":\"231234567\",\"GI\":\"57123456\",\"GL\":\"221234\",\"GM\":\"3012345\",\"GN\":\"601123456\",\"GP\":\"690001234\",\"GQ\":\"222123456\",\"GR\":\"6912345678\",\"GT\":\"51234567\",\"GU\":\"6713001234\",\"GW\":\"955012345\",\"GY\":\"6091234\",\"HK\":\"51234567\",\"HN\":\"91234567\",\"HR\":\"921234567\",\"HT\":\"34101234\",\"HU\":\"201234567\",\"ID\":\"812345678\",\"IE\":\"850123456\",\"IL\":\"502345678\",\"IM\":\"7924123456\",\"IN\":\"8123456789\",\"IO\":\"3801234\",\"IQ\":\"7912345678\",\"IR\":\"9123456789\",\"IS\":\"6111234\",\"IT\":\"3123456789\",\"JE\":\"7797712345\",\"JM\":\"8762101234\",\"JO\":\"790123456\",\"JP\":\"9012345678\",\"KE\":\"712123456\",\"KG\":\"700123456\",\"KH\":\"91234567\",\"KI\":\"72001234\",\"KM\":\"3212345\",\"KN\":\"8697652917\",\"KP\":\"1921234567\",\"KR\":\"1020000000\",\"KW\":\"50012345\",\"KY\":\"3453231234\",\"KZ\":\"7710009998\",\"LA\":\"2023123456\",\"LB\":\"71123456\",\"LC\":\"7582845678\",\"LI\":\"660234567\",\"LK\":\"712345678\",\"LR\":\"770123456\",\"LS\":\"50123456\",\"LT\":\"61234567\",\"LU\":\"628123456\",\"LV\":\"21234567\",\"LY\":\"912345678\",\"MA\":\"650123456\",\"MC\":\"612345678\",\"MD\":\"62112345\",\"ME\":\"67622901\",\"MF\":\"690001234\",\"MG\":\"321234567\",\"MH\":\"2351234\",\"MK\":\"72345678\",\"ML\":\"65012345\",\"MM\":\"92123456\",\"MN\":\"88123456\",\"MO\":\"66123456\",\"MP\":\"6702345678\",\"MQ\":\"696201234\",\"MR\":\"22123456\",\"MS\":\"6644923456\",\"MT\":\"96961234\",\"MU\":\"52512345\",\"MV\":\"7712345\",\"MW\":\"991234567\",\"MX\":\"12221234567\",\"MY\":\"123456789\",\"MZ\":\"821234567\",\"NA\":\"811234567\",\"NC\":\"751234\",\"NE\":\"93123456\",\"NF\":\"381234\",\"NG\":\"8021234567\",\"NI\":\"81234567\",\"NL\":\"612345678\",\"NO\":\"40612345\",\"NP\":\"9841234567\",\"NR\":\"5551234\",\"NU\":\"8884012\",\"NZ\":\"211234567\",\"OM\":\"92123456\",\"PA\":\"61234567\",\"PE\":\"912345678\",\"PF\":\"87123456\",\"PG\":\"70123456\",\"PH\":\"9051234567\",\"PK\":\"3012345678\",\"PL\":\"512345678\",\"PM\":\"551234\",\"PR\":\"7872345678\",\"PS\":\"599123456\",\"PT\":\"912345678\",\"PW\":\"6201234\",\"PY\":\"961456789\",\"QA\":\"33123456\",\"RE\":\"692123456\",\"RO\":\"712034567\",\"RS\":\"601234567\",\"RU\":\"9123456789\",\"RW\":\"720123456\",\"SA\":\"512345678\",\"SB\":\"7421234\",\"SC\":\"2510123\",\"SD\":\"911231234\",\"SE\":\"701234567\",\"SG\":\"81234567\",\"SH\":\"51234\",\"SI\":\"31234567\",\"SJ\":\"41234567\",\"SK\":\"912123456\",\"SL\":\"25123456\",\"SM\":\"66661212\",\"SN\":\"701234567\",\"SO\":\"71123456\",\"SR\":\"7412345\",\"SS\":\"977123456\",\"ST\":\"9812345\",\"SV\":\"70123456\",\"SX\":\"7215205678\",\"SY\":\"944567890\",\"SZ\":\"76123456\",\"TA\":\"8999\",\"TC\":\"6492311234\",\"TD\":\"63012345\",\"TG\":\"90112345\",\"TH\":\"812345678\",\"TJ\":\"917123456\",\"TK\":\"7290\",\"TL\":\"77212345\",\"TM\":\"66123456\",\"TN\":\"20123456\",\"TO\":\"7715123\",\"TR\":\"5012345678\",\"TT\":\"8682911234\",\"TV\":\"901234\",\"TW\":\"912345678\",\"TZ\":\"621234567\",\"UA\":\"501234567\",\"UG\":\"712345678\",\"US\":\"2015550123\",\"UY\":\"94231234\",\"UZ\":\"912345678\",\"VA\":\"3123456789\",\"VC\":\"7844301234\",\"VE\":\"4121234567\",\"VG\":\"2843001234\",\"VI\":\"3406421234\",\"VN\":\"912345678\",\"VU\":\"5912345\",\"WF\":\"821234\",\"WS\":\"7212345\",\"XK\":\"43201234\",\"YE\":\"712345678\",\"YT\":\"639012345\",\"ZA\":\"711234567\",\"ZM\":\"955123456\",\"ZW\":\"712345678\"}");

/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d499":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_159895__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_e59be3b4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_159895__("7f9a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_e59be3b4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_159895__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_e59be3b4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d864":
/***/ (function(module, exports, __nested_webpack_require_161772__) {

// optional / simple context binding
var aFunction = __nested_webpack_require_161772__("79aa");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "d9f6":
/***/ (function(module, exports, __nested_webpack_require_162567__) {

var anObject = __nested_webpack_require_162567__("e4ae");
var IE8_DOM_DEFINE = __nested_webpack_require_162567__("794b");
var toPrimitive = __nested_webpack_require_162567__("1bc3");
var dP = Object.defineProperty;

exports.f = __nested_webpack_require_162567__("8e60") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "db06":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dbdb":
/***/ (function(module, exports, __nested_webpack_require_163380__) {

var core = __nested_webpack_require_163380__("584a");
var global = __nested_webpack_require_163380__("e53d");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __nested_webpack_require_163380__("b8e3") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "e214":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_164148__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_19351537_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_164148__("db06");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_19351537_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_164148__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_19351537_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e4ae":
/***/ (function(module, exports, __nested_webpack_require_165876__) {

var isObject = __nested_webpack_require_165876__("f772");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "e508":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_166130__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export DynamicScroller */
/* unused harmony export DynamicScrollerItem */
/* unused harmony export IdState */
/* harmony export (binding) */ __nested_webpack_require_166130__.d(__webpack_exports__, "a", function() { return __vue_component__; });
/* harmony import */ var vue_resize__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_166130__("252c");
/* harmony import */ var vue_observe_visibility__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_166130__("85fe");
/* harmony import */ var scrollparent__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_166130__("ed83");
/* harmony import */ var scrollparent__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__nested_webpack_require_166130__.n(scrollparent__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_166130__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__nested_webpack_require_166130__.n(vue__WEBPACK_IMPORTED_MODULE_3__);





var config = {
  itemsLimit: 1000
};

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var props = {
  items: {
    type: Array,
    required: true
  },
  keyField: {
    type: String,
    default: 'id'
  },
  direction: {
    type: String,
    default: 'vertical',
    validator: function validator(value) {
      return ['vertical', 'horizontal'].includes(value);
    }
  }
};
function simpleArray() {
  return this.items.length && _typeof(this.items[0]) !== 'object';
}

var supportsPassive = false;

if (typeof window !== 'undefined') {
  supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
}

var uid = 0;
var script = {
  name: 'RecycleScroller',
  components: {
    ResizeObserver: vue_resize__WEBPACK_IMPORTED_MODULE_0__[/* ResizeObserver */ "a"]
  },
  directives: {
    ObserveVisibility: vue_observe_visibility__WEBPACK_IMPORTED_MODULE_1__[/* ObserveVisibility */ "a"]
  },
  props: _objectSpread2({}, props, {
    itemSize: {
      type: Number,
      default: null
    },
    minItemSize: {
      type: [Number, String],
      default: null
    },
    sizeField: {
      type: String,
      default: 'size'
    },
    typeField: {
      type: String,
      default: 'type'
    },
    buffer: {
      type: Number,
      default: 200
    },
    pageMode: {
      type: Boolean,
      default: false
    },
    prerender: {
      type: Number,
      default: 0
    },
    emitUpdate: {
      type: Boolean,
      default: false
    }
  }),
  data: function data() {
    return {
      pool: [],
      totalSize: 0,
      ready: false,
      hoverKey: null
    };
  },
  computed: {
    sizes: function sizes() {
      if (this.itemSize === null) {
        var sizes = {
          '-1': {
            accumulator: 0
          }
        };
        var items = this.items;
        var field = this.sizeField;
        var minItemSize = this.minItemSize;
        var computedMinSize = 10000;
        var accumulator = 0;
        var current;

        for (var i = 0, l = items.length; i < l; i++) {
          current = items[i][field] || minItemSize;

          if (current < computedMinSize) {
            computedMinSize = current;
          }

          accumulator += current;
          sizes[i] = {
            accumulator: accumulator,
            size: current
          };
        } // eslint-disable-next-line


        this.$_computedMinItemSize = computedMinSize;
        return sizes;
      }

      return [];
    },
    simpleArray: simpleArray
  },
  watch: {
    items: function items() {
      this.updateVisibleItems(true);
    },
    pageMode: function pageMode() {
      this.applyPageMode();
      this.updateVisibleItems(false);
    },
    sizes: {
      handler: function handler() {
        this.updateVisibleItems(false);
      },
      deep: true
    }
  },
  created: function created() {
    this.$_startIndex = 0;
    this.$_endIndex = 0;
    this.$_views = new Map();
    this.$_unusedViews = new Map();
    this.$_scrollDirty = false;
    this.$_lastUpdateScrollPosition = 0; // In SSR mode, we also prerender the same number of item for the first render
    // to avoir mismatch between server and client templates

    if (this.prerender) {
      this.$_prerender = true;
      this.updateVisibleItems(false);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.applyPageMode();
    this.$nextTick(function () {
      // In SSR mode, render the real number of visible items
      _this.$_prerender = false;

      _this.updateVisibleItems(true);

      _this.ready = true;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    addView: function addView(pool, index, item, key, type) {
      var view = {
        item: item,
        position: 0
      };
      var nonReactive = {
        id: uid++,
        index: index,
        used: true,
        key: key,
        type: type
      };
      Object.defineProperty(view, 'nr', {
        configurable: false,
        value: nonReactive
      });
      pool.push(view);
      return view;
    },
    unuseView: function unuseView(view) {
      var fake = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var unusedViews = this.$_unusedViews;
      var type = view.nr.type;
      var unusedPool = unusedViews.get(type);

      if (!unusedPool) {
        unusedPool = [];
        unusedViews.set(type, unusedPool);
      }

      unusedPool.push(view);

      if (!fake) {
        view.nr.used = false;
        view.position = -9999;
        this.$_views.delete(view.nr.key);
      }
    },
    handleResize: function handleResize() {
      this.$emit('resize');
      if (this.ready) this.updateVisibleItems(false);
    },
    handleScroll: function handleScroll(event) {
      var _this2 = this;

      if (!this.$_scrollDirty) {
        this.$_scrollDirty = true;
        requestAnimationFrame(function () {
          _this2.$_scrollDirty = false;

          var _this2$updateVisibleI = _this2.updateVisibleItems(false, true),
              continuous = _this2$updateVisibleI.continuous; // It seems sometimes chrome doesn't fire scroll event :/
          // When non continous scrolling is ending, we force a refresh


          if (!continuous) {
            clearTimeout(_this2.$_refreshTimout);
            _this2.$_refreshTimout = setTimeout(_this2.handleScroll, 100);
          }
        });
      }
    },
    handleVisibilityChange: function handleVisibilityChange(isVisible, entry) {
      var _this3 = this;

      if (this.ready) {
        if (isVisible || entry.boundingClientRect.width !== 0 || entry.boundingClientRect.height !== 0) {
          this.$emit('visible');
          requestAnimationFrame(function () {
            _this3.updateVisibleItems(false);
          });
        } else {
          this.$emit('hidden');
        }
      }
    },
    updateVisibleItems: function updateVisibleItems(checkItem) {
      var checkPositionDiff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var itemSize = this.itemSize;
      var minItemSize = this.$_computedMinItemSize;
      var typeField = this.typeField;
      var keyField = this.simpleArray ? null : this.keyField;
      var items = this.items;
      var count = items.length;
      var sizes = this.sizes;
      var views = this.$_views;
      var unusedViews = this.$_unusedViews;
      var pool = this.pool;
      var startIndex, endIndex;
      var totalSize;

      if (!count) {
        startIndex = endIndex = totalSize = 0;
      } else if (this.$_prerender) {
        startIndex = 0;
        endIndex = this.prerender;
        totalSize = null;
      } else {
        var scroll = this.getScroll(); // Skip update if use hasn't scrolled enough

        if (checkPositionDiff) {
          var positionDiff = scroll.start - this.$_lastUpdateScrollPosition;
          if (positionDiff < 0) positionDiff = -positionDiff;

          if (itemSize === null && positionDiff < minItemSize || positionDiff < itemSize) {
            return {
              continuous: true
            };
          }
        }

        this.$_lastUpdateScrollPosition = scroll.start;
        var buffer = this.buffer;
        scroll.start -= buffer;
        scroll.end += buffer; // Variable size mode

        if (itemSize === null) {
          var h;
          var a = 0;
          var b = count - 1;
          var i = ~~(count / 2);
          var oldI; // Searching for startIndex

          do {
            oldI = i;
            h = sizes[i].accumulator;

            if (h < scroll.start) {
              a = i;
            } else if (i < count - 1 && sizes[i + 1].accumulator > scroll.start) {
              b = i;
            }

            i = ~~((a + b) / 2);
          } while (i !== oldI);

          i < 0 && (i = 0);
          startIndex = i; // For container style

          totalSize = sizes[count - 1].accumulator; // Searching for endIndex

          for (endIndex = i; endIndex < count && sizes[endIndex].accumulator < scroll.end; endIndex++) {
          }

          if (endIndex === -1) {
            endIndex = items.length - 1;
          } else {
            endIndex++; // Bounds

            endIndex > count && (endIndex = count);
          }
        } else {
          // Fixed size mode
          startIndex = ~~(scroll.start / itemSize);
          endIndex = Math.ceil(scroll.end / itemSize); // Bounds

          startIndex < 0 && (startIndex = 0);
          endIndex > count && (endIndex = count);
          totalSize = count * itemSize;
        }
      }

      if (endIndex - startIndex > config.itemsLimit) {
        this.itemsLimitError();
      }

      this.totalSize = totalSize;
      var view;
      var continuous = startIndex <= this.$_endIndex && endIndex >= this.$_startIndex;

      if (this.$_continuous !== continuous) {
        if (continuous) {
          views.clear();
          unusedViews.clear();

          for (var _i = 0, l = pool.length; _i < l; _i++) {
            view = pool[_i];
            this.unuseView(view);
          }
        }

        this.$_continuous = continuous;
      } else if (continuous) {
        for (var _i2 = 0, _l = pool.length; _i2 < _l; _i2++) {
          view = pool[_i2];

          if (view.nr.used) {
            // Update view item index
            if (checkItem) {
              view.nr.index = items.findIndex(function (item) {
                return keyField ? item[keyField] === view.item[keyField] : item === view.item;
              });
            } // Check if index is still in visible range


            if (view.nr.index === -1 || view.nr.index < startIndex || view.nr.index >= endIndex) {
              this.unuseView(view);
            }
          }
        }
      }

      var unusedIndex = continuous ? null : new Map();
      var item, type, unusedPool;
      var v;

      for (var _i3 = startIndex; _i3 < endIndex; _i3++) {
        item = items[_i3];
        var key = keyField ? item[keyField] : item;

        if (key == null) {
          throw new Error("Key is ".concat(key, " on item (keyField is '").concat(keyField, "')"));
        }

        view = views.get(key);

        if (!itemSize && !sizes[_i3].size) {
          if (view) this.unuseView(view);
          continue;
        } // No view assigned to item


        if (!view) {
          type = item[typeField];
          unusedPool = unusedViews.get(type);

          if (continuous) {
            // Reuse existing view
            if (unusedPool && unusedPool.length) {
              view = unusedPool.pop();
              view.item = item;
              view.nr.used = true;
              view.nr.index = _i3;
              view.nr.key = key;
              view.nr.type = type;
            } else {
              view = this.addView(pool, _i3, item, key, type);
            }
          } else {
            // Use existing view
            // We don't care if they are already used
            // because we are not in continous scrolling
            v = unusedIndex.get(type) || 0;

            if (!unusedPool || v >= unusedPool.length) {
              view = this.addView(pool, _i3, item, key, type);
              this.unuseView(view, true);
              unusedPool = unusedViews.get(type);
            }

            view = unusedPool[v];
            view.item = item;
            view.nr.used = true;
            view.nr.index = _i3;
            view.nr.key = key;
            view.nr.type = type;
            unusedIndex.set(type, v + 1);
            v++;
          }

          views.set(key, view);
        } else {
          view.nr.used = true;
          view.item = item;
        } // Update position


        if (itemSize === null) {
          view.position = sizes[_i3 - 1].accumulator;
        } else {
          view.position = _i3 * itemSize;
        }
      }

      this.$_startIndex = startIndex;
      this.$_endIndex = endIndex;
      if (this.emitUpdate) this.$emit('update', startIndex, endIndex); // After the user has finished scrolling
      // Sort views so text selection is correct

      clearTimeout(this.$_sortTimer);
      this.$_sortTimer = setTimeout(this.sortViews, 300);
      return {
        continuous: continuous
      };
    },
    getListenerTarget: function getListenerTarget() {
      var target = scrollparent__WEBPACK_IMPORTED_MODULE_2___default()(this.$el); // Fix global scroll target for Chrome and Safari

      if (window.document && (target === window.document.documentElement || target === window.document.body)) {
        target = window;
      }

      return target;
    },
    getScroll: function getScroll() {
      var el = this.$el,
          direction = this.direction;
      var isVertical = direction === 'vertical';
      var scrollState;

      if (this.pageMode) {
        var bounds = el.getBoundingClientRect();
        var boundsSize = isVertical ? bounds.height : bounds.width;
        var start = -(isVertical ? bounds.top : bounds.left);
        var size = isVertical ? window.innerHeight : window.innerWidth;

        if (start < 0) {
          size += start;
          start = 0;
        }

        if (start + size > boundsSize) {
          size = boundsSize - start;
        }

        scrollState = {
          start: start,
          end: start + size
        };
      } else if (isVertical) {
        scrollState = {
          start: el.scrollTop,
          end: el.scrollTop + el.clientHeight
        };
      } else {
        scrollState = {
          start: el.scrollLeft,
          end: el.scrollLeft + el.clientWidth
        };
      }

      return scrollState;
    },
    applyPageMode: function applyPageMode() {
      if (this.pageMode) {
        this.addListeners();
      } else {
        this.removeListeners();
      }
    },
    addListeners: function addListeners() {
      this.listenerTarget = this.getListenerTarget();
      this.listenerTarget.addEventListener('scroll', this.handleScroll, supportsPassive ? {
        passive: true
      } : false);
      this.listenerTarget.addEventListener('resize', this.handleResize);
    },
    removeListeners: function removeListeners() {
      if (!this.listenerTarget) {
        return;
      }

      this.listenerTarget.removeEventListener('scroll', this.handleScroll);
      this.listenerTarget.removeEventListener('resize', this.handleResize);
      this.listenerTarget = null;
    },
    scrollToItem: function scrollToItem(index) {
      var scroll;

      if (this.itemSize === null) {
        scroll = index > 0 ? this.sizes[index - 1].accumulator : 0;
      } else {
        scroll = index * this.itemSize;
      }

      this.scrollToPosition(scroll);
    },
    scrollToPosition: function scrollToPosition(position) {
      if (this.direction === 'vertical') {
        this.$el.scrollTop = position;
      } else {
        this.$el.scrollLeft = position;
      }
    },
    itemsLimitError: function itemsLimitError() {
      var _this4 = this;

      setTimeout(function () {
        console.log('It seems the scroller element isn\'t scrolling, so it tries to render all the items at once.', 'Scroller:', _this4.$el);
        console.log('Make sure the scroller has a fixed height (or width) and \'overflow-y\' (or \'overflow-x\') set to \'auto\' so it can scroll correctly and only render the items visible in the scroll viewport.');
      });
      throw new Error('Rendered items limit reached');
    },
    sortViews: function sortViews() {
      this.pool.sort(function (viewA, viewB) {
        return viewA.nr.index - viewB.nr.index;
      });
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _obj, _obj$1;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.handleVisibilityChange,
          expression: "handleVisibilityChange"
        }
      ],
      staticClass: "vue-recycle-scroller",
      class:
        ((_obj = {
          ready: _vm.ready,
          "page-mode": _vm.pageMode
        }),
        (_obj["direction-" + _vm.direction] = true),
        _obj),
      on: {
        "&scroll": function($event) {
          return _vm.handleScroll($event)
        }
      }
    },
    [
      _vm.$slots.before
        ? _c(
            "div",
            { staticClass: "vue-recycle-scroller__slot" },
            [_vm._t("before")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "wrapper",
          staticClass: "vue-recycle-scroller__item-wrapper",
          style:
            ((_obj$1 = {}),
            (_obj$1[_vm.direction === "vertical" ? "minHeight" : "minWidth"] =
              _vm.totalSize + "px"),
            _obj$1)
        },
        _vm._l(_vm.pool, function(view) {
          return _c(
            "div",
            {
              key: view.nr.id,
              staticClass: "vue-recycle-scroller__item-view",
              class: { hover: _vm.hoverKey === view.nr.key },
              style: _vm.ready
                ? {
                    transform:
                      "translate" +
                      (_vm.direction === "vertical" ? "Y" : "X") +
                      "(" +
                      view.position +
                      "px)"
                  }
                : null,
              on: {
                mouseenter: function($event) {
                  _vm.hoverKey = view.nr.key;
                },
                mouseleave: function($event) {
                  _vm.hoverKey = null;
                }
              }
            },
            [
              _vm._t("default", null, {
                item: view.item,
                index: view.nr.index,
                active: view.nr.used
              })
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.$slots.after
        ? _c(
            "div",
            { staticClass: "vue-recycle-scroller__slot" },
            [_vm._t("after")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ResizeObserver", { on: { notify: _vm.handleResize } })
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1 = {
  name: 'DynamicScroller',
  components: {
    RecycleScroller: __vue_component__
  },
  inheritAttrs: false,
  provide: function provide() {
    if (typeof ResizeObserver !== 'undefined') {
      this.$_resizeObserver = new ResizeObserver(function (entries) {
        var _iterator = _createForOfIteratorHelper(entries),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;

            if (entry.target) {
              var event = new CustomEvent('resize', {
                detail: {
                  contentRect: entry.contentRect
                }
              });
              entry.target.dispatchEvent(event);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }

    return {
      vscrollData: this.vscrollData,
      vscrollParent: this,
      vscrollResizeObserver: this.$_resizeObserver
    };
  },
  props: _objectSpread2({}, props, {
    minItemSize: {
      type: [Number, String],
      required: true
    }
  }),
  data: function data() {
    return {
      vscrollData: {
        active: true,
        sizes: {},
        validSizes: {},
        keyField: this.keyField,
        simpleArray: false
      }
    };
  },
  computed: {
    simpleArray: simpleArray,
    itemsWithSize: function itemsWithSize() {
      var result = [];
      var items = this.items,
          keyField = this.keyField,
          simpleArray = this.simpleArray;
      var sizes = this.vscrollData.sizes;

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var id = simpleArray ? i : item[keyField];
        var size = sizes[id];

        if (typeof size === 'undefined' && !this.$_undefinedMap[id]) {
          size = 0;
        }

        result.push({
          item: item,
          id: id,
          size: size
        });
      }

      return result;
    },
    listeners: function listeners() {
      var listeners = {};

      for (var key in this.$listeners) {
        if (key !== 'resize' && key !== 'visible') {
          listeners[key] = this.$listeners[key];
        }
      }

      return listeners;
    }
  },
  watch: {
    items: function items() {
      this.forceUpdate(false);
    },
    simpleArray: {
      handler: function handler(value) {
        this.vscrollData.simpleArray = value;
      },
      immediate: true
    },
    direction: function direction(value) {
      this.forceUpdate(true);
    }
  },
  created: function created() {
    this.$_updates = [];
    this.$_undefinedSizes = 0;
    this.$_undefinedMap = {};
  },
  activated: function activated() {
    this.vscrollData.active = true;
  },
  deactivated: function deactivated() {
    this.vscrollData.active = false;
  },
  methods: {
    onScrollerResize: function onScrollerResize() {
      var scroller = this.$refs.scroller;

      if (scroller) {
        this.forceUpdate();
      }

      this.$emit('resize');
    },
    onScrollerVisible: function onScrollerVisible() {
      this.$emit('vscroll:update', {
        force: false
      });
      this.$emit('visible');
    },
    forceUpdate: function forceUpdate() {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (clear || this.simpleArray) {
        this.vscrollData.validSizes = {};
      }

      this.$emit('vscroll:update', {
        force: true
      });
    },
    scrollToItem: function scrollToItem(index) {
      var scroller = this.$refs.scroller;
      if (scroller) scroller.scrollToItem(index);
    },
    getItemSize: function getItemSize(item) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var id = this.simpleArray ? index != null ? index : this.items.indexOf(item) : item[this.keyField];
      return this.vscrollData.sizes[id] || 0;
    },
    scrollToBottom: function scrollToBottom() {
      var _this = this;

      if (this.$_scrollingToBottom) return;
      this.$_scrollingToBottom = true;
      var el = this.$el; // Item is inserted to the DOM

      this.$nextTick(function () {
        el.scrollTop = el.scrollHeight + 5000; // Item sizes are computed

        var cb = function cb() {
          el.scrollTop = el.scrollHeight + 5000;
          requestAnimationFrame(function () {
            el.scrollTop = el.scrollHeight + 5000;

            if (_this.$_undefinedSizes === 0) {
              _this.$_scrollingToBottom = false;
            } else {
              requestAnimationFrame(cb);
            }
          });
        };

        requestAnimationFrame(cb);
      });
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "RecycleScroller",
    _vm._g(
      _vm._b(
        {
          ref: "scroller",
          attrs: {
            items: _vm.itemsWithSize,
            "min-item-size": _vm.minItemSize,
            direction: _vm.direction,
            "key-field": "id"
          },
          on: { resize: _vm.onScrollerResize, visible: _vm.onScrollerVisible },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function(ref) {
                  var itemWithSize = ref.item;
                  var index = ref.index;
                  var active = ref.active;
                  return [
                    _vm._t("default", null, null, {
                      item: itemWithSize.item,
                      index: index,
                      active: active,
                      itemWithSize: itemWithSize
                    })
                  ]
                }
              }
            ],
            null,
            true
          )
        },
        "RecycleScroller",
        _vm.$attrs,
        false
      ),
      _vm.listeners
    ),
    [
      _vm._v(" "),
      _c("template", { slot: "before" }, [_vm._t("before")], 2),
      _vm._v(" "),
      _c("template", { slot: "after" }, [_vm._t("after")], 2)
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

var script$2 = {
  name: 'DynamicScrollerItem',
  inject: ['vscrollData', 'vscrollParent', 'vscrollResizeObserver'],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    item: {
      required: true
    },
    watchData: {
      type: Boolean,
      default: false
    },

    /**
     * Indicates if the view is actively used to display an item.
     */
    active: {
      type: Boolean,
      required: true
    },
    index: {
      type: Number,
      default: undefined
    },
    sizeDependencies: {
      type: [Array, Object],
      default: null
    },
    emitResize: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    id: function id() {
      return this.vscrollData.simpleArray ? this.index : this.item[this.vscrollData.keyField];
    },
    size: function size() {
      return this.vscrollData.validSizes[this.id] && this.vscrollData.sizes[this.id] || 0;
    },
    finalActive: function finalActive() {
      return this.active && this.vscrollData.active;
    }
  },
  watch: {
    watchData: 'updateWatchData',
    id: function id() {
      if (!this.size) {
        this.onDataUpdate();
      }
    },
    finalActive: function finalActive(value) {
      if (!this.size) {
        if (value) {
          if (!this.vscrollParent.$_undefinedMap[this.id]) {
            this.vscrollParent.$_undefinedSizes++;
            this.vscrollParent.$_undefinedMap[this.id] = true;
          }
        } else {
          if (this.vscrollParent.$_undefinedMap[this.id]) {
            this.vscrollParent.$_undefinedSizes--;
            this.vscrollParent.$_undefinedMap[this.id] = false;
          }
        }
      }

      if (this.vscrollResizeObserver) {
        if (value) {
          this.observeSize();
        } else {
          this.unobserveSize();
        }
      } else if (value && this.$_pendingVScrollUpdate === this.id) {
        this.updateSize();
      }
    }
  },
  created: function created() {
    var _this = this;

    if (this.$isServer) return;
    this.$_forceNextVScrollUpdate = null;
    this.updateWatchData();

    if (!this.vscrollResizeObserver) {
      var _loop = function _loop(k) {
        _this.$watch(function () {
          return _this.sizeDependencies[k];
        }, _this.onDataUpdate);
      };

      for (var k in this.sizeDependencies) {
        _loop(k);
      }

      this.vscrollParent.$on('vscroll:update', this.onVscrollUpdate);
      this.vscrollParent.$on('vscroll:update-size', this.onVscrollUpdateSize);
    }
  },
  mounted: function mounted() {
    if (this.vscrollData.active) {
      this.updateSize();
      this.observeSize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.vscrollParent.$off('vscroll:update', this.onVscrollUpdate);
    this.vscrollParent.$off('vscroll:update-size', this.onVscrollUpdateSize);
    this.unobserveSize();
  },
  methods: {
    updateSize: function updateSize() {
      if (this.finalActive) {
        if (this.$_pendingSizeUpdate !== this.id) {
          this.$_pendingSizeUpdate = this.id;
          this.$_forceNextVScrollUpdate = null;
          this.$_pendingVScrollUpdate = null;
          this.computeSize(this.id);
        }
      } else {
        this.$_forceNextVScrollUpdate = this.id;
      }
    },
    updateWatchData: function updateWatchData() {
      var _this2 = this;

      if (this.watchData) {
        this.$_watchData = this.$watch('data', function () {
          _this2.onDataUpdate();
        }, {
          deep: true
        });
      } else if (this.$_watchData) {
        this.$_watchData();
        this.$_watchData = null;
      }
    },
    onVscrollUpdate: function onVscrollUpdate(_ref) {
      var force = _ref.force;

      // If not active, sechedule a size update when it becomes active
      if (!this.finalActive && force) {
        this.$_pendingVScrollUpdate = this.id;
      }

      if (this.$_forceNextVScrollUpdate === this.id || force || !this.size) {
        this.updateSize();
      }
    },
    onDataUpdate: function onDataUpdate() {
      this.updateSize();
    },
    computeSize: function computeSize(id) {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.id === id) {
          var width = _this3.$el.offsetWidth;
          var height = _this3.$el.offsetHeight;

          _this3.applySize(width, height);
        }

        _this3.$_pendingSizeUpdate = null;
      });
    },
    applySize: function applySize(width, height) {
      var size = Math.round(this.vscrollParent.direction === 'vertical' ? height : width);

      if (size && this.size !== size) {
        if (this.vscrollParent.$_undefinedMap[this.id]) {
          this.vscrollParent.$_undefinedSizes--;
          this.vscrollParent.$_undefinedMap[this.id] = undefined;
        }

        this.$set(this.vscrollData.sizes, this.id, size);
        this.$set(this.vscrollData.validSizes, this.id, true);
        if (this.emitResize) this.$emit('resize', this.id);
      }
    },
    observeSize: function observeSize() {
      if (!this.vscrollResizeObserver) return;
      this.vscrollResizeObserver.observe(this.$el.parentNode);
      this.$el.parentNode.addEventListener('resize', this.onResize);
    },
    unobserveSize: function unobserveSize() {
      if (!this.vscrollResizeObserver) return;
      this.vscrollResizeObserver.unobserve(this.$el.parentNode);
      this.$el.parentNode.removeEventListener('resize', this.onResize);
    },
    onResize: function onResize(event) {
      var _event$detail$content = event.detail.contentRect,
          width = _event$detail$content.width,
          height = _event$detail$content.height;
      this.applySize(width, height);
    }
  },
  render: function render(h) {
    return h(this.tag, this.$slots.default);
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = normalizeComponent(
    {},
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

function IdState () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$idProp = _ref.idProp,
      idProp = _ref$idProp === void 0 ? function (vm) {
    return vm.item.id;
  } : _ref$idProp;

  var store = {};
  var vm = new vue__WEBPACK_IMPORTED_MODULE_3___default.a({
    data: function data() {
      return {
        store: store
      };
    }
  }); // @vue/component

  return {
    data: function data() {
      return {
        idState: null
      };
    },
    created: function created() {
      var _this = this;

      this.$_id = null;

      if (typeof idProp === 'function') {
        this.$_getId = function () {
          return idProp.call(_this, _this);
        };
      } else {
        this.$_getId = function () {
          return _this[idProp];
        };
      }

      this.$watch(this.$_getId, {
        handler: function handler(value) {
          var _this2 = this;

          this.$nextTick(function () {
            _this2.$_id = value;
          });
        },
        immediate: true
      });
      this.$_updateIdState();
    },
    beforeUpdate: function beforeUpdate() {
      this.$_updateIdState();
    },
    methods: {
      /**
       * Initialize an idState
       * @param {number|string} id Unique id for the data
       */
      $_idStateInit: function $_idStateInit(id) {
        var factory = this.$options.idState;

        if (typeof factory === 'function') {
          var data = factory.call(this, this);
          vm.$set(store, id, data);
          this.$_id = id;
          return data;
        } else {
          throw new Error('[mixin IdState] Missing `idState` function on component definition.');
        }
      },

      /**
       * Ensure idState is created and up-to-date
       */
      $_updateIdState: function $_updateIdState() {
        var id = this.$_getId();

        if (id == null) {
          console.warn("No id found for IdState with idProp: '".concat(idProp, "'."));
        }

        if (id !== this.$_id) {
          if (!store[id]) {
            this.$_idStateInit(id);
          }

          this.idState = store[id];
        }
      }
    }
  };
}

function registerComponents(Vue, prefix) {
  Vue.component("".concat(prefix, "recycle-scroller"), __vue_component__);
  Vue.component("".concat(prefix, "RecycleScroller"), __vue_component__);
  Vue.component("".concat(prefix, "dynamic-scroller"), __vue_component__$1);
  Vue.component("".concat(prefix, "DynamicScroller"), __vue_component__$1);
  Vue.component("".concat(prefix, "dynamic-scroller-item"), __vue_component__$2);
  Vue.component("".concat(prefix, "DynamicScrollerItem"), __vue_component__$2);
}

var plugin = {
  // eslint-disable-next-line no-undef
  version: "1.0.10",
  install: function install(Vue, options) {
    var finalOptions = Object.assign({}, {
      installComponents: true,
      componentsPrefix: ''
    }, options);

    for (var key in finalOptions) {
      if (typeof finalOptions[key] !== 'undefined') {
        config[key] = finalOptions[key];
      }
    }

    if (finalOptions.installComponents) {
      registerComponents(Vue, finalOptions.componentsPrefix);
    }
  }
};

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* unused harmony default export */ var _unused_webpack_default_export = (plugin);

//# sourceMappingURL=vue-virtual-scroller.esm.js.map

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_166130__("c8ba")))

/***/ }),

/***/ "e53d":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "e6f3":
/***/ (function(module, exports, __nested_webpack_require_210299__) {

var has = __nested_webpack_require_210299__("07e3");
var toIObject = __nested_webpack_require_210299__("36c3");
var arrayIndexOf = __nested_webpack_require_210299__("5b4e")(false);
var IE_PROTO = __nested_webpack_require_210299__("5559")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "e71e":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_210947__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_46e105de_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_210947__("c50b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_46e105de_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_210947__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_46e105de_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e853":
/***/ (function(module, exports, __nested_webpack_require_212675__) {

var isObject = __nested_webpack_require_212675__("d3f4");
var isArray = __nested_webpack_require_212675__("1169");
var SPECIES = __nested_webpack_require_212675__("2b4c")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "ebfd":
/***/ (function(module, exports, __nested_webpack_require_213253__) {

var META = __nested_webpack_require_213253__("62a0")('meta');
var isObject = __nested_webpack_require_213253__("f772");
var has = __nested_webpack_require_213253__("07e3");
var setDesc = __nested_webpack_require_213253__("d9f6").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__nested_webpack_require_213253__("294c")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "ed83":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function () {
  var regex = /(auto|scroll)/;

  var parents = function (node, ps) {
    if (node.parentNode === null) { return ps; }

    return parents(node.parentNode, ps.concat([node]));
  };

  var style = function (node, prop) {
    return getComputedStyle(node, null).getPropertyValue(prop);
  };

  var overflow = function (node) {
    return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
  };

  var scroll = function (node) {
   return regex.test(overflow(node));
  };

  var scrollParent = function (node) {
    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      return ;
    }

    var ps = parents(node.parentNode, []);

    for (var i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent;
}));


/***/ }),

/***/ "f1ae":
/***/ (function(module, exports, __nested_webpack_require_216469__) {

"use strict";

var $defineProperty = __nested_webpack_require_216469__("86cc");
var createDesc = __nested_webpack_require_216469__("4630");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "f201":
/***/ (function(module, exports, __nested_webpack_require_216829__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __nested_webpack_require_216829__("e4ae");
var aFunction = __nested_webpack_require_216829__("79aa");
var SPECIES = __nested_webpack_require_216829__("5168")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "f410":
/***/ (function(module, exports, __nested_webpack_require_217278__) {

__nested_webpack_require_217278__("1af6");
module.exports = __nested_webpack_require_217278__("584a").Array.isArray;


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __nested_webpack_require_217451__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __nested_webpack_require_217451__("5ca1");
var toLength = __nested_webpack_require_217451__("9def");
var context = __nested_webpack_require_217451__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __nested_webpack_require_217451__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f772":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "f921":
/***/ (function(module, exports, __nested_webpack_require_218479__) {

__nested_webpack_require_218479__("014b");
__nested_webpack_require_218479__("c207");
__nested_webpack_require_218479__("69d3");
__nested_webpack_require_218479__("765d");
module.exports = __nested_webpack_require_218479__("584a").Symbol;


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __nested_webpack_require_218732__) {

module.exports = __nested_webpack_require_218732__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __nested_webpack_require_218910__) {

var document = __nested_webpack_require_218910__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_219114__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_219114__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __nested_webpack_require_219114__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_219114__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"23eda527-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VuePhoneNumberInput/index.vue?vue&type=template&id=19351537&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-phone-number-input flex",class:[{ 'dark': _vm.dark }, _vm.size],attrs:{"id":_vm.id}},[(!_vm.noCountrySelector)?_c('div',{staticClass:"select-country-container"},[_c('CountrySelector',{ref:"CountrySelector",staticClass:"input-country-selector",attrs:{"id":(_vm.uniqueId + "_country_selector"),"items":_vm.codesCountries,"countries-height":_vm.countriesHeight,"error":_vm.shouldChooseCountry,"hint":_vm.shouldChooseCountry ? _vm.t.countrySelectorError : null,"disabled":_vm.disabled,"valid":_vm.isValid && !_vm.noValidatorState,"preferred-countries":_vm.preferredCountries,"only-countries":_vm.onlyCountries,"ignored-countries":_vm.ignoredCountries,"label":_vm.t.countrySelectorLabel,"no-flags":_vm.noFlags,"show-code-on-list":_vm.showCodeOnList,"size":_vm.size,"dark":_vm.dark,"theme":_vm.theme},model:{value:(_vm.countryCode),callback:function ($$v) {_vm.countryCode=$$v},expression:"countryCode"}},[_vm._t("arrow",null,{"slot":"arrow"})],2)],1):_vm._e(),_c('div',{staticClass:"flex-1"},[_c('InputTel',_vm._b({ref:"PhoneNumberInput",staticClass:"input-phone-number",attrs:{"id":(_vm.uniqueId + "_phone_number"),"label":_vm.t.phoneNumberLabel,"hint":_vm.hintValue,"dark":_vm.dark,"disabled":_vm.disabled,"size":_vm.size,"error":_vm.error,"valid":_vm.isValid && !_vm.noValidatorState,"required":_vm.required,"no-country-selector":_vm.noCountrySelector,"theme":_vm.theme},on:{"keydown":function (e) { _vm.lastKeyPressed = e.keyCode },"focus":function($event){return _vm.$emit('phone-number-focused')},"blur":function($event){return _vm.$emit('phone-number-blur')}},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}},'InputTel',_vm.$attrs,false))],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/VuePhoneNumberInput/index.vue?vue&type=template&id=19351537&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __nested_webpack_require_219114__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __nested_webpack_require_219114__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __nested_webpack_require_219114__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __nested_webpack_require_219114__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __nested_webpack_require_219114__("6b54");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __nested_webpack_require_219114__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/promise.js
var promise = __nested_webpack_require_219114__("795b");
var promise_default = /*#__PURE__*/__nested_webpack_require_219114__.n(promise);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    promise_default.a.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new promise_default.a(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/define-property.js
var define_property = __nested_webpack_require_219114__("85f2");
var define_property_default = /*#__PURE__*/__nested_webpack_require_219114__.n(define_property);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  if (key in obj) {
    define_property_default()(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __nested_webpack_require_219114__("c5f6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __nested_webpack_require_219114__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __nested_webpack_require_219114__("2fdb");

// CONCATENATED MODULE: ./src/VuePhoneNumberInput/assets/js/phoneCodeCountries.js
var allCountries = [['Afghanistan (‫افغانستان‬‎)', 'af', '93'], ['Albania (Shqipëri)', 'al', '355'], ['Algeria (‫الجزائر‬‎)', 'dz', '213'], ['American Samoa', 'as', '1684'], ['Andorra', 'ad', '376'], ['Angola', 'ao', '244'], ['Anguilla', 'ai', '1264'], ['Antigua and Barbuda', 'ag', '1268'], ['Argentina', 'ar', '54'], ['Armenia (Հայաստան)', 'am', '374'], ['Aruba', 'aw', '297'], ['Australia', 'au', '61', 0], ['Austria (Österreich)', 'at', '43'], ['Azerbaijan (Azərbaycan)', 'az', '994'], ['Bahamas', 'bs', '1242'], ['Bahrain (‫البحرين‬‎)', 'bh', '973'], ['Bangladesh (বাংলাদেশ)', 'bd', '880'], ['Barbados', 'bb', '1246'], ['Belarus (Беларусь)', 'by', '375'], ['Belgium (België)', 'be', '32'], ['Belize', 'bz', '501'], ['Benin (Bénin)', 'bj', '229'], ['Bermuda', 'bm', '1441'], ['Bhutan (འབྲུག)', 'bt', '975'], ['Bolivia', 'bo', '591'], ['Bosnia and Herzegovina (Босна и Херцеговина)', 'ba', '387'], ['Botswana', 'bw', '267'], ['Brazil (Brasil)', 'br', '55'], ['British Indian Ocean Territory', 'io', '246'], ['British Virgin Islands', 'vg', '1284'], ['Brunei', 'bn', '673'], ['Bulgaria (България)', 'bg', '359'], ['Burkina Faso', 'bf', '226'], ['Burundi (Uburundi)', 'bi', '257'], ['Cambodia (កម្ពុជា)', 'kh', '855'], ['Cameroon (Cameroun)', 'cm', '237'], ['Canada', 'ca', '1', 1, ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']], ['Cape Verde (Kabu Verdi)', 'cv', '238'], ['Caribbean Netherlands', 'bq', '599', 1], ['Cayman Islands', 'ky', '1345'], ['Central African Republic (République centrafricaine)', 'cf', '236'], ['Chad (Tchad)', 'td', '235'], ['Chile', 'cl', '56'], ['China (中国)', 'cn', '86'], ['Christmas Island', 'cx', '61', 2], ['Cocos (Keeling) Islands', 'cc', '61', 1], ['Colombia', 'co', '57'], ['Comoros (‫جزر القمر‬‎)', 'km', '269'], ['Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'cd', '243'], ['Congo (Republic) (Congo-Brazzaville)', 'cg', '242'], ['Cook Islands', 'ck', '682'], ['Costa Rica', 'cr', '506'], ['Côte d’Ivoire', 'ci', '225'], ['Croatia (Hrvatska)', 'hr', '385'], ['Cuba', 'cu', '53'], ['Curaçao', 'cw', '599', 0], ['Cyprus (Κύπρος)', 'cy', '357'], ['Czech Republic (Česká republika)', 'cz', '420'], ['Denmark (Danmark)', 'dk', '45'], ['Djibouti', 'dj', '253'], ['Dominica', 'dm', '1767'], ['Dominican Republic (República Dominicana)', 'do', '1', 2, ['809', '829', '849']], ['Ecuador', 'ec', '593'], ['Egypt (‫مصر‬‎)', 'eg', '20'], ['El Salvador', 'sv', '503'], ['Equatorial Guinea (Guinea Ecuatorial)', 'gq', '240'], ['Eritrea', 'er', '291'], ['Estonia (Eesti)', 'ee', '372'], ['Ethiopia', 'et', '251'], ['Falkland Islands (Islas Malvinas)', 'fk', '500'], ['Faroe Islands (Føroyar)', 'fo', '298'], ['Fiji', 'fj', '679'], ['Finland (Suomi)', 'fi', '358', 0], ['France', 'fr', '33'], ['French Guiana (Guyane française)', 'gf', '594'], ['French Polynesia (Polynésie française)', 'pf', '689'], ['Gabon', 'ga', '241'], ['Gambia', 'gm', '220'], ['Georgia (საქართველო)', 'ge', '995'], ['Germany (Deutschland)', 'de', '49'], ['Ghana (Gaana)', 'gh', '233'], ['Gibraltar', 'gi', '350'], ['Greece (Ελλάδα)', 'gr', '30'], ['Greenland (Kalaallit Nunaat)', 'gl', '299'], ['Grenada', 'gd', '1473'], ['Guadeloupe', 'gp', '590', 0], ['Guam', 'gu', '1671'], ['Guatemala', 'gt', '502'], ['Guernsey', 'gg', '44', 1], ['Guinea (Guinée)', 'gn', '224'], ['Guinea-Bissau (Guiné Bissau)', 'gw', '245'], ['Guyana', 'gy', '592'], ['Haiti', 'ht', '509'], ['Honduras', 'hn', '504'], ['Hong Kong (香港)', 'hk', '852'], ['Hungary (Magyarország)', 'hu', '36'], ['Iceland (Ísland)', 'is', '354'], ['India (भारत)', 'in', '91'], ['Indonesia', 'id', '62'], ['Iran (‫ایران‬‎)', 'ir', '98'], ['Iraq (‫العراق‬‎)', 'iq', '964'], ['Ireland', 'ie', '353'], ['Isle of Man', 'im', '44', 2], ['Israel (‫ישראל‬‎)', 'il', '972'], ['Italy (Italia)', 'it', '39', 0], ['Jamaica', 'jm', '1876'], ['Japan (日本)', 'jp', '81'], ['Jersey', 'je', '44', 3], ['Jordan (‫الأردن‬‎)', 'jo', '962'], ['Kazakhstan (Казахстан)', 'kz', '7', 1], ['Kenya', 'ke', '254'], ['Kiribati', 'ki', '686'], ['Kosovo', 'xk', '383'], ['Kuwait (‫الكويت‬‎)', 'kw', '965'], ['Kyrgyzstan (Кыргызстан)', 'kg', '996'], ['Laos (ລາວ)', 'la', '856'], ['Latvia (Latvija)', 'lv', '371'], ['Lebanon (‫لبنان‬‎)', 'lb', '961'], ['Lesotho', 'ls', '266'], ['Liberia', 'lr', '231'], ['Libya (‫ليبيا‬‎)', 'ly', '218'], ['Liechtenstein', 'li', '423'], ['Lithuania (Lietuva)', 'lt', '370'], ['Luxembourg', 'lu', '352'], ['Macau (澳門)', 'mo', '853'], ['Macedonia (FYROM) (Македонија)', 'mk', '389'], ['Madagascar (Madagasikara)', 'mg', '261'], ['Malawi', 'mw', '265'], ['Malaysia', 'my', '60'], ['Maldives', 'mv', '960'], ['Mali', 'ml', '223'], ['Malta', 'mt', '356'], ['Marshall Islands', 'mh', '692'], ['Martinique', 'mq', '596'], ['Mauritania (‫موريتانيا‬‎)', 'mr', '222'], ['Mauritius (Moris)', 'mu', '230'], ['Mayotte', 'yt', '262', 1], ['Mexico (México)', 'mx', '52'], ['Micronesia', 'fm', '691'], ['Moldova (Republica Moldova)', 'md', '373'], ['Monaco', 'mc', '377'], ['Mongolia (Монгол)', 'mn', '976'], ['Montenegro (Crna Gora)', 'me', '382'], ['Montserrat', 'ms', '1664'], ['Morocco (‫المغرب‬‎)', 'ma', '212', 0], ['Mozambique (Moçambique)', 'mz', '258'], ['Myanmar (Burma) (မြန်မာ)', 'mm', '95'], ['Namibia (Namibië)', 'na', '264'], ['Nauru', 'nr', '674'], ['Nepal (नेपाल)', 'np', '977'], ['Netherlands (Nederland)', 'nl', '31'], ['New Caledonia (Nouvelle-Calédonie)', 'nc', '687'], ['New Zealand', 'nz', '64'], ['Nicaragua', 'ni', '505'], ['Niger (Nijar)', 'ne', '227'], ['Nigeria', 'ng', '234'], ['Niue', 'nu', '683'], ['Norfolk Island', 'nf', '672'], ['North Korea (조선 민주주의 인민 공화국)', 'kp', '850'], ['Northern Mariana Islands', 'mp', '1670'], ['Norway (Norge)', 'no', '47', 0], ['Oman (‫عُمان‬‎)', 'om', '968'], ['Pakistan (‫پاکستان‬‎)', 'pk', '92'], ['Palau', 'pw', '680'], ['Palestine (‫فلسطين‬‎)', 'ps', '970'], ['Panama (Panamá)', 'pa', '507'], ['Papua New Guinea', 'pg', '675'], ['Paraguay', 'py', '595'], ['Peru (Perú)', 'pe', '51'], ['Philippines', 'ph', '63'], ['Poland (Polska)', 'pl', '48'], ['Portugal', 'pt', '351'], ['Puerto Rico', 'pr', '1', 3, ['787', '939']], ['Qatar (‫قطر‬‎)', 'qa', '974'], ['Réunion (La Réunion)', 're', '262', 0], ['Romania (România)', 'ro', '40'], ['Russia (Россия)', 'ru', '7', 0], ['Rwanda', 'rw', '250'], ['Saint Barthélemy', 'bl', '590', 1], ['Saint Helena', 'sh', '290'], ['Saint Kitts and Nevis', 'kn', '1869'], ['Saint Lucia', 'lc', '1758'], ['Saint Martin (Saint-Martin (partie française))', 'mf', '590', 2], ['Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', 'pm', '508'], ['Saint Vincent and the Grenadines', 'vc', '1784'], ['Samoa', 'ws', '685'], ['San Marino', 'sm', '378'], ['São Tomé and Príncipe (São Tomé e Príncipe)', 'st', '239'], ['Saudi Arabia (‫المملكة العربية السعودية‬‎)', 'sa', '966'], ['Senegal (Sénégal)', 'sn', '221'], ['Serbia (Србија)', 'rs', '381'], ['Seychelles', 'sc', '248'], ['Sierra Leone', 'sl', '232'], ['Singapore', 'sg', '65'], ['Sint Maarten', 'sx', '1721'], ['Slovakia (Slovensko)', 'sk', '421'], ['Slovenia (Slovenija)', 'si', '386'], ['Solomon Islands', 'sb', '677'], ['Somalia (Soomaaliya)', 'so', '252'], ['South Africa', 'za', '27'], ['South Korea (대한민국)', 'kr', '82'], ['South Sudan (‫جنوب السودان‬‎)', 'ss', '211'], ['Spain (España)', 'es', '34'], ['Sri Lanka (ශ්‍රී ලංකාව)', 'lk', '94'], ['Sudan (‫السودان‬‎)', 'sd', '249'], ['Suriname', 'sr', '597'], ['Svalbard and Jan Mayen', 'sj', '47', 1], ['Swaziland', 'sz', '268'], ['Sweden (Sverige)', 'se', '46'], ['Switzerland (Schweiz)', 'ch', '41'], ['Syria (‫سوريا‬‎)', 'sy', '963'], ['Taiwan (台灣)', 'tw', '886'], ['Tajikistan', 'tj', '992'], ['Tanzania', 'tz', '255'], ['Thailand (ไทย)', 'th', '66'], ['Timor-Leste', 'tl', '670'], ['Togo', 'tg', '228'], ['Tokelau', 'tk', '690'], ['Tonga', 'to', '676'], ['Trinidad and Tobago', 'tt', '1868'], ['Tunisia (‫تونس‬‎)', 'tn', '216'], ['Turkey (Türkiye)', 'tr', '90'], ['Turkmenistan', 'tm', '993'], ['Turks and Caicos Islands', 'tc', '1649'], ['Tuvalu', 'tv', '688'], ['U.S. Virgin Islands', 'vi', '1340'], ['Uganda', 'ug', '256'], ['Ukraine (Україна)', 'ua', '380'], ['United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', 'ae', '971'], ['United Kingdom', 'gb', '44', 0], ['United States', 'us', '1', 0], ['Uruguay', 'uy', '598'], ['Uzbekistan (Oʻzbekiston)', 'uz', '998'], ['Vanuatu', 'vu', '678'], ['Vatican City (Città del Vaticano)', 'va', '39', 1], ['Venezuela', 've', '58'], ['Vietnam (Việt Nam)', 'vn', '84'], ['Wallis and Futuna (Wallis-et-Futuna)', 'wf', '681'], ['Western Sahara (‫الصحراء الغربية‬‎)', 'eh', '212', 1], ['Yemen (‫اليمن‬‎)', 'ye', '967'], ['Zambia', 'zm', '260'], ['Zimbabwe', 'zw', '263'], ['Åland Islands', 'ax', '358', 1]];
var countriesIso = allCountries.map(function (country) {
  return country[1].toUpperCase();
});
var countries = allCountries.map(function (country) {
  return {
    name: country[0],
    iso2: country[1].toUpperCase(),
    dialCode: country[2],
    priority: country[3] || 0,
    areaCodes: country[4] || null
  };
});
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/examples.mobile.json
var examples_mobile = __nested_webpack_require_219114__("d391");

// CONCATENATED MODULE: ./node_modules/libphonenumber-js/metadata.min.json.js
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
/* harmony default export */ var metadata_min_json = ({"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:[25689]\\d|40)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]]],"BL":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-79]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["[39]"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0(4(?:[14]4|56)|[579])?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|[23]1|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[01359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-79]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-26-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94|80\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d\\d|606)\\d{5}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-289]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([25-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29[89]|389)","5(?:29[89]|389)0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|389[05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[08]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670"],"MQ":["596","00","(?:69|80)\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[129]\\d|31|77|88)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|59"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","(?:[45]|80\\d\\d)\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",[7,8,9],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]]],"RE":["262","00","976\\d{6}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]"],"RO":["40","00","(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-5]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:00|[1-57-9]\\d)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|22|33)|4(?:00|4[24]|65|82)|5(?:00|29|58|83)|6(?:00|66|82)|7(?:58|77)|8(?:00|42|5[25]|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","(?:33|55|[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["4"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?",[9,10,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[35]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}});
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.


function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(metadata_min_json)
	return func.apply(this, args)
}
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/tools/semver-compare.js
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
/* harmony default export */ var semver_compare = (function (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
});
//# sourceMappingURL=semver-compare.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/metadata.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

 // Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".

var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    _classCallCheck(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();



var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && metadata_getType(this.types(), _type2)) {
        return new Type(metadata_getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    _classCallCheck(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    _classCallCheck(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function metadata_getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return _typeof(_);
};
/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */


function getExtPrefix(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).ext();
  }

  return DEFAULT_EXT_PREFIX;
}
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (semver_compare(version, V3) === -1) {
      this.v2 = true;
    } else if (semver_compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }
//# sourceMappingURL=metadata.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = _createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=mergeArrays.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=checkNumberLength.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/isPossibleNumber_.js


function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
//# sourceMappingURL=isPossibleNumber_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function getNumberType_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getNumberType_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getNumberType_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getNumberType_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getNumberType_arrayLikeToArray(o, minLen); }

function getNumberType_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = getNumberType_createForOfIteratorHelperLoose(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}
//# sourceMappingURL=getNumberType.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/validate_.js



/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata.nationalNumberPattern());
}
//# sourceMappingURL=validate_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/constants.js
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
//# sourceMappingURL=constants.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
 // Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}
//# sourceMappingURL=applyInternationalSeparatorStyle.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
 // This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}
//# sourceMappingURL=formatNationalNumberUsingFormat.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
//# sourceMappingURL=getIddPrefix.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
 // The RFC 3966 format for extensions.

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var createExtensionPattern_getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + createExtensionPattern_getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
//# sourceMappingURL=createExtensionPattern.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js

 //  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/RFC3966.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || RFC3966_unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function RFC3966_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = RFC3966_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RFC3966_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return RFC3966_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RFC3966_arrayLikeToArray(o, minLen); }

function RFC3966_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

 // https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = RFC3966_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;) {
    var part = _step.value;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/format_.js
function format_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = format_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function format_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return format_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return format_arrayLikeToArray(o, minLen); }

function format_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { format_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function format_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js





var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
}; // Formats a phone number
//
// Example use cases:
//
// ```js
// formatNumber('8005553535', 'RU', 'INTERNATIONAL')
// formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
// formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
// formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
// formatNumber('+78005553535', 'NATIONAL')
// formatNumber('+78005553535', 'NATIONAL', metadata)
// ```
//

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = format_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;

    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
//# sourceMappingURL=format_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/PhoneNumber.js
function PhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { PhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function PhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PhoneNumber_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhoneNumber_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PhoneNumber_createClass(Constructor, protoProps, staticProps) { if (protoProps) PhoneNumber_defineProperties(Constructor.prototype, protoProps); if (staticProps) PhoneNumber_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }







var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var PhoneNumber_PhoneNumber = /*#__PURE__*/function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    PhoneNumber_classCallCheck(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    if (!metadata) {
      throw new TypeError('`metadata` not passed');
    }

    var _metadata = new Metadata(metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    } else {
      /* istanbul ignore if */
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (_metadata.isNonGeographicCallingCode(countryCallingCode)) {
          this.country = '001';
        }
      }
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  PhoneNumber_createClass(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? PhoneNumber_objectSpread(PhoneNumber_objectSpread({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();



var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};
//# sourceMappingURL=PhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/getExampleNumber.js

function getExampleNumber(country, examples, metadata) {
  if (examples[country]) {
    return new PhoneNumber_PhoneNumber(country, examples[country], metadata);
  }
}
//# sourceMappingURL=getExampleNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/min/exports/getExampleNumber.js



function getExampleNumber_getExampleNumber() {
	return withMetadataArgument(getExampleNumber, arguments)
}
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/ParseError.js
function ParseError_typeof(obj) { "@babel/helpers - typeof"; return ParseError_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, ParseError_typeof(obj); }

function ParseError_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ParseError_createClass(Constructor, protoProps, staticProps) { if (protoProps) ParseError_defineProperties(Constructor.prototype, protoProps); if (staticProps) ParseError_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ParseError_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (ParseError_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  _inherits(ParseError, _Error);

  var _super = _createSuper(ParseError);

  function ParseError(code) {
    var _this;

    ParseError_classCallCheck(this, ParseError);

    _this = _super.call(this, code); // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.

    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return ParseError_createClass(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));


//# sourceMappingURL=ParseError.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js
 // Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}
//# sourceMappingURL=extractExtension.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/parseDigits.js
function parseDigits_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseDigits_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseDigits_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseDigits_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseDigits_arrayLikeToArray(o, minLen); }

function parseDigits_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = parseDigits_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=parseDigits.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function parseIncompletePhoneNumber_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseIncompletePhoneNumber_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseIncompletePhoneNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); }

function parseIncompletePhoneNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = parseIncompletePhoneNumber_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js


var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
//# sourceMappingURL=stripIddPrefix.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}
//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js



/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}
//# sourceMappingURL=extractNationalNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js





/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js




/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode_extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}
//# sourceMappingURL=extractCountryCallingCode.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js
function getCountryByCallingCode_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getCountryByCallingCode_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getCountryByCallingCode_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getCountryByCallingCode_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getCountryByCallingCode_arrayLikeToArray(o, minLen); }

function getCountryByCallingCode_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {
  /* istanbul ignore if */
  if (getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  } // Is always non-empty, because `callingCode` is always valid


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}

function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);

  for (var _iterator = getCountryByCallingCode_createForOfIteratorHelperLoose(possibleCountries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // Leading digits check would be the simplest and fastest one.
    // Leading digits patterns are only defined for about 20% of all countries.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // Matching "leading digits" is a sufficient but not necessary condition.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      return country;
    }
  }
}
//# sourceMappingURL=getCountryByCallingCode.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parse_.js
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js















 // We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
var parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber_PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? parse_result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return parseRFC3966(text);
  }

  var number = extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function parse_result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode_extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

    if (defaultCountry) {
      country = defaultCountry;
    } else {
      /* istanbul ignore if */
      if (parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          country = '001';
        }
      }
    }

    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
//# sourceMappingURL=parse_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumber_.js
function parsePhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function parsePhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? parsePhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { parsePhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : parsePhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parsePhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function parsePhoneNumber_parsePhoneNumber(text, options, metadata) {
  return parse(text, parsePhoneNumber_objectSpread(parsePhoneNumber_objectSpread({}, options), {}, {
    v2: true
  }), metadata);
}
//# sourceMappingURL=parsePhoneNumber_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumber.js
function parsePhoneNumber_typeof(obj) { "@babel/helpers - typeof"; return parsePhoneNumber_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, parsePhoneNumber_typeof(obj); }

function es6_parsePhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function es6_parsePhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? es6_parsePhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { es6_parsePhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : es6_parsePhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function es6_parsePhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function parsePhoneNumber_slicedToArray(arr, i) { return parsePhoneNumber_arrayWithHoles(arr) || parsePhoneNumber_iterableToArrayLimit(arr, i) || parsePhoneNumber_unsupportedIterableToArray(arr, i) || parsePhoneNumber_nonIterableRest(); }

function parsePhoneNumber_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parsePhoneNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parsePhoneNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parsePhoneNumber_arrayLikeToArray(o, minLen); }

function parsePhoneNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function parsePhoneNumber_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function parsePhoneNumber_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function es6_parsePhoneNumber_parsePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumber_parsePhoneNumber(text, options, metadata);
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = parsePhoneNumber_slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = es6_parsePhoneNumber_objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
} // Otherwise istanbul would show this as "branch not covered".

/* istanbul ignore next */

var isObject = function isObject(_) {
  return parsePhoneNumber_typeof(_) === 'object';
};
//# sourceMappingURL=parsePhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumberFromString_.js
function parsePhoneNumberFromString_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function parsePhoneNumberFromString_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? parsePhoneNumberFromString_ownKeys(Object(source), !0).forEach(function (key) { parsePhoneNumberFromString_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : parsePhoneNumberFromString_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parsePhoneNumberFromString_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function parsePhoneNumberFromString(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = parsePhoneNumberFromString_objectSpread(parsePhoneNumberFromString_objectSpread({}, options), {}, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumber_parsePhoneNumber(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) {//
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=parsePhoneNumberFromString_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumberFromString.js


function parsePhoneNumberFromString_parsePhoneNumberFromString() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumberFromString(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumberFromString.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumberFromString.js



function exports_parsePhoneNumberFromString_parsePhoneNumberFromString() {
	return withMetadataArgument(parsePhoneNumberFromString_parsePhoneNumberFromString, arguments)
}
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeState.js
function AsYouTypeState_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeState_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeState_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeState_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeState_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var AsYouTypeState = /*#__PURE__*/function () {
  function AsYouTypeState(_ref) {
    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    AsYouTypeState_classCallCheck(this, AsYouTypeState);

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  AsYouTypeState_createClass(AsYouTypeState, [{
    key: "reset",
    value: function reset(defaultCountry, defaultCallingCode) {
      this.international = false;
      this.IDDPrefix = undefined;
      this.missingPlus = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "update",
    value: function update(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this[key] = properties[key];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      this.onCallingCodeChange(callingCode, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(country, callingCode) {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();


//# sourceMappingURL=AsYouTypeState.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.util.js
function AsYouTypeFormatter_util_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = AsYouTypeFormatter_util_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouTypeFormatter_util_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouTypeFormatter_util_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouTypeFormatter_util_arrayLikeToArray(o, minLen); }

function AsYouTypeFormatter_util_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// Unicode-unsafe (because using `.split()`).

function countOccurences(symbol, string) {
  var count = 0; // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for counting brackets it is safe.
  // for (const character of string)

  for (var _iterator = AsYouTypeFormatter_util_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;

    if (character === symbol) {
      count++;
    }
  }

  return count;
} // Repeats a string (or a symbol) N times.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function closeNonPairedParens(template, cut_before) {
  var retained_template = template.slice(0, cut_before);
  var opening_braces = countOccurences('(', retained_template);
  var closing_braces = countOccurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return template.slice(0, cut_before);
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
    var index = _dangling_braces[_i];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = AsYouTypeFormatter_util_createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;) {
    var digit = _step2.value;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}
//# sourceMappingURL=AsYouTypeFormatter.util.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.complete.js



function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  var nationalSignificantNumber = state.nationalSignificantNumber,
      international = state.international,
      nationalPrefix = state.nationalPrefix,
      carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = AsYouTypeFormatter_complete_formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return AsYouTypeFormatter_complete_formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function AsYouTypeFormatter_complete_formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}
//# sourceMappingURL=AsYouTypeFormatter.complete.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.PatternParser.js
function AsYouTypeFormatter_PatternParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeFormatter_PatternParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeFormatter_PatternParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeFormatter_PatternParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeFormatter_PatternParser_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PatternParser = /*#__PURE__*/function () {
  function PatternParser() {
    AsYouTypeFormatter_PatternParser_classCallCheck(this, PatternParser);
  }

  AsYouTypeFormatter_PatternParser_createClass(PatternParser, [{
    key: "parse",
    value: function parse(pattern) {
      this.context = [{
        or: true,
        instructions: []
      }];
      this.parsePattern(pattern);

      if (this.context.length !== 1) {
        throw new Error('Non-finalized contexts left when pattern parse ended');
      }

      var _this$context$ = this.context[0],
          branches = _this$context$.branches,
          instructions = _this$context$.instructions;

      if (branches) {
        return {
          op: '|',
          args: branches.concat([expandSingleElementArray(instructions)])
        };
      }
      /* istanbul ignore if */


      if (instructions.length === 0) {
        throw new Error('Pattern is required');
      }

      if (instructions.length === 1) {
        return instructions[0];
      }

      return instructions;
    }
  }, {
    key: "startContext",
    value: function startContext(context) {
      this.context.push(context);
    }
  }, {
    key: "endContext",
    value: function endContext() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function parsePattern(pattern) {
      if (!pattern) {
        throw new Error('Pattern is required');
      }

      var match = pattern.match(OPERATOR);

      if (!match) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        }

        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
        return;
      }

      var operator = match[1];
      var before = pattern.slice(0, match.index);
      var rightPart = pattern.slice(match.index + operator.length);

      switch (operator) {
        case '(?:':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            or: true,
            instructions: [],
            branches: []
          });
          break;

        case ')':
          if (!this.getContext().or) {
            throw new Error('")" operator must be preceded by "(?:" operator');
          }

          if (before) {
            this.parsePattern(before);
          }

          if (this.getContext().instructions.length === 0) {
            throw new Error('No instructions found after "|" operator in an "or" group');
          }

          var _this$getContext = this.getContext(),
              branches = _this$getContext.branches;

          branches.push(expandSingleElementArray(this.getContext().instructions));
          this.endContext();
          this.getContext().instructions.push({
            op: '|',
            args: branches
          });
          break;

        case '|':
          if (!this.getContext().or) {
            throw new Error('"|" operator can only be used inside "or" groups');
          }

          if (before) {
            this.parsePattern(before);
          } // The top-level is an implicit "or" group, if required.


          if (!this.getContext().branches) {
            // `branches` are not defined only for the root implicit "or" operator.

            /* istanbul ignore else */
            if (this.context.length === 1) {
              this.getContext().branches = [];
            } else {
              throw new Error('"branches" not found in an "or" group context');
            }
          }

          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions));
          this.getContext().instructions = [];
          break;

        case '[':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            oneOfSet: true
          });
          break;

        case ']':
          if (!this.getContext().oneOfSet) {
            throw new Error('"]" operator must be preceded by "[" operator');
          }

          this.endContext();
          this.getContext().instructions.push({
            op: '[]',
            args: parseOneOfSet(before)
          });
          break;

        /* istanbul ignore next */

        default:
          throw new Error("Unknown operator: ".concat(operator));
      }

      if (rightPart) {
        this.parsePattern(rightPart);
      }
    }
  }]);

  return PatternParser;
}();



function parseOneOfSet(pattern) {
  var values = [];
  var i = 0;

  while (i < pattern.length) {
    if (pattern[i] === '-') {
      if (i === 0 || i === pattern.length - 1) {
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      }

      var prevValue = pattern[i - 1].charCodeAt(0) + 1;
      var nextValue = pattern[i + 1].charCodeAt(0) - 1;
      var value = prevValue;

      while (value <= nextValue) {
        values.push(String.fromCharCode(value));
        value++;
      }
    } else {
      values.push(pattern[i]);
    }

    i++;
  }

  return values;
}

var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var OPERATOR = new RegExp( // any of:
'(' + // or operator
'\\|' + // or
'|' + // or group start
'\\(\\?\\:' + // or
'|' + // or group end
'\\)' + // or
'|' + // one-of set start
'\\[' + // or
'|' + // one-of set end
'\\]' + ')');

function expandSingleElementArray(array) {
  if (array.length === 1) {
    return array[0];
  }

  return array;
}
//# sourceMappingURL=AsYouTypeFormatter.PatternParser.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.PatternMatcher.js
function AsYouTypeFormatter_PatternMatcher_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = AsYouTypeFormatter_PatternMatcher_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouTypeFormatter_PatternMatcher_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouTypeFormatter_PatternMatcher_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouTypeFormatter_PatternMatcher_arrayLikeToArray(o, minLen); }

function AsYouTypeFormatter_PatternMatcher_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function AsYouTypeFormatter_PatternMatcher_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeFormatter_PatternMatcher_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeFormatter_PatternMatcher_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeFormatter_PatternMatcher_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeFormatter_PatternMatcher_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var AsYouTypeFormatter_PatternMatcher_PatternMatcher = /*#__PURE__*/function () {
  function PatternMatcher(pattern) {
    AsYouTypeFormatter_PatternMatcher_classCallCheck(this, PatternMatcher);

    this.matchTree = new PatternParser().parse(pattern);
  }

  AsYouTypeFormatter_PatternMatcher_createClass(PatternMatcher, [{
    key: "match",
    value: function match(string) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          allowOverflow = _ref.allowOverflow;

      if (!string) {
        throw new Error('String is required');
      }

      var result = _match(string.split(''), this.matchTree, true);

      if (result && result.match) {
        delete result.matchedChars;
      }

      if (result && result.overflow) {
        if (!allowOverflow) {
          return;
        }
      }

      return result;
    }
  }]);

  return PatternMatcher;
}();
/**
 * Matches `characters` against a pattern compiled into a `tree`.
 * @param  {string[]} characters
 * @param  {Tree} tree — A pattern compiled into a `tree`. See the `*.d.ts` file for the description of the `tree` structure.
 * @param  {boolean} last — Whether it's the last (rightmost) subtree on its level of the match tree.
 * @return {object} See the `*.d.ts` file for the description of the result object.
 */




function _match(characters, tree, last) {
  // If `tree` is a string, then `tree` is a single character.
  // That's because when a pattern is parsed, multi-character-string parts
  // of a pattern are compiled into arrays of single characters.
  // I still wrote this piece of code for a "general" hypothetical case
  // when `tree` could be a string of several characters, even though
  // such case is not possible with the current implementation.
  if (typeof tree === 'string') {
    var characterString = characters.join('');

    if (tree.indexOf(characterString) === 0) {
      // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore else */
      if (characters.length === tree.length) {
        return {
          match: true,
          matchedChars: characters
        };
      } // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore next */


      return {
        partialMatch: true // matchedChars: characters

      };
    }

    if (characterString.indexOf(tree) === 0) {
      if (last) {
        // The `else` path is not possible because `tree` is always a single character.
        // The `else` case for `characters.length > tree.length` would be
        // `characters.length <= tree.length` which means `characters.length <= 1`.
        // `characters` array can't be empty, so that means `characters === [tree]`,
        // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
        // that the `if (tree.indexOf(characterString) === 0)` condition before this
        // `if` condition would be entered, and returned from there, not reaching this code.

        /* istanbul ignore else */
        if (characters.length > tree.length) {
          return {
            overflow: true
          };
        }
      }

      return {
        match: true,
        matchedChars: characters.slice(0, tree.length)
      };
    }

    return;
  }

  if (Array.isArray(tree)) {
    var restCharacters = characters.slice();
    var i = 0;

    while (i < tree.length) {
      var subtree = tree[i];

      var result = _match(restCharacters, subtree, last && i === tree.length - 1);

      if (!result) {
        return;
      } else if (result.overflow) {
        return result;
      } else if (result.match) {
        // Continue with the next subtree with the rest of the characters.
        restCharacters = restCharacters.slice(result.matchedChars.length);

        if (restCharacters.length === 0) {
          if (i === tree.length - 1) {
            return {
              match: true,
              matchedChars: characters
            };
          } else {
            return {
              partialMatch: true // matchedChars: characters

            };
          }
        }
      } else {
        /* istanbul ignore else */
        if (result.partialMatch) {
          return {
            partialMatch: true // matchedChars: characters

          };
        } else {
          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
        }
      }

      i++;
    } // If `last` then overflow has already been checked
    // by the last element of the `tree` array.

    /* istanbul ignore if */


    if (last) {
      return {
        overflow: true
      };
    }

    return {
      match: true,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }

  switch (tree.op) {
    case '|':
      var partialMatch;

      for (var _iterator = AsYouTypeFormatter_PatternMatcher_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;) {
        var branch = _step.value;

        var _result = _match(characters, branch, last);

        if (_result) {
          if (_result.overflow) {
            return _result;
          } else if (_result.match) {
            return {
              match: true,
              matchedChars: _result.matchedChars
            };
          } else {
            /* istanbul ignore else */
            if (_result.partialMatch) {
              partialMatch = true;
            } else {
              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
            }
          }
        }
      }

      if (partialMatch) {
        return {
          partialMatch: true // matchedChars: ...

        };
      } // Not even a partial match.


      return;

    case '[]':
      for (var _iterator2 = AsYouTypeFormatter_PatternMatcher_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;) {
        var _char = _step2.value;

        if (characters[0] === _char) {
          if (characters.length === 1) {
            return {
              match: true,
              matchedChars: characters
            };
          }

          if (last) {
            return {
              overflow: true
            };
          }

          return {
            match: true,
            matchedChars: [_char]
          };
        }
      } // No character matches.


      return;

    /* istanbul ignore next */

    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}
//# sourceMappingURL=AsYouTypeFormatter.PatternMatcher.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.js
function AsYouTypeFormatter_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = AsYouTypeFormatter_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouTypeFormatter_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouTypeFormatter_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouTypeFormatter_arrayLikeToArray(o, minLen); }

function AsYouTypeFormatter_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function AsYouTypeFormatter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeFormatter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeFormatter_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeFormatter_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeFormatter_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }








 // Used in phone number format template creation.
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.

var SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + VALID_PUNCTUATION + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter_AsYouTypeFormatter = /*#__PURE__*/function () {
  function AsYouTypeFormatter(_ref) {
    var state = _ref.state,
        metadata = _ref.metadata;

    AsYouTypeFormatter_classCallCheck(this, AsYouTypeFormatter);

    this.metadata = metadata;
    this.resetFormat();
  }

  AsYouTypeFormatter_createClass(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */

  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = AsYouTypeFormatter_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;) {
          var format = _step.value;
          var formattedCompleteNumber = formatCompleteNumber(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
              return _this.getSeparatorAfterNationalPrefix(format);
            }
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref2) {
      var _this2 = this;

      var nationalSignificantNumber = _ref2.nationalSignificantNumber,
          nationalPrefix = _ref2.nationalPrefix,
          international = _ref2.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.
      // The test case could be found by searching for "leadingDigitsPatternsCount === 0".

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start narrowing down the list of possible formats based on the leading digits.
      // (only previously matched formats take part in the narrowing down process)
      // `leading_digits_patterns` start with 3 digits min
      // and then go up from there one digit at a time.


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
      // to be minimum 3 digits long in order to be eligible
      // for checking those with a leading digits pattern.
      //
      // Since `leading_digits_patterns` start with 3 digits min,
      // Google's original `libphonenumber` library only starts
      // excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      //
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.
      //
      // Also, `leading_digits_patterns` doesn't always correspond to a single
      // digits count. For example, `60|8` pattern would already match `8`
      // but the `60` part would require having at least two leading digits,
      // so the whole pattern would require inputting two digits first in order to
      // decide on whether it matches the input, even when the input is "80".
      //
      // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
      // even when there's only 1 or 2 digits of the national (significant) number.
      // To do that, it uses a non-strict pattern matcher written specifically for that.
      //

      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        // Before leading digits < 3 matching was implemented:
        // return true
        //
        // After leading digits < 3 matching was implemented:
        try {
          return new AsYouTypeFormatter_PatternMatcher_PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: true
          }) !== undefined;
        } catch (error)
        /* istanbul ignore next */
        {
          // There's a slight possibility that there could be some undiscovered bug
          // in the pattern matcher code. Since the "leading digits < 3 matching"
          // feature is not "essential" for operation, it can fall back to the old way
          // in case of any issues rather than halting the application's execution.
          console.error(error);
          return true;
        }
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
      // available then use the usual regular expression matching.
      //
      // The whole pattern is wrapped in round brackets (`()`) because
      // the pattern can use "or" operator (`|`) at the top level of the pattern.
      //


      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this3 = this;

      var _loop = function _loop() {
        var format = _step2.value;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this3.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this3.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this3.matchingFormats = _this3.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this3.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      //
      // For some weird reason, `istanbul` says "else path not taken"
      // for the `for of` line below. Supposedly that means that
      // the loop doesn't ever go over the last element in the list.
      // That's true because there always is `this.chosenFormat`
      // when `this.matchingFormats` is non-empty.
      // And, for some weird reason, it doesn't think that the case
      // with empty `this.matchingFormats` qualifies for a valid "else" path.
      // So simply muting this `istanbul` warning.
      // It doesn't skip the contents of the `for of` loop,
      // it just skips the `for of` line.
      //

      /* istanbul ignore next */
      for (var _iterator2 = AsYouTypeFormatter_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;) {
        var _ret = _loop();

        if (_ret === "break") break;
        if (_ret === "continue") continue;
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function getSeparatorAfterNationalPrefix(format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
      var IDDPrefix = _ref3.IDDPrefix,
          missingPlus = _ref3.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref4) {
      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          international = _ref4.international,
          nationalPrefix = _ref4.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      if (SUPPORT_LEGACY_FORMATTING_PATTERNS) {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
      var international = _ref5.international,
          nationalPrefix = _ref5.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    }
  }]);

  return AsYouTypeFormatter;
}();


//# sourceMappingURL=AsYouTypeFormatter.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeParser.js
function AsYouTypeParser_slicedToArray(arr, i) { return AsYouTypeParser_arrayWithHoles(arr) || AsYouTypeParser_iterableToArrayLimit(arr, i) || AsYouTypeParser_unsupportedIterableToArray(arr, i) || AsYouTypeParser_nonIterableRest(); }

function AsYouTypeParser_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouTypeParser_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouTypeParser_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouTypeParser_arrayLikeToArray(o, minLen); }

function AsYouTypeParser_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function AsYouTypeParser_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function AsYouTypeParser_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function AsYouTypeParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeParser_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }







var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser_AsYouTypeParser = /*#__PURE__*/function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    AsYouTypeParser_classCallCheck(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  AsYouTypeParser_createClass(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = AsYouTypeParser_slicedToArray(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
            return state.update(stateUpdate);
          });
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode(state) {
      var _extractCountryCallin = extractCountryCallingCode_extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function (stateUpdate) {
        return state.update(stateUpdate);
      })) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits,
          nationalSignificantNumber = state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state, {
          country: undefined,
          callingCode: undefined
        });
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode,
            number = _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          });
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state, _ref3) {
      var country = _ref3.country,
          callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
          return state.update(stateUpdate);
        });
      }
    }
  }]);

  return AsYouTypeParser;
}();
/**
 * Extracts formatted phone number from text (if there's any).
 * @param  {string} text
 * @return {string} [formattedPhoneNumber]
 */




function AsYouTypeParser_extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = AsYouTypeParser_extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = AsYouTypeParser_slicedToArray(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}
//# sourceMappingURL=AsYouTypeParser.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouType.js
function AsYouType_typeof(obj) { "@babel/helpers - typeof"; return AsYouType_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, AsYouType_typeof(obj); }

function AsYouType_slicedToArray(arr, i) { return AsYouType_arrayWithHoles(arr) || AsYouType_iterableToArrayLimit(arr, i) || AsYouType_unsupportedIterableToArray(arr, i) || AsYouType_nonIterableRest(); }

function AsYouType_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouType_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouType_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouType_arrayLikeToArray(o, minLen); }

function AsYouType_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function AsYouType_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function AsYouType_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function AsYouType_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouType_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouType_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouType_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouType_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }







var AsYouType_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var AsYouType_AsYouType = /*#__PURE__*/function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    AsYouType_classCallCheck(this, AsYouType);

    this.metadata = new Metadata(metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = AsYouType_slicedToArray(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1];

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  AsYouType_createClass(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (AsYouType_typeof(optionsOrDefaultCountry) === 'object') {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      if (defaultCallingCode) {
        /* istanbul ignore if */
        if (AsYouType_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
          if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) {
            defaultCountry = '001';
          }
        }
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter_AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser_AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset(this.defaultCountry, this.defaultCallingCode);
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      // If the number is being input in national format and some "default calling code"
      // has been passed to `AsYouType` constructor, then `this.state.callingCode`
      // is equal to that "default calling code".
      //
      // If the number is being input in national format and no "default calling code"
      // has been passed to `AsYouType` constructor, then returns `undefined`,
      // even if a "default country" has been passed to `AsYouType` constructor.
      //
      if (this.isInternational()) {
        return this.state.callingCode;
      }
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var digits = this.state.digits; // Return `undefined` if no digits have been input yet.

      if (digits) {
        return this._getCountry();
      }
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */

  }, {
    key: "_getCountry",
    value: function _getCountry() {
      var country = this.state.country;
      /* istanbul ignore if */

      if (AsYouType_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        // `AsYouType.getCountry()` returns `undefined`
        // for "non-geographic" phone numbering plans.
        if (country === '001') {
          return;
        }
      }

      return country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state = this.state,
          nationalSignificantNumber = _this$state.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */

  }, {
    key: "getNumberValue",
    value: function getNumberValue() {
      var _this$state2 = this.state,
          digits = _this$state2.digits,
          callingCode = _this$state2.callingCode,
          country = _this$state2.country,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.

      if (!digits) {
        return;
      }

      if (this.isInternational()) {
        if (callingCode) {
          return '+' + callingCode + nationalSignificantNumber;
        } else {
          return '+' + digits;
        }
      } else {
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return '+' + callingCode_ + nationalSignificantNumber;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode,
          callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
      // with the only change that it return `undefined` in case of a
      // "non-geographic" numbering plan instead of `"001"` "internal use" value.

      var country = this._getCountry();

      if (!nationalSignificantNumber) {
        return;
      }

      if (!country && !callingCode) {
        return;
      }

      var phoneNumber = new PhoneNumber_PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();


//# sourceMappingURL=AsYouType.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/min/exports/AsYouType.js
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.




function exports_AsYouType_AsYouType(country) {
	return AsYouType_AsYouType.call(this, country, metadata_min_json)
}

exports_AsYouType_AsYouType.prototype = Object.create(AsYouType_AsYouType.prototype, {})
exports_AsYouType_AsYouType.prototype.constructor = exports_AsYouType_AsYouType
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"23eda527-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VuePhoneNumberInput/InputTel/index.vue?vue&type=template&id=e59be3b4&scoped=true&
var InputTelvue_type_template_id_e59be3b4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"parent",staticClass:"input-tel",class:[{
    'is-focused': _vm.isFocus,
    'is-valid': _vm.valid,
    'has-value': _vm.value,
    'has-error': _vm.error,
    'is-disabled': _vm.disabled,
    'is-dark': _vm.dark,
    'has-hint': _vm.hint
  }, _vm.size],on:{"click":_vm.focusInput,"mouseenter":function($event){return _vm.updateHoverState(true)},"mouseleave":function($event){return _vm.updateHoverState(false)}}},[((_vm.type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"InputTel",staticClass:"input-tel__input",class:{ 'no-country-selector': _vm.noCountrySelector },style:([
      _vm.noCountrySelector ? _vm.radiusStyle : _vm.radiusRightStyle,
      _vm.inputCaretStyle,
      _vm.inputBorderStyle,
      _vm.inputBoxShadowStyle,
      _vm.inputBgColor,
      _vm.textColor
    ]),attrs:{"id":_vm.id,"placeholder":_vm.labelValue,"disabled":_vm.disabled,"required":_vm.required,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.inputValue)?_vm._i(_vm.inputValue,null)>-1:(_vm.inputValue)},on:{"keydown":_vm.keyDown,"keyup":_vm.keyUp,"focus":_vm.onFocus,"blur":_vm.onBlur,"click":function($event){return _vm.$emit('click', $event)},"change":function($event){var $$a=_vm.inputValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inputValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inputValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inputValue=$$c}}}},'input',_vm.$attrs,false)):((_vm.type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"InputTel",staticClass:"input-tel__input",class:{ 'no-country-selector': _vm.noCountrySelector },style:([
      _vm.noCountrySelector ? _vm.radiusStyle : _vm.radiusRightStyle,
      _vm.inputCaretStyle,
      _vm.inputBorderStyle,
      _vm.inputBoxShadowStyle,
      _vm.inputBgColor,
      _vm.textColor
    ]),attrs:{"id":_vm.id,"placeholder":_vm.labelValue,"disabled":_vm.disabled,"required":_vm.required,"type":"radio"},domProps:{"checked":_vm._q(_vm.inputValue,null)},on:{"keydown":_vm.keyDown,"keyup":_vm.keyUp,"focus":_vm.onFocus,"blur":_vm.onBlur,"click":function($event){return _vm.$emit('click', $event)},"change":function($event){_vm.inputValue=null}}},'input',_vm.$attrs,false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"InputTel",staticClass:"input-tel__input",class:{ 'no-country-selector': _vm.noCountrySelector },style:([
      _vm.noCountrySelector ? _vm.radiusStyle : _vm.radiusRightStyle,
      _vm.inputCaretStyle,
      _vm.inputBorderStyle,
      _vm.inputBoxShadowStyle,
      _vm.inputBgColor,
      _vm.textColor
    ]),attrs:{"id":_vm.id,"placeholder":_vm.labelValue,"disabled":_vm.disabled,"required":_vm.required,"type":_vm.type},domProps:{"value":(_vm.inputValue)},on:{"keydown":_vm.keyDown,"keyup":_vm.keyUp,"focus":_vm.onFocus,"blur":_vm.onBlur,"click":function($event){return _vm.$emit('click', $event)},"input":function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value}}},'input',_vm.$attrs,false)),_c('label',{ref:"label",staticClass:"input-tel__label",class:_vm.error ? 'text-danger' : null,style:([_vm.labelColorStyle]),attrs:{"for":_vm.id},on:{"click":_vm.focusInput}},[_vm._v(" "+_vm._s(_vm.hintValue || _vm.labelValue)+" ")]),(_vm.clearable && _vm.inputValue)?_c('button',{staticClass:"input-tel__clear",attrs:{"title":"clear","type":"button","tabindex":"-1"},on:{"click":_vm.clear}},[_c('span',{staticClass:"input-tel__clear__effect"}),_c('span',[_vm._v(" ✕ ")])]):_vm._e(),(_vm.loader)?_c('div',{staticClass:"input-tel__loader"},[_c('div',{staticClass:"input-tel__loader__progress-bar",style:([_vm.loaderBgColor])})]):_vm._e()])}
var InputTelvue_type_template_id_e59be3b4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/VuePhoneNumberInput/InputTel/index.vue?vue&type=template&id=e59be3b4&scoped=true&

// CONCATENATED MODULE: ./src/VuePhoneNumberInput/mixins/StylesHandler.js
/* harmony default export */ var StylesHandler = ({
  props: {
    theme: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelColorStyle: function labelColorStyle() {
      if (this.error) return this.theme.errorColor;else if (this.valid) return this.theme.validColor;else if (this.isFocus) return this.theme.color;else if (this.dark) return this.theme.textDarkColor;
      return null;
    },
    inputBorderStyle: function inputBorderStyle() {
      if (this.error) return this.theme.borderErrorColor;else if (this.valid) return this.theme.borderValidColor;else if (this.isHover || this.isFocus) return this.theme.borderColor;
      return null;
    },
    inputBoxShadowStyle: function inputBoxShadowStyle() {
      if (this.isFocus) {
        if (this.error) return this.theme.boxShadowError;else if (this.valid) return this.theme.boxShadowValid;
        return this.theme.boxShadowColor;
      }

      return null;
    },
    inputBgColor: function inputBgColor() {
      return !this.dark ? null : this.theme.bgDarkColor;
    },
    textColor: function textColor() {
      return this.dark ? this.theme.textDarkColor : null;
    },
    inputCaretStyle: function inputCaretStyle() {
      return {
        caretColor: this.theme.colorValue
      };
    },
    radiusStyle: function radiusStyle() {
      return this.theme.borderRadius;
    },
    radiusLeftStyle: function radiusLeftStyle() {
      return this.theme.borderLeftRadius;
    },
    radiusRightStyle: function radiusRightStyle() {
      return this.theme.borderRightRadius;
    },
    bgItemSelectedStyle: function bgItemSelectedStyle() {
      return this.theme.bgColor;
    },
    loaderBgColor: function loaderBgColor() {
      return this.theme.bgColor;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VuePhoneNumberInput/InputTel/index.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var InputTelvue_type_script_lang_js_ = ({
  name: 'InputTel',
  mixins: [StylesHandler],
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: 'Enter text'
    },
    hint: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: 'InputTel'
    },
    size: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'tel'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    noCountrySelector: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isFocus: false,
      isHover: false
    };
  },
  computed: {
    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    labelValue: function labelValue() {
      var label = this.label;
      return this.required && label ? "".concat(label, " *") : label;
    },
    hintValue: function hintValue() {
      var hint = this.hint;
      return this.required && hint ? "".concat(hint, " *") : hint;
    }
  },
  methods: {
    updateHoverState: function updateHoverState(value) {
      this.isHover = value;
    },
    focusInput: function focusInput() {
      this.$refs.InputTel.focus();
    },
    onFocus: function onFocus() {
      this.$emit('focus');
      this.isFocus = true;
    },
    onBlur: function onBlur() {
      this.$emit('blur');
      this.isFocus = false;
    },
    clear: function clear() {
      this.$emit('input', null);
      this.$emit('clear');
    },
    keyUp: function keyUp(e) {
      this.$emit('keyup', e);
    },
    keyDown: function keyDown(e) {
      this.$emit('keydown', e);
    }
  }
});
// CONCATENATED MODULE: ./src/VuePhoneNumberInput/InputTel/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var VuePhoneNumberInput_InputTelvue_type_script_lang_js_ = (InputTelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/VuePhoneNumberInput/InputTel/index.vue?vue&type=style&index=0&id=e59be3b4&prod&lang=scss&scoped=true&
var InputTelvue_type_style_index_0_id_e59be3b4_prod_lang_scss_scoped_true_ = __nested_webpack_require_219114__("d499");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/VuePhoneNumberInput/InputTel/index.vue






/* normalize component */

var component = normalizeComponent(
  VuePhoneNumberInput_InputTelvue_type_script_lang_js_,
  InputTelvue_type_template_id_e59be3b4_scoped_true_render,
  InputTelvue_type_template_id_e59be3b4_scoped_true_staticRenderFns,
  false,
  null,
  "e59be3b4",
  null
  
)

/* harmony default export */ var InputTel = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"23eda527-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VuePhoneNumberInput/CountrySelector/index.vue?vue&type=template&id=46e105de&scoped=true&
var CountrySelectorvue_type_template_id_46e105de_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"parent",staticClass:"country-selector",class:[{
    'is-focused': _vm.isFocus,
    'has-value': _vm.value,
    'has-hint': _vm.hint,
    'has-error': _vm.error,
    'is-disabled': _vm.disabled,
    'is-dark': _vm.dark,
    'no-flags': _vm.noFlags,
    'has-list-open': _vm.hasListOpen,
    'is-valid': _vm.valid
  }, _vm.size],on:{"!blur":function($event){return _vm.handleBlur.apply(null, arguments)},"mouseenter":function($event){return _vm.updateHoverState(true)},"mouseleave":function($event){return _vm.updateHoverState(false)}}},[(_vm.value && !_vm.noFlags)?_c('div',{staticClass:"country-selector__country-flag",on:{"click":function($event){$event.stopPropagation();return _vm.toggleList.apply(null, arguments)}}},[_c('div',{class:("iti-flag-small iti-flag " + (_vm.value.toLowerCase()))})]):_vm._e(),_c('input',{ref:"CountrySelector",staticClass:"country-selector__input",style:([_vm.radiusLeftStyle, _vm.inputBorderStyle, _vm.inputBoxShadowStyle, _vm.inputBgColor]),attrs:{"id":_vm.id,"placeholder":_vm.label,"disabled":_vm.disabled,"readonly":""},domProps:{"value":_vm.callingCode},on:{"focus":function($event){_vm.isFocus = true},"keydown":_vm.keyboardNav,"click":function($event){$event.stopPropagation();return _vm.toggleList.apply(null, arguments)}}}),_c('div',{staticClass:"country-selector__toggle",on:{"click":function($event){$event.stopPropagation();return _vm.toggleList.apply(null, arguments)}}},[_vm._t("arrow",function(){return [_c('svg',{staticClass:"country-selector__toggle__arrow",attrs:{"mlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{staticClass:"arrow",attrs:{"d":"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0V0z"}})])]})],2),_c('label',{ref:"label",staticClass:"country-selector__label",style:([_vm.labelColorStyle]),on:{"click":function($event){$event.stopPropagation();return _vm.toggleList.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.hint || _vm.label)+" ")]),_c('Transition',{attrs:{"name":"slide"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasListOpen),expression:"hasListOpen"}],ref:"countriesList",staticClass:"country-selector__list",class:{ 'has-calling-code': _vm.showCodeOnList },style:([_vm.radiusStyle, _vm.listHeight, _vm.inputBgColor])},[_c('RecycleScroller',{attrs:{"items":_vm.countriesSorted,"item-size":1,"key-field":"iso2"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var item = ref.item;
return [_c('button',{key:("item-" + (item.code)),staticClass:"flex align-center country-selector__list__item",class:[
            { 'selected': _vm.value === item.iso2 },
            { 'keyboard-selected': _vm.value !== item.iso2 && _vm.tmpValue === item.iso2 }
          ],style:([
            _vm.itemHeight,
            _vm.value === item.iso2 ? _vm.bgItemSelectedStyle : null
          ]),attrs:{"tabindex":"-1","type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.updateValue(item.iso2)}}},[(!_vm.noFlags)?_c('div',{staticClass:"country-selector__list__item__flag-container"},[_c('div',{class:("iti-flag-small iti-flag " + (item.iso2.toLowerCase()))})]):_vm._e(),(_vm.showCodeOnList)?_c('span',{staticClass:"country-selector__list__item__calling-code flex-fixed"},[_vm._v("+"+_vm._s(item.dialCode))]):_vm._e(),_c('div',{staticClass:"dots-text"},[_vm._v(" "+_vm._s(item.name)+" ")])])]}}])})],1)])],1)}
var CountrySelectorvue_type_template_id_46e105de_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/VuePhoneNumberInput/CountrySelector/index.vue?vue&type=template&id=46e105de&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __nested_webpack_require_219114__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __nested_webpack_require_219114__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __nested_webpack_require_219114__("20d6");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/is-array.js
var is_array = __nested_webpack_require_219114__("a745");
var is_array_default = /*#__PURE__*/__nested_webpack_require_219114__.n(is_array);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/arrayLikeToArray.js
function arrayLikeToArray_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/arrayWithoutHoles.js


function _arrayWithoutHoles(arr) {
  if (is_array_default()(arr)) return arrayLikeToArray_arrayLikeToArray(arr);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/from.js
var from = __nested_webpack_require_219114__("774e");
var from_default = /*#__PURE__*/__nested_webpack_require_219114__.n(from);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/is-iterable.js
var is_iterable = __nested_webpack_require_219114__("c8bb");
var is_iterable_default = /*#__PURE__*/__nested_webpack_require_219114__.n(is_iterable);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/symbol.js
var symbol = __nested_webpack_require_219114__("67bb");
var symbol_default = /*#__PURE__*/__nested_webpack_require_219114__.n(symbol);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/iterableToArray.js



function _iterableToArray(iter) {
  if (typeof symbol_default.a !== "undefined" && is_iterable_default()(Object(iter))) return from_default()(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/unsupportedIterableToArray.js


function unsupportedIterableToArray_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return from_default()(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray_arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || unsupportedIterableToArray_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __nested_webpack_require_219114__("7514");

// CONCATENATED MODULE: ./node_modules/libphonenumber-js/min/exports/getCountryCallingCode.js



function getCountryCallingCode_getCountryCallingCode() {
	return withMetadataArgument(getCountryCallingCode, arguments)
}
// EXTERNAL MODULE: ./node_modules/vue-virtual-scroller/dist/vue-virtual-scroller.esm.js
var vue_virtual_scroller_esm = __nested_webpack_require_219114__("e508");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VuePhoneNumberInput/CountrySelector/index.vue?vue&type=script&lang=js&










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CountrySelectorvue_type_script_lang_js_ = ({
  name: 'CountrySelector',
  components: {
    RecycleScroller: vue_virtual_scroller_esm["a" /* RecycleScroller */]
  },
  mixins: [StylesHandler],
  props: {
    id: {
      type: String,
      default: 'CountrySelector'
    },
    value: {
      type: [String, Object],
      default: null
    },
    label: {
      type: String,
      default: 'Choose country'
    },
    hint: {
      type: String,
      default: String
    },
    size: {
      type: String,
      default: String
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: Array,
      required: true
    },
    preferredCountries: {
      type: Array,
      default: null
    },
    onlyCountries: {
      type: Array,
      default: null
    },
    ignoredCountries: {
      type: Array,
      default: null
    },
    noFlags: {
      type: Boolean,
      default: false
    },
    countriesHeight: {
      type: Number,
      default: 35
    },
    showCodeOnList: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isFocus: false,
      hasListOpen: false,
      selectedIndex: null,
      tmpValue: this.value,
      query: '',
      indexItemToShow: 0,
      isHover: false
    };
  },
  computed: {
    itemHeight: function itemHeight() {
      return {
        height: "".concat(this.countriesHeight, "px")
      };
    },
    listHeight: function listHeight() {
      return {
        height: "".concat((this.countriesHeight + 1) * 7, "px"),
        maxHeight: "".concat((this.countriesHeight + 1) * 7, "px")
      };
    },
    countriesList: function countriesList() {
      var _this = this;

      return this.items.filter(function (item) {
        return !_this.ignoredCountries.includes(item.iso2);
      });
    },
    countriesFiltered: function countriesFiltered() {
      var _this2 = this;

      var countries = this.onlyCountries || this.preferredCountries;
      return countries.map(function (country) {
        return _this2.countriesList.find(function (item) {
          return item.iso2.includes(country);
        });
      });
    },
    otherCountries: function otherCountries() {
      var _this3 = this;

      return this.countriesList.filter(function (item) {
        return !_this3.preferredCountries.includes(item.iso2);
      });
    },
    countriesSorted: function countriesSorted() {
      return this.preferredCountries ? [].concat(_toConsumableArray(this.countriesFiltered), _toConsumableArray(this.otherCountries)) : this.onlyCountries ? this.countriesFiltered : this.countriesList;
    },
    selectedValueIndex: function selectedValueIndex() {
      var _this4 = this;

      return this.value ? this.countriesSorted.findIndex(function (c) {
        return c.iso2 === _this4.value;
      }) : null;
    },
    tmpValueIndex: function tmpValueIndex() {
      var _this5 = this;

      return this.countriesSorted.findIndex(function (c) {
        return c.iso2 === _this5.tmpValue;
      });
    },
    callingCode: function callingCode() {
      return this.value ? "+".concat(getCountryCallingCode_getCountryCallingCode(this.value)) : null;
    }
  },
  methods: {
    updateHoverState: function updateHoverState(value) {
      this.isHover = value;
    },
    handleBlur: function handleBlur(e) {
      if (this.$el.contains(e.relatedTarget)) return;
      this.isFocus = false;
      this.closeList();
    },
    toggleList: function toggleList() {
      this.$refs.countriesList.offsetParent ? this.closeList() : this.openList();
    },
    openList: function openList() {
      if (!this.disabled) {
        this.$refs.CountrySelector.focus();
        this.$emit('open');
        this.isFocus = true;
        this.hasListOpen = true;
        if (this.value) this.scrollToSelectedOnFocus(this.selectedValueIndex);
      }
    },
    closeList: function closeList() {
      this.$emit('close');
      this.hasListOpen = false;
    },
    updateValue: function () {
      var _updateValue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.tmpValue = val;
                this.$emit('input', val || null);
                _context.next = 4;
                return this.$nextTick();

              case 4:
                this.closeList();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateValue(_x) {
        return _updateValue.apply(this, arguments);
      }

      return updateValue;
    }(),
    scrollToSelectedOnFocus: function scrollToSelectedOnFocus(arrayIndex) {
      var _this6 = this;

      this.$nextTick(function () {
        // this.indexItemToShow = arrayIndex - 3
        _this6.$refs.countriesList.scrollTop = arrayIndex * (_this6.countriesHeight + 1) - (_this6.countriesHeight + 1) * 3;
      });
    },
    keyboardNav: function keyboardNav(e) {
      var code = e.keyCode;

      if (code === 40 || code === 38) {
        // arrow up down
        if (e.view && e.view.event) {
          // TODO : It's not compatible with FireFox
          e.view.event.preventDefault();
        }

        if (!this.hasListOpen) this.openList();
        var index = code === 40 ? this.tmpValueIndex + 1 : this.tmpValueIndex - 1;

        if (index === -1 || index >= this.countriesSorted.length) {
          index = index === -1 ? this.countriesSorted.length - 1 : 0;
        }

        this.tmpValue = this.countriesSorted[index].iso2;
        this.scrollToSelectedOnFocus(index);
      } else if (code === 13) {
        // enter
        this.hasListOpen ? this.updateValue(this.tmpValue) : this.openList();
      } else if (code === 27) {
        // escape
        this.closeList();
      } else {
        // typing a country's name
        this.searching(e);
      }
    },
    searching: function searching(e) {
      var _this7 = this;

      var code = e.keyCode;
      clearTimeout(this.queryTimer);
      this.queryTimer = setTimeout(function () {
        _this7.query = '';
      }, 1000);
      var q = String.fromCharCode(code);

      if (code === 8 && this.query !== '') {
        this.query = this.query.substring(0, this.query.length - 1);
      } else if (/[a-zA-Z-e ]/.test(q)) {
        if (!this.hasListOpen) this.openList();
        this.query += e.key;
        var countries = this.preferredCountries ? this.countriesSorted.slice(this.preferredCountries.length) : this.countriesSorted;
        var resultIndex = countries.findIndex(function (c) {
          _this7.tmpValue = c.iso2;
          return c.name.toLowerCase().startsWith(_this7.query);
        });

        if (resultIndex !== -1) {
          this.scrollToSelectedOnFocus(resultIndex + (this.preferredCountries ? this.preferredCountries.length : 0));
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/VuePhoneNumberInput/CountrySelector/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var VuePhoneNumberInput_CountrySelectorvue_type_script_lang_js_ = (CountrySelectorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/VuePhoneNumberInput/CountrySelector/index.vue?vue&type=style&index=0&id=46e105de&prod&lang=scss&scoped=true&
var CountrySelectorvue_type_style_index_0_id_46e105de_prod_lang_scss_scoped_true_ = __nested_webpack_require_219114__("e71e");

// CONCATENATED MODULE: ./src/VuePhoneNumberInput/CountrySelector/index.vue






/* normalize component */

var CountrySelector_component = normalizeComponent(
  VuePhoneNumberInput_CountrySelectorvue_type_script_lang_js_,
  CountrySelectorvue_type_template_id_46e105de_scoped_true_render,
  CountrySelectorvue_type_template_id_46e105de_scoped_true_staticRenderFns,
  false,
  null,
  "46e105de",
  null
  
)

/* harmony default export */ var CountrySelector = (CountrySelector_component.exports);
// CONCATENATED MODULE: ./src/VuePhoneNumberInput/assets/locales/index.js
/* harmony default export */ var locales = ({
  countrySelectorLabel: 'Country code',
  countrySelectorError: 'Choose country',
  phoneNumberLabel: 'Phone number',
  example: 'Example:'
});
// EXTERNAL MODULE: ./node_modules/color-transformer-ui/lib/app.js
var app = __nested_webpack_require_219114__("6038");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VuePhoneNumberInput/index.vue?vue&type=script&lang=js&












function VuePhoneNumberInputvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function VuePhoneNumberInputvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VuePhoneNumberInputvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VuePhoneNumberInputvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var VuePhoneNumberInputvue_type_script_lang_js_getShadowColor = function getShadowColor(color) {
  return Object(app["isColorName"])(color) ? Object(app["hexToRgba"])(Object(app["colorNameToHex"])(color), 0.7) : Object(app["hexToRgba"])(color, 0.7);
};

var browserLocale = function browserLocale() {
  if (!window) return null;
  var browserLocale = window.navigator.userLanguage || window.navigator.language;
  var locale = browserLocale ? browserLocale.substr(3, 4).toUpperCase() : null;
  if (locale === '') locale = browserLocale.substr(0, 2).toUpperCase();
  return locale;
};

var VuePhoneNumberInputvue_type_script_lang_js_isCountryAvailable = function isCountryAvailable(locale) {
  return countriesIso.includes(locale);
};

/* harmony default export */ var VuePhoneNumberInputvue_type_script_lang_js_ = ({
  name: 'VuePhoneNumberInput',
  components: {
    InputTel: InputTel,
    CountrySelector: CountrySelector
  },
  props: {
    value: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'MazPhoneNumberInput'
    },
    color: {
      type: String,
      default: 'dodgerblue'
    },
    validColor: {
      type: String,
      default: 'yellowgreen'
    },
    errorColor: {
      type: String,
      default: 'orangered'
    },
    darkColor: {
      type: String,
      default: '#424242'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultCountryCode: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    preferredCountries: {
      type: Array,
      default: null
    },
    onlyCountries: {
      type: Array,
      default: null
    },
    ignoredCountries: {
      type: Array,
      default: Array
    },
    translations: {
      type: Object,
      default: null
    },
    noValidatorState: {
      type: Boolean,
      default: false
    },
    noFlags: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    noExample: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    countriesHeight: {
      type: Number,
      default: 30
    },
    noUseBrowserLocale: {
      type: Boolean,
      default: false
    },
    fetchCountry: {
      type: Boolean,
      default: false
    },
    noCountrySelector: {
      type: Boolean,
      default: false
    },
    showCodeOnList: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    borderRadius: {
      type: Number,
      default: 4
    }
  },
  data: function data() {
    return {
      results: {},
      userLocale: this.defaultCountryCode,
      lastKeyPressed: null
    };
  },
  computed: {
    uniqueId: function uniqueId() {
      return "".concat(this.id, "-").concat(this._uid);
    },
    t: function t() {
      return VuePhoneNumberInputvue_type_script_lang_js_objectSpread(VuePhoneNumberInputvue_type_script_lang_js_objectSpread({}, locales), this.translations);
    },
    codesCountries: function codesCountries() {
      return countries;
    },
    countryCode: {
      get: function get() {
        return this.userLocale || this.results.countryCode;
      },
      set: function set(newCountry) {
        this.setLocale(newCountry);
        this.$refs.PhoneNumberInput.$el.querySelector('input').focus();
      }
    },
    phoneNumber: {
      get: function get() {
        return this.value;
      },
      set: function set(newPhone) {
        this.emitValues({
          countryCode: this.countryCode,
          phoneNumber: newPhone
        });
      }
    },
    shouldChooseCountry: function shouldChooseCountry() {
      return !this.countryCode && !!this.phoneNumber;
    },
    phoneFormatted: function phoneFormatted() {
      return this.results.formatInternational;
    },
    isValid: function isValid() {
      return this.results.isValid;
    },
    phoneNumberExample: function phoneNumberExample() {
      var phoneNumber = this.countryCode ? getExampleNumber_getExampleNumber(this.countryCode, examples_mobile) : null;
      return phoneNumber ? phoneNumber.formatNational() : null;
    },
    hasEmptyPhone: function hasEmptyPhone() {
      return this.phoneNumber === '' || this.phoneNumber === null;
    },
    hintValue: function hintValue() {
      return this.noExample || !this.phoneNumberExample ? null : this.hasEmptyPhone || this.isValid ? null : "".concat(this.t.example, " ").concat(this.phoneNumberExample);
    },
    theme: function theme() {
      return {
        colorValue: this.color,
        color: {
          color: this.color
        },
        textColor: {
          color: '#747474'
        },
        textDarkColor: {
          color: 'rgba(255, 255, 255, 0.7)'
        },
        validColor: {
          color: this.validColor
        },
        errorColor: {
          color: this.errorColor
        },
        darkColor: {
          color: this.darkColor
        },
        bgColor: {
          backgroundColor: this.color
        },
        bgValidColor: {
          backgroundColor: this.validColor
        },
        bgErrorColor: {
          backgroundColor: this.errorColor
        },
        bgDarkColor: {
          backgroundColor: this.darkColor
        },
        borderColor: {
          borderColor: this.color
        },
        borderValidColor: {
          borderColor: this.validColor
        },
        borderErrorColor: {
          borderColor: this.errorColor
        },
        borderDarkColor: {
          borderColor: this.darkColor
        },
        boxShadowColor: {
          boxShadow: "0 0 0 0.125rem ".concat(VuePhoneNumberInputvue_type_script_lang_js_getShadowColor(this.color))
        },
        boxShadowValid: {
          boxShadow: "0 0 0 0.125rem ".concat(VuePhoneNumberInputvue_type_script_lang_js_getShadowColor(this.validColor))
        },
        boxShadowError: {
          boxShadow: "0 0 0 0.125rem ".concat(VuePhoneNumberInputvue_type_script_lang_js_getShadowColor(this.errorColor))
        },
        borderRadius: {
          borderRadius: "".concat(this.borderRadius, "px")
        },
        borderLeftRadius: {
          borderTopLeftRadius: "".concat(this.borderRadius, "px"),
          borderBottomLeftRadius: "".concat(this.borderRadius, "px")
        },
        borderRightRadius: {
          borderTopRightRadius: "".concat(this.borderRadius, "px"),
          borderBottomRightRadius: "".concat(this.borderRadius, "px")
        }
      };
    }
  },
  watch: {
    defaultCountryCode: function defaultCountryCode(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.setLocale(newValue);
    },
    phoneNumber: {
      handler: function handler(newValue, oldValue) {
        // init component (countryCode & phoneNumber) if phone number is provide
        if (newValue && newValue !== oldValue) {
          var phoneNumber = exports_parsePhoneNumberFromString_parsePhoneNumberFromString(newValue);

          if (phoneNumber) {
            this.emitValues({
              phoneNumber: phoneNumber.nationalNumber,
              countryCode: this.countryCode ? this.countryCode : phoneNumber.country
            });
          }
        }
      },
      immediate: true
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (this.phoneNumber && this.defaultCountryCode) this.emitValues({
                countryCode: this.defaultCountryCode,
                phoneNumber: this.phoneNumber
              });

              if (!(this.defaultCountryCode && this.fetchCountry)) {
                _context.next = 4;
                break;
              }

              throw new Error('MazPhoneNumberInput: Do not use "fetch-country" and "default-country-code" options in the same time');

            case 4:
              if (!(this.defaultCountryCode && this.noUseBrowserLocale)) {
                _context.next = 6;
                break;
              }

              throw new Error('MazPhoneNumberInput: If you use a "default-country-code", do not use "no-use-browser-locale" options');

            case 6:
              if (!this.defaultCountryCode) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              this.fetchCountry ? this.fetchCountryCode() : !this.noUseBrowserLocale ? this.setLocale(browserLocale()) : null;
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              throw new Error(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 11]]);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    getAsYouTypeFormat: function getAsYouTypeFormat(payload) {
      var countryCode = payload.countryCode,
          phoneNumber = payload.phoneNumber;
      var asYouType = new exports_AsYouType_AsYouType(countryCode);
      return phoneNumber ? asYouType.input(phoneNumber) : null;
    },
    getParsePhoneNumberFromString: function getParsePhoneNumberFromString(_ref) {
      var phoneNumber = _ref.phoneNumber,
          countryCode = _ref.countryCode;
      var parsing = phoneNumber && countryCode ? exports_parsePhoneNumberFromString_parsePhoneNumberFromString(phoneNumber, countryCode) : null;
      return VuePhoneNumberInputvue_type_script_lang_js_objectSpread(VuePhoneNumberInputvue_type_script_lang_js_objectSpread({
        countryCode: countryCode,
        isValid: false
      }, phoneNumber && phoneNumber !== '' ? {
        phoneNumber: phoneNumber
      } : null), parsing ? {
        countryCallingCode: parsing.countryCallingCode,
        formattedNumber: parsing.number,
        nationalNumber: parsing.nationalNumber,
        isValid: parsing.isValid(),
        type: parsing.getType(),
        formatInternational: parsing.formatInternational(),
        formatNational: parsing.formatNational(),
        uri: parsing.getURI(),
        e164: parsing.format('E.164')
      } : null);
    },
    emitValues: function emitValues(payload) {
      var _this = this;

      var asYouType = this.getAsYouTypeFormat(payload);
      var backSpacePressed = this.lastKeyPressed === 8;
      this.$nextTick(function () {
        var lastCharacOfPhoneNumber = _this.phoneNumber ? _this.phoneNumber.trim().slice(-1) : false;

        if (backSpacePressed && lastCharacOfPhoneNumber && lastCharacOfPhoneNumber.slice(-1) === ')') {
          asYouType = _this.phoneNumber.slice(0, -2);
          payload.phoneNumber = _this.phoneNumber.slice(0, -2);
        }

        _this.results = _this.getParsePhoneNumberFromString(payload);

        _this.$emit('update', _this.results);

        _this.$emit('input', asYouType);
      });
    },
    setLocale: function setLocale(locale) {
      var countryAvailable = VuePhoneNumberInputvue_type_script_lang_js_isCountryAvailable(locale);

      if (countryAvailable && locale) {
        this.userLocale = countryAvailable ? locale : null;
        this.emitValues({
          countryCode: locale,
          phoneNumber: this.phoneNumber
        });
      } else if (!countryAvailable && locale) {
        window.console.warn("The locale ".concat(locale, " is not available"));
      }
    },
    fetchCountryCode: function () {
      var _fetchCountryCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, responseText, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetch('https://ip2c.org/s');

              case 3:
                response = _context2.sent;
                _context2.next = 6;
                return response.text();

              case 6:
                responseText = _context2.sent;
                result = (responseText || '').toString();
                if (result && result[0] === '1') this.setLocale(result.substr(2, 2));
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                throw new Error(_context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 11]]);
      }));

      function fetchCountryCode() {
        return _fetchCountryCode.apply(this, arguments);
      }

      return fetchCountryCode;
    }()
  }
});
// CONCATENATED MODULE: ./src/VuePhoneNumberInput/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_VuePhoneNumberInputvue_type_script_lang_js_ = (VuePhoneNumberInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/VuePhoneNumberInput/index.vue?vue&type=style&index=0&id=19351537&prod&lang=scss&scoped=true&
var VuePhoneNumberInputvue_type_style_index_0_id_19351537_prod_lang_scss_scoped_true_ = __nested_webpack_require_219114__("e214");

// CONCATENATED MODULE: ./src/VuePhoneNumberInput/index.vue






/* normalize component */

var VuePhoneNumberInput_component = normalizeComponent(
  src_VuePhoneNumberInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "19351537",
  null
  
)

/* harmony default export */ var VuePhoneNumberInput = (VuePhoneNumberInput_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (VuePhoneNumberInput);



/***/ }),

/***/ "fdef":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ })

/******/ })["default"];
//# sourceMappingURL=vue-phone-number-input.common.js.map

/***/ }),

/***/ 912:
/***/ (function(module) {

"use strict";
module.exports = Highcharts;

/***/ }),

/***/ 697:
/***/ (function(module) {

"use strict";
module.exports = Vue;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

// UNUSED EXPORTS: Colors, Variables, getComponentsInstance, mixins, utils

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountManagement/index.vue?vue&type=template&id=f68b85b2&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"no-top-padding",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"no-top-padding buffered-content"},[(!_vm.deleteAccountScreenOpen)?[_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountManagement.deleteAccount'))+" ")]),_c('v-card-text',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountManagement.instructions'))+" ")])])]:[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountManagement.warning'))+" "),_c('v-checkbox',{attrs:{"color":"primary","label":_vm.$t('userProfile.accountManagement.warningAcceptance'),"disabled":_vm.deletingAccount,"data-cy":"acceptWarining"},model:{value:(_vm.warningAcceptance),callback:function ($$v) {_vm.warningAcceptance=$$v},expression:"warningAcceptance"}})],1)]],2),(!_vm.deleteAccountScreenOpen)?_c('v-card-actions',{attrs:{"text":""}},[_c('not-allowed-tooltip',{attrs:{"disabled":!_vm.isLogInAs,"maxWidth":500}},[_c('v-btn',{class:_vm.isLogInAs ? 'black--text' : 'red-border red--text',attrs:{"outlined":"","text":"","disabled":_vm.isLogInAs,"data-cy":"startDeleteAccount"},on:{"click":_vm.openDeleteAccountScreen}},[_vm._v(" "+_vm._s(_vm.$t("userProfile.accountManagement.deleteAccount"))+" ")])],1),_c('v-spacer'),_c('v-spacer'),(!_vm.$vuetify.breakpoint.xs)?_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"accountManagementDone"},on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t('buttons.done'))+" ")]):_vm._e()],1):_c('v-card-actions',{attrs:{"text":""}},[_c('v-btn',{class:{
        'black--text': true,
        disabled: _vm.deletingAccount
      },attrs:{"outlined":"","text":"","disabled":_vm.deletingAccount,"data-cy":"cancelDeleteAccount"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.$t('buttons.cancel'))+" ")]),_c('v-spacer'),_c('v-btn',{class:{
        'white--text': true,
        error: _vm.warningAcceptance,
        disabled: !_vm.warningAcceptance || _vm.deletingAccount
      },attrs:{"disabled":!_vm.warningAcceptance,"text":"","loading":_vm.deletingAccount,"data-cy":"deleteAccount"},on:{"click":_vm.deleteAccount}},[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountManagement.deleteAccount'))+" ")])],1)],1)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./src/utils/http.js
function isOkResponse(status) {
  return status >= 200 && status <= 299;
}
function isConflictResponse(status) {
  return status === 409;
}
function isNotFoundResponse(status) {
  return status === 404;
}
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Common/Tooltip/NotAllowedTooltip.vue?vue&type=template&id=6e708e7c&
var NotAllowedTooltipvue_type_template_id_6e708e7c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({attrs:{"disabled":_vm.disabled,"max-width":_vm.maxWidth},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[_vm._t("default")],2)]}}],null,true)},'v-tooltip',_vm.location,false),[_c('span',[_vm._v(_vm._s(_vm.spanMessage))])])}
var NotAllowedTooltipvue_type_template_id_6e708e7c_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Common/Tooltip/NotAllowedTooltip.vue?vue&type=script&lang=js&
/* harmony default export */ var NotAllowedTooltipvue_type_script_lang_js_ = ({
  name: 'NotAllowedTooltip',
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    message: String,
    maxWidth: Number,
    location: {
      type: Object,
      default: () => {
        return {
          top: true
        };
      }
    }
  },
  computed: {
    spanMessage() {
      return this.message || this.$t('tooltip.notAllowed');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Common/Tooltip/NotAllowedTooltip.vue?vue&type=script&lang=js&
 /* harmony default export */ var Tooltip_NotAllowedTooltipvue_type_script_lang_js_ = (NotAllowedTooltipvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/Common/Tooltip/NotAllowedTooltip.vue





/* normalize component */
;
var component = normalizeComponent(
  Tooltip_NotAllowedTooltipvue_type_script_lang_js_,
  NotAllowedTooltipvue_type_template_id_6e708e7c_render,
  NotAllowedTooltipvue_type_template_id_6e708e7c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotAllowedTooltip = (component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountManagement/index.vue?vue&type=script&lang=js&


/* harmony default export */ var AccountManagementvue_type_script_lang_js_ = (Vue.extend({
  components: {
    'not-allowed-tooltip': NotAllowedTooltip
  },
  confirmDelete() {},
  data() {
    return {
      deleteAccountScreenOpen: false,
      warningAcceptance: false,
      deletingAccount: false
    };
  },
  computed: {
    isLogInAs() {
      return this.$store.getters['loginas/getIsLogInAs'];
    }
  },
  watch: {},
  methods: {
    openDeleteAccountScreen() {
      this.deleteAccountScreenOpen = true;
    },
    async deleteAccount() {
      this.deletingAccount = true;
      const resp = await this.$store.dispatch('userProfile/postDeactivateAccount', this.$components.accountsAPIHost);
      if (isOkResponse(resp.status)) {
        this.$auth.logout({
          returnTo: window.location.origin + '/'
        });
      }
      this.deletingAccount = false;
    },
    cancel() {
      this.warningAcceptance = false;
      this.deleteAccountScreenOpen = false;
    },
    close() {
      this.$emit('close');
      this.deletingAccount = false;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/UserProfile/AccountManagement/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var UserProfile_AccountManagementvue_type_script_lang_js_ = (AccountManagementvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountManagement/index.vue?vue&type=style&index=0&id=f68b85b2&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountManagement/index.vue?vue&type=style&index=0&id=f68b85b2&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountManagement/index.vue



;


/* normalize component */

var AccountManagement_component = normalizeComponent(
  UserProfile_AccountManagementvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "f68b85b2",
  null
  
)

/* harmony default export */ var AccountManagement = (AccountManagement_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountMenu/index.vue?vue&type=template&id=6dc4455c&scoped=true&
var AccountMenuvue_type_template_id_6dc4455c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accountMenu",class:{ 'accountMenu--logged-in-as': _vm.showLogInAsBanner }},[(_vm.showLogInAsBanner)?_c('div',{staticClass:"loggedInAsName"},[_vm._v(" "+_vm._s(_vm.loggedInAsFullName)+" ")]):(_vm.user.firstName || _vm.user.lastName)?_c('div',{staticClass:"name",attrs:{"data-cy":"usersName"}},[_vm._v(" "+_vm._s(_vm.fullName)+" ")]):_vm._e(),_c('v-menu',{attrs:{"tile":true,"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-avatar',_vm._g(_vm._b({class:{ avatarActive: _vm.internalMenuItems.length > 0 },attrs:{"size":"36","data-cy":"userAvatar"}},'v-avatar',attrs,false),on),[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGravatar),expression:"showGravatar"}],attrs:{"src":_vm.filteredPicture,"alt":_vm.initials},on:{"load":function($event){return _vm.onPictureLoaded()}}}),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showGravatar),expression:"!showGravatar"}],staticClass:"accountIcon",attrs:{"x-large":""}},[_vm._v(" mdi-account-circle ")])],1)]}}])},_vm._l((_vm.internalMenuItems),function(item,index){return _c('div',{key:index,staticClass:"menuContainer"},[(item.id === 'spacer')?_c('hr',{staticClass:"menuItemSpacer"}):_c('div',{staticClass:"menuItem",attrs:{"disabled":item.disabled,"data-cy":"menuItemButton"},on:{"click":function($event){return _vm.handleClick(item)}}},[_c('v-icon',{staticClass:"menuItemIcon",attrs:{"medium":""}},[_vm._v(_vm._s(item.icon))]),_c('span',[_vm._v(_vm._s(item.title))])],1)])}),0),_c('fusion-user-profile',{attrs:{"open":_vm.profileOpen,"customTabItems":_vm.userProfileTabItems,"requireDefaultTabs":_vm.requireUserProfileDefaultTabs},on:{"close":function($event){_vm.profileOpen = false}}})],1)}
var AccountMenuvue_type_template_id_6dc4455c_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/utils/constants.js
const constants = {
  study: {
    terminationReasons: {
      PENDING: 'Pending',
      IN_PROGRESS: 'In Progress',
      DISCONNECTED: 'Disconnected',
      COMPLETE: 'Complete',
      LOGGING_COMPLETED: 'Logging Completed',
      CONNECTED_AFTER_START: 'connected_after_start'
    }
  }
};
/* harmony default export */ var utils_constants = ({
  constants
});
;// CONCATENATED MODULE: ./src/utils/validation.js
const isValidObject = item => {
  return item && typeof item === 'object';
};
const isValidDate = date => {
  const formattedDate = date ? new Date(date) : date;
  return formattedDate instanceof Date && !isNaN(formattedDate);
};
/* harmony default export */ var validation = ({
  isValidObject,
  isValidDate
});
;// CONCATENATED MODULE: ./src/utils/index.js



/**
 * Builds the full logout redirect.
 * @returns {string}
 */
const getLogoutRedirect = appPublicPath => {
  return `${window.location.origin}${getRedirectSuffix(appPublicPath)}`;
};

/**
 * Gets the redirect path used by Auth0 and ensures it ends properly.
 * @returns {string}
 */
const getRedirectSuffix = appPublicPath => {
  let publicPath = appPublicPath || '/';
  if (publicPath !== '/') {
    const length = appPublicPath.length;
    publicPath = appPublicPath.substring(0, length - 1);
  }
  return publicPath;
};
/* harmony default export */ var utils = ({
  getLogoutRedirect,
  getRedirectSuffix,
  constants: constants,
  validation: validation
});

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountMenu/index.vue?vue&type=script&lang=js&

/* harmony default export */ var AccountMenuvue_type_script_lang_js_ = (Vue.extend({
  props: {
    user: {
      type: Object,
      required: true
    },
    picture: {
      type: String,
      required: false
    },
    menuItems: {
      type: Array,
      required: false,
      default: () => []
    },
    userProfileTabItems: {
      type: Array,
      required: false,
      default: () => []
    },
    requireUserProfileDefaultTabs: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  data() {
    return {
      internalMenuItems: [],
      profileOpen: false,
      pictureLoaded: false
    };
  },
  computed: {
    /**
     * Flag that indicates whether the Auth0 avatar picture should be displayed.
     * The default Avatar will not be used. If the picture cannot be
     * loaded then also show the default.
     */
    showGravatar() {
      return this.filteredPicture !== undefined && this.filteredPicture !== null && this.filteredPicture.length > 0 && this.pictureLoaded;
    },
    /**
     * Filter out the default picture created by Auth0. Instead return a 404 error.
     */
    filteredPicture() {
      let result = null;
      try {
        const pictureUrl = new URL(this.picture);
        const searchItems = pictureUrl.search.split('&').filter(item => {
          return item.indexOf('d=') === -1;
        });
        searchItems.push('d=404');
        pictureUrl.search = searchItems.join('&');
        result = pictureUrl.toString();
      } catch (error) {
        // the URL is invalid, ignore it.
      }
      return result;
    },
    /**
     * Generates a full name based on the given name and family name.
     */
    fullName() {
      const items = [this.user.firstName, this.user.lastName].filter(item => {
        return item && item.length > 0;
      });
      return items.join(' ');
    },
    /**
     * Generates a full name for users admins are logged in as.
     */
    loggedInAsFullName() {
      var _this$userProfileData, _this$userProfileData2;
      const items = [(_this$userProfileData = this.userProfileData) === null || _this$userProfileData === void 0 ? void 0 : _this$userProfileData.firstName, (_this$userProfileData2 = this.userProfileData) === null || _this$userProfileData2 === void 0 ? void 0 : _this$userProfileData2.lastName].filter(item => {
        return item && item.length > 0;
      });
      return this.$t('account.menu.loggedInAs') + items.join(' ');
    },
    /**
     * Generates initials based on the given name and family name.
     */
    initials() {
      let initials = '';
      if (this.user.firstName && this.user.firstName.length > 0) {
        initials += this.user.firstName.substr(0, 1).toUpperCase();
      }
      if (this.user.lastName && this.user.lastName.length > 0) {
        initials += this.user.lastName.substr(0, 1).toUpperCase();
      }
      return initials;
    },
    userProfileData() {
      var _this$$store$state$us;
      return (_this$$store$state$us = this.$store.state.userProfile) === null || _this$$store$state$us === void 0 ? void 0 : _this$$store$state$us.user;
    },
    isLoggedInAs() {
      return this.$store.getters['loginas/getIsLogInAs'];
    },
    loggedInAsUser() {
      return this.$store.getters['loginas/getImpersonatedUser'];
    },
    showLogInAsBanner() {
      var _this$userProfileData3, _this$loggedInAsUser;
      const hasSameAccountId = ((_this$userProfileData3 = this.userProfileData) === null || _this$userProfileData3 === void 0 ? void 0 : _this$userProfileData3.accountID) === ((_this$loggedInAsUser = this.loggedInAsUser) === null || _this$loggedInAsUser === void 0 ? void 0 : _this$loggedInAsUser.accountId);
      return this.isLoggedInAs && hasSameAccountId;
    }
  },
  methods: {
    handleClick(item) {
      this.$emit('onAccountMenuItemSelection', item.id);
      if (item.handleClick) {
        item.handleClick(item);
      }
    },
    onPictureLoaded() {
      this.pictureLoaded = true;
    }
  },
  async mounted() {
    // Because of the way handle click is invoked, this is the menu item, so save the this for the component and make sure it's available in the default handlers
    const that = this;
    this.internalMenuItems = [{
      id: 'profile',
      title: this.$t('account.menu.viewProfile'),
      icon: 'mdi-account',
      handleClick() {
        that.profileOpen = true;
      }
    }, ...this.menuItems, {
      id: 'logout',
      title: this.$t('account.menu.logout'),
      icon: 'mdi-logout',
      async handleClick() {
        await that.$auth.logout({
          returnTo: utils.getLogoutRedirect(that.$components.appPublicPath)
        });
      }
    }];
  }
}));
;// CONCATENATED MODULE: ./src/components/AccountMenu/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AccountMenuvue_type_script_lang_js_ = (AccountMenuvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountMenu/index.vue?vue&type=style&index=0&id=6dc4455c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/AccountMenu/index.vue?vue&type=style&index=0&id=6dc4455c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/AccountMenu/index.vue



;


/* normalize component */

var AccountMenu_component = normalizeComponent(
  components_AccountMenuvue_type_script_lang_js_,
  AccountMenuvue_type_template_id_6dc4455c_scoped_true_render,
  AccountMenuvue_type_template_id_6dc4455c_scoped_true_staticRenderFns,
  false,
  null,
  "6dc4455c",
  null
  
)

/* harmony default export */ var AccountMenu = (AccountMenu_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Authenticator/index.vue?vue&type=template&id=26518c08&scoped=true&
var Authenticatorvue_type_template_id_26518c08_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"authenticator--wrapper"},[(_vm.$auth.isAuthenticated && !_vm.$vuetify.breakpoint.xs)?_c('v-divider',{attrs:{"inset":"","vertical":""}}):_vm._e(),(!_vm.$auth.isAuthenticated)?_c('v-btn',{attrs:{"data-cy":"loginButton"},on:{"click":_vm.login}},[_vm._v(_vm._s(_vm.$t("app.login")))]):_vm._e(),(!_vm.$auth.isAuthenticated || !_vm.emailVerified)?_c('v-btn',{attrs:{"text":"","data-cy":"tsiHomeLink"},on:{"click":_vm.navigateHome}},[_vm._v(_vm._s(_vm.$t("app.homeLink")))]):_vm._e(),(_vm.$auth.isAuthenticated && _vm.emailVerified)?_c('fusion-account-menu',{attrs:{"user":_vm.userNames,"picture":_vm.user.picture,"menuItems":_vm.menuItems,"userProfileTabItems":_vm.userProfileTabItems,"requireUserProfileDefaultTabs":_vm.requireUserProfileDefaultTabs,"data-cy":"appBarAccountMenu"},on:{"onAccountMenuItemSelection":_vm.handleMenuItemSelection}}):_vm._e()],1)}
var Authenticatorvue_type_template_id_26518c08_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Authenticator/index.vue?vue&type=script&lang=js&

const userMetaDataPath = 'https://tsi.com/user_metadata';
/* harmony default export */ var Authenticatorvue_type_script_lang_js_ = (Vue.extend({
  props: {
    menuItems: {
      type: Array,
      required: false,
      default: () => []
    },
    userProfileTabItems: {
      type: Array,
      required: false,
      default: () => []
    },
    requireUserProfileDefaultTabs: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  components: {
    'fusion-account-menu': AccountMenu
  },
  computed: {
    user() {
      var _this$$auth, _this$$auth$user;
      let user;
      if ((_this$$auth = this.$auth) !== null && _this$$auth !== void 0 && (_this$$auth$user = _this$$auth.user) !== null && _this$$auth$user !== void 0 && _this$$auth$user.email) {
        user = this.$auth.user;
      }
      return user;
    },
    userNames() {
      var _this$user;
      if (!this.user) {
        return {
          firstName: '',
          lastName: ''
        };
      }
      const {
        given_name: firstName,
        family_name: lastName
      } = (_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user[userMetaDataPath];
      return {
        firstName,
        lastName
      };
    },
    emailVerified() {
      var _this$user2;
      return (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.email_verified;
    }
  },
  methods: {
    async login() {
      await this.$auth.loginWithRedirect();
    },
    navigateHome() {
      this.$emit('navigateHome');
    },
    handleMenuItemSelection(id) {
      this.$emit('onAccountMenuItemSelection', id);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Authenticator/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Authenticatorvue_type_script_lang_js_ = (Authenticatorvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Authenticator/index.vue?vue&type=style&index=0&id=26518c08&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Authenticator/index.vue?vue&type=style&index=0&id=26518c08&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Authenticator/index.vue



;


/* normalize component */

var Authenticator_component = normalizeComponent(
  components_Authenticatorvue_type_script_lang_js_,
  Authenticatorvue_type_template_id_26518c08_scoped_true_render,
  Authenticatorvue_type_template_id_26518c08_scoped_true_staticRenderFns,
  false,
  null,
  "26518c08",
  null
  
)

/* harmony default export */ var Authenticator = (Authenticator_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/BaseWidget/index.vue?vue&type=template&id=37f51b3a&scoped=true&
var BaseWidgetvue_type_template_id_37f51b3a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:[_vm.isFullscreen ? 'widget-fullscreen' : 'widget']},[_c('v-card-title',{staticClass:"widget-header-container vue-draggable-handle"},[_c('span',{staticClass:"widget-actions"},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"menu-dropdown black--text",attrs:{"text":"","data-cy":"dashboardWidgetDropdown"}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}])},[_c('v-list',[_vm._t("actions"),(_vm.configureDialog)?_c('v-list-item',{attrs:{"link":"","data-cy":"widgetMenuConfigure"},on:{"click":function($event){$event.stopPropagation();_vm.dialogs.configure = true}}},[_c('v-icon',[_vm._v("mdi-settings")]),_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.$t('dashboard.widget.menu.configure'))+" ")])],1):_vm._e(),_c('v-list-item',{attrs:{"link":"","data-cy":"widgetMenuRemove"},on:{"click":function($event){$event.stopPropagation();return _vm.removeWidget.apply(null, arguments)}}},[_c('v-icon',[_vm._v("mdi-close-circle")]),_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.$t('dashboard.widget.menu.remove'))+" ")])],1)],2)],1)],1),(_vm.subtitle)?_c('span',{staticClass:"widget-title-container"},[_c('div',{staticClass:"widget-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"widget-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]):_c('span',{staticClass:"widget-title-only"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"widget-left-toolbar"},[_vm._t("left-toolbar")],2),_c('v-spacer'),_c('span',{staticClass:"widget-right-toolbar"},[_vm._t("toolbar")],2),(_vm.fullscreen)?_c('span',[_c('v-btn',{staticClass:"widget-fullscreen-button",attrs:{"text":"","data-cy":"toggleWidgetFullScreen"},on:{"click":function($event){return _vm.toggleFullscreen()}}},[(_vm.isFullscreen)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v(" mdi-fullscreen-exit ")]):_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("mdi-fullscreen")])],1)],1):_vm._e()],1),_c('hr',{staticClass:"divider"}),_c('v-card-text',{staticClass:"widget-content-container no-drag"},[_vm._t("content")],2),(_vm.configureDialog)?_c(_vm.configureDialog.widgetComponent,{tag:"component",attrs:{"widgetId":_vm.configureDialog.widgetId,"open":_vm.dialogs.configure,"editing":true,"data-cy":"configureWidgetsDialog"},on:{"close":function($event){_vm.dialogs.configure = false}}}):_vm._e()],1)}
var BaseWidgetvue_type_template_id_37f51b3a_scoped_true_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/BaseWidget/index.vue?vue&type=script&lang=js&

/* harmony default export */ var BaseWidgetvue_type_script_lang_js_ = ({
  props: {
    title: String,
    widgetId: String,
    subtitle: String,
    // do not provide if not needed
    fullscreen: Boolean,
    // if true, the fullscreen button is available. If false, it is not
    observeSize: Boolean,
    // enable resize observer if true
    configureDialog: Object // do not provide if not configurable
  },

  data() {
    return {
      isFullscreen: false,
      dialogs: {
        configure: false
      }
    };
  },
  methods: {
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      this.$emit('fullscreenChange', this.isFullscreen);
    },
    removeWidget() {
      this.$emit('removeWidget');
    },
    observe(el) {
      const setDims = throttle_default()(entries => {
        const cr = entries[0].contentRect;
        const dims = {
          width: cr.width,
          height: cr.height
        };
        this.$emit('widgetSizeChanged', dims);
      }, 200);
      this.observer = new ResizeObserver(setDims);
      if (el instanceof Element) {
        this.observer.observe(el);
      }
    }
  },
  mounted() {
    if (this.observeSize) this.observe(this.$el);
  },
  destroyed() {
    if (this.observer) this.observer.disconnect();
  }
});
;// CONCATENATED MODULE: ./src/components/Dashboard/BaseWidget/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var Dashboard_BaseWidgetvue_type_script_lang_js_ = (BaseWidgetvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/BaseWidget/index.vue?vue&type=style&index=0&id=37f51b3a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Dashboard/BaseWidget/index.vue?vue&type=style&index=0&id=37f51b3a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/BaseWidget/index.vue?vue&type=style&index=1&id=37f51b3a&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Dashboard/BaseWidget/index.vue?vue&type=style&index=1&id=37f51b3a&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/Dashboard/BaseWidget/index.vue



;



/* normalize component */

var BaseWidget_component = normalizeComponent(
  Dashboard_BaseWidgetvue_type_script_lang_js_,
  BaseWidgetvue_type_template_id_37f51b3a_scoped_true_render,
  BaseWidgetvue_type_template_id_37f51b3a_scoped_true_staticRenderFns,
  false,
  null,
  "37f51b3a",
  null
  
)

/* harmony default export */ var BaseWidget = (BaseWidget_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/BaseGraph/index.vue?vue&type=template&id=f0bb4684&scoped=true&
var BaseGraphvue_type_template_id_f0bb4684_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_vm._t("header"),_c('div',{ref:"graph",staticClass:"graph"}),_vm._t("footer")],2)}
var BaseGraphvue_type_template_id_f0bb4684_scoped_true_staticRenderFns = []


// EXTERNAL MODULE: external "Highcharts"
var external_Highcharts_ = __webpack_require__(912);
var external_Highcharts_default = /*#__PURE__*/__webpack_require__.n(external_Highcharts_);
// EXTERNAL MODULE: ./node_modules/highcharts/modules/no-data-to-display.js
var no_data_to_display = __webpack_require__(646);
var no_data_to_display_default = /*#__PURE__*/__webpack_require__.n(no_data_to_display);
// EXTERNAL MODULE: ./node_modules/highcharts/modules/broken-axis.js
var broken_axis = __webpack_require__(783);
var broken_axis_default = /*#__PURE__*/__webpack_require__.n(broken_axis);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/BaseGraph/index.vue?vue&type=script&lang=js&



no_data_to_display_default()((external_Highcharts_default()));
broken_axis_default()((external_Highcharts_default()));
const defaultGraphColors = ['#00aeef', '#ec038a', '#f48123', '#4fb74a', '#4b4bf5'];
/* harmony default export */ var BaseGraphvue_type_script_lang_js_ = ({
  name: 'BaseGraph',
  props: {
    series: {
      type: Array,
      default: () => {
        return [];
      }
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    noDataMessage: {
      type: String,
      default: 'No data to display'
    },
    seriesColors: {
      type: Array,
      default: () => {
        return defaultGraphColors;
      }
    },
    customTooltipOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    batch: {
      type: Object,
      default: () => {
        return {
          enabled: false,
          size: 3
        };
      }
    },
    lockoutTime: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      locked: false,
      graph: undefined,
      seriesLength: 0,
      batchCount: 0
    };
  },
  mounted() {
    this.initializeGraph();
  },
  destroyed() {
    this.graphDestroyed();
  },
  watch: {
    series: {
      deep: true,
      handler: function () {
        if (this.series.length !== this.seriesLength) {
          this.initializeGraph();
        } else {
          if (this.batch.enabled) {
            this.batchCount++;
            if (this.batchCount === this.batch.size) {
              this.updateSeries();
              this.batchCount = 0;
              return;
            }
          } else {
            this.updateSeries();
          }
        }
        this.seriesLength = this.series.length;
      }
    },
    options: {
      deep: true,
      handler: function () {
        this.updateOptions();
      }
    }
  },
  computed: {
    graphOptions() {
      const defaultOptions = {
        accessibility: {
          enabled: false
        },
        colors: this.seriesColors,
        plotOptions: {
          series: {
            groupPadding: 0
          }
        },
        chart: {
          animation: false,
          reflow: true
        },
        navigator: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        title: {
          text: ''
        },
        lang: {
          noData: this.noDataMessage
        },
        noData: {
          style: {
            fontSize: '1.25rem',
            fontWeight: 'normal',
            color: 'black'
          }
        },
        credits: {
          enabled: false
        },
        rangeSelector: {
          enabled: false,
          selected: 1
        },
        scrollbar: {
          enabled: false
        },
        series: this.series,
        time: {
          timezoneOffset: new Date().getTimezoneOffset(),
          useUTC: false
        },
        xAxis: {
          type: 'datetime',
          ordinal: false
        },
        yAxis: {
          title: {
            text: '',
            align: 'high',
            offset: 0,
            rotation: 0,
            y: 0
          }
        }
      };
      return {
        ...defaultOptions,
        ...this.options,
        ...this.tooltipOptions()
      };
    }
  },
  methods: {
    initializeGraph() {
      var _this$$refs;
      if ((_this$$refs = this.$refs) !== null && _this$$refs !== void 0 && _this$$refs.graph) {
        this.graph = external_Highcharts_default().chart(this.$refs.graph, this.graphOptions);
        this.$emit('graphInitialized');
      }
    },
    updateOptions() {
      if (this.graph) {
        this.graph.update(this.graphOptions);
        this.$emit('optionsUpdated');
      }
    },
    updateSeries() {
      if (this.locked) return;
      if (this.graph) {
        this.locked = true;
        setTimeout(() => {
          this.locked = false;
        }, this.lockoutTime);
        this.graph.series.forEach((series, i) => {
          series.setData(this.series[i].data, false, false, true);
        });
        this.graph.xAxis[0].setExtremes(null, null, true);
        this.$emit('seriesUpdated');
      }
    },
    graphDestroyed() {
      this.$emit('graphDestroyed');
    },
    tooltipOptions() {
      let customOptions = {};
      let xUnits = '';
      let yUnits = '';
      if (this.customTooltipOptions.xUnits) {
        xUnits = this.customTooltipOptions.xUnits;
      }
      if (this.customTooltipOptions.yUnits) {
        yUnits = this.customTooltipOptions.yUnits;
      }
      if (!this.customTooltipOptions.mode) {
        return {};
      }
      if (this.customTooltipOptions.mode === 1) {
        customOptions = {
          tooltip: {
            useHTML: true,
            borderWidth: 2,
            headerFormat: '<b>X: </b>{point.key} ' + xUnits + '<br>',
            pointFormat: '<b>Y: </b>{point.y} ' + yUnits + '<br>'
          }
        };
      } else if (this.customTooltipOptions.mode === 2) {
        customOptions = {
          tooltip: {
            shared: true,
            useHTML: true,
            headerFormat: '<table><tr><th colspan="2">{point.key} ' + xUnits + '</th></tr>',
            pointFormat: '<tr><td style="color: {series.color}">{series.name} </td>' + '<td style="text-align: right">{point.y} ' + yUnits + '</td></tr>',
            footerFormat: '</table>',
            valueDecimals: 2
          }
        };
      }
      return customOptions;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/BaseGraph/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseGraphvue_type_script_lang_js_ = (BaseGraphvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/BaseGraph/index.vue





/* normalize component */
;
var BaseGraph_component = normalizeComponent(
  components_BaseGraphvue_type_script_lang_js_,
  BaseGraphvue_type_template_id_f0bb4684_scoped_true_render,
  BaseGraphvue_type_template_id_f0bb4684_scoped_true_staticRenderFns,
  false,
  null,
  "f0bb4684",
  null
  
)

/* harmony default export */ var BaseGraph = (BaseGraph_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/index.vue?vue&type=template&id=2a3f267f&scoped=true&
var Dashboardvue_type_template_id_2a3f267f_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"dashboard",style:(_vm.cssVars),attrs:{"flat":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('v-card-title',{staticClass:"headline",attrs:{"data-cy":"dashboardHeader"}},[_vm._v(" "+_vm._s(_vm.$t('dashboard.title'))+" ")]),_c('div',{staticClass:"header-actions"},[_vm._t("headerActions")],2)],1),_c('v-col',{attrs:{"cols":"12","md":"6","align":"center"}},[_c('v-card-text',{staticClass:"devices-summary"},[_vm._t("headerCenter")],2)],1)],1),(_vm.widgetsDisabled)?_c('div',{staticClass:"text-center disabled-message"},[_vm._v(" "+_vm._s(_vm.$t('dashboard.messages.disabled'))+" ")]):_vm._e(),_c('grid-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.grid.loading),expression:"!grid.loading"}],ref:"dashboardGrid",staticClass:"dashboard-grid",attrs:{"layout":_vm.grid.layout,"col-num":_vm.colNum,"row-height":_vm.grid.rowHeight,"margin":_vm.margin,"is-draggable":_vm.grid.isDraggable,"is-resizable":_vm.grid.isResizable,"vertical-compact":_vm.grid.verticalCompact,"use-css-transforms":true,"responsive":false,"breakpoints":_vm.grid.breakpoints,"cols":_vm.grid.cols},on:{"layout-updated":_vm.layoutUpdated}},_vm._l((_vm.grid.layout),function(item){return _c('grid-item',{key:item.i,class:{ 'widget--fullscreen': item.isFullscreen },attrs:{"x":item.x,"y":item.y,"w":item.w,"h":item.h,"i":item.i,"isResizable":item.isResizable,"maxW":item.maxW,"maxH":item.maxH,"drag-allow-from":".vue-draggable-handle","drag-ignore-from":".no-drag, .widget-fullscreen .vue-draggable-handle"},on:{"resized":_vm.setWidgetDims,"container-resized":_vm.setWidgetDims,"moved":_vm.setWidgetMoved}},[(_vm.widgetsById[item.i])?_c(_vm.widgetsById[item.i].widgetComponent,{tag:"component",class:{ disabled: _vm.widgetsById[item.i].disabled },attrs:{"widgetId":_vm.widgetsById[item.i].id,"width":_vm.widgetsById[item.i].width,"height":_vm.widgetsById[item.i].height,"settings":_vm.widgetsById[item.i].settings},on:{"fullscreenChange":function($event){return _vm.toggleFullscreen(item.i, $event)},"removeWidget":function($event){return _vm.showRemoveWarning(item.i)},"refreshDashboard":function($event){return _vm.refreshDashboard()}}}):_vm._e()],1)}),1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grid.loading),expression:"grid.loading"}],staticClass:"text-center emptyMessage"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1),(_vm.showEmptyMessage)?_c('div',{staticClass:"text-center empty-message",attrs:{"data-cy":"dashboardEmptyMessage"}},[_vm._v(" "+_vm._s(_vm.$t('dashboard.messages.empty'))+" ")]):_vm._e(),_vm._t("addDialog"),_c('fusion-remove-warning-dialog',{attrs:{"open":_vm.dialogs.removeWarning},on:{"ok":_vm.removeWidget,"cancel":_vm.clearWidgetToRemove}})],2)}
var Dashboardvue_type_template_id_2a3f267f_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: external "VueGridLayout"
var external_VueGridLayout_namespaceObject = VueGridLayout;
var external_VueGridLayout_default = /*#__PURE__*/__webpack_require__.n(external_VueGridLayout_namespaceObject);
;// CONCATENATED MODULE: ./src/store/index.js
Vue.use(Vuex);
/* harmony default export */ var src_store = (new Vuex.Store({
  state: {},
  mutations: {},
  actions: {}
}));
;// CONCATENATED MODULE: ./src/components/Snackbar/module/utils.js

const SNACKBAR_DEFAULT_DURATION_MS = 5000;
const SNACKBAR_STATIC_DURATION_MS = -1;
const messageTypes = Object.freeze({
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
});
function addSnackbarSuccess(text, timeout = SNACKBAR_DEFAULT_DURATION_MS) {
  const message = {
    text,
    timeout,
    type: messageTypes.SUCCESS
  };
  store.dispatch('notifications/addMessage', message);
}
function addSnackbarInfo(text, timeout = SNACKBAR_STATIC_DURATION_MS) {
  const message = {
    text,
    timeout,
    type: messageTypes.INFO
  };
  store.dispatch('notifications/addMessage', message);
}
function addSnackbarWarning(text, timeout = SNACKBAR_STATIC_DURATION_MS) {
  const message = {
    text,
    timeout,
    type: messageTypes.WARNING
  };
  src_store.dispatch('notifications/addMessage', message);
}
function addSnackbarError(text, timeout = SNACKBAR_STATIC_DURATION_MS) {
  const message = {
    text,
    timeout,
    type: messageTypes.ERROR
  };
  store.dispatch('notifications/addMessage', message);
}
;// CONCATENATED MODULE: ./src/components/Dashboard/module/actions.js
/* harmony default export */ var actions = ({
  // Widgets
  async getWidgets({
    commit
  }, {
    name,
    accountsAPIHostV2
  }) {
    return axios.get(`${accountsAPIHostV2}/widgets/${name}`);
  },
  async postWidget({
    commit
  }, {
    widget,
    accountsAPIHostV2
  }) {
    return axios.post(`${accountsAPIHostV2}/widgets`, widget);
  },
  async patchWidget({
    commit
  }, {
    id,
    properties,
    accountsAPIHostV2
  }) {
    return axios.patch(`${accountsAPIHostV2}/widgets/${id}`, {
      properties
    });
  },
  async deleteWidget({
    commit
  }, {
    id,
    accountsAPIHostV2
  }) {
    return axios.delete(`${accountsAPIHostV2}/widgets/${id}`);
  },
  // Layouts
  getLayout({
    commit
  }, {
    name,
    accountsAPIHostV2
  }) {
    return axios.get(`${accountsAPIHostV2}/layouts/${name}`);
  },
  async postLayout({
    commit
  }, {
    layouts,
    accountsAPIHostV2
  }) {
    return axios.post(`${accountsAPIHostV2}/layouts`, layouts);
  }
});
;// CONCATENATED MODULE: ./src/components/Dashboard/module/mutations.js
/* harmony default export */ var mutations = ({
  // TODO store stuff in state not just in the component
});
;// CONCATENATED MODULE: ./src/components/Dashboard/module/state.js
/* harmony default export */ var state = ({
  // TODO These things shouldn't just be passed back to the dashboard
  // widgets: [],
  // layouts: []
});
;// CONCATENATED MODULE: ./src/components/Dashboard/module/index.js



/* harmony default export */ var Dashboard_module = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/index.vue?vue&type=script&lang=js&





/* harmony default export */ var Dashboardvue_type_script_lang_js_ = ({
  components: {
    GridLayout: (external_VueGridLayout_default()).GridLayout,
    GridItem: (external_VueGridLayout_default()).GridItem
  },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      accountId: null,
      grid: {
        dims: {
          w: -1,
          h: -1
        },
        layout: [],
        originalLayout: [],
        layouts: {},
        layoutsLocked: {},
        widgetMoved: false,
        loading: true,
        rowHeight: 450,
        margins: {
          lg: [40, 40],
          md: [40, 40],
          sm: [24, 24],
          xs: [24, 24],
          xxs: [16, 16]
        },
        isDraggable: true,
        isResizable: true,
        verticalCompact: true,
        breakpoints: {
          lg: 2000,
          md: 1600,
          sm: 1200,
          xs: 700,
          xxs: 0
        },
        cols: {
          lg: 5,
          md: 4,
          sm: 3,
          xs: 2,
          xxs: 1
        },
        sizes: {
          sm: {
            w: 1,
            h: 1
          },
          md: {
            w: 2,
            h: 1
          },
          lg: {
            w: 2,
            h: 2
          }
        }
      },
      widgets: [],
      widgetSizes: {
        MapWidget: ['sm', 'md', 'lg'],
        PopoverWidget: ['sm'],
        HistoryWidget: ['sm', 'md', 'lg'],
        ExampleWidget: ['sm', 'md', 'lg']
      },
      widgetToRemove: null,
      dialogs: {
        removeWarning: false
      }
    };
  },
  computed: {
    /**
     * Compare grid element width to specified breakpoints
     * @returns String of current viewport
     */
    viewport() {
      let viewport;
      if (this.grid.dims.w >= this.grid.breakpoints.xxs) viewport = 'xxs';
      if (this.grid.dims.w >= this.grid.breakpoints.xs) viewport = 'xs';
      if (this.grid.dims.w >= this.grid.breakpoints.sm) viewport = 'sm';
      if (this.grid.dims.w >= this.grid.breakpoints.md) viewport = 'md';
      if (this.grid.dims.w >= this.grid.breakpoints.lg) viewport = 'lg';
      return viewport;
    },
    /**
     * @returns Number of grid columns for current viewport
     */
    colNum() {
      return this.viewport ? this.grid.cols[this.viewport] : 3;
    },
    /**
     * @returns Row height proportional to grid column width (not currently used)
     */
    rowHeight() {
      return Math.round(this.grid.dims.w / this.colNum);
    },
    margin() {
      return this.viewport ? this.grid.margins[this.viewport] : [24, 24];
    },
    cssVars() {
      return {
        '--row-height': `${this.grid.rowHeight}px`,
        '--widget-margin': `${this.margin[0]}px`
      };
    },
    /**
     * Build a 2D grid map of the layout for each viewport
     * Marks each cell with widget ID or as empty
     * @return  {Object} with properties for each viewport
     *          Each viewport {Object} includes width {Number},
     *          height {Number}, and map {Array} properties
     */
    gridMaps() {
      const grids = {};
      for (const viewport in this.grid.layouts) {
        const layout = this.grid.layouts[viewport];
        const width = this.grid.cols[viewport];
        const height = layout.length > 0 ? Math.max(...layout.map(item => item.y + item.h)) : 1;
        const map = this.buildGridMap(layout, width, height);
        grids[viewport] = {
          width,
          height,
          map
        };
      }
      return grids;
    },
    widgetsDisabled() {
      const disabled = this.widgets.find(widget => widget.disabled === true);
      return !!disabled;
    },
    /**
     * Used for ease of lookup during grid render
     * @returns Object of widgets keyed by widgetId
     */
    widgetsById() {
      const ret = this.arrayToObject(this.widgets, 'id');
      return ret;
    },
    showEmptyMessage() {
      return this.grid.layout.length === 0 && this.widgets.length === 0;
    },
    hasNotifications() {
      return this.$store.hasModule('notifications');
    }
  },
  watch: {
    /**
     * Changes layout when viewport changes
     */
    viewport(newBreakpoint, oldBreakpoint) {
      if (oldBreakpoint && this.grid.widgetMoved) {
        this.resetWidgetOrder(oldBreakpoint);
        this.grid.widgetMoved = false;
      }
      this.grid.layout = this.grid.layouts[newBreakpoint] ? this.grid.layouts[newBreakpoint] : [];
    }
  },
  methods: {
    async getWidgets() {
      const resp = await this.$store.dispatch('dashboard/getWidgets', {
        name: this.name,
        accountsAPIHostV2: this.$components.accountsAPIHostV2
      });
      if (isOkResponse(resp.status)) {
        const widgets = resp.data;
        widgets.forEach(widget => this.setWidgetSizes(widget));
        this.widgets = widgets;
      } else {
        if (this.hasNotifications) {
          const message = {
            text: this.$t('dashboard.messages.warningLoading'),
            type: messageTypes.WARNING,
            timeout: SNACKBAR_STATIC_DURATION_MS
          };
          this.$store.dispatch('notifications/addMessage', message);
        }
      }
    },
    async getLayouts() {
      let layouts = {};
      const resp = await this.$store.dispatch('dashboard/getLayout', {
        name: this.name,
        accountsAPIHostV2: this.$components.accountsAPIHostV2
      });
      if (isOkResponse(resp.status)) {
        const body = resp.data;
        layouts = body.layouts;
      } else {
        // The dashboard layout document does not exist
        // until a user visits the Dashboard for the first time.
        // The API response will include a status code 404,
        // and we don’t want to trigger a snackbar warning in this case.
        if (!isNotFoundResponse(resp.status)) {
          if (this.hasNotifications) {
            const message = {
              text: this.$t('dashboard.messages.warningLoading'),
              type: messageTypes.WARNING,
              timeout: SNACKBAR_STATIC_DURATION_MS
            };
            this.$store.dispatch('notifications/addMessage', message);
          }
        }
      }

      // create empty layouts for all breakpoints if none are returned
      const isEmpty = Object.values(layouts).every(x => x === null || x === '') || Object.keys(layouts).length === 0;
      if (isEmpty) {
        for (const breakpoint in this.grid.breakpoints) {
          layouts[breakpoint] = [];
        }
        this.grid.layouts = layouts;

        // add any pre-existing widgets to the layouts
        this.addWidgetsToLayout(this.widgets);
      } else {
        this.grid.layouts = layouts;
        this.updateLayoutItemSizes();
      }
      this.grid.loading = false;
    },
    patchLayouts() {
      this.widgets.forEach(widget => {
        const found = this.grid.layout.find(item => item.i === widget.id);
        if (!found) this.addWidgetsToLayout([widget]);
      });
    },
    async saveLayouts() {
      if (!this.grid.loading) {
        if (this.accountId) {
          const layouts = {
            accountId: this.accountId,
            name: this.name,
            layouts: this.grid.layouts
          };
          await this.$store.dispatch('dashboard/postLayout', {
            layouts,
            accountsAPIHostV2: this.$components.accountsAPIHostV2
          });
        }
      }
    },
    /**
     * Set layouts to locked if they contain a userModified item
     */
    setLockedLayouts() {
      const locked = {};
      for (const viewport in this.grid.layouts) {
        const moved = this.grid.layouts[viewport].some(item => item.userModified === true);
        locked[viewport] = moved;
      }
      this.grid.layoutsLocked = locked;
    },
    layoutUpdated() {
      this.saveLayouts();
      this.setLockedLayouts();
    },
    async removeWidget() {
      const index = this.widgets.findIndex(item => item.id === this.widgetToRemove);
      if (typeof index === 'number') {
        const widget = this.widgets[index];
        const resp = await this.$store.dispatch('dashboard/deleteWidget', {
          id: widget.id,
          accountsAPIHostV2: this.$components.accountsAPIHostV2
        });
        if (isOkResponse(resp.status)) {
          this.removeWidgetsFromLayout([widget]);
          this.widgets.splice(index, 1);
        } else {
          if (this.hasNotifications) {
            const message = {
              text: this.$t('dashboard.messages.errorRemoveWidget'),
              type: messageTypes.ERROR,
              timeout: SNACKBAR_STATIC_DURATION_MS
            };
            this.$store.dispatch('notifications/addMessage', message);
          }
        }
        this.clearWidgetToRemove();
      }
    },
    async refreshDashboard() {
      await this.getWidgets();
      this.patchLayouts();
    },
    /**
     * Add passed widgets to all layouts
     * @param {Array} widgets to add
     * @param {Boolean} skipLockedLayouts (optional) flag for whether locked layouts should be skipped
     */
    addWidgetsToLayout(widgets, skipLockedLayouts = false) {
      for (const viewport in this.grid.layouts) {
        if (skipLockedLayouts && this.grid.layoutsLocked[viewport]) {
          continue;
        }
        widgets.forEach(widget => {
          this.addItem(widget, viewport);
        });
      }
    },
    /**
     * Remove passed widgets to all layouts
     * @param {Array} widgets to remove
     * @param {Boolean} skipLockedLayouts (optional) flag for whether locked layouts should be skipped
     */
    removeWidgetsFromLayout(widgets, skipLockedLayouts = false) {
      for (const viewport in this.grid.layouts) {
        if (skipLockedLayouts && this.grid.layoutsLocked[viewport]) {
          continue;
        }
        widgets.forEach(widget => {
          this.removeItem(widget, viewport);
        });
      }
    },
    /**
     * Updates layout items dims to match contained widget
     * Can be called for a single widget
     * @param {Object} widget for which to update items or null to update all items
     */
    updateLayoutItemSizes(widget = null) {
      for (const viewport in this.grid.layouts) {
        const layout = this.grid.layouts[viewport];
        if (widget) {
          const layoutItem = layout.find(item => item.i === widget.id);
          if (layoutItem) {
            layoutItem.isResizable = widget.isResizable;
            layoutItem.w = widget.w;
            layoutItem.h = widget.h;
            layoutItem.maxW = widget.maxW;
            layoutItem.maxH = widget.maxH;
          }
        } else {
          layout.forEach(item => {
            const itemWidget = this.widgetsById[item.i];
            if (itemWidget) {
              item.isResizable = itemWidget.isResizable;
              item.w = itemWidget.w;
              item.h = itemWidget.h;
              item.maxW = itemWidget.maxW;
              item.maxH = itemWidget.maxH;
            }
          });
        }
      }
    },
    /**
     * Determine size support for widget
     * set w/h and resize min/max accordingly
     * @param {Object} item widget to update
     */
    setWidgetSizes(item) {
      const sizes = this.widgetSizes[item.widgetComponent];
      const minW = Math.min(...sizes.map(size => this.grid.sizes[size].w));
      const minH = Math.min(...sizes.map(size => this.grid.sizes[size].h));
      const maxW = Math.max(...sizes.map(size => this.grid.sizes[size].w));
      const maxH = Math.max(...sizes.map(size => this.grid.sizes[size].h));
      item.isResizable = !(minW === maxW && minH === maxH);
      item.w = item.properties.w >= minW && item.properties.w <= maxW ? item.properties.w : minW;
      item.h = item.properties.h >= minH && item.properties.w <= maxH ? item.properties.h : minH;
      item.maxW = maxW;
      item.maxH = maxH;
      return item;
    },
    /**
     * Adds a new item to all the grid layouts
     * Item is placed at the end of the grid
     * @param {Object} item widget to add
     * @param {String} viewport to update
     */
    addItem(item, viewport) {
      if (!item) return;
      // set size support for widget
      item = this.setWidgetSizes(item);

      // get the next open cell
      const {
        x,
        y
      } = this.getNextOpenCell(viewport, item);

      // get the layout for the given layout and add item
      const layout = this.grid.layouts[viewport];
      layout.push({
        x,
        y,
        w: item.w,
        h: item.h,
        maxW: item.maxW,
        maxH: item.maxH,
        isResizable: item.isResizable,
        i: item.id
      });
    },
    /**
     * Removes an item from all grid layouts
     * @param {Object} item widget to remove
     * @param {String} viewport to update
     */
    removeItem(item, viewport) {
      if (!item) return;
      const layout = this.grid.layouts[viewport];
      const index = layout.map(el => el.i).indexOf(item.id);
      layout.splice(index, 1);
    },
    /**
     * Find a widget in the widgets array
     * @param {String} id of widget
     * @returns Object of widget
     */
    getWidget(id) {
      return this.widgets.find(widget => {
        return widget.id === id;
      });
    },
    showRemoveWarning(removeId) {
      this.dialogs.removeWarning = true;
      this.widgetToRemove = removeId;
    },
    clearWidgetToRemove() {
      this.widgetToRemove = null;
      this.dialogs.removeWarning = false;
    },
    /**
     * Set the flag that a widget moved
     * Add the userModified property to the layout item (used to lock layout)
     */
    setWidgetMoved(i) {
      this.grid.widgetMoved = true;
      this.grid.layouts[this.viewport].find(item => item.i === i).userModified = true;
    },
    /**
     * Get the layout order of widgets for the given grid map
     * @param {Array} map to evaluate
     * @return {Array} of item IDs in display order
     */
    getLayoutOrder(map) {
      const itemSet = new Set();
      for (const row of map) {
        for (const cell of row) {
          if (cell !== '') {
            itemSet.add(cell);
          }
        }
      }
      return [...itemSet];
    },
    /**
     * Reset the widget order on non-visible layouts
     * to match the order of the visible layout
     * Locked layouts will not be updated
     * @param {String} viewport to use as sort order
     */
    resetWidgetOrder(viewport) {
      // get the rendered order of items in the visible layout
      const map = this.gridMaps[viewport].map;
      const order = this.getLayoutOrder(map);

      // sort widgets by layout order
      const sorted = [...this.widgets].sort((a, b) => {
        return order.indexOf(a.id) > order.indexOf(b.id) ? 1 : -1;
      });

      // remove widgets from layouts, skipping locked layouts
      this.removeWidgetsFromLayout(this.widgets, true);
      // add sorted widgets back to layouts, skipping locked layouts
      this.addWidgetsToLayout(sorted, true);
    },
    /**
     * Set the grid and pixel dimensions on the widget
     * when the grid item changes size
     */
    setWidgetDims(i, newH, newW, newHPx, newWPx) {
      const widget = this.getWidget(i);
      if (!widget) return;
      let updateItem = false;
      if (newW !== widget.w) {
        widget.w = parseInt(newW);
        updateItem = true;
      }
      if (newH !== widget.h) {
        widget.h = parseInt(newH);
        updateItem = true;
      }
      if (updateItem) {
        this.updateLayoutItemSizes(widget);
        this.$store.dispatch('dashboard/patchWidget', {
          properties: {
            w: newW,
            h: newH
          },
          id: widget.id,
          accountsAPIHostV2: this.$components.accountsAPIHostV2
        });
      }
      widget.width = parseInt(newWPx);
      widget.height = parseInt(newHPx);
    },
    toggleFullscreen(widgetId, isFullscreen) {
      for (const viewport in this.grid.layouts) {
        const layout = this.grid.layouts[viewport];
        const item = layout.find(el => el.i === widgetId);
        item.isFullscreen = isFullscreen;
      }
      // TODO: render doesn't update without forcing it. Look into why and try to fix
      this.$forceUpdate();
    },
    /**
     * Collect all open cells for the given grid map
     * @param   {Array} map to loop over
     * @return  {Array} of open cells
     */
    getOpenCells(map) {
      const cells = [];
      for (let y = 0; y < map.length; y++) {
        for (let x = 0; x < map[y].length; x++) {
          if (map[y][x] === '') {
            cells.push({
              x,
              y
            });
          }
        }
      }
      return cells;
    },
    /**
     * Find the next open cell in the grid for a given viewport
     * large enough to place the a new widget
     * @return  {Object} with cell coordinates
     */
    getNextOpenCell(viewport, item) {
      const grid = this.gridMaps[viewport];
      const {
        map,
        height
      } = grid;
      const openCells = this.getOpenCells(map);

      // find first open cell with enough open adjacent cells
      // to fit the size of the widget being placed
      // return null if suitable space is not found
      const nextCell = openCells.find(cell => {
        const isOpen = [];
        for (let y = cell.y; y < cell.y + item.h; y++) {
          for (let x = cell.x; x < cell.x + item.w; x++) {
            let open = false;
            // if map[y] is undefined, it is a new row to be added
            if (map[y] === undefined || map[y][x] === '') {
              open = true;
            }
            isOpen.push(open);
          }
        }
        return isOpen.includes(false) ? null : cell;
      });

      // define new cell coordinates
      const newCell = {
        x: 0,
        y: height
      };
      return nextCell || newCell;
    },
    /**
     * Build 2D grid map for given layout
     * @param  {Array} layout array of items to map
     * @param  {Number} width of grid
     * @param  {Number} height of grid
     * @return {Array} 2D array of cells with widget locations marked
     */
    buildGridMap(layout, width, height) {
      // build empty grid map
      const map = [];
      for (let y = 0; y < height; y++) {
        map[y] = [];
        for (let x = 0; x < width; x++) {
          map[y][x] = '';
        }
      }

      // mark occupied cells in grid map
      layout.forEach(item => {
        for (let y = item.y; y < item.y + item.h; y++) {
          for (let x = item.x; x < item.x + item.w; x++) {
            // items that are normally wider than one cell
            // are forced to one cell width at XXS viewport
            // only update array elements that exist in grid map
            if (map[y][x] === undefined) {
              continue;
            }
            map[y][x] = item.i;
          }
        }
      });
      return map;
    },
    arrayToObject(array, key) {
      const object = {};
      array.forEach(item => {
        object[item[key]] = item;
      });
      return object;
    },
    objectToArray(object) {
      return Object.values(object);
    },
    /**
     * Sets up resize observer on the grid element
     * Observed dimensions used to determine viewport size
     */
    observe(el) {
      const setGridDims = throttle_default()(entries => {
        const cr = entries[0].contentRect;
        this.grid.dims.w = cr.width;
        this.grid.dims.h = cr.height;
      }, 200);
      this.observer = new ResizeObserver(setGridDims);
      if (el instanceof Element) {
        this.observer.observe(el);
      }
    },
    registerDashboard() {
      const hasDashboard = this.$store.hasModule('dashboard');
      if (!hasDashboard) {
        this.$store.registerModule('dashboard', Dashboard_module);
      }
      this.registered = true;
    }
  },
  mounted() {
    this.registerDashboard();
    this.observe(this.$refs.dashboardGrid.$el);
    this.$auth.getAccountId().then(async myAccountId => {
      this.accountId = myAccountId;
      await this.getWidgets();
      await this.getLayouts();
    }).catch(error => {
      console.log(error);
    });
  },
  destroyed() {
    if (this.observer) this.observer.disconnect();
  }
});
;// CONCATENATED MODULE: ./src/components/Dashboard/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Dashboardvue_type_script_lang_js_ = (Dashboardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/index.vue?vue&type=style&index=0&id=2a3f267f&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Dashboard/index.vue?vue&type=style&index=0&id=2a3f267f&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/index.vue?vue&type=style&index=1&id=2a3f267f&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Dashboard/index.vue?vue&type=style&index=1&id=2a3f267f&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/Dashboard/index.vue



;



/* normalize component */

var Dashboard_component = normalizeComponent(
  components_Dashboardvue_type_script_lang_js_,
  Dashboardvue_type_template_id_2a3f267f_scoped_true_render,
  Dashboardvue_type_template_id_2a3f267f_scoped_true_staticRenderFns,
  false,
  null,
  "2a3f267f",
  null
  
)

/* harmony default export */ var Dashboard = (Dashboard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/index.vue?vue&type=template&id=34270abf&scoped=true&
var StudyManagervue_type_template_id_34270abf_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"studyManager__container"},[_c('v-row',{staticClass:"mb-0 justify-space-between"},[_c('v-col',{staticClass:"pb-0 d-flex justify-start align-center",attrs:{"cols":"10","md":"4","order":"1"}},[_vm._t("header",function(){return [_c('div',{staticClass:"header"},[_c('h1',{staticClass:"pl-4 pt-4 font-weight-regular title"},[_vm._v(_vm._s(_vm.$t('studyManager.title')))]),_c('p',{staticClass:"pl-4 subtitle"},[_vm._v(_vm._s(_vm.$t('studyManager.localTimeZoneMessage')))])])]})],2),(_vm.$slots.actions)?_c('v-col',{staticClass:"pb-0 d-flex justify-end align-center",attrs:{"cols":"2","md":"4","order":"2","order-md":"3"}},[_vm._t("actions")],2):_vm._e()],1),_c('hr',{staticClass:"mb-6 mt-3 mt-md-0"}),_c('v-data-table',{staticClass:"studyManager",class:{ mobile: _vm.isMobile },attrs:{"mobile-breakpoint":_vm.$vuetify.breakpoint.thresholds.sm,"data-cy":"studyManagerTable","fixed-header":true,"headers":_vm.generateColumns,"footer-props":_vm.footerProps,"items":_vm.getCompleteStudies,"items-per-page":_vm.itemPerPage,"search":_vm.search,"custom-filter":_vm.filterParentAndChildren,"item-key":"_id","sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"show-select":"","show-expand":"","single-expand":false,"expanded":_vm.expanded,"height":_vm.tableHeight},on:{"update:expanded":function($event){_vm.expanded=$event},"current-items":_vm.handleCurrentItems},scopedSlots:_vm._u([{key:"top",fn:function(){return [(_vm.showSearchBar)?_c('div',{staticClass:"searchInputContainer"},[_c('v-text-field',{attrs:{"data-cy":"studyManagerSearchInput","label":_vm.$t('studyManager.searchInputText'),"dense":"","hide-details":"","prepend-inner-icon":"mdi-magnify","outlined":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1):_c('div',{staticClass:"bulkActionsContainer",attrs:{"data-cy":"bulkActionsContainer"}},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.$tc('studyManager.bulkSelection', _vm.selected.length)))]),_c('div',{staticClass:"bulkActions",attrs:{"data-cy":"bulkActions"}},_vm._l((_vm.bulkActionsMenu),function(action,i){return _c('v-btn',{key:i,staticClass:"bulkActionBtn",attrs:{"tile":"","depressed":"","text":"","disabled":action.disabled},on:{"click":function($event){return action.bulkAction()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(action.icon)+" ")]),_vm._v(" "+_vm._s(action.title)+" ")],1)}),1)])]},proxy:true},(_vm.isMobile)?{key:"body.prepend",fn:function(){return [(_vm.enableExpandCollapseButtons)?_c('ExpandCollapseButtons',{attrs:{"isMobile":_vm.isMobile},on:{"expandAll":_vm.expandAll,"collapseAll":_vm.collapseAll}}):_vm._e()]},proxy:true}:null,{key:"header.data-table-select",fn:function(){return [_c('v-checkbox',{staticClass:"pa-0 ma-0 mr-2",attrs:{"value":_vm.allCurrentStudiesSelected,"indeterminate":_vm.someCurrentStudiesSelected,"disabled":!_vm.currentItems.length,"label":_vm.selectAllLabel,"color":"default","hide-details":"","data-cy":"selectAll"},on:{"change":_vm.toggleSelectAll}})]},proxy:true},{key:"item",fn:function(ref){
var item = ref.item;
var expand = ref.expand;
var isExpanded = ref.isExpanded;
return [_c('TableRow',{attrs:{"item":item,"isMobile":_vm.isMobile,"expand":expand,"isExpanded":isExpanded,"select":_vm.toggleSelectStudy,"isSelected":_vm.isStudySelected(item._id),"columns":_vm.columns,"actions":_vm.filterActionsMenu(item),"actionsDisabled":!_vm.showSearchBar}})]}},{key:"expanded-item",fn:function(ref){
var item = ref.item;
return _vm._l((item.children),function(child){return _c('TableRow',{key:child._id,attrs:{"item":child,"isMobile":_vm.isMobile,"select":_vm.toggleSelectStudy,"isSelected":_vm.isStudySelected(child._id),"isChild":true,"columns":_vm.columns,"actions":_vm.filterActionsMenu(child),"actionsDisabled":!_vm.showSearchBar}})})}},{key:"no-data",fn:function(){return [(_vm.studiesHaveBeenFetched)?_c('p',{staticClass:"emptyStudies"},[_vm._v(_vm._s(_vm.$t('studyManager.emptyDataLabel')))]):_c('p',{staticClass:"emptyStudies"},[_vm._v(_vm._s(_vm.$t('studyManager.retrievingStudies')))])]},proxy:true},(!_vm.isMobile)?{key:"footer.prepend",fn:function(){return [(_vm.enableExpandCollapseButtons)?_c('ExpandCollapseButtons',{attrs:{"isMobile":_vm.isMobile},on:{"expandAll":_vm.expandAll,"collapseAll":_vm.collapseAll}}):_vm._e()]},proxy:true}:null,{key:"footer",fn:function(){return [_c('v-dialog',{attrs:{"content-class":"studyManagerDetailsDialog","scrollable":""},model:{value:(_vm.dialogDetails),callback:function ($$v) {_vm.dialogDetails=$$v},expression:"dialogDetails"}},[_c('DetailsDialog',{attrs:{"detailsDialogFields":_vm.detailsDialogFields},on:{"closeDialog":_vm.closeDialogDetails}})],1),_c('v-dialog',{attrs:{"content-class":"studyManagerDetailsDialog","data-cy":"studyManagerEditDialog","persistent":"","scrollable":""},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('EditDialog',{attrs:{"detailsDialogFields":_vm.detailsDialogFields,"resetDialog":_vm.dialogEdit},on:{"closeDialog":_vm.closeDialogEdit}})],1),_c('v-dialog',{attrs:{"content-class":"studyManagerDetailsDialog","data-cy":"studyManagerDeleteDialog"},model:{value:(_vm.dialogDelete),callback:function ($$v) {_vm.dialogDelete=$$v},expression:"dialogDelete"}},[_c('DeleteDialog',{on:{"closeDialog":_vm.closeDialogDelete}})],1)]},proxy:true}],null,true)}),_c('v-card',{staticClass:"studyManagerButtons d-flex mb-6",class:[_vm.showCancelBtn ? 'justify-space-between' : 'justify-end'],attrs:{"data-cy":"studyManagerButtons","flat":"","tile":""}},[(_vm.showCancelBtn)?_c('v-btn',{staticClass:"ma-4",attrs:{"min-width":"120px","outlined":""},on:{"click":_vm.cancelBtnAction}},[_vm._v(" "+_vm._s(_vm.$t('buttons.cancel'))+" ")]):_vm._e(),(_vm.showSendToReportCreatorBtn)?_c('v-btn',{staticClass:"ma-4",attrs:{"disabled":_vm.disableSendToReportCreatorBulkAction,"color":"primary","min-width":"120px"},on:{"click":_vm.sendToReportCreatorBulkAction}},[_vm._v(" "+_vm._s(_vm.$t('studyManager.actionItems.sendToReportCreator'))+" "),_c('v-icon',{staticClass:"ml-1"},[_vm._v("mdi-arrow-right")])],1):(_vm.showDoneBtn)?_c('v-btn',{staticClass:"ma-4",attrs:{"color":"primary","min-width":"120px"},on:{"click":_vm.doneBtnAction}},[_vm._v(" "+_vm._s(_vm.$t('buttons.done'))+" ")]):_vm._e()],1)],1)}
var StudyManagervue_type_template_id_34270abf_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: external "Vuex"
var external_Vuex_namespaceObject = Vuex;
// EXTERNAL MODULE: ./node_modules/@fusion/auth/dist/fusion-auth.common.js
var fusion_auth_common = __webpack_require__(986);
;// CONCATENATED MODULE: ./src/components/StudyManager/module/definitions.js
const EMPTY_PARENT = 'empty_parent';
;// CONCATENATED MODULE: ./src/utils/common.js

const BLANK_SPACE = ' ';

/**
 * Returns the object that has the most recent timestamp
 * @param {Array} arrayOfObjects
 * @param {string} key The key of the timestamp
 * @returns {Object} The object with the most recent timestamp
 */
const getLatestObjectByTimestamp = (arrayOfObjects, key) => {
  let latestObject = null;
  let latestTimestamp = 0;
  if (arrayOfObjects !== null && arrayOfObjects !== void 0 && arrayOfObjects.length && key) {
    for (const item of arrayOfObjects) {
      const newDate = isValidObject(item) ? new Date(item[key]) : null;
      if (isValidDate(newDate) && newDate.getTime() > latestTimestamp) {
        latestTimestamp = newDate.getTime();
        latestObject = item;
      }
    }
  }
  return latestObject;
};

/**
 * Returns the translated text if exists or an empty string
 * @param {string} keyPath eg. studyManager.detailsDialog.content.terminationReasons.inProgress
 * @param {function} i18n Object with functions to provide string translation
 * @returns {string} The translated text
 */
const getTranslatedText = (keyPath, i18n) => {
  if (isValidObject(i18n) && typeof i18n.te === 'function' && typeof i18n.t === 'function') {
    if (i18n.te(keyPath)) {
      return i18n.t(keyPath);
    }
  }
  return BLANK_SPACE;
};

/**
 * Converts a text with this format 'connected_after_start' or this one 'Connected After Start' into 'connectedAfterStart'
 * @param {string} text
 * @returns {Object} The camel case text
 */
const convertTextToCamelCase = text => {
  if (typeof text === 'string' && text.length) {
    const splittedText = text.split(/[\s_]+/);
    if (splittedText.length > 1) {
      return splittedText.map((word, index) => {
        const formattedText = word.toLowerCase();
        return index === 0 ? formattedText : `${formattedText.charAt(0).toUpperCase()}${formattedText.slice(1)}`;
      }).join('');
    }

    // Lower case the first letter. Eg: Complete -> complete
    return `${text.charAt(0).toLowerCase()}${text.slice(1)}`;
  }
  return text;
};
;// CONCATENATED MODULE: ./src/components/StudyManager/module/utils.js



const DISCONNECTED_DEVICE_MILLISECONDS = (/* unused pure expression or super */ null && (1.5 * 60 * 1000));

/**
 * Converts milliseconds to a string format 'dd:hh:mm:ss'.
 * @see https://confluencetsi.atlassian.net/wiki/spaces/FUS/pages/1529511977/Study+Duration+Calculation+Algorithms
 * @param {number} milliseconds - The duration in milliseconds.
 * @returns {string} The formatted duration as 'dd:hh:mm:ss'.
 */
function formatDuration(milliseconds, showDays = true) {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor(totalSeconds % 86400 / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;

  // Zero padding
  const paddedDays = showDays ? `${days.toString().padStart(2, '0')}:` : '';
  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');
  const paddedSeconds = seconds.toString().padStart(2, '0');
  return `${paddedDays}${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
}

/**
 * Check if duration needs to be formatted
 * @param {number,string} duration
 * @returns true if needs duration formatted false otherwise
 */
function needsDurationFormatted(duration) {
  return duration && (typeof duration === 'number' || typeof duration === 'string' && /^\d+$/.test(duration));
}
function formatStudyWithCorrectDurations(study) {
  if (needsDurationFormatted(study.duration)) {
    // this like the others will parse as int if needs formatting to cover the case where the duration is a string or number representation of milliseconds
    study.duration = formatDuration(parseInt(study.duration));
  }
  if (needsDurationFormatted(study.data_duration)) {
    study.data_duration = formatDuration(parseInt(study.data_duration));
  }
  if (needsDurationFormatted(study.pause_duration)) {
    study.pause_duration = formatDuration(parseInt(study.pause_duration));
  }
  if (needsDurationFormatted(study.sampling_interval)) {
    study.sampling_interval = formatDuration(parseInt(study.sampling_interval) * 1000, false);
  }
}
function getDeviceModelName(model, i18n) {
  const key = `model.${model}`;
  if (!i18n.te(key)) {
    return 'N/A';
  }
  return `${i18n.t(key)} (${model})`;
}
function formatStudyWithCorrectModalName(study, i18n) {
  if (study.gateway_model) study.gateway_model_name = getDeviceModelName(study.gateway_model, i18n);
  if (study.device_model) study.device_model_name = getDeviceModelName(study.device_model, i18n);
}
function getFormattedTimestamp(timestamp) {
  if (isValidDate(timestamp)) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  return '';
}
function formatStudyWithFormattedMinTimestamp(study) {
  if (study) {
    let minTimestamp = study.min_timestamp;
    if (isEmptyParentStudy(study)) {
      const minChildStudy = getLatestObjectByTimestamp(study.children, 'min_timestamp');
      minTimestamp = minChildStudy === null || minChildStudy === void 0 ? void 0 : minChildStudy.min_timestamp;
    }
    study.formatted_min_timestamp = getFormattedTimestamp(minTimestamp);
  }
}
function isEmptyParentStudy(study) {
  return study.study_type === EMPTY_PARENT;
}
function getChildrenLongestDuration(children) {
  if (!(children !== null && children !== void 0 && children.length)) return '';
  const longestDuration = children === null || children === void 0 ? void 0 : children.reduce((prevValue, childStudy) => prevValue > childStudy.duration ? prevValue : childStudy.duration, 0);
  return longestDuration ? formatDuration(longestDuration) : '';
}
function fillEmptyParentStudyData(study, longestDuration) {
  if (!isEmptyParentStudy(study)) return;
  if (!study.duration) study.duration = longestDuration;
}

// loop through and for each study's duration/data_duration/pause_duration if they are milliseconds then format
// also update the correct model names for device/gateway models
function formatAllRequestedStudies(studies, i18n) {
  const rv = studies.map(study => {
    var _study$children, _study$children2;
    // adds access text details
    formatAccessDetail(study, !!study.is_shared, i18n);

    // Update the correct durations
    formatStudyWithCorrectDurations(study);

    // Update the correct model name
    formatStudyWithCorrectModalName(study, i18n);
    formatStudyWithFormattedMinTimestamp(study);

    // repeat for children
    if ((study === null || study === void 0 ? void 0 : (_study$children = study.children) === null || _study$children === void 0 ? void 0 : _study$children.length) > 0) {
      const longestChildDuration = getChildrenLongestDuration(study.children);
      study.children = formatAllRequestedStudies(study.children, i18n);
      fillEmptyParentStudyData(study, longestChildDuration);
    }

    // single module empty parent studies are excluded and their children should be shown directly
    if (isEmptyParentStudy(study) && (study === null || study === void 0 ? void 0 : (_study$children2 = study.children) === null || _study$children2 === void 0 ? void 0 : _study$children2.length) === 1) {
      const uniqueChildStudy = study.children[0];
      // adds empty children list to avoid display issues
      if (!uniqueChildStudy.children) uniqueChildStudy.children = [];
      // keep a reference in the study to know its a single module child study
      uniqueChildStudy.singleChildStudy = true;
      return uniqueChildStudy;
    }
    return study;
  });
  return rv;
}

/**
 * Does a case-insensitive comparison of two strings returning true if they are equal
 * @param {string} string1
 * @param {string} string2
 * @returns {boolean}
 */
function compareStringsCI(string1, string2) {
  return (string1 === null || string1 === void 0 ? void 0 : string1.toLowerCase()) === (string2 === null || string2 === void 0 ? void 0 : string2.toLowerCase());
}
function getLatestTimestamp(isoDates) {
  let latestTimestamp = 0;
  if (isoDates !== null && isoDates !== void 0 && isoDates.length) {
    const timestamps = isoDates.map(date => date ? new Date(date).getTime() : 0);
    latestTimestamp = Math.max(...timestamps);
    return latestTimestamp ? new Date(latestTimestamp).toISOString() : null;
  }
  return null;
}
function getLastDeviceCommunicationTimestamp(iotCoreData) {
  if (iotCoreData && typeof iotCoreData === 'object') {
    return getLatestTimestamp([iotCoreData.last_event_time, iotCoreData.last_heartbeat_time, iotCoreData.last_state_time]);
  }
  return null;
}
function isDeviceConnected(device) {
  const lastCommunicationTime = getLastDeviceCommunicationTimestamp(device.iot_core_data);
  if (lastCommunicationTime) {
    const lastCommunicationDate = new Date(lastCommunicationTime);
    // checks for invalid date
    if (isNaN(lastCommunicationDate)) {
      return false;
    }
    return lastCommunicationDate.getTime() > new Date().getTime() - DISCONNECTED_DEVICE_MILLISECONDS;
  }
  return false;
}

// formatAccessDetail will spread the access detail information also to all children
function formatAccessDetail(study, isShared, i18n) {
  var _study$children3;
  const isSharedInfo = isShared;
  const accessDetail = isSharedInfo ? `${i18n.t('studyManager.accessTypes.shared')}` : `${i18n.t('studyManager.accessTypes.owned')}`;
  study.access = accessDetail;
  study.is_shared = isSharedInfo;
  if ((study === null || study === void 0 ? void 0 : (_study$children3 = study.children) === null || _study$children3 === void 0 ? void 0 : _study$children3.length) > 0) {
    study.children = study.children.map(child => {
      return {
        ...child,
        is_shared: isSharedInfo,
        access: accessDetail
      };
    });
  }
}
;// CONCATENATED MODULE: ./src/components/StudyManager/module/actions.js


/* harmony default export */ var module_actions = ({
  setSelectedItems({
    commit
  }, items) {
    commit('setSelectedItems', items);
  },
  async requestStudies({
    commit
  }, {
    clientURL,
    i18n
  }) {
    const response = await axios.get(`${clientURL}/studies?timestamp=${new Date().getTime()}`); // timestamp included to prevent IE11 from caching
    const studies = isOkResponse(response.status) ? response.data || [] : [];
    const formatted = formatAllRequestedStudies(studies, i18n);
    commit('setStudies', formatted);
    return formatted;
  },
  async updateStudy({
    commit
  }, {
    clientURL,
    studyId,
    updates
  }) {
    const updatedResponse = await axios.patch(`${clientURL}/studies/${studyId}`, updates);
    if (isOkResponse(updatedResponse.status)) {
      return true;
    } else {
      return false;
    }
  },
  async deleteStudy({
    commit
  }, {
    clientURL,
    studyId
  }) {
    const deletedResponse = await axios.delete(`${clientURL}/studies/${studyId}`);
    if (isOkResponse(deletedResponse.status)) {
      return true;
    } else {
      return false;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/StudyManager/module/getters.js



// constants
const terminationReasons = constants.study.terminationReasons;
/* harmony default export */ var getters = ({
  getSelectedItem: state => {
    return state.selectedItem;
  },
  getSelectedItems: state => {
    return state.selectedItems;
  },
  getStudies: state => {
    return state.studies;
  },
  getCompleteStudies: state => {
    return state.studies.filter(study => study.upload_complete && !compareStringsCI(study === null || study === void 0 ? void 0 : study.termination_reason, terminationReasons.DISCONNECTED) && !compareStringsCI(study === null || study === void 0 ? void 0 : study.termination_reason, terminationReasons.CONNECTED_AFTER_START));
  }
});
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/components/StudyManager/module/mutations.js

/* harmony default export */ var module_mutations = ({
  setSelectedItems(state, items) {
    state.selectedItems = items;
  },
  setStudies(state, studies) {
    // dont update studies state if its not changing
    // this prevents unnecessary UI updates
    if (!lodash_default().isEqual(studies, state.studies)) {
      state.studies = studies;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/StudyManager/module/state.js
/* harmony default export */ var module_state = ({
  selectedItems: [],
  studies: [],
  smartBridgeDevices: {}
});
;// CONCATENATED MODULE: ./src/components/StudyManager/module/index.js






/* harmony default export */ var StudyManager_module = ({
  namespaced: true,
  state: module_state,
  getters: getters,
  mutations: module_mutations,
  actions: module_actions
});
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Delete.vue?vue&type=template&id=95433b52&scoped=true&
var Deletevue_type_template_id_95433b52_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"studyManagerDialog",attrs:{"data-cy":"studyManagerDeleteDialog"}},[_c('header',[_vm._v(" "+_vm._s(_vm.$t('studyManager.deleteDialog.header'))+" ")]),(_vm.getSelectedItems.length === 1)?_c('div',{staticClass:"dialogContent"},[_c('h2',[_vm._v(_vm._s(_vm.singleStudyMessage))])]):_c('div',{staticClass:"dialogContent"},[(_vm.excludedItems.length)?[_c('h3',[_vm._v(_vm._s(_vm.$t('studyManager.deleteDialog.warningText'))),_c('br'),_vm._v(_vm._s(_vm.$t('studyManager.deleteDialog.bulkWarningText')))]),_c('v-list-item',{staticClass:"mb-4"},[_c('v-list-item-content',_vm._l((_vm.excludedName),function(study,index){return _c('v-list-item-title',{key:study + '-' + index},[_vm._v(_vm._s(study))])}),1)],1),_c('v-divider',{staticClass:"mb-8"})]:_vm._e(),_c('h3',[_vm._v(_vm._s(_vm.$t('studyManager.deleteDialog.bulkHeader')))]),_c('v-list-item',{staticClass:"mb-4"},[_c('v-list-item-content',_vm._l((_vm.studiesName),function(study,index){return _c('v-list-item-title',{key:study + '-' + index},[_vm._v(_vm._s(study))])}),1)],1),_c('h3',[_vm._v(_vm._s(_vm.$t('studyManager.deleteDialog.bulkConfirmationText')))])],2),_c('footer',[_c('v-btn',{staticClass:"dialogBtn",attrs:{"min-width":"140px","outlined":""},on:{"click":_vm.closeDialog}},[_c('span',{staticClass:"btnText"},[_vm._v(_vm._s(_vm.$t('buttons.cancel')))])]),_c('v-btn',{staticClass:"dialogBtn",attrs:{"color":"error","min-width":"140px","disabled":_vm.disableDelete,"loading":_vm.deletingStudy},on:{"click":_vm.deleteBtnAction}},[_c('span',{staticClass:"btnText"},[_vm._v(_vm._s(_vm.$t('buttons.delete')))])])],1)])}
var Deletevue_type_template_id_95433b52_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Delete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Deletevue_type_script_lang_js_ = (Vue.extend({
  data() {
    return {
      deletingStudy: false,
      excludedItems: []
    };
  },
  computed: {
    ...(0,external_Vuex_namespaceObject.mapGetters)('studyManager', ['getSelectedItems', 'getStudies']),
    allowedItems() {
      return this.getSelectedItems.filter(item => !this.excludedIds.includes(item._id));
    },
    studiesName() {
      return this.allowedItems.map(study => study.study_name);
    },
    excludedName() {
      return this.excludedItems.map(study => study.study_name);
    },
    selectedIds() {
      return this.getSelectedItems.map(study => study._id);
    },
    excludedIds() {
      return this.excludedItems.map(study => study._id);
    },
    disableDelete() {
      return this.excludedItems.length === this.getSelectedItems.length;
    },
    singleStudyMessage() {
      if (!this.allowedItems.length) {
        return this.$t('studyManager.deleteDialog.warningText');
      }
      return `${this.studiesName} ${this.$t('studyManager.deleteDialog.confirmationText')}`;
    },
    // used to delete empty parent studies when all their children are bulk deleted at the same time
    emptyParentStudiesToDelete() {
      const emptyParentStudies = [];
      for (const study of this.allowedItems) {
        if (!(study !== null && study !== void 0 && study.parent_id)) continue;
        const isParentAlreadyIncluded = emptyParentStudies.includes(study === null || study === void 0 ? void 0 : study.parent_id) || this.selectedIds.includes(study === null || study === void 0 ? void 0 : study.parent_id);
        if (isParentAlreadyIncluded) continue;
        const parentStudy = this.getStudies.find(item => item._id === study.parent_id);
        if (!parentStudy) continue;
        if (parentStudy.study_type !== EMPTY_PARENT) continue;
        if (parentStudy !== null && parentStudy !== void 0 && parentStudy.children) {
          const childIds = parentStudy.children.map(child => child._id);
          const allIncluded = childIds.every(id => this.selectedIds.includes(id));
          if (allIncluded) {
            emptyParentStudies.push(study.parent_id);
          }
        }
      }
      return emptyParentStudies;
    }
  },
  mounted() {
    this.checkParentStudies();
  },
  watch: {
    getSelectedItems() {
      this.checkParentStudies();
    }
  },
  methods: {
    ...(0,external_Vuex_namespaceObject.mapActions)('studyManager', ['deleteStudy', 'requestStudies']),
    async deleteBtnAction() {
      this.deletingStudy = true;
      for (const study of this.allowedItems) {
        const singleChildStudy = study === null || study === void 0 ? void 0 : study.singleChildStudy;
        await this.deleteStudy({
          clientURL: this.$components.studiesAPIHostV2,
          studyId: study._id
        });
        // Single module child studies will need to also delete their own parent study object
        if (singleChildStudy) {
          await this.deleteStudy({
            clientURL: this.$components.studiesAPIHostV2,
            studyId: study.parent_id
          });
        }
      }
      for (const emptyParentToDelete of this.emptyParentStudiesToDelete) {
        await this.deleteStudy({
          clientURL: this.$components.studiesAPIHostV2,
          studyId: emptyParentToDelete
        });
      }
      await this.requestStudies({
        clientURL: this.$components.studiesAPIHostV3,
        i18n: this.$i18n
      });
      this.deletingStudy = false;
      this.$emit('closeDialog', true);
    },
    checkParentStudies() {
      this.excludedItems = [];
      this.getSelectedItems.forEach(study => {
        if (study.children) {
          const childIds = study.children.map(child => child._id);
          const allIncluded = childIds.every(id => this.selectedIds.includes(id));
          if (!allIncluded) {
            this.excludedItems.push(study);
          }
        }
      });
    },
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Delete.vue?vue&type=script&lang=js&
 /* harmony default export */ var Dialogs_Deletevue_type_script_lang_js_ = (Deletevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Delete.vue?vue&type=style&index=0&id=95433b52&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Delete.vue?vue&type=style&index=0&id=95433b52&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Delete.vue



;


/* normalize component */

var Delete_component = normalizeComponent(
  Dialogs_Deletevue_type_script_lang_js_,
  Deletevue_type_template_id_95433b52_scoped_true_render,
  Deletevue_type_template_id_95433b52_scoped_true_staticRenderFns,
  false,
  null,
  "95433b52",
  null
  
)

/* harmony default export */ var Delete = (Delete_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Details.vue?vue&type=template&id=a8bbb5f8&scoped=true&
var Detailsvue_type_template_id_a8bbb5f8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"studyManagerDialog",attrs:{"data-cy":"studyManagerDetailsDialog"}},[_c('header',[_vm._v(" "+_vm._s(_vm.$t('studyManager.detailsDialog.header'))+" ")]),_c('v-card-text',{staticClass:"dialogContent"},[_c('div',{staticClass:"dialogTitle"},[_c('h3',{staticClass:"text-h5 font-weight-bold",attrs:{"data-cy":"studyManagerDetailsDialogStudyName"}},[_vm._v(_vm._s(_vm.selectedStudy.study_name))]),_c('p',{staticClass:"text-subtitle-2",attrs:{"data-cy":"studyManagerDetailsDialogID"}},[_vm._v("ID: "+_vm._s(_vm.selectedStudy._id))])]),_c('div',{staticClass:"dialogDetails"},[_c('v-container',{staticClass:"dialogCards"},[_c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.orderFields),function(index,item){return _c('v-col',{key:(index + "-" + item),staticClass:"dialogColumns",attrs:{"cols":"6","data-cy":"studyManagerDetailsDialogInfo"}},[_c('v-card',{key:item,staticClass:"dialogItem"},[_c('p',{staticClass:"text-subtitle-1 font-weight-bold dialogItemTitle"},[_vm._v(_vm._s(_vm.$t(("studyManager.detailsDialog.content." + item))))]),_c('p',{staticClass:"dialogItemText"},[_vm._v(" "+_vm._s(_vm.getPropertyData(item))+" ")]),(item === 'duration' && _vm.selectedStudy.duration)?_c('div',[_c('p',{staticClass:"dialogItemSubText text-subtitle-2"},[_vm._v(" "+_vm._s(_vm.formattedStartEndTimes)+" ")]),(_vm.selectedStudy.pause_duration !== 0)?_c('div',[_c('p',{staticClass:"dialogItemSubText text-subtitle-2"},[_vm._v(" Pause Duration: "+_vm._s(_vm.selectedStudy.pause_duration)+" ")]),_c('p',{staticClass:"dialogItemSubText text-subtitle-2"},[_vm._v(" Data Duration: "+_vm._s(_vm.selectedStudy.data_duration)+" ")])]):_vm._e()]):_vm._e(),(item === 'device' && _vm.selectedStudy.device_model)?_c('p',{staticClass:"dialogItemSubText text-subtitle-2"},[_vm._v(" "+_vm._s(_vm.selectedStudy.device_model)+"/"+_vm._s(_vm.selectedStudy.device_serial)+" ")]):_vm._e(),(item === 'gateway' && _vm.selectedStudy.gateway_model)?_c('p',{staticClass:"dialogItemSubText text-subtitle-2"},[_vm._v(" "+_vm._s(_vm.selectedStudy.gateway_model)+"/"+_vm._s(_vm.selectedStudy.gateway_serial)+" ")]):_vm._e()])],1)}),1)],1),(_vm.showNotes)?_c('v-card',{staticClass:"dialogItem notes"},[_c('p',{staticClass:"text-subtitle-1 font-weight-bold dialogItemTitle"},[_vm._v(_vm._s(_vm.$t("studyManager.detailsDialog.content.notes"))+" ")]),_c('p',{staticClass:"dialogItemText"},[_vm._v(" "+_vm._s(_vm.getPropertyData('notes'))+" ")])]):_vm._e()],1)]),_c('footer',[_c('v-btn',{staticClass:"dialogBtn",attrs:{"color":"primary","min-width":"140px","data-cy":"studyManagerDetailsDialogDoneButton"},on:{"click":_vm.closeDialog}},[_c('span',{staticClass:"btnText"},[_vm._v(_vm._s(_vm.$t('buttons.done')))])])],1)],1)}
var Detailsvue_type_template_id_a8bbb5f8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/utils.js

const utils_BLANK_SPACE = ' ';

/**
 * Applies standard model naming to devices
 * @param {string} model
 * @param {function} i18n Object with functions to provide string translation
 * @returns {string} Name to display for device
 */
function deviceDisplayName(model, i18n) {
  const keyPath = `model.${model}`;
  return getTranslatedText(keyPath, i18n);
}

/**
 * Display a blank value when duration is falsy
 * @param {number | string} duration
 * @returns {string} Duration to display
 */
function durationDisplay(duration) {
  return duration || utils_BLANK_SPACE;
}

/**
 * Translates the termination_reason value to the correct display text
 * @param {string} terminationReason
 * @param {function} i18n Object with functions to provide string translation
 * @returns {string} Termination reason text to display
 */
function terminationReasonDisplay(terminationReason, i18n) {
  const formattedTerminationReason = convertTextToCamelCase(terminationReason);
  const keyPath = `studyManager.detailsDialog.content.terminationReasons.${formattedTerminationReason}`;
  const translatedText = getTranslatedText(keyPath, i18n);
  return translatedText.trim() ? translatedText : terminationReason;
}

/**
 * Formats an ISO Date String according to specified options.
 * Note: default timezone set to match values coming from database
 * @param options - Formatting options.
 * @returns {string} The formatted date string.
 */
function formatISODate({
  locale = 'en',
  isoDateString,
  timezone = 'UTC',
  showSeconds = false,
  showTimeZone = false,
  show24HourTime = false
}) {
  const dateFromISOString = new Date(isoDateString);
  let options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };
  if (showSeconds) {
    options = {
      ...options,
      second: 'numeric'
    };
  }
  if (timezone) {
    options = {
      ...options,
      timeZone: timezone
    };
  }
  if (showTimeZone) {
    options = {
      ...options,
      timeZoneName: 'short'
    };
  }
  if (show24HourTime) {
    options = {
      ...options,
      hour12: false
    };
  }
  return Intl.DateTimeFormat(locale, options).format(dateFromISOString);
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Details.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Detailsvue_type_script_lang_js_ = (Vue.extend({
  props: {
    detailsDialogFields: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...(0,external_Vuex_namespaceObject.mapGetters)('studyManager', ['getSelectedItems']),
    selectedStudy() {
      return this.getSelectedItems[0];
    },
    orderFields() {
      return JSON.parse(JSON.stringify(this.detailsDialogFields, ['duration', 'device', 'study type', 'gateway', 'sampling_interval', 'location', 'number of samples', 'termination_reason']));
    },
    showNotes() {
      return this.detailsDialogFields.notes === true && this.getPropertyData('notes');
    },
    formattedStartEndTimes() {
      const formattedStartTime = getFormattedTimestamp(this.selectedStudy.min_timestamp) || '-';
      const formattedEndTime = getFormattedTimestamp(this.selectedStudy.max_timestamp) || '-';
      return `${formattedStartTime} - ${formattedEndTime}`;
    }
  },
  methods: {
    getPropertyData(field) {
      switch (field) {
        case 'study type':
          return this.selectedStudy.study_type;
        case 'device':
          return this.deviceDisplayName();
        case 'number of samples':
          return this.selectedStudy.total_samples;
        case 'gateway':
          return this.selectedStudy.gateway_name;
        case 'duration':
          return this.durationDisplay();
        case 'termination_reason':
          return this.getTerminationReasonDisplay(this.selectedStudy.termination_reason);
        default:
          return this.selectedStudy[field];
      }
    },
    getStudyModule(deviceModel) {
      const key = `model.${deviceModel}`;
      if (!this.$te(key)) {
        return '';
      }
      return this.$t(key);
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    deviceDisplayName() {
      return deviceDisplayName(this.selectedStudy.device_model, this.$i18n);
    },
    durationDisplay() {
      return durationDisplay(this.selectedStudy.duration);
    },
    getTerminationReasonDisplay(terminationReason) {
      return terminationReasonDisplay(terminationReason, this.$i18n);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Details.vue?vue&type=script&lang=js&
 /* harmony default export */ var Dialogs_Detailsvue_type_script_lang_js_ = (Detailsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Details.vue?vue&type=style&index=0&id=a8bbb5f8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Details.vue?vue&type=style&index=0&id=a8bbb5f8&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Details.vue



;


/* normalize component */

var Details_component = normalizeComponent(
  Dialogs_Detailsvue_type_script_lang_js_,
  Detailsvue_type_template_id_a8bbb5f8_scoped_true_render,
  Detailsvue_type_template_id_a8bbb5f8_scoped_true_staticRenderFns,
  false,
  null,
  "a8bbb5f8",
  null
  
)

/* harmony default export */ var Details = (Details_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Edit.vue?vue&type=template&id=7b1ebca2&scoped=true&
var Editvue_type_template_id_7b1ebca2_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"studyManagerDialog",attrs:{"data-cy":"studyManagerEditDialog"}},[_c('header',[_vm._v(" "+_vm._s(_vm.$t('studyManager.editDialog.header'))+" ")]),_c('v-card-text',{staticClass:"dialogContent"},[_c('v-form',{ref:"form",attrs:{"lazy-validation":"","data-cy":"studyEditForm"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"dialogItem validate",attrs:{"data-cy":"studyNameField"}},[_c('p',{staticClass:"dialogItemTitle"},[_vm._v(_vm._s(_vm.$t('studyManager.detailsDialog.content.studyName')))]),_c('p',{staticClass:"dialogItemText"},[_c('v-text-field',{attrs:{"data-cy":"studyNameTextField","counter":"","maxlength":"128","outlined":"","rules":_vm.studyNameRules},model:{value:(_vm.studyName),callback:function ($$v) {_vm.studyName=$$v},expression:"studyName"}})],1)]),_vm._l((_vm.orderFields),function(index,item){return _c('v-card',{key:item,staticClass:"dialogItem"},[_c('p',{staticClass:"dialogItemTitle"},[_vm._v(_vm._s(_vm.$t(("studyManager.detailsDialog.content." + item))))]),_c('p',{staticClass:"dialogItemText"},[_vm._v(" "+_vm._s(_vm.getPropertyData(item))+" ")]),(item === 'device' && _vm.selectedStudy.device_model)?_c('p',{staticClass:"dialogItemSubText"},[_vm._v(" "+_vm._s(_vm.selectedStudy.device_model)+"/"+_vm._s(_vm.selectedStudy.device_serial)+" ")]):_vm._e()])}),(_vm.detailsDialogFields.location)?_c('v-card',{staticClass:"dialogItem validate",attrs:{"data-cy":"studyLocationField"}},[_c('p',{staticClass:"dialogItemTitle"},[_vm._v(_vm._s(_vm.$t('studyManager.detailsDialog.content.location')))]),_c('p',{staticClass:"dialogItemText"},[_c('v-text-field',{attrs:{"data-cy":"studyLocationTextField","counter":"","maxlength":"128","outlined":"","rules":_vm.locationRules},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1)]):_vm._e(),(_vm.detailsDialogFields.notes)?_c('v-card',{staticClass:"dialogItem validate",attrs:{"data-cy":"studyNotesField"}},[_c('p',{staticClass:"dialogItemTitle"},[_vm._v(_vm._s(_vm.$t('studyManager.detailsDialog.content.notes')))]),_c('p',{staticClass:"dialogItemText"},[_c('v-textarea',{attrs:{"data-cy":"studyNotesTextField","counter":"","maxlength":"256","outlined":"","rules":_vm.notesRules},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1)]):_vm._e()],2)],1),_c('footer',{attrs:{"data-cy":"formButtons"}},[_c('v-btn',{staticClass:"dialogBtn",attrs:{"min-width":"140px","outlined":""},on:{"click":_vm.cancelEditDialog}},[_c('span',{staticClass:"btnText"},[_vm._v(_vm._s(_vm.$t('buttons.cancel')))])]),_c('v-btn',{staticClass:"dialogBtn",attrs:{"color":"primary","min-width":"140px","disabled":_vm.disabledSaveBtn,"loading":_vm.savingStudy},on:{"click":_vm.doneBtnAction}},[_c('span',{staticClass:"btnText"},[_vm._v(_vm._s(_vm.$t('buttons.save')))])])],1),_c('v-dialog',{attrs:{"content-class":"editCancelDialog","data-cy":"confirmCancelDialog"},model:{value:(_vm.cancelDialog),callback:function ($$v) {_vm.cancelDialog=$$v},expression:"cancelDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(" "+_vm._s(_vm.$t('buttons.cancel'))+" ")]),_c('v-card-text',{staticClass:"text",attrs:{"data-cy":"confirmCancelDialogText"}},[_vm._v(" "+_vm._s(_vm.$t('studyManager.editDialog.content.cancelText'))+" ")]),_c('div',{staticClass:"buttons",attrs:{"data-cy":"confirmCancelBtns"}},[_c('v-btn',{attrs:{"outlined":""},on:{"click":_vm.confirmCancel}},[_vm._v(" "+_vm._s(_vm.$t('buttons.yes'))+" ")]),_c('v-btn',{attrs:{"outlined":""},on:{"click":_vm.cancelAction}},[_vm._v(" "+_vm._s(_vm.$t('buttons.no'))+" ")])],1)],1)],1)],1)}
var Editvue_type_template_id_7b1ebca2_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Edit.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Editvue_type_script_lang_js_ = (Vue.extend({
  props: {
    detailsDialogFields: {
      type: Object,
      required: true
    },
    resetDialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      valid: false,
      studyName: '',
      location: '',
      notes: '',
      cancelDialog: false,
      studyNameRules: [v => !!v || this.$t('studyManager.editDialog.content.studyNameRequired'), v => v ? v.length <= 128 || this.$t('studyManager.editDialog.content.max128Characters') : true],
      locationRules: [v => v ? v.length <= 128 || this.$t('studyManager.editDialog.content.max128Characters') : true],
      notesRules: [v => v ? v.length <= 256 || this.$t('studyManager.editDialog.content.max256Characters') : true],
      savingStudy: false
    };
  },
  created() {
    this.setValues();
  },
  computed: {
    ...(0,external_Vuex_namespaceObject.mapGetters)('studyManager', ['getSelectedItems', 'getStudies']),
    selectedStudy() {
      return this.getSelectedItems[0];
    },
    orderFields() {
      return JSON.parse(JSON.stringify(this.detailsDialogFields, ['study start time', 'duration', 'device', 'type']));
    },
    disabledSaveBtn() {
      const previousData = [this.selectedStudy.study_name, this.selectedStudy.location, this.selectedStudy.notes];
      return previousData.toString() === [this.studyName, this.location, this.notes].toString() || !this.valid;
    }
  },
  methods: {
    ...(0,external_Vuex_namespaceObject.mapActions)('studyManager', ['updateStudy', 'requestStudies']),
    getPropertyData(field) {
      switch (field) {
        case 'study start time':
          return this.selectedStudy.formatted_min_timestamp;
        case 'type':
          return this.selectedStudy.study_type;
        case 'device':
          return this.deviceDisplayName();
        case 'duration':
          return this.durationDisplay();
        default:
          return this.selectedStudy[field];
      }
    },
    deviceDisplayName() {
      return deviceDisplayName(this.selectedStudy.device_model, this.$i18n);
    },
    durationDisplay() {
      return durationDisplay(this.selectedStudy.duration);
    },
    setValues() {
      this.studyName = this.selectedStudy.study_name;
      this.location = this.selectedStudy.location;
      this.notes = this.selectedStudy.notes;
    },
    async doneBtnAction() {
      this.savingStudy = true;
      const updates = {
        study_name: this.studyName,
        location: this.location,
        notes: this.notes
      };
      const updated = await this.updateStudy({
        clientURL: this.$components.studiesAPIHostV2,
        studyId: this.selectedStudy._id,
        updates
      });
      if (updated) {
        await this.requestStudies({
          clientURL: this.$components.studiesAPIHostV3,
          i18n: this.$i18n
        });
      }
      this.savingStudy = false;
      this.$emit('closeDialog');
      Object.assign(this.selectedStudy, updates);
    },
    cancelEditDialog() {
      this.cancelDialog = true;
    },
    cancelAction() {
      this.cancelDialog = false;
    },
    confirmCancel() {
      this.setValues();
      this.cancelAction();
      this.$emit('closeDialog');
    }
  },
  watch: {
    resetDialog() {
      this.setValues();
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Edit.vue?vue&type=script&lang=js&
 /* harmony default export */ var Dialogs_Editvue_type_script_lang_js_ = (Editvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/Dialogs/Edit.vue?vue&type=style&index=0&id=7b1ebca2&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Edit.vue?vue&type=style&index=0&id=7b1ebca2&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/StudyManager/Dialogs/Edit.vue



;


/* normalize component */

var Edit_component = normalizeComponent(
  Dialogs_Editvue_type_script_lang_js_,
  Editvue_type_template_id_7b1ebca2_scoped_true_render,
  Editvue_type_template_id_7b1ebca2_scoped_true_staticRenderFns,
  false,
  null,
  "7b1ebca2",
  null
  
)

/* harmony default export */ var Edit = (Edit_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/ExpandCollapseButtons.vue?vue&type=template&id=7043b929&scoped=true&
var ExpandCollapseButtonsvue_type_template_id_7043b929_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'expand-collapse-buttons': true,
    'is-mobile': _vm.isMobile,
  }},[_c('v-btn',{attrs:{"data-cy":"expandAll"},on:{"click":function($event){return _vm.$emit('expandAll')}}},[_vm._v(_vm._s(_vm.$t('studyManager.tableFooter.expandAll')))]),_c('span',{staticClass:"separator"},[_vm._v(_vm._s('|'))]),_c('v-btn',{attrs:{"data-cy":"collapseAll"},on:{"click":function($event){return _vm.$emit('collapseAll')}}},[_vm._v(_vm._s(_vm.$t('studyManager.tableFooter.collapseAll')))])],1)}
var ExpandCollapseButtonsvue_type_template_id_7043b929_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/ExpandCollapseButtons.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ExpandCollapseButtonsvue_type_script_lang_js_ = ({
  props: {
    isMobile: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/StudyManager/components/ExpandCollapseButtons.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ExpandCollapseButtonsvue_type_script_lang_js_ = (ExpandCollapseButtonsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/ExpandCollapseButtons.vue?vue&type=style&index=0&id=7043b929&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/StudyManager/components/ExpandCollapseButtons.vue?vue&type=style&index=0&id=7043b929&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/StudyManager/components/ExpandCollapseButtons.vue



;


/* normalize component */

var ExpandCollapseButtons_component = normalizeComponent(
  components_ExpandCollapseButtonsvue_type_script_lang_js_,
  ExpandCollapseButtonsvue_type_template_id_7043b929_scoped_true_render,
  ExpandCollapseButtonsvue_type_template_id_7043b929_scoped_true_staticRenderFns,
  false,
  null,
  "7043b929",
  null
  
)

/* harmony default export */ var ExpandCollapseButtons = (ExpandCollapseButtons_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableRow.vue?vue&type=template&id=23eb32b0&scoped=true&
var TableRowvue_type_template_id_23eb32b0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{key:_vm.item.id,class:{ 'child-expanded-row': _vm.isChild },attrs:{"data-cy":("study" + (_vm.item._id) + "Row")}},[(_vm.isMobile)?[_c('td',{staticClass:"mobile-table-row"},[_c('div',{staticClass:"d-flex justify-space-between my-2"},[_c('v-simple-checkbox',{staticClass:"v-data-table__checkbox",attrs:{"value":_vm.isSelected,"data-cy":"columnSelect"},on:{"input":function($event){return _vm.select(_vm.item._id)}}}),(_vm.actionsColumn)?_c('TableColActions',{attrs:{"item":_vm.item,"actions":_vm.actions,"actionsDisabled":_vm.actionsDisabled}}):_vm._e()],1),_c('ul',{staticClass:"mobile-table-row--list",class:{'expandable': _vm.itemCanBeExpanded}},_vm._l((_vm.dataColumns),function(col){return _c('li',{key:col.value,staticClass:"mobile-table-row--list-entry"},[_c('span',[_vm._v(_vm._s(col.text)+": ")]),_c(_vm.getComponent(col.value),{tag:"component",attrs:{"value":_vm.getColumnValue(_vm.item, col.value)}})],1)}),0),(_vm.itemCanBeExpanded)?_c('div',{staticClass:"text-end my-2"},[_c('v-btn',{staticClass:"primary--text flex-row-reverse",attrs:{"text":""},on:{"click":function($event){return _vm.expand(!_vm.isExpanded)}}},[_vm._v(" "+_vm._s(_vm.isExpanded ? _vm.$t('studyManager.mobileExpansionOptions.hide') : _vm.$t('studyManager.mobileExpansionOptions.view'))+" ")])],1):_vm._e()])]:[_c('td',{staticClass:"text-start pr-0",attrs:{"data-cy":"columnSelect"}},[_c('v-simple-checkbox',{staticClass:"v-data-table__checkbox",class:{'v-data-table__checkbox--child': _vm.isChild},attrs:{"value":_vm.isSelected},on:{"input":function($event){return _vm.select(_vm.item._id)}}})],1),_c('td',{staticClass:"text-center px-0",attrs:{"data-cy":"columnExpand"}},[(_vm.itemCanBeExpanded)?_c('v-btn',{staticClass:"v-data-table__expand-icon",class:{'v-data-table__expand-icon--active' : _vm.isExpanded},attrs:{"icon":""},on:{"click":function($event){return _vm.expand(!_vm.isExpanded)}}},[_c('v-icon',[_vm._v("mdi-chevron-right")])],1):_vm._e()],1),_vm._l((_vm.dataColumns),function(col){return _c('td',{key:col.value,class:_vm.getAlignmentClass(col.align)},[_c(_vm.getComponent(col.value),{tag:"component",attrs:{"value":_vm.getColumnValue(_vm.item, col.value)}})],1)}),(_vm.actionsColumn)?_c('td',{class:("text-" + (_vm.actionsColumn.align.trim()))},[_c('TableColActions',{attrs:{"item":_vm.item,"actions":_vm.actions,"actionsDisabled":_vm.actionsDisabled}})],1):_vm._e()]],2)}
var TableRowvue_type_template_id_23eb32b0_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableCol.vue?vue&type=template&id=25a8dfca&
var TableColvue_type_template_id_25a8dfca_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.value))])}
var TableColvue_type_template_id_25a8dfca_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableCol.vue?vue&type=script&lang=js&
//
//
//
//

/* harmony default export */ var TableColvue_type_script_lang_js_ = (Vue.extend({
  props: {
    value: [String, Number]
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableCol.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TableColvue_type_script_lang_js_ = (TableColvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableCol.vue





/* normalize component */
;
var TableCol_component = normalizeComponent(
  components_TableColvue_type_script_lang_js_,
  TableColvue_type_template_id_25a8dfca_render,
  TableColvue_type_template_id_25a8dfca_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TableCol = (TableCol_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColNA.vue?vue&type=template&id=1d77be4e&
var TableColNAvue_type_template_id_1d77be4e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.value || _vm.$t('studyManager.notApplicableLabel')))])}
var TableColNAvue_type_template_id_1d77be4e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColNA.vue?vue&type=script&lang=js&
//
//
//
//

/* harmony default export */ var TableColNAvue_type_script_lang_js_ = (Vue.extend({
  props: {
    value: String
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColNA.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TableColNAvue_type_script_lang_js_ = (TableColNAvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColNA.vue





/* normalize component */
;
var TableColNA_component = normalizeComponent(
  components_TableColNAvue_type_script_lang_js_,
  TableColNAvue_type_template_id_1d77be4e_render,
  TableColNAvue_type_template_id_1d77be4e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TableColNA = (TableColNA_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColNotes.vue?vue&type=template&id=7050a8d0&
var TableColNotesvue_type_template_id_7050a8d0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.addEllipsis(_vm.value)))])}
var TableColNotesvue_type_template_id_7050a8d0_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColNotes.vue?vue&type=script&lang=js&
//
//
//
//

/* harmony default export */ var TableColNotesvue_type_script_lang_js_ = (Vue.extend({
  props: {
    value: String
  },
  methods: {
    addEllipsis(notes) {
      if (notes && notes.length > 50) {
        return notes.slice(0, 50) + '…';
      }
      return notes;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColNotes.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TableColNotesvue_type_script_lang_js_ = (TableColNotesvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColNotes.vue





/* normalize component */
;
var TableColNotes_component = normalizeComponent(
  components_TableColNotesvue_type_script_lang_js_,
  TableColNotesvue_type_template_id_7050a8d0_render,
  TableColNotesvue_type_template_id_7050a8d0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TableColNotes = (TableColNotes_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColId.vue?vue&type=template&id=92e04930&
var TableColIdvue_type_template_id_92e04930_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.formatStudyId(_vm.value))+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.value))])])}
var TableColIdvue_type_template_id_92e04930_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColId.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TableColIdvue_type_script_lang_js_ = (Vue.extend({
  props: {
    value: String
  },
  methods: {
    formatStudyId(studyId) {
      return `${studyId.slice(0, 4)}...${studyId.slice(-4)}`;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColId.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TableColIdvue_type_script_lang_js_ = (TableColIdvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColId.vue





/* normalize component */
;
var TableColId_component = normalizeComponent(
  components_TableColIdvue_type_script_lang_js_,
  TableColIdvue_type_template_id_92e04930_render,
  TableColIdvue_type_template_id_92e04930_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TableColId = (TableColId_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColDuration.vue?vue&type=template&id=62277d72&
var TableColDurationvue_type_template_id_62277d72_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.value || ''))])}
var TableColDurationvue_type_template_id_62277d72_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColDuration.vue?vue&type=script&lang=js&
//
//
//
//

/* harmony default export */ var TableColDurationvue_type_script_lang_js_ = (Vue.extend({
  props: {
    value: [String, Number]
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColDuration.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TableColDurationvue_type_script_lang_js_ = (TableColDurationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColDuration.vue





/* normalize component */
;
var TableColDuration_component = normalizeComponent(
  components_TableColDurationvue_type_script_lang_js_,
  TableColDurationvue_type_template_id_62277d72_render,
  TableColDurationvue_type_template_id_62277d72_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TableColDuration = (TableColDuration_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColActions.vue?vue&type=template&id=3937db74&scoped=true&
var TableColActionsvue_type_template_id_3937db74_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"content-class":"actionMenuDropdownStudyManager","bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"data-cy":"studyManagerActionsActivatorBtn","disabled":_vm.actionsDisabled,"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"size":24}},[_vm._v(" mdi-dots-vertical ")])],1)]}}])},[_c('v-list',{attrs:{"data-cy":"studyManagerActionsBtns"}},[_c('v-list-item',[_c('v-list-item-title',[_c('span',[_vm._v(_vm._s(_vm.$t('studyManager.actionsTitle')))]),_c('v-icon',{attrs:{"color":"white","size":24}},[_vm._v(" mdi-dots-vertical ")])],1)],1),_vm._l((_vm.actions),function(action,i){return _c('v-list-item',{key:i,class:action.class,attrs:{"disabled":action.disabled,"data-cy":action.dataCy},on:{"click":function($event){return action.action(_vm.item)}}},[_c('v-list-item-title',[_c('v-icon',{attrs:{"size":18}},[_vm._v(" "+_vm._s(action.icon)+" ")]),_c('span',[_vm._v(_vm._s(action.title))])],1)],1)})],2)],1)}
var TableColActionsvue_type_template_id_3937db74_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColActions.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TableColActionsvue_type_script_lang_js_ = (Vue.extend({
  props: {
    item: Object,
    actions: Array,
    actionsDisabled: Boolean
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColActions.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TableColActionsvue_type_script_lang_js_ = (TableColActionsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableColActions.vue?vue&type=style&index=0&id=3937db74&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColActions.vue?vue&type=style&index=0&id=3937db74&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableColActions.vue



;


/* normalize component */

var TableColActions_component = normalizeComponent(
  components_TableColActionsvue_type_script_lang_js_,
  TableColActionsvue_type_template_id_3937db74_scoped_true_render,
  TableColActionsvue_type_template_id_3937db74_scoped_true_staticRenderFns,
  false,
  null,
  "3937db74",
  null
  
)

/* harmony default export */ var TableColActions = (TableColActions_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableRow.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var TableRowvue_type_script_lang_js_ = (Vue.extend({
  components: {
    TableCol: TableCol,
    TableColNA: TableColNA,
    TableColNotes: TableColNotes,
    TableColId: TableColId,
    TableColDuration: TableColDuration,
    TableColActions: TableColActions
  },
  props: {
    item: Object,
    isMobile: Boolean,
    expand: Function,
    isExpanded: Boolean,
    select: Function,
    isSelected: Boolean,
    isChild: Boolean,
    columns: Array,
    actions: Array,
    actionsDisabled: Boolean
  },
  data() {
    return {
      components: {
        _id: TableColId,
        device_serial: TableColNA,
        device_name: TableColNA,
        duration: TableColDuration,
        notes: TableColNotes
      }
    };
  },
  computed: {
    itemCanBeExpanded() {
      var _this$item$children;
      return ((_this$item$children = this.item.children) === null || _this$item$children === void 0 ? void 0 : _this$item$children.length) > 0;
    },
    dataColumns() {
      return this.columns.filter(col => col.value !== 'actions');
    },
    actionsColumn() {
      return this.columns.filter(col => col.value === 'actions')[0];
    }
  },
  methods: {
    getComponent(column) {
      return this.components[column] || TableCol;
    },
    getColumnValue(item, column) {
      if (item.study_type === EMPTY_PARENT) {
        switch (column) {
          case 'device_model':
            column = 'gateway_model';
            break;
          case 'device_serial':
            column = 'gateway_serial';
            break;
          case 'device_name':
            column = 'gateway_name';
            break;
        }
      }
      switch (column) {
        case 'device_model':
          return item.device_model_name;
        case 'gateway_model':
          return item.gateway_model_name;
        default:
          return item[column];
      }
    },
    getAlignmentClass(align) {
      return `text-${align || 'start'}`;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableRow.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TableRowvue_type_script_lang_js_ = (TableRowvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/components/TableRow.vue?vue&type=style&index=0&id=23eb32b0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableRow.vue?vue&type=style&index=0&id=23eb32b0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/StudyManager/components/TableRow.vue



;


/* normalize component */

var TableRow_component = normalizeComponent(
  components_TableRowvue_type_script_lang_js_,
  TableRowvue_type_template_id_23eb32b0_scoped_true_render,
  TableRowvue_type_template_id_23eb32b0_scoped_true_staticRenderFns,
  false,
  null,
  "23eb32b0",
  null
  
)

/* harmony default export */ var TableRow = (TableRow_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// constants
const actionKeys = Object.freeze({
  DETAILS: 'details',
  EDIT: 'edit',
  EXPORT: 'export',
  REPORT_CREATOR: 'report-creator',
  DELETE: 'delete'
});
/* harmony default export */ var StudyManagervue_type_script_lang_js_ = (Vue.extend({
  components: {
    DeleteDialog: Delete,
    DetailsDialog: Details,
    EditDialog: Edit,
    ExpandCollapseButtons: ExpandCollapseButtons,
    TableRow: TableRow
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    detailsDialogFields: {
      type: Object,
      required: false,
      default: () => {
        return {
          timestamp: false,
          duration: false,
          device: false,
          location: false,
          total_samples: false,
          notes: false,
          gateway: false,
          sampling_interval: false,
          termination_reason: false
        };
      }
    },
    footerProps: {
      type: Object,
      required: false,
      default: () => ({
        'items-per-page-options': [10, 25, 50]
      })
    },
    intervalRequest: {
      type: Number,
      required: false,
      default: 0
    },
    itemPerPage: {
      type: Number,
      required: false,
      default: () => 10
    },
    showCancelBtn: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showDetailsBtn: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showEditBtn: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showExportBtn: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showSendToReportCreatorBtn: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showDeleteBtn: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showDoneBtn: {
      type: Boolean,
      required: false,
      default: () => true
    },
    sortBy: {
      type: String,
      required: false,
      default: undefined
    },
    sortDesc: {
      type: Boolean,
      required: false,
      default: false
    },
    studiesLeftToComplete: {
      type: Number,
      required: false
    },
    tableHeight: {
      type: [Number, String],
      required: false,
      default: 'calc(100vh - 320px)'
    }
  },
  data() {
    return {
      currentItems: [],
      selected: [],
      expanded: [],
      search: '',
      dialogDelete: false,
      dialogDetails: false,
      dialogEdit: false,
      actionItem: {},
      ApiRequestInterval: null,
      sessionStartTime: new Date().toISOString(),
      studiesHaveBeenFetched: false
    };
  },
  computed: {
    ...(0,external_Vuex_namespaceObject.mapGetters)('studyManager', ['getCompleteStudies']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    expandableStudies() {
      return this.getCompleteStudies.filter(study => {
        return !!study.children.length;
      });
    },
    enableExpandCollapseButtons() {
      return !!this.expandableStudies.length;
    },
    allCurrentStudies() {
      return this.currentItems.flatMap(study => [study, ...study.children]);
    },
    allStudiesFlat() {
      return this.getCompleteStudies.flatMap(study => [study, ...study.children]);
    },
    selectedStudies() {
      return this.allStudiesFlat.filter(study => this.selected.includes(study._id));
    },
    selectedStudiesForReportCreator() {
      return this.selectedStudies.filter(study => study.study_type !== EMPTY_PARENT);
    },
    allCurrentStudiesSelected() {
      return this.allCurrentStudies.length && this.allCurrentStudies.every(study => this.selected.includes(study._id));
    },
    someCurrentStudiesSelected() {
      return this.selected.length > 0 && this.selected.length !== this.allCurrentStudies.length;
    },
    selectAllLabel() {
      return this.isMobile ? this.$t('studyManager.selectAllLabel') : '';
    },
    disableSendToReportCreatorAction() {
      if (this.studiesLeftToComplete === undefined) {
        return false;
      }
      return this.studiesLeftToComplete === 0;
    },
    disableSendToReportCreatorBulkAction() {
      return this.selectedStudiesForReportCreator.length === 0 || this.selectedStudiesForReportCreator.length > this.studiesLeftToComplete || this.studiesLeftToComplete === 0;
    },
    actionsMenu() {
      const actions = [];
      if (this.showDetailsBtn) actions.push({
        key: actionKeys.DETAILS,
        action: this.detailsAction,
        icon: 'mdi-eye',
        title: this.$t('studyManager.actionItems.details'),
        dataCy: 'studyDetailsButton'
      });
      if (this.showEditBtn) actions.push({
        key: actionKeys.EDIT,
        action: this.editAction,
        icon: 'mdi-pencil',
        title: this.$t('studyManager.actionItems.edit'),
        dataCy: 'studyEditButton'
      });
      if (this.showExportBtn) actions.push({
        key: actionKeys.EXPORT,
        bulkAction: () => {},
        action: this.exportAction,
        icon: 'mdi-upload',
        title: this.$t('studyManager.actionItems.export'),
        disabled: false,
        dataCy: 'studyExportButton'
      });
      if (this.showSendToReportCreatorBtn) actions.push({
        key: actionKeys.REPORT_CREATOR,
        action: this.sendToReportCreatorAction,
        icon: 'mdi-clipboard-arrow-right',
        title: this.$t('studyManager.actionItems.sendToReportCreator'),
        disabled: this.disableSendToReportCreatorAction,
        dataCy: 'studyERCButton'
      });
      if (this.showDeleteBtn) actions.push({
        key: actionKeys.DELETE,
        bulkAction: this.deleteBulkAction,
        action: this.deleteAction,
        class: 'deleteBtn',
        icon: 'mdi-delete',
        title: this.$t('studyManager.actionItems.delete'),
        disabled: false,
        dataCy: 'studyDeleteButton'
      });
      return actions;
    },
    bulkActionsMenu() {
      return this.actionsMenu.filter(action => action.bulkAction);
    },
    generateColumns() {
      let columns;
      if (this.actionsMenu.length === 0) {
        columns = this.columns.map(column => {
          if (column.value === 'actions') {
            column.align = ' d-none';
          }
          return column;
        });
      } else {
        columns = this.columns.map(column => {
          if (column.value === 'actions') {
            column.align = 'center';
          }
          return column;
        });
      }
      const defaultColumns = [{
        text: '',
        value: 'data-table-select',
        class: 'select-header'
      }, {
        text: '',
        value: 'data-table-expand',
        class: 'expand-header'
      }];
      return [...defaultColumns, ...columns];
    },
    showSearchBar() {
      return this.selected.length <= 0;
    },
    deviceNamesInError() {
      const sbNames = this.smartBridgeOffline.map(serial => this.$t('studyManager.uploadError.smartBridge', {
        serial
      }));
      const dtNames = this.dustTrakDisconnected.map(serial => this.$t('studyManager.uploadError.dustTrak', {
        serial
      }));
      const deviceNames = [...sbNames, ...dtNames];
      return deviceNames.join(', ');
    }
  },
  created() {
    this.registerModule();
  },
  mounted() {
    const isAuthenticated = this.$auth.isAuthenticated;
    if (isAuthenticated) {
      this.createIntervalAndGetData();
    } else {
      // Request API endpoint if the user is authenticated
      this.$auth.$on(fusion_auth_common.AuthEvents.AUTH_CHANGED, async isAuthenticated => {
        if (isAuthenticated) {
          this.createIntervalAndGetData();
        }
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.ApiRequestInterval);
  },
  methods: {
    ...(0,external_Vuex_namespaceObject.mapActions)('studyManager', ['requestStudies', 'setSelectedItems']),
    async registerModule() {
      const hasModule = this.$store.hasModule('studyManager');
      if (!hasModule) {
        this.$store.registerModule('studyManager', StudyManager_module);
      }
    },
    searchFilter(value, search) {
      // Based on Vuetify defaultFilter
      // https://github.com/vuetifyjs/vuetify/blob/v2.7.2/packages/vuetify/src/util/helpers.ts#L356
      return !!value && !!search && typeof value !== 'boolean' && value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
    },
    filterChildren(search, items) {
      return items.some(child => Object.keys(child).some(key => this.searchFilter(child[key], search)));
    },
    filterParentAndChildren(value, search, item) {
      return this.searchFilter(value, search) || this.filterChildren(search, item.children);
    },
    createIntervalAndGetData() {
      this.generateData();
      if (this.intervalRequest > 0) {
        this.ApiRequestInterval = setInterval(this.generateData, Number(this.intervalRequest * 1000));
      }
    },
    async generateData() {
      await this.requestStudies({
        clientURL: this.$components.studiesAPIHostV3,
        i18n: this.$i18n
      });
      await Vue.nextTick();
      this.studiesHaveBeenFetched = true;
    },
    filterActionsMenu(item) {
      if (item.is_shared) {
        return this.actionsMenu.filter(action => action.key === actionKeys.DETAILS || action.key === actionKeys.REPORT_CREATOR);
      }
      if (item.study_type === EMPTY_PARENT) {
        return this.actionsMenu.filter(action => action.key !== actionKeys.REPORT_CREATOR && action.key !== actionKeys.DETAILS && action.key !== actionKeys.EXPORT);
      }
      return this.actionsMenu;
    },
    cancelBtnAction() {
      this.selected = [];
      this.$emit('cancelBtnAction');
    },
    doneBtnAction() {
      this.$emit('doneBtnAction', this.selectedStudies);
      this.selected = [];
    },
    detailsAction(item) {
      this.setSelectedItems([item]);
      this.dialogDetails = true;
    },
    editAction(item) {
      this.setSelectedItems([item]);
      this.dialogEdit = true;
    },
    exportAction(item) {
      // TODO: Export method
    },
    sendToReportCreatorAction(item) {
      this.$emit('reportCreatorAction', item);
    },
    sendToReportCreatorBulkAction() {
      if (this.selectedStudiesForReportCreator.length > 0) {
        this.$emit('reportCreatorAction', this.selectedStudiesForReportCreator);
      }
    },
    deleteAction(item) {
      this.setSelectedItems([item]);
      this.dialogDelete = true;
    },
    deleteBulkAction() {
      this.setSelectedItems(this.selectedStudies);
      this.dialogDelete = true;
    },
    closeDialogDetails() {
      this.dialogDetails = false;
    },
    closeDialogEdit() {
      this.dialogEdit = false;
    },
    closeDialogDelete(clearSelectedItems) {
      if (clearSelectedItems) {
        this.selected = [];
      }
      this.dialogDelete = false;
    },
    expandAll() {
      this.expanded = this.expandableStudies;
    },
    collapseAll() {
      this.expanded = [];
    },
    autoExpandCollapse() {
      if (!this.search) return;
      for (const item of this.currentItems) {
        if (this.filterChildren(this.search, item.children)) {
          this.expandStudy(item);
        } else {
          this.collapseStudy(item);
        }
      }
    },
    expandStudy(item) {
      const isExpanded = this.expanded.find(entry => entry._id === item._id);
      if (!isExpanded) this.expanded.push(item);
    },
    collapseStudy(item) {
      this.expanded = this.expanded.filter(entry => entry._id !== item._id);
    },
    toggleSelectAll() {
      if (this.allCurrentStudiesSelected) {
        this.selected = [];
      } else {
        const difference = this.allCurrentStudies.filter(study => !this.selected.includes(study._id));
        this.selected = [...this.selected, ...difference.map(study => study._id)];
        this.expandAll();
      }
    },
    toggleSelectStudy(studyId) {
      if (this.isStudySelected(studyId)) {
        this.deselectStudy(studyId);
      } else {
        this.selectStudy(studyId);
      }
    },
    deselectStudy(studyId) {
      const index = this.selected.findIndex(id => id === studyId);
      if (index > -1) {
        this.selected.splice(index, 1);
      }
    },
    selectStudy(studyId) {
      if (!this.selected.includes(studyId)) {
        this.selected.push(studyId);
      }
    },
    isStudySelected(studyId) {
      return this.selected.includes(studyId);
    },
    handleCurrentItems(items) {
      this.currentItems = items;
      this.autoExpandCollapse();
    }
  },
  watch: {
    intervalRequest(value) {
      if (value <= 0) {
        clearInterval(this.ApiRequestInterval);
      } else {
        this.createIntervalAndGetData();
      }
    },
    search(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.collapseAll();
      }
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/StudyManager/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_StudyManagervue_type_script_lang_js_ = (StudyManagervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StudyManager/index.vue?vue&type=style&index=0&id=34270abf&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/StudyManager/index.vue?vue&type=style&index=0&id=34270abf&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/StudyManager/index.vue



;


/* normalize component */

var StudyManager_component = normalizeComponent(
  components_StudyManagervue_type_script_lang_js_,
  StudyManagervue_type_template_id_34270abf_scoped_true_render,
  StudyManagervue_type_template_id_34270abf_scoped_true_staticRenderFns,
  false,
  null,
  "34270abf",
  null
  
)

/* harmony default export */ var StudyManager = (StudyManager_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/RemoveWarningDialog/index.vue?vue&type=template&id=bd04c0f2&
var RemoveWarningDialogvue_type_template_id_bd04c0f2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fusion-dialog',{attrs:{"open":_vm.open,"data-cy":"removeWarningDialog","persistentOverlay":true,"fullscreen":_vm.$vuetify.breakpoint.xs,"content-class":"removeWarning","maxWidth":450},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-btn',{staticClass:"black--text dialog-btn",attrs:{"v-if":_vm.$vuetify.breakpoint.xs,"text":"","outlined":"","data-cy":"removeWidgetCancel"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.$t('buttons.cancel'))+" ")]),_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text dialog-btn",attrs:{"text":"","data-cy":"removeWidgetOK"},on:{"click":_vm.remove}},[_vm._v(" "+_vm._s(_vm.$t('dashboard.removeWarningDialog.removeButton'))+" ")])]},proxy:true}])},[_c('v-card-title',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"header-icon"},[_vm._v("mdi-alert")]),_vm._v(" "+_vm._s(_vm.$t('dashboard.removeWarningDialog.title'))+" ")],1),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t('dashboard.removeWarningDialog.message'))+" ")])],1)}
var RemoveWarningDialogvue_type_template_id_bd04c0f2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/RemoveWarningDialog/index.vue?vue&type=script&lang=js&
/* harmony default export */ var RemoveWarningDialogvue_type_script_lang_js_ = ({
  props: ['open'],
  methods: {
    remove() {
      this.$emit('ok');
    },
    cancel() {
      this.$emit('cancel');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Dashboard/RemoveWarningDialog/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var Dashboard_RemoveWarningDialogvue_type_script_lang_js_ = (RemoveWarningDialogvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dashboard/RemoveWarningDialog/index.vue?vue&type=style&index=0&id=bd04c0f2&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Dashboard/RemoveWarningDialog/index.vue?vue&type=style&index=0&id=bd04c0f2&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/Dashboard/RemoveWarningDialog/index.vue



;


/* normalize component */

var RemoveWarningDialog_component = normalizeComponent(
  Dashboard_RemoveWarningDialogvue_type_script_lang_js_,
  RemoveWarningDialogvue_type_template_id_bd04c0f2_render,
  RemoveWarningDialogvue_type_template_id_bd04c0f2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RemoveWarningDialog = (RemoveWarningDialog_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Appbar/index.vue?vue&type=template&id=c968870e&scoped=true&
var Appbarvue_type_template_id_c968870e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"no-padding",attrs:{"clipped-left":_vm.drawerClipped,"dark":"","app":""}},[_vm._t("burger",function(){return [(_vm.showHamburger)?_c('v-app-bar-nav-icon',{staticClass:"mx-0 text",attrs:{"x-large":"","color":_vm.$vuetify.theme.currentTheme.textAlternate,"data-cy":"hamburgerButton"},on:{"click":function($event){$event.stopPropagation();return _vm.drawerClick.apply(null, arguments)}}}):_vm._e()]}),_c('v-img',{staticClass:"logo mr-4",class:{
      'small-logo': _vm.$vuetify.breakpoint.sm || _vm.$vuetify.breakpoint.smAndDown
    },attrs:{"contain":"","src":_vm.logoSrc,"width":_vm.logoWidth,"transition":"scale-transition","data-cy":"logoImage"}}),_c('v-progress-linear',{attrs:{"active":_vm.isLoading,"background-opacity":_vm.progress.opacity,"buffer-value":_vm.progress.bufferVal,"height":_vm.progress.height,"color":"light-blue","indeterminate":"","absolute":"","bottom":"","data-cy":"appBarProgress"}}),_vm._t("left-toolbar"),_c('v-spacer'),_vm._t("right-toolbar")],2)}
var Appbarvue_type_template_id_c968870e_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Appbar/index.vue?vue&type=script&lang=js&
/* harmony default export */ var Appbarvue_type_script_lang_js_ = (Vue.extend({
  props: {
    logoSrc: {
      type: String,
      default: ''
    },
    logoWidth: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    hasDrawer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      progress: {
        opacity: 0.3,
        bufferVal: 100,
        height: 4
      }
    };
  },
  computed: {
    showHamburger() {
      return this.hasDrawer && this.$vuetify.breakpoint.lgAndDown;
    },
    drawerClipped() {
      return this.$vuetify.breakpoint.mdAndUp;
    }
  },
  methods: {
    drawerClick() {
      this.$emit('drawerClicked');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Appbar/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Appbarvue_type_script_lang_js_ = (Appbarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Appbar/index.vue?vue&type=style&index=0&id=c968870e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Appbar/index.vue?vue&type=style&index=0&id=c968870e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Appbar/index.vue



;


/* normalize component */

var Appbar_component = normalizeComponent(
  components_Appbarvue_type_script_lang_js_,
  Appbarvue_type_template_id_c968870e_scoped_true_render,
  Appbarvue_type_template_id_c968870e_scoped_true_staticRenderFns,
  false,
  null,
  "c968870e",
  null
  
)

/* harmony default export */ var Appbar = (Appbar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Sidebar/index.vue?vue&type=template&id=33951163&scoped=true&
var Sidebarvue_type_template_id_33951163_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_vm._l((_vm.routes),function(route,i){return [(route.meta.locations.includes('sidebar') && route.meta.navigable && (_vm.isPermitted(route.meta.routePermissions.slugs) || route.meta.routePermissions.alwaysVisible))?_c('v-list-item',{key:i,class:{ restrictedContent: !_vm.isActive(route) },attrs:{"to":route.path,"inactive":!_vm.isActive(route),"exact":"","router":"","data-cy":"sideBar"}},[(_vm.isPermitted(route.meta.routePermissions.slugs))?[(route.meta.icon)?_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(route.meta.icon))])],1):_vm._e(),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(route.meta.title)))])],1)]:[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(route.meta.icon)?_c('v-list-item-action',_vm._g(_vm._b({},'v-list-item-action',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s(route.meta.icon))])],1):_vm._e(),_c('v-list-item-content',_vm._g(_vm._b({},'v-list-item-content',attrs,false),on),[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(route.meta.title)))])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t(route.meta.upgradeText)))])])]],2):_vm._e()]})],2)}
var Sidebarvue_type_template_id_33951163_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Sidebar/index.vue?vue&type=script&lang=js&
/* harmony default export */ var Sidebarvue_type_script_lang_js_ = (Vue.extend({
  props: {
    routes: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isPermitted(slug) {
      var _this$$permissions;
      return (_this$$permissions = this.$permissions) === null || _this$$permissions === void 0 ? void 0 : _this$$permissions.isAllowed(slug);
    },
    isActive(route) {
      return this.isPermitted(route.meta.routePermissions.slugs) && !route.inactive;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Sidebar/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Sidebarvue_type_script_lang_js_ = (Sidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Sidebar/index.vue?vue&type=style&index=0&id=33951163&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Sidebar/index.vue?vue&type=style&index=0&id=33951163&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Sidebar/index.vue



;


/* normalize component */

var Sidebar_component = normalizeComponent(
  components_Sidebarvue_type_script_lang_js_,
  Sidebarvue_type_template_id_33951163_scoped_true_render,
  Sidebarvue_type_template_id_33951163_scoped_true_staticRenderFns,
  false,
  null,
  "33951163",
  null
  
)

/* harmony default export */ var Sidebar = (Sidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dialog/index.vue?vue&type=template&id=6cba9dd7&scoped=true&
var Dialogvue_type_template_id_6cba9dd7_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"content-class":_vm.contentClass,"max-width":_vm.maxWidth ? _vm.maxWidth : 520,"max-height":_vm.maxHeight ? _vm.maxHeight : 800,"fullscreen":_vm.$vuetify.breakpoint.xs,"hide-overlay":_vm.persistent,"persistent":_vm.persistent || _vm.persistentOverlay,"no-click-animation":_vm.persistent,"scrollable":""},on:{"input":_vm.close},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("activator",null,null,on)]}}],null,true),model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',{class:{ mobile: _vm.$vuetify.breakpoint.xs, 'vertical-center': _vm.verticalCenter }},[(!_vm.noHeader)?_vm._t("header",function(){return [_c('v-card-title',[(_vm.icon)?_c('v-icon',{staticClass:"header-icon"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)]}):_vm._e(),_c('fusion-scroll',[_c('v-card-text',{class:{
          noHeader: _vm.noHeader,
          mobile: _vm.$vuetify.breakpoint.xs,
          padded: _vm.padded
        }},[_vm._t("default")],2)],1),(_vm.isErrored)?_c('v-card-actions',{staticClass:"errors",attrs:{"text":""}},[_c('div',{staticClass:"hint-text err-font"},[_vm._v(_vm._s(_vm.error))])]):_vm._e(),(!_vm.noActions)?_c('v-card-actions',{staticClass:"actions",attrs:{"text":""}},[_vm._t("actions")],2):_vm._e()],2)],1)}
var Dialogvue_type_template_id_6cba9dd7_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dialog/index.vue?vue&type=script&lang=js&
/* harmony default export */ var Dialogvue_type_script_lang_js_ = (Vue.extend({
  props: {
    open: Boolean,
    error: String,
    maxWidth: Number,
    maxHeight: Number,
    title: String,
    noHeader: Boolean,
    noActions: Boolean,
    noMessage: Boolean,
    persistent: Boolean,
    persistentOverlay: Boolean,
    padded: Boolean,
    'content-class': String,
    icon: String,
    verticalCenter: Boolean
  },
  data() {
    return {
      isOpen: this.open,
      isErrored: !!this.error
    };
  },
  watch: {
    open() {
      this.isOpen = this.open;
    },
    error() {
      this.isErrored = !!this.error;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Dialog/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Dialogvue_type_script_lang_js_ = (Dialogvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dialog/index.vue?vue&type=style&index=0&id=6cba9dd7&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Dialog/index.vue?vue&type=style&index=0&id=6cba9dd7&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Dialog/index.vue



;


/* normalize component */

var Dialog_component = normalizeComponent(
  components_Dialogvue_type_script_lang_js_,
  Dialogvue_type_template_id_6cba9dd7_scoped_true_render,
  Dialogvue_type_template_id_6cba9dd7_scoped_true_staticRenderFns,
  false,
  null,
  "6cba9dd7",
  null
  
)

/* harmony default export */ var Dialog = (Dialog_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Feedback/FeedbackDialog/index.vue?vue&type=template&id=e5636000&
var FeedbackDialogvue_type_template_id_e5636000_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog',{attrs:{"open":_vm.open,"data-cy":"feedbackDialog","persistent":!_vm.$vuetify.breakpoint.sm,"persistentOverlay":_vm.$vuetify.breakpoint.sm,"content-class":"feedback","maxWidth":450},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('v-icon',{staticClass:"header-icon"},[_vm._v("mdi-bullhorn")]),_vm._v(" "+_vm._s(_vm.$t('feedback.feedbackDialog.feedback'))+" ")],1),(!_vm.sent)?_c(_vm.userMessage,{tag:"component",attrs:{"data-cy":"feedbackUserMessage"},on:{"close":_vm.close}}):_vm._e()]},proxy:true},(_vm.sent)?{key:"actions",fn:function(){return [_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"doneFeedback"},on:{"click":function($event){return _vm.close()}}},[_vm._v(_vm._s(_vm.$t('buttons.done')))])]},proxy:true}:{key:"actions",fn:function(){return [_c('v-btn',{staticClass:"black--text",attrs:{"v-if":_vm.$vuetify.breakpoint.xs,"disabled":_vm.sending,"text":"","outlined":"","data-cy":"cancelFeedback"},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('buttons.cancel')))]),_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"loading":_vm.sending,"disabled":_vm.submitDisabled,"text":"","data-cy":"submitFeedback"},on:{"click":function($event){return _vm.submitFeedback()}}},[_vm._v(_vm._s(_vm.$t('buttons.submit')))])]},proxy:true}],null,true)},[(_vm.sent)?[_c('p',{attrs:{"data-cy":"feedbackSuccessMessage"}},[_vm._v(_vm._s(_vm.$t('feedback.feedbackDialog.messages.success')))])]:[_c('v-text-field',{attrs:{"data-cy":"feedbackSubject","label":_vm.$t('feedback.feedbackDialog.subject')},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_c('v-textarea',{attrs:{"outlined":"","no-resize":"","label":_vm.$t('feedback.feedbackDialog.message'),"data-cy":"feedbackMessage"},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}),(_vm.showErrors)?_c('div',{staticClass:"error-text"},_vm._l((_vm.errors),function(error){return _c('p',{key:error.id},[_vm._v(_vm._s(error))])}),0):_vm._e()]],2)}
var FeedbackDialogvue_type_template_id_e5636000_staticRenderFns = []


;// CONCATENATED MODULE: ./src/utils/logInAs.js
const LOG_IN_AS_HEADER_NAMES = Object.freeze({
  LOG_IN_AS: 'X-Log-in-as',
  ACCOUNT_ID: 'X-Account-Id',
  USER_ID: 'X-User-Id'
});
const LOG_IN_AS_HEADER_USER_VALUES = Object.freeze({
  [LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID]: 'accountId',
  [LOG_IN_AS_HEADER_NAMES.USER_ID]: 'userId'
});
const PATH_PARAMS = Object.freeze({
  ACCOUNT_ID: 'accountId',
  USER_ID: 'userId'
});
const getLogInAsHeaders = (headersArray, loggedInAsUser) => {
  const headers = {};
  if (headersArray !== null && headersArray !== void 0 && headersArray.length && loggedInAsUser !== null && loggedInAsUser !== void 0 && loggedInAsUser.accountId) {
    headers[LOG_IN_AS_HEADER_NAMES.LOG_IN_AS] = true;
    headersArray.forEach(key => {
      if (loggedInAsUser[LOG_IN_AS_HEADER_USER_VALUES[key]]) {
        headers[key] = loggedInAsUser[LOG_IN_AS_HEADER_USER_VALUES[key]];
      }
    });
  }
  return headers;
};
const getLogInAsUrl = (url, loggedInUser, loggedInAsUser) => {
  const accountId = loggedInAsUser !== null && loggedInAsUser !== void 0 && loggedInAsUser.accountId ? loggedInAsUser.accountId : loggedInUser.accountId;
  const userId = loggedInAsUser !== null && loggedInAsUser !== void 0 && loggedInAsUser.userId ? loggedInAsUser.userId : loggedInUser.userId;
  return url.replace(PATH_PARAMS.ACCOUNT_ID, accountId).replace(PATH_PARAMS.USER_ID, userId);
};
;// CONCATENATED MODULE: ./src/components/Feedback/module/actions.js

/* harmony default export */ var Feedback_module_actions = ({
  async postFeedback({
    commit
  }, {
    $auth,
    feedbackData,
    applicationID,
    clientID,
    clientURL,
    loggedInAsUser
  }) {
    const loggedInUser = {
      accountId: await $auth.getAccountId()
    };
    const url = getLogInAsUrl(`${clientURL}/feedback/account/accountId`, loggedInUser, loggedInAsUser);
    const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID], loggedInAsUser);
    const payload = {
      ...{
        client: clientID,
        applicationId: applicationID
      },
      ...feedbackData
    };
    return axios.post(url, payload, {
      headers
    });
  },
  async postContactSupport({
    commit
  }, {
    $auth,
    contactData,
    applicationID,
    clientID,
    clientURL,
    loggedInAsUser
  }) {
    const loggedInUser = {
      accountId: await $auth.getAccountId()
    };
    const url = getLogInAsUrl(`${clientURL}/feedback/contact/account/accountId`, loggedInUser, loggedInAsUser);
    const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID], loggedInAsUser);
    const payload = {
      ...{
        client: clientID,
        applicationId: applicationID
      },
      ...contactData
    };
    return axios.post(url, payload, {
      headers
    });
  }
});
;// CONCATENATED MODULE: ./src/components/Feedback/module/getters.js
/* harmony default export */ var module_getters = ({});
;// CONCATENATED MODULE: ./src/components/Feedback/module/mutations.js
/* harmony default export */ var Feedback_module_mutations = ({});
;// CONCATENATED MODULE: ./src/components/Feedback/module/state.js
/* harmony default export */ var Feedback_module_state = ({});
;// CONCATENATED MODULE: ./src/components/Feedback/module/index.js




/* harmony default export */ var Feedback_module = ({
  namespaced: true,
  state: Feedback_module_state,
  getters: module_getters,
  mutations: Feedback_module_mutations,
  actions: Feedback_module_actions
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Feedback/FeedbackDialog/index.vue?vue&type=script&lang=js&




/* harmony default export */ var FeedbackDialogvue_type_script_lang_js_ = (Vue.extend({
  props: ['open', 'helpRoute'],
  components: {
    'base-dialog': Dialog
  },
  data() {
    return {
      registered: false,
      title: '',
      message: '',
      menu: false,
      sending: false,
      sent: false,
      errors: []
    };
  },
  computed: {
    submitDisabled() {
      return !this.title || !this.message;
    },
    userMessage() {
      const linkText = this.$t('feedback.feedbackDialog.userMessage.linkText');
      const link = this.helpRoute ? `<router-link to="${this.helpRoute}"><span @click="$emit('close')">${linkText}</span></router-link>` : linkText;
      const msg = this.$t('feedback.feedbackDialog.userMessage.text', {
        linkText: link
      });
      return {
        template: `<v-card-subtitle>${msg}</v-card-subtitle>`
      };
    },
    hasNotifications() {
      return this.$store.hasModule('notifications');
    },
    showErrors() {
      return this.errors.length > 0;
    }
  },
  methods: {
    async submitFeedback() {
      this.errors = [];
      this.sending = true;
      const fb = {
        title: this.title,
        message: this.message
      };
      const resp = await this.$store.dispatch('feedback/postFeedback', {
        $auth: this.$auth,
        feedbackData: fb,
        applicationID: this.$components.applicationID,
        clientID: this.$components.clientID,
        clientURL: this.$components.clientURL,
        loggedInAsUser: this.getLoggedInAsUser()
      });
      if (isOkResponse(resp.status)) {
        this.sent = true;
      } else {
        const message = this.$t('feedback.feedbackDialog.messages.error');
        if (this.hasNotifications) {
          addSnackbarWarning(message);
        } else {
          this.errors.push(message);
        }
      }
      this.sending = false;
    },
    close() {
      this.$emit('close');
      setTimeout(() => {
        this.clear();
      }, 1000);
    },
    clear() {
      this.title = '';
      this.message = '';
      this.sent = false;
      this.errors = [];
    },
    setMenu(val) {
      if (!val) {
        this.clear();
      }
    },
    registerFeedback() {
      const hasFeedback = this.$store.hasModule('feedback');
      if (!hasFeedback) {
        this.$store.registerModule('feedback', Feedback_module);
      }
      this.registered = true;
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getImpersonatedUser'];
    }
  },
  mounted() {
    this.registerFeedback();
  }
}));
;// CONCATENATED MODULE: ./src/components/Feedback/FeedbackDialog/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var Feedback_FeedbackDialogvue_type_script_lang_js_ = (FeedbackDialogvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Feedback/FeedbackDialog/index.vue?vue&type=style&index=0&id=e5636000&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Feedback/FeedbackDialog/index.vue?vue&type=style&index=0&id=e5636000&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/Feedback/FeedbackDialog/index.vue



;


/* normalize component */

var FeedbackDialog_component = normalizeComponent(
  Feedback_FeedbackDialogvue_type_script_lang_js_,
  FeedbackDialogvue_type_template_id_e5636000_render,
  FeedbackDialogvue_type_template_id_e5636000_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FeedbackDialog = (FeedbackDialog_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Snackbar/index.vue?vue&type=template&id=c38c1e68&scoped=true&
var Snackbarvue_type_template_id_c38c1e68_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{staticClass:"global-snackbar",attrs:{"value":_vm.show,"timeout":_vm.timeout,"vertical":_vm.vertical,"fixed":"","bottom":"","center":""},on:{"input":_vm.close},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({staticClass:"global-snackbar__btn",attrs:{"text":""},on:{"click":_vm.close}},'v-btn',attrs,false),[_vm._v(_vm._s(_vm.buttonText))])]}}])},[_c('v-icon',{staticClass:"global-snackbar__icon",class:_vm.type,attrs:{"color":_vm.iconColor,"size":"22"}},[_vm._v(_vm._s(_vm.iconSlug))]),_c('div',{staticClass:"global-snackbar__text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)}
var Snackbarvue_type_template_id_c38c1e68_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/Snackbar/module/actions.js

/* harmony default export */ var Snackbar_module_actions = ({
  addMessage({
    commit
  }, message) {
    commit('addMessage', Object.assign({
      timeout: SNACKBAR_DEFAULT_DURATION_MS
    }, message));
  },
  removeMessage({
    commit
  }) {
    commit('removeMessage');
  }
});
;// CONCATENATED MODULE: ./src/components/Snackbar/module/getters.js
/* harmony default export */ var Snackbar_module_getters = ({
  getNextMessage: state => {
    return state.messages[0];
  }
});
;// CONCATENATED MODULE: ./src/components/Snackbar/module/mutations.js
/* harmony default export */ var Snackbar_module_mutations = ({
  addMessage(state, message) {
    state.messages.push(message);
  },
  removeMessage(state) {
    state.messages.shift();
  }
});
;// CONCATENATED MODULE: ./src/components/Snackbar/module/state.js
/* harmony default export */ var Snackbar_module_state = ({
  messages: []
});
;// CONCATENATED MODULE: ./src/components/Snackbar/module/index.js




/* harmony default export */ var Snackbar_module = ({
  namespaced: true,
  state: Snackbar_module_state,
  getters: Snackbar_module_getters,
  mutations: Snackbar_module_mutations,
  actions: Snackbar_module_actions
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Snackbar/index.vue?vue&type=script&lang=js&


const COLOR_WHITE = '#ffffff';
const COLOR_RED = '#fa1717';
/* harmony default export */ var Snackbarvue_type_script_lang_js_ = (Vue.extend({
  data() {
    return {
      registered: false,
      show: false,
      enterActive: false,
      leaveActive: false,
      icons: {
        [messageTypes.INFO]: {
          slug: 'mdi-information-outline',
          color: COLOR_WHITE
        },
        [messageTypes.SUCCESS]: {
          slug: 'mdi-check-circle-outline',
          color: COLOR_WHITE
        },
        [messageTypes.WARNING]: {
          slug: 'mdi-alert',
          color: COLOR_WHITE
        },
        [messageTypes.ERROR]: {
          slug: 'mdi-alert-circle',
          color: COLOR_RED
        }
      }
    };
  },
  computed: {
    message() {
      return this.registered ? this.$store.getters['notifications/getNextMessage'] : undefined;
    },
    type() {
      return this.message ? this.message.type : '';
    },
    text() {
      return this.message ? this.message.text : '';
    },
    timeout() {
      return this.message ? this.message.timeout : -1;
    },
    iconSlug() {
      return this.message ? this.icons[this.message.type].slug : null;
    },
    iconColor() {
      return this.message ? this.icons[this.message.type].color : null;
    },
    buttonText() {
      return this.message && this.message.buttonText ? this.message.buttonText : this.$t('snackbar.defaultButtonText');
    },
    vertical() {
      return !!(this.$vuetify.breakpoint.xs || this.text.length > 150);
    }
  },
  watch: {
    message(newMessage) {
      this.show = !!newMessage;
    },
    leaveActive(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.$store.dispatch('notifications/removeMessage');
      }
    }
  },
  methods: {
    close() {
      this.show = false;
    },
    observe(el) {
      const config = {
        attributes: true,
        childList: false,
        subtree: false
      };
      const handler = mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class') {
            this.enterActive = mutation.target.classList.contains('v-snack-transition-enter-active');
            this.leaveActive = mutation.target.classList.contains('v-snack-transition-leave-active');
          }
        });
      };
      if (el instanceof Element) {
        this.observer = new MutationObserver(handler);
        this.observer.observe(el, config);
      }
    },
    registerNotifications() {
      const hasNotifications = this.$store.hasModule('notifications');
      if (!hasNotifications) {
        this.$store.registerModule('notifications', Snackbar_module);
      }
      this.registered = true;
    }
  },
  mounted() {
    this.registerNotifications();
    this.observe(this.$el.querySelector('.v-snack__wrapper'));
  },
  destroyed() {
    this.observer.disconnect();
  }
}));
;// CONCATENATED MODULE: ./src/components/Snackbar/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Snackbarvue_type_script_lang_js_ = (Snackbarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Snackbar/index.vue?vue&type=style&index=0&id=c38c1e68&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Snackbar/index.vue?vue&type=style&index=0&id=c38c1e68&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Snackbar/index.vue



;


/* normalize component */

var Snackbar_component = normalizeComponent(
  components_Snackbarvue_type_script_lang_js_,
  Snackbarvue_type_template_id_c38c1e68_scoped_true_render,
  Snackbarvue_type_template_id_c38c1e68_scoped_true_staticRenderFns,
  false,
  null,
  "c38c1e68",
  null
  
)

/* harmony default export */ var Snackbar = (Snackbar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/index.vue?vue&type=template&id=298f6d3c&scoped=true&
var HelpCentervue_type_template_id_298f6d3c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-6 help-center-card mx-auto",attrs:{"max-width":"720"}},[_c('div',{staticClass:"header-container"},[(_vm.$vuetify.breakpoint.xs && !(_vm.helpMode == _vm.modes.default))?_c('v-btn',{staticClass:"btn__header-icon",attrs:{"text":""},on:{"click":function($event){return _vm.setHelpMode(_vm.modes.default)}}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("mdi-arrow-left")])],1):_vm._e(),_c('v-card-title',{staticClass:"headline",attrs:{"data-cy":"helpCenterHeader"}},[_vm._v(_vm._s(_vm.$t('helpCenter.title')))])],1),_c('v-divider',{staticClass:"divider"}),(_vm.$vuetify.breakpoint.xs)?[(_vm.helpMode == _vm.modes.default)?[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('helpCenter.topics')))]),_c('v-btn',{staticClass:"primary--text mobile-menu",attrs:{"text":""},on:{"click":function($event){return _vm.setHelpMode(_vm.modes.solutions)}}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.solutions')))]),_c('v-btn',{staticClass:"primary--text mobile-menu",attrs:{"text":""},on:{"click":function($event){return _vm.setHelpMode(_vm.modes.resources)}}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.resources')))]),_c('v-btn',{staticClass:"primary--text mobile-menu",attrs:{"text":""},on:{"click":function($event){return _vm.setHelpMode(_vm.modes.termsAndPolicies)}}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.termsAndPolicies')))]),_c('v-btn',{staticClass:"primary--text mobile-menu",attrs:{"text":""},on:{"click":function($event){return _vm.setHelpMode(_vm.modes.releaseNotes)}}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.releaseNotes')))]),_c('v-btn',{staticClass:"primary--text mobile-menu",attrs:{"text":""},on:{"click":function($event){return _vm.setHelpMode(_vm.modes.contactSupport)}}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.contactSupport')))])]:(_vm.helpMode == _vm.modes.solutions)?_c('fusion-solutions-tab'):(_vm.helpMode == _vm.modes.resources)?_c('fusion-resources-tab'):(_vm.helpMode == _vm.modes.termsAndPolicies)?_c('fusion-terms-and-policies-tab'):(_vm.helpMode == _vm.modes.releaseNotes)?_c('fusion-latest-release-note-tab'):(_vm.helpMode == _vm.modes.contactSupport)?_c('fusion-contact-support-tab'):_vm._e()]:[_c('div',{staticClass:"actions"},[_c('v-tabs',{attrs:{"vertical":"","value":_vm.desktopHelpMode}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('helpCenter.topics')))]),_c('v-tab',{attrs:{"data-cy":"solutionsTab"}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.solutions')))]),_c('v-tab',{attrs:{"data-cy":"resourcesTab"}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.resources')))]),_c('v-tab',{attrs:{"data-cy":"termsAndPoliciesTab"}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.termsAndPolicies')))]),_c('v-tab',{attrs:{"data-cy":"releaseNotesTab"}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.releaseNotes')))]),_c('v-tab',{attrs:{"data-cy":"contactSupportTab"}},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.contactSupport')))]),_c('v-tab-item',[_c('fusion-solutions-tab')],1),_c('v-tab-item',[_c('fusion-resources-tab')],1),_c('v-tab-item',[_c('fusion-terms-and-policies-tab')],1),_c('v-tab-item',[_c('fusion-latest-release-note-tab')],1),_c('v-tab-item',[_c('fusion-contact-support-tab')],1)],1)],1)]],2)}
var HelpCentervue_type_template_id_298f6d3c_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/HelpCenter/module/actions.js

/* harmony default export */ var HelpCenter_module_actions = ({
  async getLinks({
    commit
  }, {
    applicationsAPIHost,
    applicationID
  }) {
    const result = await axios.get(`${applicationsAPIHost}/applications/${applicationID}/help`);
    if (isOkResponse(result.status)) {
      commit('setLinks', result.data);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/module/mutations.js
/* harmony default export */ var HelpCenter_module_mutations = ({
  setLinks(state, links) {
    state.links = links;
  }
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/module/state.js
/* harmony default export */ var HelpCenter_module_state = ({
  links: null
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/module/index.js



/* harmony default export */ var HelpCenter_module = ({
  namespaced: true,
  state: HelpCenter_module_state,
  mutations: HelpCenter_module_mutations,
  actions: HelpCenter_module_actions
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/index.vue?vue&type=script&lang=js&


/* harmony default export */ var HelpCentervue_type_script_lang_js_ = ({
  data() {
    return {
      helpMode: 0,
      modes: {
        default: 0,
        solutions: 1,
        resources: 2,
        termsAndPolicies: 3,
        releaseNotes: 4,
        contactSupport: 5
      }
    };
  },
  computed: {
    desktopHelpMode() {
      return this.helpMode !== 0 ? this.helpMode - 1 : 0;
    }
  },
  methods: {
    close() {
      this.setHelpMode(this.modes.default);
    },
    setHelpMode(n) {
      this.helpMode = n;
    },
    registerHelpCenterModule() {
      const hasHelpCenterModule = this.$store.hasModule('helpCenter');
      if (!hasHelpCenterModule) {
        this.$store.registerModule('helpCenter', HelpCenter_module);
      }
    }
  },
  async mounted() {
    this.registerHelpCenterModule();
    if (this.$auth.isAuthenticated) {
      await this.$store.dispatch('helpCenter/getLinks', {
        applicationsAPIHost: this.$components.applicationsAPIHost,
        applicationID: this.$components.applicationID
      });
    }
    this.$auth.$on(fusion_auth_common.AuthEvents.AUTH_CHANGED, async isAuthenticated => {
      if (isAuthenticated) {
        await this.$store.dispatch('helpCenter/getLinks', {
          applicationsAPIHost: this.$components.applicationsAPIHost,
          applicationID: this.$components.applicationID
        });
      }
    });
    const modeSelected = parseInt(this.$route.query.topic);
    if (modeSelected > 0 && modeSelected < 5) {
      this.setHelpMode(modeSelected);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_HelpCentervue_type_script_lang_js_ = (HelpCentervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/index.vue?vue&type=style&index=0&id=298f6d3c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/HelpCenter/index.vue?vue&type=style&index=0&id=298f6d3c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/index.vue?vue&type=style&index=1&id=298f6d3c&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/HelpCenter/index.vue?vue&type=style&index=1&id=298f6d3c&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/HelpCenter/index.vue



;



/* normalize component */

var HelpCenter_component = normalizeComponent(
  components_HelpCentervue_type_script_lang_js_,
  HelpCentervue_type_template_id_298f6d3c_scoped_true_render,
  HelpCentervue_type_template_id_298f6d3c_scoped_true_staticRenderFns,
  false,
  null,
  "298f6d3c",
  null
  
)

/* harmony default export */ var HelpCenter = (HelpCenter_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/SolutionsTab/index.vue?vue&type=template&id=25669323&scoped=true&
var SolutionsTabvue_type_template_id_25669323_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"solutions",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.$t('helpCenter.tabs.solutions'))+" ")]),_vm._l((_vm.links),function(link,index){return _c('div',{key:index},[_c('a',{attrs:{"text":"","data-cy":link.cypressKey},on:{"click":function($event){return _vm.navigateLink(link)}}},[_vm._v(" "+_vm._s(_vm.$t(link.displayKey))+" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-launch")])],1)])})],2)}
var SolutionsTabvue_type_template_id_25669323_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/SolutionsTab/index.vue?vue&type=script&lang=js&
/* harmony default export */ var SolutionsTabvue_type_script_lang_js_ = ({
  computed: {
    links() {
      if (this.$store.state.helpCenter) {
        return this.$store.state.helpCenter.links;
      } else {
        return [];
      }
    }
  },
  methods: {
    navigateLink(link) {
      window.open(link.url);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/SolutionsTab/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var HelpCenter_SolutionsTabvue_type_script_lang_js_ = (SolutionsTabvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/SolutionsTab/index.vue?vue&type=style&index=0&id=25669323&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/HelpCenter/SolutionsTab/index.vue?vue&type=style&index=0&id=25669323&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/HelpCenter/SolutionsTab/index.vue



;


/* normalize component */

var SolutionsTab_component = normalizeComponent(
  HelpCenter_SolutionsTabvue_type_script_lang_js_,
  SolutionsTabvue_type_template_id_25669323_scoped_true_render,
  SolutionsTabvue_type_template_id_25669323_scoped_true_staticRenderFns,
  false,
  null,
  "25669323",
  null
  
)

/* harmony default export */ var SolutionsTab = (SolutionsTab_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/ResourcesTab/index.vue?vue&type=template&id=24b11b81&scoped=true&
var ResourcesTabvue_type_template_id_24b11b81_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.$t('helpCenter.tabs.resources'))+" ")]),_c('text-tree-structure',{attrs:{"resources":_vm.resources}})],1)}
var ResourcesTabvue_type_template_id_24b11b81_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/ResourcesTab/TextTreeStructure/index.vue?vue&type=template&id=fc6a7258&scoped=true&
var TextTreeStructurevue_type_template_id_fc6a7258_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-tree-structure"},[_c('v-card-text',_vm._l((_vm.resources),function(resource,index){return _c('div',{key:index},[_c('div',{staticClass:"text-tree-structure-title"},[_vm._v(" "+_vm._s(_vm.$t(resource.title))+" ")]),_c('links',{attrs:{"links":resource.links}}),(resource.subContent)?_c('ul',_vm._l((resource.subContent),function(subContent,index){return _c('li',{key:index},[(subContent.subTitle)?_c('div',{staticClass:"text-tree-structure-subTitle"},[_vm._v(" "+_vm._s(subContent.subTitle)+" ")]):_vm._e(),_c('links',{attrs:{"links":subContent.links}})],1)}),0):_vm._e()],1)}),0)],1)}
var TextTreeStructurevue_type_template_id_fc6a7258_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/ResourcesTab/Links/index.vue?vue&type=template&id=0e3fe489&
var Linksvue_type_template_id_0e3fe489_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.links)?_c('ul',{staticClass:"links"},_vm._l((_vm.links),function(link,index){return _c('li',{key:index},[_c('a',{attrs:{"text":""},on:{"click":function($event){return _vm.navigateLink(link)}}},[_vm._v(" "+_vm._s(link.text)+" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-launch")])],1)])}),0):_vm._e()}
var Linksvue_type_template_id_0e3fe489_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/ResourcesTab/Links/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Linksvue_type_script_lang_js_ = ({
  name: 'Links',
  props: {
    links: Array
  },
  methods: {
    navigateLink(link) {
      window.open(link.url);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/Links/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var ResourcesTab_Linksvue_type_script_lang_js_ = (Linksvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/Links/index.vue





/* normalize component */
;
var Links_component = normalizeComponent(
  ResourcesTab_Linksvue_type_script_lang_js_,
  Linksvue_type_template_id_0e3fe489_render,
  Linksvue_type_template_id_0e3fe489_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Links = (Links_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/ResourcesTab/TextTreeStructure/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var TextTreeStructurevue_type_script_lang_js_ = ({
  name: 'TextTreeStructure',
  props: {
    resources: Array
  },
  components: {
    links: Links
  }
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/TextTreeStructure/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var ResourcesTab_TextTreeStructurevue_type_script_lang_js_ = (TextTreeStructurevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/ResourcesTab/TextTreeStructure/index.vue?vue&type=style&index=0&id=fc6a7258&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/TextTreeStructure/index.vue?vue&type=style&index=0&id=fc6a7258&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/TextTreeStructure/index.vue



;


/* normalize component */

var TextTreeStructure_component = normalizeComponent(
  ResourcesTab_TextTreeStructurevue_type_script_lang_js_,
  TextTreeStructurevue_type_template_id_fc6a7258_scoped_true_render,
  TextTreeStructurevue_type_template_id_fc6a7258_scoped_true_staticRenderFns,
  false,
  null,
  "fc6a7258",
  null
  
)

/* harmony default export */ var TextTreeStructure = (TextTreeStructure_component.exports);
;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/utils.js
const TSI_GET_MEDIA = 'https://tsi.com/getmedia';
const TSI_RESOURCES = 'https://tsi.com/resources';
const TSI_IEQ_APPLICATIONS = 'https://tsi.com/indoor-environments/learn';
const YOUTUBE = 'https://www.youtube.com';
const RESOURCES_TAB_CONFIGURATION = [{
  title: 'helpCenter.resources.hardwareDocumentation',
  subContent: [{
    subTitle: 'AirAssure Indoor Air Quality (IAQ) Monitor',
    links: [{
      text: 'AirAssure IAQ Monitor Operation and Maintenance Manual US',
      url: `${TSI_GET_MEDIA}/8335ca71-7966-48f2-b697-902c52b54017/AirAssure_IAQ_Op_Maint_Mnl_6015658F-US-web`
    }, {
      text: 'AirAssure IAQ Monitor Setup Video',
      url: `${YOUTUBE}/watch?v=jZbZS5HFQiI`
    }, {
      text: 'AirAssure Luftqualität-Messgerät Einrichtungs-Video',
      url: `${YOUTUBE}/watch?v=tnukYLCyQwY`
    }, {
      text: 'Appareil de mesure de la qualité de l’air intérieur AirAssure installation et configuration',
      url: `${YOUTUBE}/watch?v=NOWqjzVb9Zk`
    }, {
      text: 'AirAssure Indoor Air Quality Monitor - Spec Sheet',
      url: `${TSI_GET_MEDIA}/43145cbb-d386-40be-b307-3fe48f0cb4b3/AirAssure-IAQ_A4_5002719_RevB_Web`
    }, {
      text: 'AirAssure 8144 Series Frequently Asked Questions',
      url: `${TSI_RESOURCES}/airassure-iaq-monitors-faqs/`
    }]
  }, {
    subTitle: 'BlueSky Air Quality Monitor',
    links: [{
      text: 'BlueSky Air Quality Monitor 8143 Quick Start Guide',
      url: `${TSI_GET_MEDIA}/600af05f-d840-4e18-8af7-2010804bde91/BlueSky-Quick-Start-Guide_5x7_5002493_Trifold_Web`
    }, {
      text: 'BlueSky Air Quality Monitor 8145 Quick Start (EN, DE, FR)',
      url: `${TSI_GET_MEDIA}/f475a173-5771-4a21-85fb-302460450f41/BlueSky-Quick-Start-Guide_Model-8145_5x7_US_FR_DE_5002829_RevB_Web`
    }, {
      text: 'BlueSky Environmental Air Quality Monitors Set up Videos Guide',
      url: `${YOUTUBE}/watch?v=BFZdLYp4Qjo`
    }, {
      text: 'BlueSky Air Quality Monitor Model 8143 Operation and Maintenance Manual',
      url: `${TSI_GET_MEDIA}/a9299d7b-de37-4177-ab3b-488dfbfd2d07/BlueSky_Op_Maint_Manual_6013929`
    }, {
      text: 'BlueSky Air Quality Monitor Model 8145 Operation and Maintenance Manual',
      url: `${TSI_GET_MEDIA}/32e60649-8bf2-454e-9529-2d47277d84e9/BlueSky_Air_Quality_Monitor_8145_Mnl_6016553-US-web`
    }, {
      text: 'Cellular BlueSky 8145-CEOD/CEODEU Op. & Maint . Manual',
      url: `${TSI_GET_MEDIA}/80174870-78dc-4cc2-a5e9-36618d176737/Cellular_BlueSky_8145_Mnl_6016660-US`
    }, {
      text: 'Solar Power BlueSky 8145-SO/CS/CSEU Op. & Maint . Manual ',
      url: `${TSI_GET_MEDIA}/6548c2cc-67f1-405e-bb05-74266a053aab/Solar_Power_BlueSky_8145_Mnl_6016614`
    }, {
      text: 'BlueSky Air Quality Monitor 8143 Spec Sheet',
      url: `${TSI_GET_MEDIA}/e68b17de-52a1-4c49-a180-56c3cc4556cb/BlueSky-Air-Quality-Monitor_US_5002491_RevD_Web`
    }, {
      text: 'Obtaining the Mac Address of a BlueSky Monitor',
      url: `${TSI_GET_MEDIA}/efe3fcbb-f3ee-44b9-a5e0-7a106c720b48/BlueSky-Obtaining-Mac-Address_US_5002696_RevA_Web`
    }, {
      text: 'BlueSky Monitors - Frequently Asked Questions (FAQs)',
      url: `${TSI_RESOURCES}/bluesky-faqs/`
    }]
  }]
}, {
  title: 'helpCenter.resources.softwareDocumentation',
  links: [{
    text: 'TSI Link Solutions - BlueSky Monitor FAQs',
    url: `${TSI_RESOURCES}/bluesky-faqs/bluesky-faqs-tsi-link-solutions/`
  }, {
    text: 'TSI AirAssure and BlueSky Air Quality Monitors Data File Formatting App Note (ENVTL-001) US',
    url: `${TSI_GET_MEDIA}/7e99a9ee-dd02-4407-adc0-945ec80db28a/AirAssure_BlueSky_Data_File_Formatting-AppNote_ENVTL-001_US-web`
  }, {
    text: 'TSI Link™ Data Analyzer',
    url: 'https://go.tsi.com/l/855103/2023-04-26/2mlrvy/855103/1682502186Z2ZCKff1/TSI_Link_Data_Analyzer_Setup_Guide_6016429C_US.pdf'
  }]
}, {
  title: 'helpCenter.resources.instructionalVideos',
  links: [{
    text: 'TSI Link youtube playlist',
    url: `${YOUTUBE}/playlist?list=PLhVqGWPimcyn-4fElckZ5V0HxMM4I2WYC`
  }, {
    text: 'Air Assure youtube playlist',
    url: `${YOUTUBE}/playlist?list=PLhVqGWPimcylV2SruohRryq3akP4QxW3y`
  }, {
    text: 'Blue Sky youtube playlist',
    url: `${YOUTUBE}/playlist?list=PLhVqGWPimcylgCDEXomfHZyQdT9OVVv2K`
  }]
}, {
  title: 'helpCenter.resources.managingAccount',
  links: [{
    text: 'Renewals',
    url: `${TSI_RESOURCES}/tsi-link-subscription-renewal/`
  }]
}, {
  title: 'helpCenter.resources.caseStudies',
  links: [{
    text: 'Wildfires',
    url: `${TSI_IEQ_APPLICATIONS}/children-hospital-customer-story`
  }, {
    text: 'Arenas & Entertainment',
    url: `${TSI_IEQ_APPLICATIONS}/calgary-sports-customer-story`
  }, {
    text: 'Schools',
    url: `${TSI_IEQ_APPLICATIONS}/mps-customer-story`
  }]
}, {
  title: 'helpCenter.resources.blogPosts',
  links: [{
    text: 'TSI Blog',
    url: 'https://tsi.com/learn/blog'
  }]
}];
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/ResourcesTab/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ResourcesTabvue_type_script_lang_js_ = ({
  name: 'ResourcesTab',
  data() {
    return {
      resources: RESOURCES_TAB_CONFIGURATION
    };
  },
  components: {
    'text-tree-structure': TextTreeStructure
  }
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var HelpCenter_ResourcesTabvue_type_script_lang_js_ = (ResourcesTabvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/ResourcesTab/index.vue?vue&type=style&index=0&id=24b11b81&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/index.vue?vue&type=style&index=0&id=24b11b81&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/HelpCenter/ResourcesTab/index.vue



;


/* normalize component */

var ResourcesTab_component = normalizeComponent(
  HelpCenter_ResourcesTabvue_type_script_lang_js_,
  ResourcesTabvue_type_template_id_24b11b81_scoped_true_render,
  ResourcesTabvue_type_template_id_24b11b81_scoped_true_staticRenderFns,
  false,
  null,
  "24b11b81",
  null
  
)

/* harmony default export */ var ResourcesTab = (ResourcesTab_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/TermsAndPoliciesTab/index.vue?vue&type=template&id=645bbe3e&scoped=true&
var TermsAndPoliciesTabvue_type_template_id_645bbe3e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"termsAndPolicies",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.$t('helpCenter.tabs.termsAndPolicies'))+" ")]),_c('div',[_c('a',{attrs:{"text":"","data-cy":"tocLink"},on:{"click":_vm.navigateTermsAndCondtions}},[_vm._v(" "+_vm._s(_vm.$t('helpCenter.links.termsOfUse'))+" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-launch")])],1)]),_c('div',[_c('a',{attrs:{"text":"","data-cy":"dppLink"},on:{"click":_vm.navigateDataPrivacyPolicy}},[_vm._v(" "+_vm._s(_vm.$t('helpCenter.links.privacyPolicy'))+" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-launch")])],1)])],1)}
var TermsAndPoliciesTabvue_type_template_id_645bbe3e_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/TermsAndPoliciesTab/index.vue?vue&type=script&lang=js&
const TOC_LINK = 'https://tsi.com/terms/';
const DPP_LINK = 'https://tsi.com/terms/#PrivacyPolicy';
/* harmony default export */ var TermsAndPoliciesTabvue_type_script_lang_js_ = ({
  methods: {
    navigateTermsAndCondtions() {
      window.open(TOC_LINK);
    },
    navigateDataPrivacyPolicy() {
      window.open(DPP_LINK);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/HelpCenter/TermsAndPoliciesTab/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var HelpCenter_TermsAndPoliciesTabvue_type_script_lang_js_ = (TermsAndPoliciesTabvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HelpCenter/TermsAndPoliciesTab/index.vue?vue&type=style&index=0&id=645bbe3e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/HelpCenter/TermsAndPoliciesTab/index.vue?vue&type=style&index=0&id=645bbe3e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/HelpCenter/TermsAndPoliciesTab/index.vue



;


/* normalize component */

var TermsAndPoliciesTab_component = normalizeComponent(
  HelpCenter_TermsAndPoliciesTabvue_type_script_lang_js_,
  TermsAndPoliciesTabvue_type_template_id_645bbe3e_scoped_true_render,
  TermsAndPoliciesTabvue_type_template_id_645bbe3e_scoped_true_staticRenderFns,
  false,
  null,
  "645bbe3e",
  null
  
)

/* harmony default export */ var TermsAndPoliciesTab = (TermsAndPoliciesTab_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Feedback/ContactSupportTab/index.vue?vue&type=template&id=e61b7bc4&scoped=true&
var ContactSupportTabvue_type_template_id_e61b7bc4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"contact-support",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('helpCenter.tabs.contactSupport')))]),(_vm.sent)?[_c('v-card-text',{attrs:{"data-cy":"contactSuccessMsg"}},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('feedback.contactSupport.messageSent')))])]),_c('p',[_vm._v(_vm._s(_vm.$t('feedback.contactSupport.messages.success')))])]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"resetContact"},on:{"click":function($event){return _vm.init()}}},[_vm._v(_vm._s(_vm.$t('buttons.done')))])],1)]:[_c('fusion-scroll',[_c('v-card-text',[_c('v-form',{ref:"form"},[_c('v-text-field',{staticClass:"text-field-required",attrs:{"data-cy":"contactName","label":_vm.$t('feedback.contactSupport.fullName'),"rules":[_vm.rules.required],"disabled":!_vm.user},model:{value:(_vm.fields.fullName),callback:function ($$v) {_vm.$set(_vm.fields, "fullName", $$v)},expression:"fields.fullName"}}),_c('v-text-field',{staticClass:"text-field-required",attrs:{"data-cy":"contactSubject","label":_vm.$t('feedback.contactSupport.subject'),"rules":[_vm.rules.required],"disabled":!_vm.user},model:{value:(_vm.fields.subject),callback:function ($$v) {_vm.$set(_vm.fields, "subject", $$v)},expression:"fields.subject"}}),_c('v-textarea',{staticClass:"text-field-required",attrs:{"data-cy":"contactMessage","no-resize":"","label":_vm.$t('feedback.contactSupport.message'),"rules":[_vm.rules.required],"disabled":!_vm.user},model:{value:(_vm.fields.message),callback:function ($$v) {_vm.$set(_vm.fields, "message", $$v)},expression:"fields.message"}})],1)],1)],1),_c('v-card-text',[_c('div',{staticClass:"hint-text"},[_vm._v(_vm._s(_vm.$t('validation.requiredHelp')))]),(_vm.showErrors)?_c('div',{staticClass:"hint-text"},_vm._l((_vm.errors),function(error){return _c('span',{key:error.id},[_vm._v(_vm._s(error))])}),0):_vm._e()]),_c('v-card-actions',[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"resetContact"},on:{"click":function($event){return _vm.init()}}},[_vm._v(_vm._s(_vm.$t('buttons.reset')))]),_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"loading":_vm.sending,"disabled":_vm.submitDisabled,"text":"","data-cy":"submitContact"},on:{"click":function($event){return _vm.submitContact()}}},[_vm._v(_vm._s(_vm.$t('buttons.send')))])],1)]],2)}
var ContactSupportTabvue_type_template_id_e61b7bc4_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Feedback/ContactSupportTab/index.vue?vue&type=script&lang=js&



/* harmony default export */ var ContactSupportTabvue_type_script_lang_js_ = ({
  data() {
    return {
      registered: false,
      sending: false,
      sent: false,
      errors: [],
      fields: {
        fullName: '',
        emailAddress: '',
        subject: '',
        message: ''
      },
      rules: {
        required: value => !!value || this.$t('validation.required')
      }
    };
  },
  computed: {
    hasUserProfile() {
      return this.$store.hasModule('userProfile');
    },
    hasNotifications() {
      return this.$store.hasModule('notifications');
    },
    user() {
      return this.hasUserProfile ? this.$store.getters['userProfile/getUser'] : undefined;
    },
    fieldsValid() {
      if (this.rules.required(this.fields.fullName) !== true || this.rules.required(this.fields.subject) !== true || this.rules.required(this.fields.message) !== true) {
        return false;
      }
      return true;
    },
    showErrors() {
      return this.errors.length > 0;
    },
    submitDisabled() {
      return !this.fieldsValid;
    }
  },
  methods: {
    init() {
      if (this.user) {
        this.fields.fullName = `${this.user.firstName} ${this.user.lastName}`;
        this.fields.emailAddress = this.user.email;
      } else {
        this.fields.fullName = '';
        this.fields.emailAddress = '';
      }
      this.fields.subject = '';
      this.fields.message = '';
      this.sent = false;
      this.errors = [];
    },
    registerFeedback() {
      const hasFeedback = this.$store.hasModule('feedback');
      if (!hasFeedback) {
        this.$store.registerModule('feedback', Feedback_module);
      }
      this.registered = true;
    },
    async submitContact() {
      this.errors = [];
      this.sending = true;
      const resp = await this.$store.dispatch('feedback/postContactSupport', {
        $auth: this.$auth,
        contactData: this.fields,
        applicationID: this.$components.applicationID,
        clientID: this.$components.clientID,
        clientURL: this.$components.clientURL,
        loggedInAsUser: this.getLoggedInAsUser()
      });
      if (isOkResponse(resp.status)) {
        this.sent = true;
      } else {
        const message = this.$t('feedback.contactSupport.messages.error');
        if (this.hasNotifications) {
          addSnackbarWarning(message);
        } else {
          this.errors.push(message);
        }
      }
      this.sending = false;
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getImpersonatedUser'];
    }
  },
  mounted() {
    this.registerFeedback();
    this.init();
  }
});
;// CONCATENATED MODULE: ./src/components/Feedback/ContactSupportTab/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var Feedback_ContactSupportTabvue_type_script_lang_js_ = (ContactSupportTabvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Feedback/ContactSupportTab/index.vue?vue&type=style&index=0&id=e61b7bc4&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Feedback/ContactSupportTab/index.vue?vue&type=style&index=0&id=e61b7bc4&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Feedback/ContactSupportTab/index.vue



;


/* normalize component */

var ContactSupportTab_component = normalizeComponent(
  Feedback_ContactSupportTabvue_type_script_lang_js_,
  ContactSupportTabvue_type_template_id_e61b7bc4_scoped_true_render,
  ContactSupportTabvue_type_template_id_e61b7bc4_scoped_true_staticRenderFns,
  false,
  null,
  "e61b7bc4",
  null
  
)

/* harmony default export */ var ContactSupportTab = (ContactSupportTab_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/index.vue?vue&type=template&id=5fe47ce6&scoped=true&
var AccountDetailsvue_type_template_id_5fe47ce6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"no-top-padding action-card",attrs:{"flat":"","height":"100%"}},[_c('v-card-text',{staticClass:"buffered-content no-top-padding"},[(!_vm.edit.phone && !_vm.edit.address && !_vm.edit.email)?_c('user-name',{ref:"name",attrs:{"edit":_vm.edit.name,"data-cy":"userName"},on:{"validated":_vm.onValidation,"edit":function($event){_vm.edit.name = true},"editDone":function($event){_vm.edit.name = false}}}):_vm._e(),(!_vm.edit.phone && !_vm.edit.address && !_vm.edit.name && !_vm.edit.email)?_c('hr'):_vm._e(),(!_vm.edit.name && !_vm.edit.address && !_vm.edit.phone)?_c('user-email',{ref:"email",attrs:{"edit":_vm.edit.email,"data-cy":"email"},on:{"validated":_vm.onValidation,"edit":function($event){_vm.edit.email = true},"editDone":function($event){_vm.edit.email = false}}}):_vm._e(),(!_vm.edit.phone && !_vm.edit.address && !_vm.edit.name && !_vm.edit.email)?_c('hr'):_vm._e(),(!_vm.edit.name && !_vm.edit.address && !_vm.edit.email)?_c('user-phone',{ref:"phone",attrs:{"edit":_vm.edit.phone,"data-cy":"phone"},on:{"validated":_vm.onValidation,"edit":function($event){_vm.edit.phone = true},"editDone":function($event){_vm.edit.phone = false}}}):_vm._e(),(!_vm.edit.phone && !_vm.edit.address && !_vm.edit.name && !_vm.edit.email)?_c('hr'):_vm._e(),(!_vm.edit.phone && !_vm.edit.name && !_vm.edit.email)?_c('user-address',{ref:"addr",attrs:{"edit":_vm.edit.address},on:{"validated":_vm.onValidation,"edit":function($event){_vm.edit.address = true},"editDone":function($event){_vm.edit.address = false}}}):_vm._e()],1),(!_vm.edit.name && !_vm.edit.phone && !_vm.edit.address && !_vm.edit.email)?_c('v-card-actions',{attrs:{"text":""}},[_c('v-spacer'),(!_vm.$vuetify.breakpoint.xs)?_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"userProfileDone"},on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t('buttons.done'))+" ")]):_vm._e()],1):_c('v-card-actions',{attrs:{"text":""}},[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"userProfileCancel"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.$t('buttons.cancel'))+" ")]),_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"disabled":!_vm.detailsValid,"loading":_vm.saving,"text":"","data-cy":"userProfileSave"},on:{"click":function($event){return _vm.save()}}},[_vm._v(" "+_vm._s(_vm.$t('buttons.save'))+" ")])],1)],1)}
var AccountDetailsvue_type_template_id_5fe47ce6_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserName/index.vue?vue&type=template&id=8c094e04&scoped=true&
var UserNamevue_type_template_id_8c094e04_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.edit)?[_c('v-card-subtitle',{staticClass:"no-top-padding d-flex flex-row align-center"},[_c('div',[_vm._v(_vm._s(_vm.$t("userProfile.accountDetails.name")))]),_c('v-spacer'),_c('v-btn',{staticStyle:{"margin-left":"16px"},attrs:{"text":"","color":"primary","data-cy":"editName"},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(" "+_vm._s(_vm.$t("buttons.edit"))+" ")])],1),_c('v-card-text',{attrs:{"data-cy":"fullName"}},[_c('strong',[_vm._v(_vm._s(_vm.fullname))])])]:[_c('v-card-text',[_c('v-row',[_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.accountDetails.firstName'),"maxlength":"255","rules":[_vm.rules.required],"data-cy":"firstName"},model:{value:(_vm.inputFirstName),callback:function ($$v) {_vm.inputFirstName=$$v},expression:"inputFirstName"}}),(!_vm.$vuetify.breakpoint.xs)?_c('v-spacer'):_vm._e(),_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.accountDetails.lastName'),"maxlength":"255","rules":[_vm.rules.required],"data-cy":"lastName"},model:{value:(_vm.inputLastName),callback:function ($$v) {_vm.inputLastName=$$v},expression:"inputLastName"}})],1)],1),_c('v-card-actions',{attrs:{"text":""}},[_c('div',{staticClass:"hint-text err-font",attrs:{"data-cy":"requiredText"}},[_vm._v(" "+_vm._s(_vm.$t("validation.requiredHelp"))+" ")])])]],2)}
var UserNamevue_type_template_id_8c094e04_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserName/index.vue?vue&type=script&lang=js&
/* harmony default export */ var UserNamevue_type_script_lang_js_ = ({
  name: 'user-name',
  props: {
    edit: Boolean
  },
  data() {
    var _this$$store, _this$$store$state, _this$$store$state$us, _this$$store$state$us2, _this$$store2, _this$$store2$state, _this$$store2$state$u, _this$$store2$state$u2;
    return {
      inputFirstName: ((_this$$store = this.$store) === null || _this$$store === void 0 ? void 0 : (_this$$store$state = _this$$store.state) === null || _this$$store$state === void 0 ? void 0 : (_this$$store$state$us = _this$$store$state.userProfile) === null || _this$$store$state$us === void 0 ? void 0 : (_this$$store$state$us2 = _this$$store$state$us.user) === null || _this$$store$state$us2 === void 0 ? void 0 : _this$$store$state$us2.firstName) || null,
      inputLastName: ((_this$$store2 = this.$store) === null || _this$$store2 === void 0 ? void 0 : (_this$$store2$state = _this$$store2.state) === null || _this$$store2$state === void 0 ? void 0 : (_this$$store2$state$u = _this$$store2$state.userProfile) === null || _this$$store2$state$u === void 0 ? void 0 : (_this$$store2$state$u2 = _this$$store2$state$u.user) === null || _this$$store2$state$u2 === void 0 ? void 0 : _this$$store2$state$u2.lastName) || null,
      fnValid: true,
      lnValid: true,
      rules: {
        required: value => !!value || this.$t('validation.required')
      }
    };
  },
  computed: {
    firstName() {
      if (this.$store.state.userProfile.user) {
        return this.$store.state.userProfile.user.firstName;
      } else {
        return null;
      }
    },
    lastName() {
      if (this.$store.state.userProfile.user) {
        return this.$store.state.userProfile.user.lastName;
      } else {
        return null;
      }
    },
    fullname() {
      const items = [this.firstName, this.lastName].filter(item => {
        return item && item.length > 0;
      });
      return items.join(' ');
    },
    validity() {
      return this.fnValid && this.lnValid;
    }
  },
  watch: {
    inputFirstName: function (n) {
      this.fnValid = this.isValid(n);
    },
    inputLastName: function (n) {
      this.lnValid = this.isValid(n);
    },
    validity: function (v) {
      if (v) this.$emit('validated', {
        valid: true,
        type: 'name'
      });else this.$emit('validated', {
        valid: false,
        type: 'name'
      });
    },
    edit: function () {
      this.inputFirstName = this.firstName;
      this.inputLastName = this.lastName;
    }
  },
  methods: {
    async save() {
      if (!this.isValid(this.inputFirstName) || !this.isValid(this.inputLastName)) {
        return false;
      }
      const accountName = {
        firstName: this.inputFirstName,
        lastName: this.inputLastName
      };
      const loggedInAsUser = this.getLoggedInAsUser();
      await this.$store.dispatch('userProfile/patchUserFullName', {
        accountsAPIHost: this.$components.accountsAPIHost,
        userSettings: accountName,
        loggedInAsUser
      });
      await this.getUserSettings();
      this.inputFirstName = this.firstName;
      this.inputLastName = this.lastName;
      return true;
    },
    isValid(n) {
      if (this.rules.required(n) !== true) return false;
      return true;
    },
    async getUserSettings() {
      const loggedInAsUser = this.getLoggedInAsUser();
      await this.$store.dispatch('userProfile/getUser', {
        accountsAPIHost: this.$components.accountsAPIHost,
        loggedInAsUser
      });
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getIsLogInAs'] ? this.$store.getters['loginas/getImpersonatedUser'] : null;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserName/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var AccountDetails_UserNamevue_type_script_lang_js_ = (UserNamevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserName/index.vue?vue&type=style&index=0&id=8c094e04&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserName/index.vue?vue&type=style&index=0&id=8c094e04&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserName/index.vue



;


/* normalize component */

var UserName_component = normalizeComponent(
  AccountDetails_UserNamevue_type_script_lang_js_,
  UserNamevue_type_template_id_8c094e04_scoped_true_render,
  UserNamevue_type_template_id_8c094e04_scoped_true_staticRenderFns,
  false,
  null,
  "8c094e04",
  null
  
)

/* harmony default export */ var UserName = (UserName_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserAddress/index.vue?vue&type=template&id=ea8d137a&scoped=true&
var UserAddressvue_type_template_id_ea8d137a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.edit && _vm.addresses === null)?[_c('v-card-subtitle',[_vm._v(_vm._s(_vm.$t('userProfile.accountDetails.address')))]),_c('v-card-text',[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1)]:(!_vm.edit && _vm.addresses.length > 0)?_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i},[_c('v-card-subtitle',{staticClass:"d-flex flex-row align-center",attrs:{"data-cy":("addressSubtitle" + i)}},[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountDetails.address'))+" "),(address.isPrimary && address.type)?[_vm._v(" ("+_vm._s(_vm.$t('userProfile.accountDetails.isPrimary') + ' ')+" - "+_vm._s(' ' + address.type)+") ")]:(address.type)?[_vm._v("("+_vm._s(address.type)+")")]:(address.isPrimary)?[_vm._v("("+_vm._s(_vm.$t('userProfile.accountDetails.isPrimary'))+")")]:_vm._e(),_c('v-spacer'),(i === 0)?_c('v-btn',{staticStyle:{"margin-left":"16px"},attrs:{"text":"","color":"primary","data-cy":"editExistingAddress"},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(_vm._s(_vm.$t('buttons.edit')))]):_vm._e()],2),_c('v-card-text',[_c('strong',[_c('v-row',[_vm._v(_vm._s(address.name))]),_c('v-row',[_vm._v(_vm._s(address.line1))]),_c('v-row',[_vm._v(_vm._s(address.line2))]),_c('v-row',[_vm._v(" "+_vm._s(address.city)+", "+_vm._s(address.state)+" "+_vm._s(address.postalCode)+" ")]),_c('v-row',[_vm._v(_vm._s(_vm.getCountry(address.country)))])],1)])],1)}):(!_vm.edit && _vm.addresses.length === 0)?[_c('v-card-subtitle',{staticClass:"d-flex flex-row align-center"},[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountDetails.address'))+" "),_c('v-spacer'),_c('v-btn',{staticStyle:{"margin-left":"16px"},attrs:{"text":"","color":"primary","data-cy":"editAddress"},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(_vm._s(_vm.$t('buttons.edit')))])],1),_c('v-card-text',{attrs:{"data-cy":"addressEmptyMessage"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('userProfile.address.emptyMessage')))])])]:[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i},[(i !== 0)?_c('hr',{staticClass:"dashed-rule"}):_vm._e(),_c('strong',{staticStyle:{"display":"flex"}},[_vm._v(" "+_vm._s(_vm.$t('userProfile.address.address'))+" "),(address.isPrimary)?[_vm._v("("+_vm._s(_vm.$t('userProfile.accountDetails.isPrimary'))+")")]:[_c('v-spacer'),_c('v-btn',{staticClass:"primary--text",attrs:{"text":"","disabled":_vm.updating,"loading":_vm.updating},on:{"click":function () { return _vm.setPrimary(address.id); }}},[_vm._v(_vm._s(_vm.$t('userProfile.accountDetails.makePrimary')))])]],2),_c('v-row',{attrs:{"data-cy":"addressTypeExisting"}},[_c('v-col',{attrs:{"data-test":"test"}},[_c('v-radio-group',{attrs:{"data-cy":"typeAddressRadioBtns","row":""},model:{value:(address.type),callback:function ($$v) {_vm.$set(address, "type", $$v)},expression:"address.type"}},[_c('v-radio',{attrs:{"color":"primary","label":_vm.type.home,"value":_vm.type.home}}),_c('v-radio',{attrs:{"color":"primary","label":_vm.type.business,"value":_vm.type.business}})],1)],1)],1),_c('v-row',{attrs:{"data-cy":"addressCompanyExisting"}},[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.companyName'),"maxlength":"255"},model:{value:(address.name),callback:function ($$v) {_vm.$set(address, "name", $$v)},expression:"address.name"}})],1)],1),_c('v-row',{attrs:{"data-cy":"addressLine1Existing"}},[_c('v-col',[_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.address.lineOne'),"maxlength":"255","rules":[_vm.rules.required]},model:{value:(address.line1),callback:function ($$v) {_vm.$set(address, "line1", $$v)},expression:"address.line1"}})],1)],1),_c('v-row',{attrs:{"data-cy":"addressLine2Existing"}},[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.lineTwo'),"maxlength":"255"},model:{value:(address.line2),callback:function ($$v) {_vm.$set(address, "line2", $$v)},expression:"address.line2"}})],1)],1),(_vm.$vuetify.breakpoint.xs)?[_c('v-row',[_c('v-col',[_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.address.city'),"maxlength":"255","rules":[_vm.rules.required]},model:{value:(address.city),callback:function ($$v) {_vm.$set(address, "city", $$v)},expression:"address.city"}})],1)],1),_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.state'),"maxlength":"255"},model:{value:(address.state),callback:function ($$v) {_vm.$set(address, "state", $$v)},expression:"address.state"}})],1)],1)]:[_c('v-row',[_c('v-col',{attrs:{"data-cy":"addressCityExisting"}},[_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.address.city'),"maxlength":"255","rules":[_vm.rules.required]},model:{value:(address.city),callback:function ($$v) {_vm.$set(address, "city", $$v)},expression:"address.city"}})],1),_c('v-col',{attrs:{"data-cy":"addressStateExisting"}},[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.state'),"maxlength":"255"},model:{value:(address.state),callback:function ($$v) {_vm.$set(address, "state", $$v)},expression:"address.state"}})],1)],1)],(_vm.$vuetify.breakpoint.xs)?[_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.postal'),"maxlength":"9"},model:{value:(address.postalCode),callback:function ($$v) {_vm.$set(address, "postalCode", $$v)},expression:"address.postalCode"}})],1)],1),_c('v-row',[_c('v-col',[_c('v-select',{staticClass:"text-field-required",attrs:{"items":_vm.countries,"label":_vm.$t('userProfile.address.country'),"rules":[_vm.rules.required]},model:{value:(address.country),callback:function ($$v) {_vm.$set(address, "country", $$v)},expression:"address.country"}})],1)],1)]:[_c('v-row',[_c('v-col',{attrs:{"data-cy":"addressZipExisting"}},[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.postal'),"maxlength":"9"},model:{value:(address.postalCode),callback:function ($$v) {_vm.$set(address, "postalCode", $$v)},expression:"address.postalCode"}})],1),_c('v-col',{attrs:{"data-cy":"addressCountryExisting"}},[_c('v-select',{staticClass:"text-field-required",attrs:{"items":_vm.countries,"label":_vm.$t('userProfile.address.country'),"rules":[_vm.rules.required]},model:{value:(address.country),callback:function ($$v) {_vm.$set(address, "country", $$v)},expression:"address.country"}})],1)],1)],_c('v-row',{staticClass:"margin-bottom-16"},[_c('v-btn',{staticClass:"error--text",attrs:{"text":"","loading":_vm.removing || _vm.updating},on:{"click":function($event){return _vm.removeAddress(address.id)}}},[_vm._v(_vm._s(_vm.$t('userProfile.address.remove')))]),(_vm.addresses.length == i + 1 && _vm.addresses.length < 10)?[_c('v-spacer'),(!_vm.creating)?_c('v-btn',{staticClass:"primary--text",attrs:{"text":""},on:{"click":function($event){_vm.create = true}}},[_vm._v(_vm._s(_vm.$t('userProfile.address.add')))]):_vm._e()]:_vm._e()],2)],2)}),(_vm.creating)?[(_vm.addresses.length > 0)?_c('hr',{staticStyle:{"border-top":"dashed 1px","margin":"16px 0"}}):_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.$t('userProfile.address.new')))]),_c('v-row',{attrs:{"data-cy":"addressTypeNew"}},[_c('v-col',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.newAddress.type),callback:function ($$v) {_vm.$set(_vm.newAddress, "type", $$v)},expression:"newAddress.type"}},[_c('v-radio',{attrs:{"color":"primary","label":_vm.type.home,"value":_vm.type.home}}),_c('v-radio',{attrs:{"color":"primary","label":_vm.type.business,"value":_vm.type.business}})],1)],1)],1),_c('v-row',{attrs:{"data-cy":"addressCompanyNew"}},[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.companyName'),"maxlength":"255"},model:{value:(_vm.newAddress.name),callback:function ($$v) {_vm.$set(_vm.newAddress, "name", $$v)},expression:"newAddress.name"}})],1)],1),_c('v-row',{attrs:{"data-cy":"addressLine1New"}},[_c('v-col',[_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.address.lineOne'),"maxlength":"255","rules":[_vm.rules.required]},model:{value:(_vm.newAddress.line1),callback:function ($$v) {_vm.$set(_vm.newAddress, "line1", $$v)},expression:"newAddress.line1"}})],1)],1),_c('v-row',{attrs:{"data-cy":"addressLine2New"}},[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.lineTwo'),"maxlength":"255"},model:{value:(_vm.newAddress.line2),callback:function ($$v) {_vm.$set(_vm.newAddress, "line2", $$v)},expression:"newAddress.line2"}})],1)],1),(_vm.$vuetify.breakpoint.xs)?[_c('v-row',[_c('v-col',[_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.address.city'),"maxlength":"255","rules":[_vm.rules.required]},model:{value:(_vm.newAddress.city),callback:function ($$v) {_vm.$set(_vm.newAddress, "city", $$v)},expression:"newAddress.city"}})],1)],1),_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.state'),"maxlength":"255"},model:{value:(_vm.newAddress.state),callback:function ($$v) {_vm.$set(_vm.newAddress, "state", $$v)},expression:"newAddress.state"}})],1)],1)]:[_c('v-row',[_c('v-col',{attrs:{"data-cy":"addressCityNew"}},[_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.address.city'),"maxlength":"255","rules":[_vm.rules.required]},model:{value:(_vm.newAddress.city),callback:function ($$v) {_vm.$set(_vm.newAddress, "city", $$v)},expression:"newAddress.city"}})],1),_c('v-col',{attrs:{"data-cy":"addressStateNew"}},[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.state'),"maxlength":"255"},model:{value:(_vm.newAddress.state),callback:function ($$v) {_vm.$set(_vm.newAddress, "state", $$v)},expression:"newAddress.state"}})],1)],1)],(_vm.$vuetify.breakpoint.xs)?[_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.postal'),"maxlength":"9"},model:{value:(_vm.newAddress.postalCode),callback:function ($$v) {_vm.$set(_vm.newAddress, "postalCode", $$v)},expression:"newAddress.postalCode"}})],1)],1),_c('v-row',[_c('v-col',[_c('v-select',{staticClass:"text-field-required",attrs:{"items":_vm.countries,"label":_vm.$t('userProfile.address.country'),"rules":[_vm.rules.required]},model:{value:(_vm.newAddress.country),callback:function ($$v) {_vm.$set(_vm.newAddress, "country", $$v)},expression:"newAddress.country"}})],1)],1)]:[_c('v-row',[_c('v-col',{attrs:{"data-cy":"addressZipNew"}},[_c('v-text-field',{attrs:{"label":_vm.$t('userProfile.address.postal'),"maxlength":"9"},model:{value:(_vm.newAddress.postalCode),callback:function ($$v) {_vm.$set(_vm.newAddress, "postalCode", $$v)},expression:"newAddress.postalCode"}})],1),_c('v-col',{attrs:{"data-cy":"addressCountryNew"}},[_c('v-select',{staticClass:"text-field-required",attrs:{"items":_vm.countries,"label":_vm.$t('userProfile.address.country'),"rules":[_vm.rules.required]},model:{value:(_vm.newAddress.country),callback:function ($$v) {_vm.$set(_vm.newAddress, "country", $$v)},expression:"newAddress.country"}})],1)],1)]]:_vm._e()],(_vm.error && _vm.edit)?_c('v-card-actions',{staticClass:"errors",attrs:{"text":""}},[_c('div',{staticClass:"hint-text err-font"},[_vm._v(_vm._s(_vm.error))])]):_vm._e()],2)}
var UserAddressvue_type_template_id_ea8d137a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/countries.js
const countryList = [{
  value: 'us',
  text: 'United States'
}, {
  value: 'be',
  text: 'Belgium'
}, {
  value: 'bg',
  text: 'Bulgaria'
}, {
  value: 'ca',
  text: 'Canada'
}, {
  value: 'cz',
  text: 'Czechia'
}, {
  value: 'dk',
  text: 'Denmark'
}, {
  value: 'de',
  text: 'Germany'
}, {
  value: 'ee',
  text: 'Estonia'
}, {
  value: 'ie',
  text: 'Ireland'
}, {
  value: 'el',
  text: 'Greece'
}, {
  value: 'es',
  text: 'Spain'
}, {
  value: 'fr',
  text: 'France'
}, {
  value: 'hr',
  text: 'Croatia'
}, {
  value: 'it',
  text: 'Italy'
}, {
  value: 'cy',
  text: 'Cyprus'
}, {
  value: 'lv',
  text: 'Latvia'
}, {
  value: 'lt',
  text: 'Lithuania'
}, {
  value: 'lu',
  text: 'Luxembourg'
}, {
  value: 'hu',
  text: 'Hungary'
}, {
  value: 'mt',
  text: 'Malta'
}, {
  value: 'nl',
  text: 'Netherlands'
}, {
  value: 'at',
  text: 'Austria'
}, {
  value: 'pl',
  text: 'Poland'
}, {
  value: 'pt',
  text: 'Portugal'
}, {
  value: 'ro',
  text: 'Romania'
}, {
  value: 'si',
  text: 'Slovenia'
}, {
  value: 'sk',
  text: 'Slovakia'
}, {
  value: 'fi',
  text: 'Finland'
}, {
  value: 'se',
  text: 'Sweden'
}, {
  value: 'uk',
  text: 'United Kingdom'
}];
const countryLookup = {
  us: 'United States',
  be: 'Belgium',
  bg: 'Bulgaria',
  ca: 'Canada',
  cz: 'Czechia',
  dk: 'Denmark',
  de: 'Germany',
  ee: 'Estonia',
  ie: 'Ireland',
  el: 'Greece',
  es: 'Spain',
  fr: 'France',
  hr: 'Croatia',
  it: 'Italy',
  cy: 'Cyprus',
  lv: 'Latvia',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  hu: 'Hungary',
  mt: 'Malta',
  nl: 'Netherlands',
  at: 'Austria',
  pl: 'Poland',
  pt: 'Portugal',
  ro: 'Romania',
  si: 'Slovenia',
  sk: 'Slovakia',
  fi: 'Finland',
  se: 'Sweden',
  uk: 'United Kingdom'
};
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserAddress/index.vue?vue&type=script&lang=js&


/* harmony default export */ var UserAddressvue_type_script_lang_js_ = ({
  name: 'user-address',
  props: {
    edit: Boolean
  },
  data() {
    return {
      addresses: null,
      create: false,
      removing: false,
      updating: false,
      error: this.$t('validation.requiredHelp'),
      newAddress: {
        name: '',
        business: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        type: '',
        postalCode: '',
        country: ''
      },
      countries: countryList,
      type: {
        home: this.$t('userProfile.address.type.home'),
        business: this.$t('userProfile.address.type.business')
      },
      rules: {
        required: value => !!value || this.$t('validation.required')
      }
    };
  },
  mounted() {
    this.getAddresses().catch(error => {
      console.log(error);
    });
    this.error = this.$t('validation.requiredHelp');
  },
  computed: {
    newAddressValid() {
      let v = true;
      if (this.rules.required(this.newAddress.line1) !== true) v = false;
      if (this.rules.required(this.newAddress.city) !== true) v = false;
      if (this.rules.required(this.newAddress.country) !== true) v = false;
      return v;
    },
    addressesValid() {
      let v = true;
      if (this.addresses !== null) {
        for (const address of this.addresses) {
          if (this.rules.required(address.line1) !== true) v = false;
          if (this.rules.required(address.city) !== true) v = false;
          if (this.rules.required(address.country) !== true) v = false;
        }
      }
      return v;
    },
    validity() {
      return this.addressesValid && this.updating === false && (!this.creating && this.newAddress.line1 === '' || this.newAddressValid);
    },
    creating() {
      if (this.addresses === null) {
        return true;
      }
      return this.create || this.addresses.length === 0;
    }
  },
  watch: {
    edit(e) {
      if (!e) {
        this.resetFields();
        this.getAddresses();
        this.create = false;
      } else if (this.creating) {
        this.create = true;
      }
      if (this.validity) {
        this.$emit('validated', {
          valid: true,
          type: 'addr'
        });
      } else {
        this.$emit('validated', {
          valid: false,
          type: 'addr'
        });
      }
    },
    validity: function (v) {
      if (v) this.$emit('validated', {
        valid: true,
        type: 'addr'
      });else this.$emit('validated', {
        valid: false,
        type: 'addr'
      });
    }
  },
  methods: {
    async save() {
      let ok = true;
      const loggedInAsUser = this.getLoggedInAsUser();
      if (this.creating) {
        const addr = {
          ...this.newAddress
        };
        const resp = await this.$store.dispatch('userProfile/postCreateAddress', {
          accountsAPIHost: this.$components.accountsAPIHost,
          address: addr,
          loggedInAsUser
        });
        if (!isOkResponse(resp.status)) {
          ok = false;
          this.error = resp.statusText;
          setTimeout(() => {
            this.error = '';
          }, 5000);
        }
      } else {
        for (const address of this.addresses) {
          const resp = await this.$store.dispatch('userProfile/patchAddress', {
            accountsAPIHost: this.$components.accountsAPIHost,
            address,
            loggedInAsUser
          });
          if (!isOkResponse(resp.status)) {
            ok = false;
            this.error = resp.statusText;
            setTimeout(() => {
              this.error = '';
            }, 5000);
          }
        }
      }
      await this.getAddresses();
      if (ok) {
        this.resetFields();
      }
      return ok;
    },
    getCountry(code) {
      return countryLookup[code];
    },
    async removeAddress(id) {
      this.removing = true;
      const loggedInAsUser = this.getLoggedInAsUser();
      await this.$store.dispatch('userProfile/deleteAddress', {
        accountsAPIHost: this.$components.accountsAPIHost,
        addressID: id,
        loggedInAsUser
      });
      await this.getAddresses();
      this.removing = false;
      if (this.addresses.length === 0) {
        this.$emit('editDone');
      }
    },
    async setPrimary(id) {
      this.updating = true;
      const loggedInAsUser = this.getLoggedInAsUser();
      const body = {
        isPrimary: true,
        id
      };
      await this.$store.dispatch('userProfile/patchAddress', {
        accountsAPIHost: this.$components.accountsAPIHost,
        address: body,
        loggedInAsUser
      });
      await this.getAddresses();
      this.updating = false;
    },
    async getAddresses() {
      const loggedInAsUser = this.getLoggedInAsUser();
      const resp = await this.$store.dispatch('userProfile/getAddresses', {
        accountsAPIHost: this.$components.accountsAPIHost,
        loggedInAsUser
      });
      if (resp && isOkResponse(resp.status)) {
        this.addresses = resp.data;
      }
    },
    resetFields() {
      this.newAddress = {
        name: '',
        business: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        type: '',
        postalCode: '',
        country: ''
      };
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getIsLogInAs'] ? this.$store.getters['loginas/getImpersonatedUser'] : null;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserAddress/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var AccountDetails_UserAddressvue_type_script_lang_js_ = (UserAddressvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserAddress/index.vue?vue&type=style&index=0&id=ea8d137a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserAddress/index.vue?vue&type=style&index=0&id=ea8d137a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserAddress/index.vue



;


/* normalize component */

var UserAddress_component = normalizeComponent(
  AccountDetails_UserAddressvue_type_script_lang_js_,
  UserAddressvue_type_template_id_ea8d137a_scoped_true_render,
  UserAddressvue_type_template_id_ea8d137a_scoped_true_staticRenderFns,
  false,
  null,
  "ea8d137a",
  null
  
)

/* harmony default export */ var UserAddress = (UserAddress_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserPhone/index.vue?vue&type=template&id=41d73f10&scoped=true&
var UserPhonevue_type_template_id_41d73f10_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.edit && _vm.phones === null)?[_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountDetails.phone'))+" ")]),_c('v-card-text',[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1)]:(!_vm.edit && _vm.phones.length > 0)?_vm._l((_vm.phones),function(phone,i){return _c('div',{key:i},[_c('v-card-subtitle',{staticClass:"d-flex flex-row align-center"},[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountDetails.phone'))+" "),(phone.isPrimary && phone.type)?[_vm._v(" ("+_vm._s(_vm.$t('userProfile.accountDetails.isPrimary') + ' ')+" - "+_vm._s(' ' + phone.type)+") ")]:(phone.type)?[_vm._v("("+_vm._s(phone.type)+")")]:(phone.isPrimary)?[_vm._v("("+_vm._s(_vm.$t('userProfile.accountDetails.isPrimary'))+")")]:_vm._e(),_c('v-spacer'),(i === 0)?_c('v-btn',{staticStyle:{"margin-left":"16px"},attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(_vm._s(_vm.$t('buttons.edit')))]):_vm._e()],2),_c('v-card-text',[_c('strong',[_vm._v(_vm._s(phone.number))])])],1)}):(!_vm.edit && _vm.phones.length === 0)?[_c('v-card-subtitle',{staticClass:"d-flex flex-row align-center"},[_vm._v(" "+_vm._s(_vm.$t('userProfile.accountDetails.phone'))+" "),_c('v-spacer'),_c('v-btn',{staticStyle:{"margin-left":"16px"},attrs:{"color":"primary","text":"","data-cy":"editPhone"},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(_vm._s(_vm.$t('buttons.edit')))])],1),_c('v-card-text',{attrs:{"data-cy":"phoneEmptyMessage"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('userProfile.phone.emptyMessage')))])])]:[_c('div',[_vm._v(_vm._s(_vm.$t('userProfile.phone.primaryChangedWarning')))]),_vm._l((_vm.phones),function(phone,i){return _c('div',{key:i},[_c('br'),_c('strong',{staticStyle:{"display":"flex"}},[_vm._v(" "+_vm._s(_vm.$t('userProfile.phone.title'))+" "),(phone.isPrimary)?[_vm._v("("+_vm._s(_vm.$t('userProfile.accountDetails.isPrimary'))+")")]:[_c('v-spacer'),_c('v-btn',{staticClass:"primary--text",attrs:{"text":"","disabled":_vm.updating,"loading":_vm.updating,"data-cy":"primaryPhone"},on:{"click":function () { return _vm.setPrimary(phone.id); }}},[_vm._v(_vm._s(_vm.$t('userProfile.accountDetails.makePrimary')))])]],2),_c('v-row',[_c('v-col',[_c('v-radio-group',{attrs:{"row":""},model:{value:(phone.type),callback:function ($$v) {_vm.$set(phone, "type", $$v)},expression:"phone.type"}},[_c('v-radio',{attrs:{"color":"primary","label":_vm.type.mobile,"value":_vm.type.mobile}}),_c('v-radio',{attrs:{"color":"primary","label":_vm.type.work,"value":_vm.type.work}}),_c('v-radio',{staticClass:"text-field-required",attrs:{"color":"primary","label":_vm.type.home,"value":_vm.type.home}})],1)],1)],1),_c('v-row',{staticStyle:{"display":"flex"}},[_c('vue-phone-number-input',{staticClass:"block-required",attrs:{"color":"#00aeef","valid-color":"#4FB74A","error-color":"#FA1717","clearable":"","default-country-code":phone.countryCode,"preferred-countries":_vm.preferredCountries,"ignored-countries":_vm.ignoredCountries,"rules":[_vm.rules.required],"error":_vm.isNumberInUse(phone.id)},on:{"update":function($event){return _vm.updateExistingPhone($event, phone)}},model:{value:(phone.input),callback:function ($$v) {_vm.$set(phone, "input", $$v)},expression:"phone.input"}})],1),_c('v-row',[(_vm.isNumberInUse(phone.id))?_c('v-card-actions',{staticClass:"errors",attrs:{"text":""}},[_c('div',{staticClass:"hint-text err-font"},[_vm._v(_vm._s(_vm.$t('validation.numberIsInUse')))])]):_vm._e()],1),_c('v-row',{staticClass:"margin-bottom-16"},[_c('v-btn',{staticClass:"error--text",attrs:{"text":"","loading":_vm.removing || _vm.updating,"data-cy":"removePhoneNumber"},on:{"click":function($event){return _vm.removePhone(phone.id)}}},[_vm._v(_vm._s(_vm.$t('userProfile.phone.remove')))]),(_vm.phones.length == i + 1 && _vm.phones.length < 10)?[_c('v-spacer'),(!_vm.create)?_c('v-btn',{staticClass:"primary--text",attrs:{"text":"","data-cy":"addAnotherPhoneNumber"},on:{"click":function($event){_vm.create = true}}},[_vm._v(_vm._s(_vm.$t('userProfile.phone.add')))]):_vm._e()]:_vm._e(),_c('br')],2)],1)}),(_vm.creating)?[_c('br'),_c('strong',[_vm._v(_vm._s(_vm.$t('userProfile.phone.new')))]),_c('v-row',[_c('v-col',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.newPhone.type),callback:function ($$v) {_vm.$set(_vm.newPhone, "type", $$v)},expression:"newPhone.type"}},[_c('v-radio',{attrs:{"color":"primary","label":_vm.type.mobile,"value":_vm.type.mobile}}),_c('v-radio',{attrs:{"color":"primary","label":_vm.type.work,"value":_vm.type.work}}),_c('v-radio',{staticClass:"text-field-required",attrs:{"color":"primary","label":_vm.type.home,"value":_vm.type.home}})],1)],1)],1),_c('v-row',{staticStyle:{"display":"flex"}},[_c('vue-phone-number-input',{staticClass:"block-required",attrs:{"color":"#00aeef","valid-color":"#4FB74A","error-color":"#FA1717","clearable":"","preferred-countries":_vm.preferredCountries,"ignored-countries":_vm.ignoredCountries,"rules":[_vm.rules.required],"error":_vm.isNumberInUse(this.newPhone.number)},on:{"update":_vm.updateNewPhone},model:{value:(_vm.newPhoneInput),callback:function ($$v) {_vm.newPhoneInput=$$v},expression:"newPhoneInput"}})],1),_c('v-row',[(_vm.isNumberInUse(this.newPhone.number))?_c('v-card-actions',{staticClass:"errors",attrs:{"text":""}},[_c('div',{staticClass:"hint-text err-font"},[_vm._v(_vm._s(_vm.$t('validation.numberIsInUse')))])]):_vm._e()],1)]:_vm._e()],(_vm.error && _vm.edit)?_c('v-card-actions',{staticClass:"errors",attrs:{"text":"","data-cy":"requiredText"}},[_c('div',{staticClass:"hint-text err-font"},[_vm._v(_vm._s(_vm.error))])]):_vm._e()],2)}
var UserPhonevue_type_template_id_41d73f10_scoped_true_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/vue-phone-number-input/dist/vue-phone-number-input.common.js
var vue_phone_number_input_common = __webpack_require__(328);
var vue_phone_number_input_common_default = /*#__PURE__*/__webpack_require__.n(vue_phone_number_input_common);
;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserPhone/phone-dialcodes.js
const countryDialCodeToIso = {
  1: 'US',
  32: 'BE',
  359: 'BG',
  420: 'CZ',
  45: 'DK',
  49: 'DE',
  372: 'EE',
  353: 'IE',
  34: 'ES',
  33: 'FR',
  385: 'HR',
  39: 'IT',
  357: 'CY',
  371: 'LV',
  370: 'LT',
  352: 'LU',
  36: 'HU',
  356: 'MT',
  31: 'NL',
  43: 'AT',
  48: 'PL',
  351: 'PT',
  40: 'RO',
  386: 'SI',
  421: 'SK',
  358: 'FI',
  46: 'SE',
  44: 'GB',
  7: 'KZ'
};
const convertCountryDialCodeToIso = dialCode => {
  return (countryDialCodeToIso === null || countryDialCodeToIso === void 0 ? void 0 : countryDialCodeToIso[dialCode]) || 'US';
};
const parseDialcodePhoneNumber = phoneNumber => {
  if (phoneNumber && phoneNumber.length >= 12 && phoneNumber.length <= 14) {
    const num = phoneNumber.substr(phoneNumber.length - 10);
    const dc = phoneNumber.substring(0, phoneNumber.length - num.length).replace('+', '');
    return {
      dialCode: dc,
      number: num,
      part1: num.substring(0, 3),
      part2: num.substring(3, 6),
      part3: num.substring(6, 10)
    };
  } else {
    return {
      dialCode: '1',
      number: '',
      part1: '',
      part2: '',
      part3: ''
    };
  }
};
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserPhone/index.vue?vue&type=script&lang=js&




/* harmony default export */ var UserPhonevue_type_script_lang_js_ = ({
  name: 'user-phone',
  components: {
    'vue-phone-number-input': (vue_phone_number_input_common_default())
  },
  props: {
    edit: Boolean
  },
  data() {
    return {
      phones: null,
      create: false,
      removing: false,
      updating: false,
      error: this.$t('validation.requiredHelp'),
      numberInUseWarning: {},
      newPhone: {
        number: '',
        formatNational: '',
        countryCode: '',
        countryCallingCode: '',
        isValid: false,
        type: ''
      },
      newPhoneInput: '',
      preferredCountries: ['US', 'GB', 'CA', 'FR', 'AX'],
      ignoredCountries: ['AF', 'AO', 'BH', 'BY', 'MM', 'BI', 'CF', 'TD', 'CN', 'CD', 'CG', 'CI', 'CU', 'CY', 'ER', 'ET', 'GW', 'HT', 'HK', 'IR', 'IQ', 'KP', 'LB', 'LR', 'LY', 'ML', 'NI', 'RU', 'RW', 'WS', 'SL', 'SO', 'ZA', 'SS', 'SD', 'SY', 'UA', 'VE', 'YE', 'ZW'],
      type: {
        mobile: this.$t('userProfile.phone.type.mobile'),
        work: this.$t('userProfile.phone.type.work'),
        home: this.$t('userProfile.phone.type.home')
      },
      rules: {
        required: value => !!value || this.$t('validation.required'),
        phone: value => {
          return (
            // regex used: https://stackoverflow.com/questions/16699007/regular-expression-to-match-standard-10-digit-phone-number
            /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value) || this.$t('validation.invalidEntry')
          );
        }
      },
      selectedNewCountry: null
    };
  },
  mounted() {
    this.getPhones().catch(error => {
      console.log(error);
    });
  },
  computed: {
    shownCountry() {
      return this.selectedNewCountry || 'us';
    },
    newPhoneValid() {
      let v = true;
      if (!this.newPhone.isValid) v = false;
      if (this.rules.required(this.newPhone.type) !== true) v = false;
      return v;
    },
    phonesValid() {
      let v = true;
      if (this.phones !== null) {
        for (const phone of this.phones) {
          if (!phone.isValid) v = false;
          if (this.rules.required(phone.type) !== true) v = false;
        }
      }
      return v;
    },
    validity() {
      return this.phonesValid && this.updating === false && (!this.creating && this.newPhone.number === '' || this.newPhoneValid);
    },
    creating() {
      if (this.phones === null) {
        return true;
      }
      return this.create || this.phones.length === 0;
    }
  },
  watch: {
    edit(e) {
      if (!e) {
        this.resetFields();
        this.getPhones();
        this.create = false;
      } else if (this.creating) {
        this.create = true;
      }
      if (this.validity) {
        this.$emit('validated', {
          valid: true,
          type: 'phone'
        });
      } else {
        this.$emit('validated', {
          valid: false,
          type: 'phone'
        });
      }
    },
    validity: function (v) {
      if (v) this.$emit('validated', {
        valid: true,
        type: 'phone'
      });else this.$emit('validated', {
        valid: false,
        type: 'phone'
      });
    }
  },
  methods: {
    async save() {
      let ok = true;
      const phonesInUse = [];
      const loggedInAsUser = this.getLoggedInAsUser();
      if (this.creating) {
        const phone = {
          ...this.newPhone
        };
        let resp = {
          status: -1
        };
        try {
          resp = await this.$store.dispatch('userProfile/postCreatePhone', {
            accountsAPIHost: this.$components.accountsAPIHost,
            phone,
            loggedInAsUser
          });
        } catch (error) {
          console.log(error);
        }
        if (!isOkResponse(resp.status)) {
          ok = false;
          if (resp.status === 409) {
            // TODO how to share the constants
            phonesInUse.push(phone.number);
          } else {
            this.error = resp.statusText;
            setTimeout(() => {
              this.error = '';
            }, 5000);
          }
        }
      } else {
        for (const phone of this.phones) {
          if (phone.number !== phone.originalNumber || phone.countryCode !== phone.originalCountryCode || phone.type !== phone.originalType) {
            let resp = {
              status: -1
            };
            try {
              resp = await this.$store.dispatch('userProfile/patchPhone', {
                accountsAPIHost: this.$components.accountsAPIHost,
                phone,
                loggedInAsUser
              });
            } catch (error) {
              console.log(error);
            }
            if (!isOkResponse(resp.status)) {
              ok = false;
              if (resp.status === 409) {
                phonesInUse.push(phone.id);
              } else {
                this.error = resp.statusText;
                setTimeout(() => {
                  this.error = '';
                }, 5000);
              }
            }
          }
        }
      }
      if (phonesInUse) {
        this.setNumberInUseWarning(phonesInUse);
        this.error = '';
      }
      if (ok) {
        this.resetFields();
        if (this.creating) {
          this.create = false;
        }
      }
      return ok;
    },
    async removePhone(id) {
      this.removing = true;
      const loggedInAsUser = this.getLoggedInAsUser();
      try {
        await this.$store.dispatch('userProfile/deletePhone', {
          accountsAPIHost: this.$components.accountsAPIHost,
          phoneID: id,
          loggedInAsUser
        });
        await this.getPhones();
      } catch (error) {
        console.log(error);
      }
      this.removing = false;
      if (this.phones.length === 0) {
        this.$emit('editDone');
      }
    },
    async setPrimary(id) {
      this.updating = true;
      const body = {
        isPrimary: true,
        id
      };
      const loggedInAsUser = this.getLoggedInAsUser();
      try {
        await this.$store.dispatch('userProfile/patchPhone', {
          accountsAPIHost: this.$components.accountsAPIHost,
          phone: body,
          loggedInAsUser
        });
        await this.getPhones();
      } catch (error) {
        console.log(error);
      }
      this.updating = false;
    },
    async getPhones() {
      const loggedInAsUser = this.getLoggedInAsUser();
      let resp = {
        status: -1
      };
      try {
        resp = await this.$store.dispatch('userProfile/getPhones', {
          accountsAPIHost: this.$components.accountsAPIHost,
          loggedInAsUser
        });
      } catch (error) {
        console.log(error);
      }
      const phones = [];
      if (resp && isOkResponse(resp.status)) {
        const body = resp.data;
        for (let i = 0; i < body.length; i++) {
          body[i].isValid = true;
          body[i].originalNumber = body[i].number;
          body[i].originalCountryCode = body[i].countryCode;
          body[i].originalType = body[i].type;
          if (body[i].formatNational === '') {
            body[i].input = body[i].number;
          } else {
            body[i].input = body[i].formatNational;
          }
          if (body[i].countryCode === '') {
            const dialCode = parseDialcodePhoneNumber(body[i].number).dialCode;
            body[i].countryCode = convertCountryDialCodeToIso(dialCode);
          }
          if (body[i].id) {
            phones.push(body[i]);
          }
        }
        this.phones = phones;
      }
    },
    resetFields() {
      this.newPhone = {
        number: '',
        formatNational: '',
        countryCode: '',
        countryCallingCode: '',
        isValid: false,
        type: ''
      };
      this.newPhoneInput = '';
    },
    // TODO new phone input is a string, this code doesn't even make sense and doesn't appear used
    onChangeCountryNew({
      iso2,
      dialCode
    }) {
      this.selectedNewCountry = iso2;
      this.newPhoneInput.dialCode = dialCode;
    },
    updateNewPhone(payload) {
      this.clearNumberInUseWarning(payload.e164);
      this.newPhone.number = payload.e164;
      this.newPhone.formatNational = payload.formatNational;
      this.newPhone.countryCode = payload.countryCode;
      this.newPhone.countryCallingCode = payload.countryCallingCode;
      this.newPhone.isValid = payload.isValid;
    },
    updateExistingPhone(payload, phone) {
      this.clearNumberInUseWarning(phone.id);
      phone.number = payload.e164;
      phone.formatNational = payload.formatNational;
      phone.countryCode = payload.countryCode;
      phone.countryCallingCode = payload.countryCallingCode;
      phone.isValid = payload.isValid;
    },
    convertCountryDialCodeToIso(dialCode) {
      return convertCountryDialCodeToIso(dialCode);
    },
    validIntegerWithLeadingZeros(value) {
      value = value.replace(/^0+/, '') || '0';
      const n = Math.floor(Number(value));
      return n !== Infinity && String(n) === value && n >= 0;
    },
    isNumberInUse(phone) {
      if (phone in this.numberInUseWarning) {
        return this.numberInUseWarning[phone];
      }
      return false;
    },
    setNumberInUseWarning(phones) {
      phones.map(phone => this.numberInUseWarning[phone] = true);
      this.$emit('validated', {
        valid: false,
        type: 'phone'
      });
    },
    clearNumberInUseWarning(phone) {
      if (this.isNumberInUse(phone)) {
        this.numberInUseWarning[phone] = false;
      }
      this.error = this.$t('validation.requiredHelp');
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getIsLogInAs'] ? this.$store.getters['loginas/getImpersonatedUser'] : null;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserPhone/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var AccountDetails_UserPhonevue_type_script_lang_js_ = (UserPhonevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserPhone/index.vue?vue&type=style&index=0&id=41d73f10&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserPhone/index.vue?vue&type=style&index=0&id=41d73f10&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserPhone/index.vue?vue&type=style&index=1&id=41d73f10&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserPhone/index.vue?vue&type=style&index=1&id=41d73f10&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserPhone/index.vue



;



/* normalize component */

var UserPhone_component = normalizeComponent(
  AccountDetails_UserPhonevue_type_script_lang_js_,
  UserPhonevue_type_template_id_41d73f10_scoped_true_render,
  UserPhonevue_type_template_id_41d73f10_scoped_true_staticRenderFns,
  false,
  null,
  "41d73f10",
  null
  
)

/* harmony default export */ var UserPhone = (UserPhone_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserEmail/index.vue?vue&type=template&id=53821fb5&scoped=true&
var UserEmailvue_type_template_id_53821fb5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.edit)?[_c('v-card-subtitle',{staticClass:"d-flex flex-row align-center"},[_c('div',[_vm._v(_vm._s(_vm.$t('userProfile.accountDetails.email')))]),_c('v-spacer'),_c('v-btn',{staticStyle:{"margin-left":"16px"},attrs:{"text":"","color":"primary","data-cy":"editEmail"},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(_vm._s(_vm.$t('buttons.edit')))])],1),_c('v-card-text',{attrs:{"data-cy":"userEmail"}},[_c('strong',[_vm._v(_vm._s(_vm.email))])])]:[_c('v-card-text',[_c('div',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.$t('userProfile.email.changeMessage')))]),_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.email.address'),"maxlength":"255","rules":[_vm.rules.required, _vm.rules.email],"data-cy":"newEmailAddress"},model:{value:(_vm.newEmail),callback:function ($$v) {_vm.newEmail=$$v},expression:"newEmail"}}),_c('br'),_c('br'),_c('v-text-field',{staticClass:"text-field-required",attrs:{"label":_vm.$t('userProfile.email.addressConfirm'),"maxlength":"255","rules":[_vm.rules.required, _vm.rules.email],"data-cy":"confirmNewEmailAddress"},model:{value:(_vm.newEmailConfirm),callback:function ($$v) {_vm.newEmailConfirm=$$v},expression:"newEmailConfirm"}}),(_vm.error !== '')?_c('div',{staticClass:"errorMessage",attrs:{"data-cy":"errorMessage"}},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)]],2)}
var UserEmailvue_type_template_id_53821fb5_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserEmail/index.vue?vue&type=script&lang=js&

/* harmony default export */ var UserEmailvue_type_script_lang_js_ = ({
  name: 'user-email',
  props: {
    edit: Boolean
  },
  data() {
    return {
      create: false,
      removing: false,
      error: this.$t('validation.requiredHelp'),
      updating: false,
      newEmail: '',
      newEmailConfirm: '',
      rules: {
        required: value => !!value || this.$t('validation.required'),
        email: value => {
          const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return (
            // regex used: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
            // note: it might not work for non-standard email addresses and edge cases.
            regex.test(value) || this.$t('validation.invalidEntry')
          );
        }
      }
    };
  },
  computed: {
    email() {
      var _this$$store$state$us, _this$$store$state$us2;
      if ((_this$$store$state$us = this.$store.state.userProfile) !== null && _this$$store$state$us !== void 0 && (_this$$store$state$us2 = _this$$store$state$us.user) !== null && _this$$store$state$us2 !== void 0 && _this$$store$state$us2.email) {
        return this.$store.state.userProfile.user.email;
      } else {
        return null;
      }
    },
    newEmailValid() {
      let v = true;
      if (this.newEmail !== this.newEmailConfirm) v = false;
      if (this.rules.required(this.newEmail) !== true) v = false;
      if (this.rules.email(this.newEmail) !== true) v = false;
      return v;
    }
  },
  watch: {
    edit(e) {
      if (!e) {
        this.resetFields();
      }
      if (this.newEmailValid) {
        this.$emit('validated', {
          valid: true,
          type: 'email'
        });
      } else {
        this.$emit('validated', {
          valid: false,
          type: 'email'
        });
      }
    },
    newEmailValid: function (v) {
      if (v) this.$emit('validated', {
        valid: true,
        type: 'email'
      });else this.$emit('validated', {
        valid: false,
        type: 'email'
      });
    }
  },
  methods: {
    async save() {
      let ok = true;
      const loggedInAsUser = this.getLoggedInAsUser();
      const resp = await this.$store.dispatch('userProfile/editEmail', {
        accountsAPIHost: this.$components.accountsAPIHost,
        emailEditObj: {
          currentEmail: this.email,
          newEmail: this.newEmail,
          confirmEmail: this.newEmail
        },
        loggedInAsUser
      });
      if (!isOkResponse(resp.status)) {
        ok = false;
        this.resetFields();
        this.error = this.$t('userProfile.email.saveFail');
      }
      if (ok) {
        if (loggedInAsUser) {
          await this.$store.dispatch('userProfile/getUser', {
            accountsAPIHost: this.$components.accountsAPIHost,
            loggedInAsUser
          });
          return true;
        }
        this.logout();
      }
      return false;
    },
    resetFields() {
      this.newEmail = '';
      this.newEmailConfirm = '';
      this.error = this.$t('validation.requiredHelp');
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin + '/'
      });
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getIsLogInAs'] ? this.$store.getters['loginas/getImpersonatedUser'] : null;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserEmail/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var AccountDetails_UserEmailvue_type_script_lang_js_ = (UserEmailvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/UserEmail/index.vue?vue&type=style&index=0&id=53821fb5&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserEmail/index.vue?vue&type=style&index=0&id=53821fb5&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/UserEmail/index.vue



;


/* normalize component */

var UserEmail_component = normalizeComponent(
  AccountDetails_UserEmailvue_type_script_lang_js_,
  UserEmailvue_type_template_id_53821fb5_scoped_true_render,
  UserEmailvue_type_template_id_53821fb5_scoped_true_staticRenderFns,
  false,
  null,
  "53821fb5",
  null
  
)

/* harmony default export */ var UserEmail = (UserEmail_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/index.vue?vue&type=script&lang=js&




/* harmony default export */ var AccountDetailsvue_type_script_lang_js_ = ({
  components: {
    'user-name': UserName,
    'user-address': UserAddress,
    'user-phone': UserPhone,
    'user-email': UserEmail
  },
  data() {
    return {
      edit: {
        phone: false,
        name: false,
        address: false,
        email: false
      },
      saving: false,
      nameValid: true,
      addressValid: true,
      phoneValid: true,
      emailValid: true
    };
  },
  computed: {
    detailsValid() {
      if (this.edit.phone) {
        return this.phoneValid;
      } else if (this.edit.address) {
        return this.addressValid;
      } else if (this.edit.name) {
        return this.nameValid;
      } else if (this.edit.email) {
        return this.emailValid;
      } else {
        return false;
      }
    }
  },
  methods: {
    async save() {
      this.saving = true;
      let ok = true;
      if (this.edit.phone) {
        ok = await this.$refs.phone.save();
      } else if (this.edit.address) {
        ok = await this.$refs.addr.save();
      } else if (this.edit.name) {
        ok = await this.$refs.name.save();
      } else if (this.edit.email) {
        ok = await this.$refs.email.save();
      }
      this.saving = false;
      if (ok) {
        this.edit = {
          phone: false,
          name: false,
          address: false,
          email: false
        };
      }
    },
    cancel() {
      this.edit = {
        phone: false,
        name: false,
        address: false,
        email: false
      };
    },
    close() {
      this.$emit('close');
    },
    onValidation(v) {
      if (v.type === 'name') {
        this.nameValid = v.valid;
      }
      if (v.type === 'addr') {
        this.addressValid = v.valid;
      }
      if (v.type === 'phone') {
        this.phoneValid = v.valid;
      }
      if (v.type === 'email') {
        this.emailValid = v.valid;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var UserProfile_AccountDetailsvue_type_script_lang_js_ = (AccountDetailsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/AccountDetails/index.vue?vue&type=style&index=0&id=5fe47ce6&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/index.vue?vue&type=style&index=0&id=5fe47ce6&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/AccountDetails/index.vue



;


/* normalize component */

var AccountDetails_component = normalizeComponent(
  UserProfile_AccountDetailsvue_type_script_lang_js_,
  AccountDetailsvue_type_template_id_5fe47ce6_scoped_true_render,
  AccountDetailsvue_type_template_id_5fe47ce6_scoped_true_staticRenderFns,
  false,
  null,
  "5fe47ce6",
  null
  
)

/* harmony default export */ var AccountDetails = (AccountDetails_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/NotificationSettings/index.vue?vue&type=template&id=41e9ebb2&scoped=true&
var NotificationSettingsvue_type_template_id_41e9ebb2_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"no-top-padding",attrs:{"flat":""}},[(_vm.editing)?[_c('v-card-text',{staticClass:"no-top-padding buffered-content"},[_c('div',[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.heading")))]),_c('br'),_c('div',[_c('v-checkbox',{attrs:{"color":"primary","label":_vm.$t('userProfile.notificationSettings.email'),"data-cy":"emailNotifications"},model:{value:(_vm.emailEnabled),callback:function ($$v) {_vm.emailEnabled=$$v},expression:"emailEnabled"}})],1),_c('div',{staticClass:"delivery-help"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.emailHelp")))]),(_vm.showingOptinWarningEmail)?_c('div',{staticClass:"optin-warning"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.emailOptinWarning")))]):_vm._e(),_c('br'),_c('div',[_c('v-checkbox',{attrs:{"color":"primary","disabled":_vm.noPhone || _vm.isUnavailablePrimaryPhone,"label":_vm.$t('userProfile.notificationSettings.phone'),"data-cy":"phoneNotifications"},model:{value:(_vm.smsEnabled),callback:function ($$v) {_vm.smsEnabled=$$v},expression:"smsEnabled"}})],1),(_vm.noPhone)?_c('div',{staticClass:"delivery-help"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.noPhoneHelp")))]):(_vm.isUnavailablePrimaryPhone)?_c('div',{staticClass:"delivery-help"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.unavailablePrimaryPhone")))]):_c('div',{staticClass:"delivery-help"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.phoneHelp")))]),(_vm.showingOptinWarningPhone && !_vm.isUnavailablePrimaryPhone)?_c('div',{staticClass:"optin-warning"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.phoneOptinWarning")))]):_vm._e()]),_c('v-card-actions',[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"notificationsCancel"},on:{"click":function($event){return _vm.cancelEditing()}}},[_vm._v(_vm._s(_vm.$t("buttons.cancel")))]),_c('v-spacer'),_c('not-allowed-tooltip',{attrs:{"disabled":!_vm.isLogInAs}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"loading":_vm.saving,"text":"","disabled":_vm.isLogInAs,"data-cy":"notificationsSave"},on:{"click":function($event){return _vm.saveEditing()}}},[_vm._v(_vm._s(_vm.$t("buttons.save")))])],1)],1)]:(_vm.showingOptoutDisclaimerPhone || _vm.showingOptoutDisclaimerEmail)?[_c('v-card-subtitle',{staticClass:"d-flex flex-row align-center"},[(_vm.showingOptoutDisclaimerPhone)?_c('strong',[_vm._v(_vm._s(_vm.$t("userProfile.legal.optOutPhoneDisclaimer.title")))]):_c('strong',[_vm._v(_vm._s(_vm.$t("userProfile.legal.optOutEmailDisclaimer.title")))])]),_c('v-card-text',{staticClass:"no-top-padding"},[(_vm.showingOptoutDisclaimerPhone)?_c('p',[_vm._v(_vm._s(_vm.$t("userProfile.legal.optOutPhoneDisclaimer.content")))]):_c('p',[_vm._v(_vm._s(_vm.$t("userProfile.legal.optOutEmailDisclaimer.content")))])]),(_vm.showingOptoutDisclaimerPhone)?_c('v-card-actions',{attrs:{"text":""}},[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"cancelPhoneOptout"},on:{"click":function($event){return _vm.cancelPhoneOptout()}}},[_vm._v(_vm._s(_vm.$t("buttons.cancel")))]),_c('v-spacer'),_c('not-allowed-tooltip',{attrs:{"disabled":!_vm.isLogInAs}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","disabled":_vm.isLogInAs,"data-cy":"continuePhoneOptout"},on:{"click":function($event){return _vm.continuePhoneOptout()}}},[_vm._v(_vm._s(_vm.$t("buttons.continue")))])],1)],1):_c('v-card-actions',{attrs:{"text":""}},[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"cancelEmailOptout"},on:{"click":function($event){return _vm.cancelEmailOptout()}}},[_vm._v(_vm._s(_vm.$t("buttons.cancel")))]),_c('v-spacer'),_c('not-allowed-tooltip',{attrs:{"disabled":!_vm.isLogInAs}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","disabled":_vm.isLogInAs,"data-cy":"continueEmailOptout"},on:{"click":function($event){return _vm.continueEmailOptout()}}},[_vm._v(_vm._s(_vm.$t("buttons.continue")))])],1)],1)]:(_vm.showingDisclaimer)?[_c('v-card-text',{staticClass:"no-top-padding"},[_c('legal-disclaimer',{attrs:{"isSmallTitle":_vm.isSmallDisclaimerTitle}}),_c('br'),_c('br'),_vm._v(" "+_vm._s(_vm.$t("userProfile.legal.disclaimer.content"))+" ")],1),_c('v-card-actions',{attrs:{"text":""}},[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"cancelDisclaimer"},on:{"click":function($event){return _vm.cancelDisclaimer()}}},[_vm._v(_vm._s(_vm.$t("buttons.cancel")))]),_c('v-spacer'),_c('not-allowed-tooltip',{attrs:{"disabled":!_vm.isLogInAs}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","disabled":_vm.isLogInAs,"data-cy":"continueDisclaimer"},on:{"click":function($event){return _vm.continueDisclaimer()}}},[_vm._v(_vm._s(_vm.$t("buttons.continue")))])],1)],1)]:[_c('v-card-text',{staticClass:"buffered-content"},[_c('div',[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.heading")))]),_c('div',{staticClass:"notification-method-container",attrs:{"data-cy":"deliveryMethodEmail"}},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.email")))])]),(_vm.notificationEmail === null)?_c('div',{staticClass:"none"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.none")))]):_c('div',{staticClass:"delivery-methods"},[_vm._v(" "+_vm._s(_vm.$t("userProfile.notificationSettings.messagesDeliveredTo"))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.notificationEmail)+" ")])]),_c('div',{staticClass:"notification-method-container",attrs:{"data-cy":"deliveryMethodPhone"}},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.phone")))])]),(_vm.loadingPhone)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):(_vm.noPhone)?_c('div',{staticClass:"none"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.noPhoneHelp")))]):(_vm.isUnavailablePrimaryPhone)?_c('div',{staticClass:"none"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.unavailablePrimaryPhone"))+" ")]):(_vm.notificationPhone === null)?_c('div',{staticClass:"none"},[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.none")))]):_c('div',{staticClass:"delivery-methods"},[_vm._v(" "+_vm._s(_vm.$t("userProfile.notificationSettings.messagesDeliveredTo"))+" "),_c('br'),(!_vm.smsPending)?_c('p',[_vm._v(_vm._s(_vm.notificationPhone))]):[_c('p',[_vm._v(_vm._s(_vm.notificationPhone)+" ("+_vm._s(_vm.$t("userProfile.notificationSettings.pending"))+")")]),_c('p',[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.phoneOptinPending")))])]],2)],1),_c('div',[_vm._v(_vm._s(_vm.$t("userProfile.notificationSettings.editInstructions")))])]),(_vm.$vuetify.breakpoint.xs && !_vm.showMobileDoneButton)?_c('v-card-actions',{attrs:{"text":""}},[_c('v-spacer'),_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":""},on:{"click":function($event){return _vm.edit()}}},[_vm._v(_vm._s(_vm.$t("buttons.edit")))])],1):_c('v-card-actions',{attrs:{"text":""}},[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"editNotifications"},on:{"click":function($event){return _vm.edit()}}},[_vm._v(_vm._s(_vm.$t("buttons.edit")))]),_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"notificationsDone"},on:{"click":function($event){return _vm.close()}}},[_vm._v(_vm._s(_vm.$t("buttons.done")))])],1)]],2)}
var NotificationSettingsvue_type_template_id_41e9ebb2_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/LegalDisclaimer/index.vue?vue&type=template&id=3fb0100e&scoped=true&
var LegalDisclaimervue_type_template_id_3fb0100e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',{staticClass:"headline",class:{'small-title': _vm.isSmallTitle}},[_vm._v(_vm._s(_vm.$t("userProfile.legal.disclaimer.title")))]),_c('fusion-scroll',[_c('div',{staticClass:"paragraphs"},[_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("EMAIL AND SMS/TEXT MESSAGE NOTIFICATIONS TERMS OF USE")]),_c('p',[_vm._v(" TSI Link™ Solutions Email and SMS/Text messaging notifications (collectively, “Notifications”) are provided by TSI Incorporated (“TSI,” “we,” or “us”). These terms of use (“Terms”) constitute a legal contract between you and TSI and govern all aspects of your use of the Notifications. The Notifications provide access to product-related information and alerts. Please read these Terms carefully. By accessing and using the Notifications, you agree to be bound by these Terms. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("YOUR INFORMATION AND DISCLOSURE TO THIRD PARTIES")]),_c('p',[_vm._v(" TSI has made a commitment to protecting the privacy of those who use the Notifications. Please review TSI’s Privacy Policy at "),_c('a',{attrs:{"href":"https://www.tsi.com/footer/privacy-policy/","target":"blank"}},[_vm._v("https://www.tsi.com/footer/privacy-policy/")]),_vm._v(" . TSI’s Privacy Policy is incorporated by reference in the Terms. By using the Notifications, you are consenting to the Privacy Policy. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("OPT-OUT")]),_c('p',[_vm._v(" You may “opt-out” of SMS/Text messaging notifications at any time by changing your individual alert delivery method or disabling SMS/Text message notifications on the TSI Link™ Solutions portal, "),_c('a',{attrs:{"href":"https://tsilink.com/","target":"blank"}},[_vm._v("https://tsilink.com/")]),_vm._v(" , within the User Profile, in the Notifications section. You may also “opt-out” of SMS/Text messaging notifications by replying “STOP” to the number from which you received the last SMS/text message. ")]),_c('p',[_vm._v(" You may “opt-out” of Email notifications at any time by changing your individual alert delivery method or disabling Email notifications on the TSI Link™ Solutions portal, "),_c('a',{attrs:{"href":"https://tsilink.com/","target":"blank"}},[_vm._v("https://tsilink.com/")]),_vm._v(" , within the User Profile, in the Notifications section. ")]),_c('p',[_vm._v(" After opting out, you will not receive any additional Notifications, unless you opt back in. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("MESSAGING COSTS")]),_c('p',[_vm._v(" While there is no direct cost to you to opt-in and use the Notifications, "),_c('strong',[_c('i',[_vm._v("standard fees and text messaging rates may apply")])]),_vm._v(" to SMS/Text messaging notifications depending on your mobile phone carrier. TSI does not have any control over these rates, nor does it have control as to any other obligations you may have to your mobile carrier in connection with your SMS/Text messaging service. When you opt-in to receive SMS/Text notifications, you are accepting any such charges from your mobile carrier. As mobile access and text message delivery is subject to your mobile carrier network availability, such access and delivery is not guaranteed. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("MESSAGING FREQUENCY")]),_c('p',[_vm._v(" Messaging frequency per month may vary depending on your alert settings. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("DEVICE COMPATIBILITY AND ELIGIBILITY")]),_c('p',[_vm._v(" The Notifications only function on certain devices and operating systems. You acknowledge that future operating system upgrades to your device may or may not be compatible with the Notifications. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("SECURITY")]),_c('p',[_vm._v(" TSI makes no warranty whatsoever to you, express or implied, regarding the security of the Notifications, including with respect to the ability of unauthorized persons to intercept or access information transmitted by you through the Notifications. You acknowledge and agree that you are solely responsible for maintaining the security of your devices. TSI is not responsible for any losses resulting from the loss or theft of your device, the loss or theft of your information transmitted from or stored on your devices, or any losses arising from the use of your device by someone whom you have given access. You are required to notify us of any unauthorized use of the Notifications by "),_c('a',{attrs:{"href":"mailto:cloudsupport@tsi.com"}},[_vm._v("cloudsupport@tsi.com")]),_vm._v(" . To protect the security of your information, TSI may require you to authenticate your identity (i.e., prove that you are who you say you are) when you use the Notifications. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("SEVERABILITY/NO WAIVER")]),_c('p',[_vm._v(" If any provision of the Terms shall be deemed unlawful, void, or unenforceable for any reason, then such provision shall be deemed severable from the Terms and shall not affect the validity and enforceability of any remaining provisions. TSI's failure to enforce the strict performance of any provision of the Terms or the additional terms and conditions for any product or service will not constitute a waiver of our right to subsequently enforce such provision or any other provisions of the Terms or the additional terms and conditions. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("LIMITATION ON LIABILITY")]),_c('p',[_vm._v(" YOU EXPRESSLY UNDERSTAND AND AGREE THAT TSI AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS, AGENTS, EMPLOYEES, PARTNERS, CONTRACTORS, CONSULTANTS, LICENSORS, AND SUPPLIERS SHALL NOT BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES, EVEN IF TSI HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, RESULTING FROM THE USE OR THE INABILITY TO USE THE NOTIFICATIONS, UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA, STATEMENTS OR CONDUCT OF ANY THIRD PARTY REGARDING THE NOTIFICATIONS, OR ANY OTHER MATTER RELATING TO THE NOTIFICATIONS. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("DISCLAIMERS")]),_c('p',[_vm._v(" THE NOTIFICATIONS ARE PROVIDED TO YOU ON AN “AS-IS” AND “AS-AVAILABLE” BASIS WITHOUT ANY REPRESENTATIONS OR WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. TSI MAKES NO WARRANTY THAT (i) THE NOTIFICATIONS WILL MEET YOUR REQUIREMENTS, (ii) THAT OPERATION OF THE NOTIFICATIONS WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE, OR (iii) THE CONTENT THAT MAY BE OBTAINED FROM THE USE OF THE NOTIFICATIONS WILL BE ACCURATE OR RELIABLE. TSI UNDERTAKES NO OBLIGATION TO UPDATE THE NOTIFICATIONS. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM TSI, OR THROUGH THE NOTIFICATIONS SHALL CREATE ANY WARRANTY REGARDING THE NOTIFICATIONS NOT EXPRESSLY STATED IN THIS AGREEMENT. YOU UNDERSTAND AND ACKNOWLEDGE THAT ADDITIONAL DISCLAIMERS, LIMITATIONS, AND NOTICES REGARDING THE NOTIFICATIONS AND THEIR CONTENT AND DATA MAY BE PROVIDED BY TSI FROM TIME TO TIME WITHIN THE NOTIFICATION. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("INDEMNIFICATION")]),_c('p',[_vm._v(" You will defend, indemnify, and hold us harmless from and against any actual or threatened suit, actions, proceedings (at law or in equity), claims, damages, payments, deficiencies, fines, judgments, settlements, liabilities, losses, costs, and expenses (including reasonable attorneys' fees, costs, penalties, interest, and disbursements) arising from or related to your conduct with respect to the Notifications or violation (or alleged violation) of these Terms. Under no circumstance will TSI be liable for damages of any kind that result from your use of, or the inability to use, the Notifications. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("CHANGES")]),_c('p',[_vm._v(" You are responsible for reviewing these Terms regularly. TSI reserves the right, at any time, without notice to you, and in its sole discretion, to modify or discontinue the Notifications, the Terms, or any TSI policies related to use of the Notifications. Revisions to the Terms or TSI's policies may be provided through TSI’s Website, including by posting the revisions on TSI’s Website. Continued use of the Notifications following such modifications to the Notifications, the Terms, additional terms and conditions for any service, or other TSI policies will constitute your acceptance of such modifications and revisions. ")]),_c('h3',{staticClass:"text-subtitle-2"},[_vm._v("CONTACT US")]),_c('p',[_vm._v(" If you have any questions regarding the Notifications, these should be directed to "),_c('a',{attrs:{"href":"mailto:cloudsupport@tsi.com"}},[_vm._v("cloudsupport@tsi.com")]),_vm._v(" . ")])])])],1)}
var LegalDisclaimervue_type_template_id_3fb0100e_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/LegalDisclaimer/index.vue?vue&type=script&lang=js&
/* harmony default export */ var LegalDisclaimervue_type_script_lang_js_ = (Vue.extend({
  props: {
    isSmallTitle: Boolean
  },
  data() {
    return {};
  }
}));
;// CONCATENATED MODULE: ./src/components/UserProfile/LegalDisclaimer/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var UserProfile_LegalDisclaimervue_type_script_lang_js_ = (LegalDisclaimervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/LegalDisclaimer/index.vue?vue&type=style&index=0&id=3fb0100e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/LegalDisclaimer/index.vue?vue&type=style&index=0&id=3fb0100e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/LegalDisclaimer/index.vue



;


/* normalize component */

var LegalDisclaimer_component = normalizeComponent(
  UserProfile_LegalDisclaimervue_type_script_lang_js_,
  LegalDisclaimervue_type_template_id_3fb0100e_scoped_true_render,
  LegalDisclaimervue_type_template_id_3fb0100e_scoped_true_staticRenderFns,
  false,
  null,
  "3fb0100e",
  null
  
)

/* harmony default export */ var LegalDisclaimer = (LegalDisclaimer_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/NotificationSettings/index.vue?vue&type=script&lang=js&



/* harmony default export */ var NotificationSettingsvue_type_script_lang_js_ = (Vue.extend({
  name: 'notification-settings',
  components: {
    'legal-disclaimer': LegalDisclaimer,
    'not-allowed-tooltip': NotAllowedTooltip
  },
  props: {
    isSmallDisclaimerTitle: Boolean,
    refresh: Boolean,
    showMobileDoneButton: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      editing: false,
      saving: false,
      showingDisclaimer: false,
      showingOptoutDisclaimerPhone: false,
      showingOptoutDisclaimerEmail: false,
      showingOptinWarningPhone: false,
      showingOptinWarningEmail: false,
      emailEnabled: false,
      smsEnabled: false,
      selectedPhone: null,
      selectedEmail: null,
      phone: undefined,
      unavailableCountryCodesForSMSNotifications: null
    };
  },
  watch: {
    notificationEmail: {
      immediate: true,
      handler(newValue) {
        this.emailEnabled = newValue !== null;
      }
    },
    notificationPhone: {
      immediate: true,
      handler(newValue) {
        this.smsEnabled = newValue !== null;
      }
    },
    refresh() {
      this.getPrimaryPhone();
    },
    smsEnabled(newValue, oldValue) {
      if (!this.smsEnabled && !this.showingOutputDisclaimerPhone && this.notificationPhone) {
        this.showingOptoutDisclaimerPhone = true;
        this.editing = false;
      }
      this.showingOptinWarningPhone = newValue && !oldValue;
    },
    emailEnabled(newValue, oldValue) {
      if (!this.emailEnabled && this.notificationEmail) {
        this.showingOptoutDisclaimerEmail = true;
        this.editing = false;
      }
      this.showingOptinWarningEmail = newValue && !oldValue;
    }
  },
  async mounted() {
    this.getPrimaryPhone().catch(error => {
      console.log(error);
    });
    this.unavailableCountryCodesForSMSNotifications = await this.getAppUnavailableCountryCodes();
  },
  methods: {
    ...(0,external_Vuex_namespaceObject.mapActions)('userProfile', ['updateUser']),
    close() {
      this.$emit('close');
    },
    edit() {
      if (this.notificationEmail === null || this.notificationPhone === null || !this.phone.allowSmsNotifications) {
        this.showingDisclaimer = true;
      } else {
        this.continueDisclaimer();
      }
    },
    continueDisclaimer() {
      this.showingDisclaimer = false;
      this.editing = true;
      this.getPrimaryPhone().catch(error => {
        console.log(error);
      });
      this.$emit('onDisclaimerAgree');
    },
    cancelDisclaimer() {
      this.showingDisclaimer = false;
    },
    async saveEditing() {
      this.saving = true;
      if (this.smsEnabled && this.phone && this.phone.id) {
        await this.$store.dispatch('userProfile/postPhoneOptin', {
          accountsAPIHost: this.$components.accountsAPIHost,
          phoneID: this.phone.id
        });
      } else if (!this.smsEnabled && this.phone && this.phone.id) {
        await this.$store.dispatch('userProfile/postPhoneOptout', {
          accountsAPIHost: this.$components.accountsAPIHost,
          phoneID: this.phone.id
        });
      }
      if (this.emailEnabled) {
        await this.$store.dispatch('userProfile/postEmailOptin', {
          accountsAPIHost: this.$components.accountsAPIHost,
          body: {
            preferencesUrl: window.location.href
          }
        });
      } else {
        await this.$store.dispatch('userProfile/postEmailOptout', {
          accountsAPIHost: this.$components.accountsAPIHost,
          body: {
            preferencesUrl: window.location.href
          }
        });
      }
      const userDetails = this.$store.state.userProfile.user;
      userDetails.allowEmailNotifications = this.emailEnabled;
      this.updateUser(userDetails);
      await this.getPrimaryPhone();
      this.$emit('onSave', {
        smsEnabled: this.smsEnabled,
        emailEnabled: this.emailEnabled
      });
      this.$emit('onDisclaimerAgree');
      this.showingOptinWarningPhone = false;
      this.showingOptinWarningEmail = false;
      this.saving = false;
      this.editing = false;
    },
    cancelEditing() {
      this.editing = false;
      this.showingOptinWarningPhone = false;
      this.showingOptinWarningEmail = false;
      this.$emit('onDisclaimerAgree');
    },
    async getPrimaryPhone() {
      const loggedInAsUser = this.getLoggedInAsUser();
      const resp = await this.$store.dispatch('userProfile/getPhones', {
        accountsAPIHost: this.$components.accountsAPIHost,
        loggedInAsUser
      });
      if (resp && resp.data && resp.data !== null) {
        const phones = resp.data;
        this.phone = null;
        for (let i = 0; i < phones.length; i++) {
          if (phones[i].isPrimary) {
            this.phone = phones[i];
          }
        }
      } else {
        this.phone = null;
      }
    },
    continuePhoneOptout() {
      this.smsEnabled = false;
      this.editing = true;
      this.showingOptoutDisclaimerPhone = false;
    },
    continueEmailOptout() {
      this.emailEnabled = false;
      this.editing = true;
      this.showingOptoutDisclaimerEmail = false;
    },
    cancelPhoneOptout() {
      this.smsEnabled = true;
      this.editing = true;
      this.showingOptoutDisclaimerPhone = false;
    },
    cancelEmailOptout() {
      this.emailEnabled = true;
      this.editing = true;
      this.showingOptoutDisclaimerEmail = false;
    },
    async getAppUnavailableCountryCodes() {
      const applicationsAPIHost = this.$components.applicationsAPIHost;
      const applicationID = this.$components.applicationID;
      const resp = await this.$store.dispatch('userProfile/getUnavailableCountryCodes', {
        applicationsAPIHost,
        applicationID
      });
      if (resp && resp.data && resp.data !== null) {
        return resp.data;
      }
      return null;
    },
    async removeNotificationsForUnavailablePhone() {
      await this.$store.dispatch('userProfile/postPhoneOptout', {
        accountsAPIHost: this.$components.accountsAPIHost,
        phoneID: this.phone.id
      });
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getIsLogInAs'] ? this.$store.getters['loginas/getImpersonatedUser'] : null;
    }
  },
  computed: {
    notificationEmail() {
      return this.user && this.user.allowEmailNotifications ? this.user.email : null;
    },
    notificationPhone() {
      return this.phone && (this.phone.allowSmsNotifications || this.phone.smsNotificationsPending) ? this.phone.number : null;
    },
    smsPending() {
      return this.phone && this.phone.smsNotificationsPending;
    },
    user() {
      return this.$store.getters['userProfile/getUser'];
    },
    loadingPhone() {
      return this.phone === undefined;
    },
    noPhone() {
      return this.phone === null;
    },
    isUnavailablePrimaryPhone() {
      if (this.unavailableCountryCodesForSMSNotifications && this.unavailableCountryCodesForSMSNotifications.length) {
        if (this.unavailableCountryCodesForSMSNotifications.includes(this.phone.countryCallingCode)) {
          this.removeNotificationsForUnavailablePhone();
          return true;
        }
      }
      return false;
    },
    isLogInAs() {
      return this.$store.getters['loginas/getIsLogInAs'];
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/UserProfile/NotificationSettings/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var UserProfile_NotificationSettingsvue_type_script_lang_js_ = (NotificationSettingsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/NotificationSettings/index.vue?vue&type=style&index=0&id=41e9ebb2&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/NotificationSettings/index.vue?vue&type=style&index=0&id=41e9ebb2&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/NotificationSettings/index.vue



;


/* normalize component */

var NotificationSettings_component = normalizeComponent(
  UserProfile_NotificationSettingsvue_type_script_lang_js_,
  NotificationSettingsvue_type_template_id_41e9ebb2_scoped_true_render,
  NotificationSettingsvue_type_template_id_41e9ebb2_scoped_true_staticRenderFns,
  false,
  null,
  "41e9ebb2",
  null
  
)

/* harmony default export */ var NotificationSettings = (NotificationSettings_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/UnitSettings/index.vue?vue&type=template&id=48d07c9d&scoped=true&
var UnitSettingsvue_type_template_id_48d07c9d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"no-top-padding action-card",attrs:{"flat":"","height":"100%"}},[_c('v-card-text',{staticClass:"buffered-content no-top-padding"},[_c('v-select',{attrs:{"items":_vm.tempUnits,"item-text":"text","item-value":"value","label":_vm.$t('userProfile.unitSettings.tempUnit'),"data-cy":"unitSettingsTempSelect"},model:{value:(_vm.temperature),callback:function ($$v) {_vm.temperature=$$v},expression:"temperature"}}),_c('v-select',{attrs:{"items":_vm.pressureUnits,"item-text":"text","item-value":"value","label":_vm.$t('userProfile.unitSettings.pressureUnit'),"data-cy":"unitSettingsPressureSelect"},model:{value:(_vm.pressure),callback:function ($$v) {_vm.pressure=$$v},expression:"pressure"}}),_c('v-select',{attrs:{"items":_vm.pmUnits,"item-text":"text","item-value":"value","label":_vm.$t('userProfile.unitSettings.pmUnit'),"data-cy":"unitSettingsPMSelect"},model:{value:(_vm.pm),callback:function ($$v) {_vm.pm=$$v},expression:"pm"}})],1),_c('v-card-actions',{attrs:{"text":""}},[_c('v-spacer'),(!_vm.$vuetify.breakpoint.xs)?_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"userProfileDone"},on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t('buttons.done'))+" ")]):_vm._e()],1)],1)}
var UnitSettingsvue_type_template_id_48d07c9d_scoped_true_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/@fusion/units/dist/units.js
var units = __webpack_require__(678);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/UnitSettings/index.vue?vue&type=script&lang=js&



/* harmony default export */ var UnitSettingsvue_type_script_lang_js_ = ({
  name: 'unit-settings',
  data() {
    return {
      pressure: this.$store.state.userProfile.settings.pressureUnit,
      pm: this.$store.state.userProfile.settings.pmUnit,
      temperature: this.mapTempState(this.$store.state.userProfile.settings.tempUnit),
      tempUnits: [{
        text: this.$t('userProfile.unitSettings.tempUnits.f'),
        value: units.UnitOfMeasure.DEGREES_F
      }, {
        text: this.$t('userProfile.unitSettings.tempUnits.c'),
        value: units.UnitOfMeasure.DEGREES_C
      }],
      pressureUnits: [{
        text: this.$t('userProfile.unitSettings.pressureUnits.inHg'),
        value: units.UnitOfMeasure.INCH_MERCURY
      }, {
        text: this.$t('userProfile.unitSettings.pressureUnits.hPa'),
        value: units.UnitOfMeasure.HECTOPASCAL
      }, {
        text: this.$t('userProfile.unitSettings.pressureUnits.mbar'),
        value: units.UnitOfMeasure.MILLIBAR
      }],
      pmUnits: [{
        text: this.$t('userProfile.unitSettings.pmUnits.mgm3'),
        value: units.UnitOfMeasure.MILLIGRAMS_PER_CUBIC_METER
      }, {
        text: this.$t('userProfile.unitSettings.pmUnits.ugm3'),
        value: units.UnitOfMeasure.MICROGRAMS_PER_CUBIC_METER
      }]
    };
  },
  methods: {
    ...(0,external_Vuex_namespaceObject.mapMutations)('userProfile', ['setUserSettings']),
    mapTempState(input) {
      switch (input) {
        case units.UnitOfMeasure.DEGREES_F:
        case 1:
          return units.UnitOfMeasure.DEGREES_F;
        case units.UnitOfMeasure.DEGREES_C:
        case 0:
          return units.UnitOfMeasure.DEGREES_C;
      }
    },
    close() {
      this.$emit('close');
    },
    async save() {
      const settings = {
        bluesky: {
          tempUnit: this.temperature,
          pressureUnit: this.pressure,
          pmUnit: this.pm
        }
      };
      const loggedInAsUser = this.getLoggedInAsUser();
      const saveResult = await this.$store.dispatch('userProfile/patchUserSettings', {
        accountsAPIHost: this.$components.accountsAPIHost,
        userSettings: settings,
        loggedInAsUser
      });
      if (isOkResponse(saveResult === null || saveResult === void 0 ? void 0 : saveResult.status)) {
        // persist saved changes to Vuex store
        await this.setUserSettings(settings);
      }
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getIsLogInAs'] ? this.$store.getters['loginas/getImpersonatedUser'] : null;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/UnitSettings/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var UserProfile_UnitSettingsvue_type_script_lang_js_ = (UnitSettingsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/UnitSettings/index.vue?vue&type=style&index=0&id=48d07c9d&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/UnitSettings/index.vue?vue&type=style&index=0&id=48d07c9d&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/UnitSettings/index.vue



;


/* normalize component */

var UnitSettings_component = normalizeComponent(
  UserProfile_UnitSettingsvue_type_script_lang_js_,
  UnitSettingsvue_type_template_id_48d07c9d_scoped_true_render,
  UnitSettingsvue_type_template_id_48d07c9d_scoped_true_staticRenderFns,
  false,
  null,
  "48d07c9d",
  null
  
)

/* harmony default export */ var UnitSettings = (UnitSettings_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/PasswordReset/index.vue?vue&type=template&id=7003f149&scoped=true&
var PasswordResetvue_type_template_id_7003f149_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"no-top-padding",attrs:{"flat":""}},[(_vm.reseting)?[_c('v-card-text',{staticClass:"no-top-padding buffered-content"},[_c('v-form',{ref:"resetPassword"},[_c('v-col',[_c('v-text-field',{staticClass:"text-field-required",attrs:{"type":_vm.currPassword.type,"label":_vm.$t('userProfile.passwordReset.currentPassword'),"rules":[_vm.rules.required],"hint":_vm.$t('userProfile.passwordReset.currentPasswordExp'),"data-cy":"currentPassword"},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',{on:{"click":function($event){_vm.currPassword = _vm.toggleType(_vm.currPassword)}}},[_vm._v(_vm._s(_vm.currPassword.icon))])]},proxy:true}],null,false,73314093),model:{value:(_vm.currPassword.val),callback:function ($$v) {_vm.$set(_vm.currPassword, "val", $$v)},expression:"currPassword.val"}}),_c('v-spacer'),_c('v-text-field',{staticClass:"text-field-required",attrs:{"type":_vm.newPassword.type,"label":_vm.$t('userProfile.passwordReset.newPassword'),"max-length":"255","min-length":"8","rules":[_vm.rules.required, _vm.rules.validPassword],"hint":_vm.$t('userProfile.passwordReset.newPasswordExp'),"data-cy":"newPassword"},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',{on:{"click":function($event){_vm.newPassword = _vm.toggleType(_vm.newPassword)}}},[_vm._v(_vm._s(_vm.newPassword.icon))])]},proxy:true}],null,false,599341767),model:{value:(_vm.newPassword.val),callback:function ($$v) {_vm.$set(_vm.newPassword, "val", $$v)},expression:"newPassword.val"}}),_c('v-spacer'),_c('v-text-field',{staticClass:"text-field-required",attrs:{"type":_vm.newPasswordRe.type,"label":_vm.$t('userProfile.passwordReset.newPasswordRe'),"max-length":"255","min-length":"8","rules":[_vm.rules.required, _vm.rules.validPassword, _vm.rules.matchNewPass],"hint":_vm.$t('userProfile.passwordReset.newPasswordReExp'),"data-cy":"confirmNewPassword"},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',{on:{"click":function($event){_vm.newPasswordRe = _vm.toggleType(_vm.newPasswordRe)}}},[_vm._v(_vm._s(_vm.newPasswordRe.icon))])]},proxy:true}],null,false,3412591952),model:{value:(_vm.newPasswordRe.val),callback:function ($$v) {_vm.$set(_vm.newPasswordRe, "val", $$v)},expression:"newPasswordRe.val"}}),(_vm.errored)?_c('v-card-actions',{staticClass:"errors",attrs:{"text":""}},[((_vm.errorCode = 403))?_c('div',{staticClass:"hint-text err-font"},[_vm._v(_vm._s(_vm.$t('userProfile.passwordReset.passwordError')))]):_c('div',{staticClass:"hint-text err-font"},[_vm._v(" "+_vm._s(_vm.$t('userProfile.passwordReset.error'))+" (Code: "+_vm._s(_vm.errorCode)+") ")])]):_vm._e()],1)],1),_c('v-card-text',[_c('v-col',{staticStyle:{"padding":"0"}},[_vm._v(" "+_vm._s(_vm.$t('userProfile.passwordReset.passwordRulesExp'))+" "),_c('v-spacer'),_vm._v(" - "+_vm._s(_vm.$t('userProfile.passwordReset.rule1'))+" "),_c('v-spacer'),_vm._v(" - "+_vm._s(_vm.$t('userProfile.passwordReset.rule2'))+" "),_c('v-spacer'),_vm._v(" - "+_vm._s(_vm.$t('userProfile.passwordReset.rule3'))+" "),_c('v-spacer'),_vm._v(" - "+_vm._s(_vm.$t('userProfile.passwordReset.rule4'))+" ")],1)],1)],1),_c('v-card-actions',{attrs:{"text":""}},[_c('div',{staticClass:"hint-text err-font"},[_vm._v(_vm._s(_vm.$t('validation.requiredHelp')))])]),_c('v-card-actions',{attrs:{"text":""}},[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"cancelResetPassword"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('buttons.cancel')))]),_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"disabled":!_vm.valid,"loading":_vm.saving,"text":"","data-cy":"savePassword"},on:{"click":function($event){return _vm.save()}}},[_vm._v(_vm._s(_vm.$t('buttons.save')))])],1)]:[_c('v-card-text',{staticClass:"buffered-content"},[_vm._v(_vm._s(_vm.$t('userProfile.passwordReset.logoutWarning')))]),_c('v-card-actions',{attrs:{"text":""}},[_c('not-allowed-tooltip',{attrs:{"disabled":!_vm.isLogInAs,"message":_vm.$t('userProfile.passwordReset.notAllowedForLogInAs'),"maxWidth":500}},[_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","disabled":_vm.isLogInAs,"data-cy":"resetPasswordButton"},on:{"click":function($event){_vm.reseting = true}}},[_vm._v(_vm._s(_vm.$t('userProfile.passwordReset.title')))])],1),_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"resetPasswordDone"},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('buttons.done')))])],1)]],2)}
var PasswordResetvue_type_template_id_7003f149_scoped_true_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/password-sheriff/index.js
var password_sheriff = __webpack_require__(671);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/PasswordReset/index.vue?vue&type=script&lang=js&
/* eslint-disable eqeqeq */



/* harmony default export */ var PasswordResetvue_type_script_lang_js_ = (Vue.extend({
  components: {
    'not-allowed-tooltip': NotAllowedTooltip
  },
  data() {
    return {
      saving: false,
      reseting: false,
      errored: false,
      errorCode: -1,
      currPassword: {
        val: null,
        type: 'password',
        icon: 'mdi-eye',
        valid: () => {
          if (this.currPassword.val) {
            if (this.rules.required(this.currPassword.val) == true) {
              return true;
            }
          }
          return false;
        }
      },
      newPassword: {
        val: null,
        type: 'password',
        icon: 'mdi-eye',
        valid: () => {
          const p = this.newPassword.val;
          if (p) {
            if (this.rules.required(p) == true && this.rules.validPassword(p) == true) {
              return true;
            }
          }
          return false;
        }
      },
      newPasswordRe: {
        val: null,
        type: 'password',
        icon: 'mdi-eye',
        valid: () => {
          const p = this.newPasswordRe.val;
          if (p) {
            if (this.rules.required(p) == true && this.rules.validPassword(p) == true && this.rules.matchNewPass(p) == true) {
              return true;
            }
          }
          return false;
        }
      },
      goodPasswordPolicy: new password_sheriff.PasswordPolicy({
        length: {
          minLength: 8
        },
        containsAtLeast: {
          atLeast: 3,
          expressions: [password_sheriff.charsets.lowerCase, password_sheriff.charsets.upperCase, password_sheriff.charsets.numbers, password_sheriff.charsets.specialCharacters]
        }
      }),
      rules: {
        required: value => !!value || this.$t('validation.required'),
        validPassword: value => {
          return this.goodPasswordPolicy.check(value) || this.$t('validation.invalidEntry');
        },
        matchNewPass: value => {
          return this.newPassword.val == value || this.$t('validation.noMatch');
        }
      }
    };
  },
  computed: {
    valid() {
      return this.currPassword.valid() && this.newPassword.valid() && this.newPasswordRe.valid();
    },
    isLogInAs() {
      return this.$store.getters['loginas/getIsLogInAs'];
    }
  },
  methods: {
    async save() {
      if (this.currPassword.val && this.newPassword.val && this.newPasswordRe.val) {
        this.saving = true;
        const passData = {
          currentPassword: this.currPassword.val,
          newPassword: this.newPassword.val,
          confirmPassword: this.newPasswordRe.val
        };
        const resp = await this.$store.dispatch('userProfile/postResetPassword', {
          accountsAPIHost: this.$components.accountsAPIHost,
          passwordData: passData
        });
        if (isOkResponse(resp.status)) {
          this.$auth.logout({
            returnTo: window.location.origin + '/'
          });
        } else {
          this.errored = true;
          this.errorCode = resp.status;
          setTimeout(() => {
            this.errored = false;
          }, 5000);
        }
        this.resetFields();
        this.saving = false;
      }
    },
    cancel() {
      this.resetFields();
      this.reseting = false;
    },
    close() {
      this.$emit('close');
    },
    toggleType(pobj) {
      const o = {
        ...pobj
      };
      if (pobj.type == 'password') {
        o.type = 'text';
        o.icon = 'mdi-eye-off';
      }
      if (pobj.type == 'text') {
        o.type = 'password';
        o.icon = 'mdi-eye';
      }
      return o;
    },
    resetFields() {
      this.$refs.resetPassword.reset();
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/UserProfile/PasswordReset/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var UserProfile_PasswordResetvue_type_script_lang_js_ = (PasswordResetvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/PasswordReset/index.vue?vue&type=style&index=0&id=7003f149&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/PasswordReset/index.vue?vue&type=style&index=0&id=7003f149&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/PasswordReset/index.vue



;


/* normalize component */

var PasswordReset_component = normalizeComponent(
  UserProfile_PasswordResetvue_type_script_lang_js_,
  PasswordResetvue_type_template_id_7003f149_scoped_true_render,
  PasswordResetvue_type_template_id_7003f149_scoped_true_staticRenderFns,
  false,
  null,
  "7003f149",
  null
  
)

/* harmony default export */ var PasswordReset = (PasswordReset_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/index.vue?vue&type=template&id=4e1b2564&scoped=true&
var UserProfilevue_type_template_id_4e1b2564_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fusion-dialog',{attrs:{"open":_vm.isOpen,"title":_vm.$t('userProfile.title'),"noActions":!_vm.$vuetify.breakpoint.xs || _vm.profileMode != _vm.modes.default,"maxWidth":800,"persistentOverlay":true},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"header-container"},[(_vm.$vuetify.breakpoint.xs && !(_vm.profileMode == _vm.modes.default))?_c('v-btn',{staticClass:"btn__header-icon",attrs:{"text":""},on:{"click":function($event){return _vm.setProfileMode(_vm.modes.default)}}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("mdi-arrow-left")])],1):_c('v-icon',{staticClass:"header-icon",attrs:{"x-large":""}},[_vm._v("mdi-account")]),_c('v-card-title',{staticClass:"header-title",attrs:{"data-cy":"userProfileHeader"}},[_vm._v(" "+_vm._s(_vm.$t('userProfile.title'))+" ")])],1)]},proxy:true},(_vm.$vuetify.breakpoint.xs && _vm.profileMode == _vm.modes.default)?{key:"actions",fn:function(){return [_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"userProfileDone"},on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t('buttons.done'))+" ")])]},proxy:true}:null],null,true)},[(_vm.$vuetify.breakpoint.xs)?[(_vm.profileMode == _vm.modes.default)?_vm._l((_vm.internalTabItems),function(tabItem){return _c('v-btn',{key:((tabItem.componentName) + "-mobile-btn"),staticClass:"primary--text mobile-menu",attrs:{"text":""},on:{"click":function($event){return _vm.setProfileMode(_vm.modes[tabItem.componentName])}}},[_vm._v(" "+_vm._s(tabItem.title)+" ")])}):_vm._e(),_vm._l((_vm.internalTabItems),function(tabItem){return _c(tabItem.componentName,{directives:[{name:"show",rawName:"v-show",value:(_vm.profileMode === _vm.modes[tabItem.componentName]),expression:"profileMode === modes[tabItem.componentName]"}],key:((tabItem.componentName) + "-mobile-component"),ref:tabItem.componentName,refInFor:true,tag:"component",attrs:{"refresh":_vm.refreshNotificationTab},on:{"close":_vm.close}})})]:[_c('v-tabs',{staticClass:"profile-tabs",attrs:{"vertical":"","hide-slider":""}},[_vm._l((_vm.internalTabItems),function(tabItem){return _c('v-tab',{key:((tabItem.componentName) + "-desktop-tab"),attrs:{"data-cy":((tabItem.componentName) + "-desktop-tab")},on:{"click":_vm.refreshNotification}},[_vm._v(" "+_vm._s(tabItem.title)+" ")])}),_vm._l((_vm.internalTabItems),function(tabItem){return _c('v-tab-item',{key:((tabItem.componentName) + "-desktop-tab-item")},[_c(tabItem.componentName,{ref:tabItem.componentName,refInFor:true,tag:"component",attrs:{"refresh":_vm.refreshNotificationTab},on:{"close":_vm.close}})],1)})],2)]],2)}
var UserProfilevue_type_template_id_4e1b2564_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/UserProfile/module/actions.js


const getLoggedInUser = async auth => {
  return {
    accountId: await auth.getAccountId(),
    userId: await auth.getUserId()
  };
};
/* harmony default export */ function UserProfile_module_actions(auth) {
  return {
    updateUser({
      commit
    }, userData) {
      commit('updateUser', userData);
    },
    setAccount({
      commit
    }, accountData) {
      commit('setAccount', accountData);
    },
    async deleteAddress(context, {
      accountsAPIHost,
      addressID,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/addresses/${addressID}`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.delete(url, {
        headers
      });
    },
    async deletePhone(context, {
      accountsAPIHost,
      phoneID,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/phones/${phoneID}`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.delete(url, {
        headers
      });
    },
    async getAccount({
      commit
    }, accountsAPIHost) {
      const accountId = await auth.getAccountId();
      const result = await axios.get(`${accountsAPIHost}/accounts/${accountId}`);
      if (isOkResponse(result === null || result === void 0 ? void 0 : result.status)) {
        commit('setAccount', result.data);
      }
    },
    async getAddresses(context, {
      accountsAPIHost,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/addresses`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.get(url, {
        headers
      });
    },
    async editEmail(context, {
      accountsAPIHost,
      emailEditObj,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/email`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.post(url, emailEditObj, {
        headers
      });
    },
    async getPhones(context, {
      accountsAPIHost,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/phones`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.get(url, {
        headers
      });

      // TODO  should we be storing the phones?? instead of parsing it out in the component
      // commit('getPhones', phones.data)
    },

    async getUnavailableCountryCodes(context, {
      applicationsAPIHost,
      applicationID
    }) {
      var _result;
      let result;
      try {
        result = await axios.get(`${applicationsAPIHost}/applications/${applicationID}/unavailableCountries`);
      } catch (error) {
        result = {
          status: 500
        };
      }
      if (isOkResponse((_result = result) === null || _result === void 0 ? void 0 : _result.status)) {
        return result;
      }
      return null;
    },
    async getUser({
      commit
    }, {
      accountsAPIHost,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      const result = await axios.get(url, {
        headers
      });
      if (isOkResponse(result === null || result === void 0 ? void 0 : result.status)) {
        commit('getUser', result.data);
      }
    },
    async getUserSettings({
      commit
    }, {
      accountsAPIHost,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/settings`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      const result = await axios.get(url, {
        headers
      });
      if (isOkResponse(result === null || result === void 0 ? void 0 : result.status)) {
        commit('setUserSettings', result.data);
      }
    },
    async patchAddress(context, {
      accountsAPIHost,
      address,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/addresses/${address.id}`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.patch(url, address, {
        headers
      });
    },
    async patchPhone(context, {
      accountsAPIHost,
      phone,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/phones/${phone.id}`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.patch(url, phone, {
        headers
      });
    },
    async patchUpdateUser({
      commit
    }, {
      accountsAPIHost,
      user,
      loggedInAsUser
    }) {
      var _result2;
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      let result;
      try {
        result = await axios.patch(url, user.userData, {
          headers
        });
      } catch (error) {
        result = {
          status: -1
        };
      }
      if (isOkResponse((_result2 = result) === null || _result2 === void 0 ? void 0 : _result2.status)) {
        // It is a little strange not to user something on the response,
        // but this is what the original code was doing, save it and then update Vuex with the data that was saved
        commit('updateUser', user.userData);
      }
    },
    async patchUserFullName(context, {
      accountsAPIHost,
      userSettings,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.patch(url, userSettings, {
        headers
      });
    },
    async patchUserSettings(context, {
      accountsAPIHost,
      userSettings,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/settings`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.patch(url, userSettings, {
        headers
      });
    },
    async postResetPassword(context, {
      accountsAPIHost,
      passwordData
    }) {
      const accountId = await auth.getAccountId();
      const userId = await auth.getUserId();
      return axios.post(`${accountsAPIHost}/accounts/${accountId}/users/${userId}/password`, passwordData);
    },
    async postEmailOptin(context, {
      accountsAPIHost,
      body
    }) {
      const accountId = await auth.getAccountId();
      const userId = await auth.getUserId();
      return axios.post(`${accountsAPIHost}/accounts/${accountId}/users/${userId}/email/optin`, body);
    },
    async postEmailOptout(context, {
      accountsAPIHost,
      body
    }) {
      const accountId = await auth.getAccountId();
      const userId = await auth.getUserId();
      return axios.post(`${accountsAPIHost}/accounts/${accountId}/users/${userId}/email/optout`, body);
    },
    async postPhoneOptin(context, {
      accountsAPIHost,
      phoneID
    }) {
      const accountId = await auth.getAccountId();
      const userId = await auth.getUserId();
      return axios.post(`${accountsAPIHost}/accounts/${accountId}/users/${userId}/phones/${phoneID}/optin`, {});
    },
    async postPhoneOptout(context, {
      accountsAPIHost,
      phoneID
    }) {
      const accountId = await auth.getAccountId();
      const userId = await auth.getUserId();
      return axios.post(`${accountsAPIHost}/accounts/${accountId}/users/${userId}/phones/${phoneID}/optout`, {});
    },
    async postDeactivateAccount(context, accountsAPIHost) {
      const accountId = await auth.getAccountId();
      const body = {
        action: 'delete'
      };
      return axios.post(`${accountsAPIHost}/accounts/${accountId}/actions`, body);
    },
    async getPendingAccountActions(context, accountsAPIHost) {
      const accountId = await auth.getAccountId();
      return axios.get(`${accountsAPIHost}/accounts/${accountId}/actions`);
    },
    async deleteAccountAction(context, {
      accountsAPIHost,
      actionId
    }) {
      const accountId = await auth.getAccountId();
      return axios.delete(`${accountsAPIHost}/accounts/${accountId}/actions/${actionId}`);
    },
    async postCreateAddress(context, {
      accountsAPIHost,
      address,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/addresses`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.post(url, address, {
        headers
      });
    },
    async postCreatePhone(context, {
      accountsAPIHost,
      phone,
      loggedInAsUser
    }) {
      const loggedInUser = await getLoggedInUser(auth);
      const url = getLogInAsUrl(`${accountsAPIHost}/accounts/accountId/users/userId/phones`, loggedInUser, loggedInAsUser);
      const headers = getLogInAsHeaders([LOG_IN_AS_HEADER_NAMES.ACCOUNT_ID, LOG_IN_AS_HEADER_NAMES.USER_ID], loggedInAsUser);
      return axios.post(url, phone, {
        headers
      });
    }
  };
}
;// CONCATENATED MODULE: ./src/components/UserProfile/module/getters.js
/* harmony default export */ var UserProfile_module_getters = ({
  getUser(state) {
    const tmpUsr = {
      firstName: '',
      lastName: ''
    };
    return state.user || tmpUsr;
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/module/mutations.js
/* harmony default export */ var UserProfile_module_mutations = ({
  getUser(state, userData) {
    state.user = userData;
    state.id = userData.id;
  },
  updateUser(state, userData) {
    state.user = {
      ...state.user,
      ...userData
    };
  },
  setAccount(state, accountData) {
    state.account = accountData;
  },
  setUserSettings(state, userSettings) {
    if (!userSettings.bluesky) return;
    userSettings = userSettings.bluesky;
    // delete settings not shown in units section
    delete userSettings.devicesUpdated;
    delete userSettings.lastViewedVersion;
    delete userSettings.visited;
    state.settings = {
      ...state.settings,
      ...userSettings
    };
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/module/state.js

/* harmony default export */ var UserProfile_module_state = ({
  user: null,
  account: null,
  id: null,
  settings: {
    tempUnit: units.UnitOfMeasure.DEGREES_F,
    pressureUnit: units.UnitOfMeasure.INCH_MERCURY,
    pmUnit: units.UnitOfMeasure.MICROGRAMS_PER_CUBIC_METER
  }
});
;// CONCATENATED MODULE: ./src/components/UserProfile/module/index.js




/* harmony default export */ function UserProfile_module(auth) {
  return {
    namespaced: true,
    state: UserProfile_module_state,
    getters: UserProfile_module_getters,
    mutations: UserProfile_module_mutations,
    actions: UserProfile_module_actions(auth)
  };
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/index.vue?vue&type=script&lang=js&


/* harmony default export */ var UserProfilevue_type_script_lang_js_ = (Vue.extend({
  name: 'UserProfile',
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false
    },
    customTabItems: {
      type: Array,
      required: false,
      default: () => []
    },
    requireDefaultTabs: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  data() {
    return {
      isOpen: false,
      profileMode: 'default',
      modes: {
        default: 'default'
      },
      refreshNotificationTab: true
    };
  },
  computed: {
    internalTabItems() {
      return this.requireDefaultTabs ? [{
        title: this.$t('userProfile.accountDetails.title'),
        componentName: 'fusion-account-details'
      }, {
        title: this.$t('userProfile.notificationSettings.title'),
        componentName: 'fusion-notification-settings'
      }, {
        title: this.$t('userProfile.accountManagement.title'),
        componentName: 'fusion-account-management'
      }, ...this.customTabItems, {
        title: this.$t('userProfile.passwordReset.title'),
        componentName: 'fusion-password-reset'
      }] : this.customTabItems;
    },
    loggedInAsUser() {
      return this.$store.getters['loginas/getImpersonatedUser'];
    }
  },
  methods: {
    async close() {
      this.$emit('close');
      this.isOpen = false;
      for (const ref in this.$refs) {
        var _component$save;
        const component = this.$refs[ref][0];
        // optional chaining (?.) only calls save method if it exists on the component
        await ((_component$save = component.save) === null || _component$save === void 0 ? void 0 : _component$save.call(component));
      }
      this.setProfileMode(this.modes.default);
    },
    setProfileMode(n) {
      this.profileMode = n;
      this.refreshNotification();
    },
    refreshNotification() {
      this.refreshNotificationTab = !this.refreshNotificationTab;
    },
    registerUserProfile() {
      const hasUserProfile = this.$store.hasModule('userProfile');
      if (!hasUserProfile) {
        this.$store.registerModule('userProfile', UserProfile_module(this.$auth));
      }
      this.registered = true;
    },
    getLoggedInAsUser() {
      return this.$store.getters['loginas/getIsLogInAs'] ? this.$store.getters['loginas/getImpersonatedUser'] : null;
    },
    async getUser() {
      const loggedInAsUser = this.getLoggedInAsUser();
      await this.$store.dispatch('userProfile/getUser', {
        accountsAPIHost: this.$components.accountsAPIHost,
        loggedInAsUser
      });
    },
    async getUserSettings() {
      const loggedInAsUser = this.getLoggedInAsUser();
      await this.$store.dispatch('userProfile/getUserSettings', {
        accountsAPIHost: this.$components.accountsAPIHost,
        loggedInAsUser
      });
    }
  },
  watch: {
    open(value) {
      this.isOpen = value;
      this.refreshNotification();
    },
    async 'loggedInAsUser.accountId'(accountId) {
      if (accountId) {
        await this.getUser();
        await this.getUserSettings();
      }
    }
  },
  async mounted() {
    this.registerUserProfile();
    // TODO: Add in AccountDetails when it's ready

    for (const tabItem of this.internalTabItems) {
      this.modes[tabItem.componentName] = tabItem.componentName;
    }
    if (this.$auth.isAuthenticated) {
      await this.getUser();
      await this.getUserSettings();
    }
    this.$auth.$on(fusion_auth_common.AuthEvents.AUTH_CHANGED, async isAuthenticated => {
      if (isAuthenticated) {
        await this.getUser();
        await this.getUserSettings();
      }
    });
  }
}));
;// CONCATENATED MODULE: ./src/components/UserProfile/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_UserProfilevue_type_script_lang_js_ = (UserProfilevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/index.vue?vue&type=style&index=0&id=4e1b2564&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserProfile/index.vue?vue&type=style&index=0&id=4e1b2564&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/UserProfile/index.vue



;


/* normalize component */

var UserProfile_component = normalizeComponent(
  components_UserProfilevue_type_script_lang_js_,
  UserProfilevue_type_template_id_4e1b2564_scoped_true_render,
  UserProfilevue_type_template_id_4e1b2564_scoped_true_staticRenderFns,
  false,
  null,
  "4e1b2564",
  null
  
)

/* harmony default export */ var UserProfile = (UserProfile_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReactivateAccountDialog/index.vue?vue&type=template&id=3039f8b8&
var ReactivateAccountDialogvue_type_template_id_3039f8b8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fusion-dialog',{attrs:{"open":_vm.open,"error":_vm.error,"title":_vm.$t('reactivateAccount.title'),"data-cy":"reactivateAccountDialog","fullscreen":_vm.$vuetify.breakpoint.xs,"persistentOverlay":true},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('v-icon',{staticClass:"header-icon"},[_vm._v("mdi-account")]),_vm._v(" "+_vm._s(_vm.$t('reactivateAccount.title'))+" ")],1)]},proxy:true},{key:"actions",fn:function(){return [_c('v-btn',{class:{ disabled: _vm.reactivating },attrs:{"disabled":_vm.reactivating,"outlined":"","text":"","data-cy":"cancelReactivate"},on:{"click":_vm.logout}},[_vm._v(" "+_vm._s(_vm.$t('reactivateAccount.no'))+" ")]),_c('v-spacer'),_c('v-btn',{staticClass:"primary white--text",attrs:{"text":"","data-cy":"reactivateAccount","loading":_vm.reactivating,"disabled":_vm.reactivating},on:{"click":_vm.reactivate}},[_vm._v(" "+_vm._s(_vm.$t('reactivateAccount.yes'))+" ")])]},proxy:true}])},[_c('div',[_c('v-card-text',[(_vm.daysRemaining > 0)?_c('i18n',{attrs:{"path":"reactivateAccount.text","tag":"p"},scopedSlots:_vm._u([{key:"days",fn:function(){return [_c('strong',[_vm._v(_vm._s(_vm.daysRemaining))])]},proxy:true}],null,false,1700575464)}):_c('p',[_vm._v(_vm._s(_vm.$t('reactivateAccount.altText')))])],1)],1)])}
var ReactivateAccountDialogvue_type_template_id_3039f8b8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReactivateAccountDialog/index.vue?vue&type=script&lang=js&

/* harmony default export */ var ReactivateAccountDialogvue_type_script_lang_js_ = ({
  name: 'ReactivateAccountDialog',
  props: {
    open: Boolean
  },
  data() {
    return {
      reactivating: false,
      error: '',
      deleteAction: {
        id: '',
        scheduledFor: ''
      }
    };
  },
  async mounted() {
    const resp = await this.$store.dispatch('userProfile/getPendingAccountActions', this.$components.accountsAPIHost);
    if (isOkResponse(resp.status)) {
      const body = resp.data;
      for (let i = 0; i < body.length; i++) {
        if (body[i].type === 'delete') {
          this.deleteAction = body[i];
        }
      }
    }
  },
  computed: {
    daysRemaining() {
      const oneDay = 24 * 60 * 60 * 1000;
      const today = new Date();
      const delDay = new Date(this.deleteAction.scheduledFor);
      return Math.round(Math.abs((today - delDay) / oneDay));
    }
  },
  methods: {
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin + '/'
      });
    },
    async reactivate() {
      this.reactivating = true;
      const resp = await this.$store.dispatch('userProfile/deleteAccountAction', {
        accountsAPIHost: this.$components.accountsAPIHost,
        actionId: this.deleteAction.id
      });
      if (!isOkResponse(resp.status)) {
        this.error = this.$t('reactivateAccount.failedToReactivate');
        this.reactivating = false;
      } else {
        this.$emit('close');
        if (this.$router.currentRoute.path !== '/home') {
          this.$router.push('/home');
        }
        this.reactivating = false;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/ReactivateAccountDialog/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ReactivateAccountDialogvue_type_script_lang_js_ = (ReactivateAccountDialogvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/ReactivateAccountDialog/index.vue





/* normalize component */
;
var ReactivateAccountDialog_component = normalizeComponent(
  components_ReactivateAccountDialogvue_type_script_lang_js_,
  ReactivateAccountDialogvue_type_template_id_3039f8b8_render,
  ReactivateAccountDialogvue_type_template_id_3039f8b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReactivateAccountDialog = (ReactivateAccountDialog_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/ReleaseNotesHistory/index.vue?vue&type=template&id=21cbb6c9&scoped=true&
var ReleaseNotesHistoryvue_type_template_id_21cbb6c9_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"release-note-cards"},_vm._l((this.historicReleaseNotes),function(releaseNote,index){return _c('v-card',{key:index,staticClass:"ma-6 release-notes-card mx-auto",attrs:{"max-width":"720","data-cy":"releaseNoteCard"}},[_c('v-card-title',{attrs:{"data-cy":"releaseNoteCardTitle"}},[_vm._v(" "+_vm._s(releaseNote.version)+" "),_c('v-spacer'),_vm._v(" "+_vm._s(new Date(releaseNote.date).toLocaleDateString())+" ")],1),_c('fusion-release-note-text',{attrs:{"releaseNote":releaseNote}})],1)}),1)}
var ReleaseNotesHistoryvue_type_template_id_21cbb6c9_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/ReleaseNotes/module/actions.js

/* harmony default export */ var ReleaseNotes_module_actions = ({
  async getHistoricReleaseNotes({
    commit
  }, {
    applicationsAPIHost,
    applicationID
  }) {
    const result = await axios.get(`${applicationsAPIHost}/applications/${applicationID}/releaseNotes`);
    if (isOkResponse(result.status)) {
      commit('setHistoricReleaseNotes', result.data);
    }
  },
  async getLatestReleaseNote({
    commit
  }, {
    applicationsAPIHost,
    applicationID
  }) {
    const result = await axios.get(`${applicationsAPIHost}/applications/${applicationID}/releaseNotes/latest`);
    if (isOkResponse(result.status)) {
      commit('setLatestReleaseNote', result.data);
    }
  }
});
// EXTERNAL MODULE: ./src/components/ReleaseNotes/module/getters.js
var ReleaseNotes_module_getters = __webpack_require__(773);
var getters_default = /*#__PURE__*/__webpack_require__.n(ReleaseNotes_module_getters);
;// CONCATENATED MODULE: ./src/components/ReleaseNotes/module/mutations.js
/* harmony default export */ var ReleaseNotes_module_mutations = ({
  setHistoricReleaseNotes(state, historicList) {
    state.historicList = historicList;
  },
  setLatestReleaseNote(state, latest) {
    state.latest = latest;
  }
});
;// CONCATENATED MODULE: ./src/components/ReleaseNotes/module/state.js
/* harmony default export */ var ReleaseNotes_module_state = ({
  historicList: null,
  latest: null
});
;// CONCATENATED MODULE: ./src/components/ReleaseNotes/module/index.js




/* harmony default export */ var ReleaseNotes_module = ({
  namespaced: true,
  state: ReleaseNotes_module_state,
  getters: (getters_default()),
  mutations: ReleaseNotes_module_mutations,
  actions: ReleaseNotes_module_actions
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/ReleaseNotesHistory/index.vue?vue&type=script&lang=js&


/* harmony default export */ var ReleaseNotesHistoryvue_type_script_lang_js_ = (Vue.extend({
  name: 'HistoricReleaseNotes',
  computed: {
    historicReleaseNotes() {
      if (this.$store.state.releaseNotes) {
        return this.$store.state.releaseNotes.historicList;
      } else {
        return [];
      }
    }
  },
  methods: {
    registerReleaseNotesModule() {
      const hasReleaseNotesModule = this.$store.hasModule('releaseNotes');
      if (!hasReleaseNotesModule) {
        this.$store.registerModule('releaseNotes', ReleaseNotes_module);
      }
    }
  },
  async mounted() {
    this.registerReleaseNotesModule();
    if (this.$auth.isAuthenticated) {
      await this.$store.dispatch('releaseNotes/getHistoricReleaseNotes', {
        applicationsAPIHost: this.$components.applicationsAPIHost,
        applicationID: this.$components.applicationID
      });
    }
    this.$auth.$on(fusion_auth_common.AuthEvents.AUTH_CHANGED, async isAuthenticated => {
      if (isAuthenticated) {
        await this.$store.dispatch('releaseNotes/getHistoricReleaseNotes', {
          applicationsAPIHost: this.$components.applicationsAPIHost,
          applicationID: this.$components.applicationID
        });
      }
    });
  }
}));
;// CONCATENATED MODULE: ./src/components/ReleaseNotes/ReleaseNotesHistory/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var ReleaseNotes_ReleaseNotesHistoryvue_type_script_lang_js_ = (ReleaseNotesHistoryvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/ReleaseNotesHistory/index.vue?vue&type=style&index=0&id=21cbb6c9&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ReleaseNotes/ReleaseNotesHistory/index.vue?vue&type=style&index=0&id=21cbb6c9&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/ReleaseNotes/ReleaseNotesHistory/index.vue



;


/* normalize component */

var ReleaseNotesHistory_component = normalizeComponent(
  ReleaseNotes_ReleaseNotesHistoryvue_type_script_lang_js_,
  ReleaseNotesHistoryvue_type_template_id_21cbb6c9_scoped_true_render,
  ReleaseNotesHistoryvue_type_template_id_21cbb6c9_scoped_true_staticRenderFns,
  false,
  null,
  "21cbb6c9",
  null
  
)

/* harmony default export */ var ReleaseNotesHistory = (ReleaseNotesHistory_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/ReleaseNoteText/index.vue?vue&type=template&id=c1fc5950&scoped=true&
var ReleaseNoteTextvue_type_template_id_c1fc5950_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"releaseNotes"},[(this.releaseNote !== null)?_c('v-card-text',{staticClass:"paragraphs"},[_c('div',[_c('div',{staticClass:"releaseHeader",attrs:{"data-cy":"featureHeader"}},[_vm._v(" "+_vm._s(_vm.$t('releaseNotes.features'))+" ")]),_c('ul',[_vm._l((this.releaseNote.features),function(feature,featureIndex){return _c('li',{key:featureIndex},[_vm._v(" "+_vm._s(feature.text)+" "),_c('ul',_vm._l((feature.subtext),function(subtext,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(subtext)+" ")])}),0)])}),(this.releaseNote.features.length == 0)?_c('li',[_vm._v(" N/A ")]):_vm._e()],2)]),_c('div',[_c('div',{staticClass:"releaseHeader",attrs:{"data-cy":"enhancementsHeader"}},[_vm._v(" "+_vm._s(_vm.$t('releaseNotes.bugFixesAndEnhancements'))+" ")]),_c('ul',[_vm._l((this.releaseNote.minor_enhancements),function(minor_enhancement,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(minor_enhancement.text)+" "),_c('ul',_vm._l((minor_enhancement.subtext),function(subtext,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(subtext)+" ")])}),0)])}),(this.releaseNote.minor_enhancements.length == 0)?_c('li',[_vm._v(" N/A ")]):_vm._e()],2)]),_c('div',[_c('div',{staticClass:"releaseHeader",attrs:{"data-cy":"issuesHeader"}},[_vm._v(" "+_vm._s(_vm.$t('releaseNotes.issues'))+" ")]),_c('ul',[_vm._l((this.releaseNote.issues),function(issue,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(issue.text)+" "),_c('ul',_vm._l((issue.subtext),function(subtext,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(subtext)+" ")])}),0)])}),(this.releaseNote.issues.length == 0)?_c('li',[_vm._v(" N/A ")]):_vm._e()],2)])]):_vm._e()],1)}
var ReleaseNoteTextvue_type_template_id_c1fc5950_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/ReleaseNoteText/index.vue?vue&type=script&lang=js&
/* harmony default export */ var ReleaseNoteTextvue_type_script_lang_js_ = (Vue.extend({
  name: 'ReleaseNoteText',
  props: {
    releaseNote: {
      type: Object,
      required: true
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/ReleaseNotes/ReleaseNoteText/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var ReleaseNotes_ReleaseNoteTextvue_type_script_lang_js_ = (ReleaseNoteTextvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/ReleaseNoteText/index.vue?vue&type=style&index=0&id=c1fc5950&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ReleaseNotes/ReleaseNoteText/index.vue?vue&type=style&index=0&id=c1fc5950&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/ReleaseNotes/ReleaseNoteText/index.vue



;


/* normalize component */

var ReleaseNoteText_component = normalizeComponent(
  ReleaseNotes_ReleaseNoteTextvue_type_script_lang_js_,
  ReleaseNoteTextvue_type_template_id_c1fc5950_scoped_true_render,
  ReleaseNoteTextvue_type_template_id_c1fc5950_scoped_true_staticRenderFns,
  false,
  null,
  "c1fc5950",
  null
  
)

/* harmony default export */ var ReleaseNoteText = (ReleaseNoteText_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/LatestReleaseNoteDialog/index.vue?vue&type=template&id=01fdd56a&scoped=true&
var LatestReleaseNoteDialogvue_type_template_id_01fdd56a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fusion-dialog',{attrs:{"open":_vm.open,"data-cy":"latestReleaseNoteDialog","fullscreen":this.isFullscreen,"persistentOverlay":true},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',{attrs:{"data-cy":"releaseNoteHeader"}},[_vm._v(" "+_vm._s(_vm.$t('releaseNotes.title'))+" "),_c('v-spacer'),(_vm.latestReleaseNote !== null)?_c('div',{staticClass:"version"},[_vm._v(_vm._s(_vm.latestReleaseNote.version))]):_vm._e()],1)]},proxy:true},{key:"actions",fn:function(){return [_c('v-btn',{staticClass:"black--text button-padding-16",attrs:{"outlined":"","text":"","data-cy":"releaseNoteChangeLogButton"},on:{"click":_vm.navigateReleaseNotes}},[_vm._v(" "+_vm._s(_vm.$t('releaseNotes.openChangeLog'))+" ")]),_c('v-spacer'),_c('v-btn',{staticClass:"secondary white--text button-padding-24",attrs:{"text":"","data-cy":"releaseNoteCloseButton"},on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t('buttons.close'))+" ")])]},proxy:true}])},[(_vm.latestReleaseNote !== null)?_c('fusion-release-note-text',{attrs:{"releaseNote":_vm.latestReleaseNote}}):_vm._e()],1)}
var LatestReleaseNoteDialogvue_type_template_id_01fdd56a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/LatestReleaseNoteDialog/index.vue?vue&type=script&lang=js&


/* harmony default export */ var LatestReleaseNoteDialogvue_type_script_lang_js_ = (Vue.extend({
  name: 'LatestReleaseNoteDialog',
  props: ['open'],
  data() {
    return {
      url: `${window.location.protocol}//${window.location.hostname}`
    };
  },
  computed: {
    isFullscreen() {
      return this.$vuetify.breakpoint.xs;
    },
    latestReleaseNote() {
      if (this.$store.state.releaseNotes) {
        return this.$store.state.releaseNotes.latest;
      } else {
        return null;
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    navigateReleaseNotes() {
      this.$router.push('/release-notes');
    },
    registerReleaseNotesModule() {
      const hasReleaseNotesModule = this.$store.hasModule('releaseNotes');
      if (!hasReleaseNotesModule) {
        this.$store.registerModule('releaseNotes', ReleaseNotes_module);
      }
    }
  },
  async mounted() {
    this.registerReleaseNotesModule();
    if (this.$auth.isAuthenticated) {
      await this.$store.dispatch('releaseNotes/getLatestReleaseNote', {
        applicationsAPIHost: this.$components.applicationsAPIHost,
        applicationID: this.$components.applicationID
      });
    }
    this.$auth.$on(fusion_auth_common.AuthEvents.AUTH_CHANGED, async isAuthenticated => {
      if (isAuthenticated) {
        await this.$store.dispatch('releaseNotes/getLatestReleaseNote', {
          applicationsAPIHost: this.$components.applicationsAPIHost,
          applicationID: this.$components.applicationID
        });
      }
    });
  }
}));
;// CONCATENATED MODULE: ./src/components/ReleaseNotes/LatestReleaseNoteDialog/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var ReleaseNotes_LatestReleaseNoteDialogvue_type_script_lang_js_ = (LatestReleaseNoteDialogvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/LatestReleaseNoteDialog/index.vue?vue&type=style&index=0&id=01fdd56a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ReleaseNotes/LatestReleaseNoteDialog/index.vue?vue&type=style&index=0&id=01fdd56a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/ReleaseNotes/LatestReleaseNoteDialog/index.vue



;


/* normalize component */

var LatestReleaseNoteDialog_component = normalizeComponent(
  ReleaseNotes_LatestReleaseNoteDialogvue_type_script_lang_js_,
  LatestReleaseNoteDialogvue_type_template_id_01fdd56a_scoped_true_render,
  LatestReleaseNoteDialogvue_type_template_id_01fdd56a_scoped_true_staticRenderFns,
  false,
  null,
  "01fdd56a",
  null
  
)

/* harmony default export */ var LatestReleaseNoteDialog = (LatestReleaseNoteDialog_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/LatestReleaseNoteTab/index.vue?vue&type=template&id=9fe3bd62&scoped=true&
var LatestReleaseNoteTabvue_type_template_id_9fe3bd62_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"headline",attrs:{"data-cy":"releaseNotesHeader"}},[_vm._v(" "+_vm._s(_vm.$t('releaseNotes.title'))+" "),_c('v-spacer'),(_vm.latestReleaseNote !== null)?_c('div',{staticClass:"version"},[_vm._v(_vm._s(_vm.latestReleaseNote.version))]):_vm._e()],1),(_vm.latestReleaseNote !== null)?_c('fusion-release-note-text',{attrs:{"releaseNote":_vm.latestReleaseNote}}):_vm._e(),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{staticClass:"black--text button-padding-16",attrs:{"outlined":"","text":"","data-cy":"releaseNotesChangeLogButton"},on:{"click":_vm.navigateReleaseNotes}},[_vm._v(_vm._s(_vm.$t('releaseNotes.openChangeLog')))])],1)],1)}
var LatestReleaseNoteTabvue_type_template_id_9fe3bd62_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/LatestReleaseNoteTab/index.vue?vue&type=script&lang=js&


/* harmony default export */ var LatestReleaseNoteTabvue_type_script_lang_js_ = (Vue.extend({
  name: 'LatestReleaseNoteTab',
  computed: {
    latestReleaseNote() {
      if (this.$store.state.releaseNotes) {
        return this.$store.state.releaseNotes.latest;
      } else {
        return null;
      }
    }
  },
  methods: {
    navigateReleaseNotes() {
      this.$router.push('/release-notes');
    },
    registerReleaseNotesModule() {
      const hasReleaseNotesModule = this.$store.hasModule('releaseNotes');
      if (!hasReleaseNotesModule) {
        this.$store.registerModule('releaseNotes', ReleaseNotes_module);
      }
    }
  },
  async mounted() {
    this.registerReleaseNotesModule();
    if (this.$auth.isAuthenticated) {
      await this.$store.dispatch('releaseNotes/getLatestReleaseNote', {
        applicationsAPIHost: this.$components.applicationsAPIHost,
        applicationID: this.$components.applicationID
      });
    }
    this.$auth.$on(fusion_auth_common.AuthEvents.AUTH_CHANGED, async isAuthenticated => {
      if (isAuthenticated) {
        await this.$store.dispatch('releaseNotes/getLatestReleaseNote', {
          applicationsAPIHost: this.$components.applicationsAPIHost,
          applicationID: this.$components.applicationID
        });
      }
    });
  }
}));
;// CONCATENATED MODULE: ./src/components/ReleaseNotes/LatestReleaseNoteTab/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var ReleaseNotes_LatestReleaseNoteTabvue_type_script_lang_js_ = (LatestReleaseNoteTabvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReleaseNotes/LatestReleaseNoteTab/index.vue?vue&type=style&index=0&id=9fe3bd62&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ReleaseNotes/LatestReleaseNoteTab/index.vue?vue&type=style&index=0&id=9fe3bd62&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/ReleaseNotes/LatestReleaseNoteTab/index.vue



;


/* normalize component */

var LatestReleaseNoteTab_component = normalizeComponent(
  ReleaseNotes_LatestReleaseNoteTabvue_type_script_lang_js_,
  LatestReleaseNoteTabvue_type_template_id_9fe3bd62_scoped_true_render,
  LatestReleaseNoteTabvue_type_template_id_9fe3bd62_scoped_true_staticRenderFns,
  false,
  null,
  "9fe3bd62",
  null
  
)

/* harmony default export */ var LatestReleaseNoteTab = (LatestReleaseNoteTab_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SolutionCards/index.vue?vue&type=template&id=4266adb3&scoped=true&
var SolutionCardsvue_type_template_id_4266adb3_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"solution-container",attrs:{"justify":"center"}},[(!_vm.solutions || _vm.solutions.length === 0)?_c('div',{staticClass:"solution-spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._l((_vm.solutions),function(solution){return _c('fusion-solution-card',{key:solution.id,attrs:{"applicationId":solution.id,"icon":solution.meta.icon,"iconColor":solution.meta.iconColor,"titleKey":solution.displayKey,"imgSrc":solution.meta.imgSrc,"order":solution.order,"baseURL":solution.baseURL}})})],2)}
var SolutionCardsvue_type_template_id_4266adb3_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/SolutionCards/module/actions.js

/* harmony default export */ var SolutionCards_module_actions = ({
  async getSolutions({
    commit
  }, {
    applicationsAPIHost
  }) {
    const result = await axios.get(`${applicationsAPIHost}/applications`);
    if (isOkResponse(result.status)) {
      const solutions = result.data.filter(item => item.baseURL);
      commit('setSolutions', solutions);
    }
  },
  async getNavigation({
    commit
  }, {
    applicationsAPIHost
  }) {
    const result = await axios.get(`${applicationsAPIHost}/applications/navigation`);
    if (isOkResponse(result.status)) {
      commit('setNavigation', result.data);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SolutionCards/module/mutations.js
/* harmony default export */ var SolutionCards_module_mutations = ({
  setSolutions(state, solutions) {
    state.solutions = solutions;
  },
  setNavigation(state, navigation) {
    state.navigation = navigation;
  }
});
;// CONCATENATED MODULE: ./src/components/SolutionCards/module/state.js
/* harmony default export */ var SolutionCards_module_state = ({
  solutions: null,
  navigation: null
});
;// CONCATENATED MODULE: ./src/components/SolutionCards/module/index.js



/* harmony default export */ var SolutionCards_module = ({
  namespaced: true,
  state: SolutionCards_module_state,
  mutations: SolutionCards_module_mutations,
  actions: SolutionCards_module_actions
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SolutionCards/index.vue?vue&type=script&lang=js&

const events = {
  AUTH_CHANGED: 'authenticationChange'
};
/* harmony default export */ var SolutionCardsvue_type_script_lang_js_ = (Vue.extend({
  name: 'SolutionCards',
  data() {
    return {};
  },
  computed: {
    solutions() {
      var _this$$store$state, _this$$store$state$so;
      return (_this$$store$state = this.$store.state) === null || _this$$store$state === void 0 ? void 0 : (_this$$store$state$so = _this$$store$state.solutionCards) === null || _this$$store$state$so === void 0 ? void 0 : _this$$store$state$so.solutions;
    }
  },
  watch: {},
  methods: {
    async registerModule() {
      const hasModule = this.$store.hasModule('solutionCards');
      if (!hasModule) {
        this.$store.registerModule('solutionCards', SolutionCards_module);
      }
    },
    async moduleDispatch() {
      await this.$store.dispatch('solutionCards/getSolutions', {
        applicationsAPIHost: this.$components.applicationsAPIHost
      });
      await this.$store.dispatch('solutionCards/getNavigation', {
        applicationsAPIHost: this.$components.applicationsAPIHost
      });
    }
  },
  async mounted() {
    this.registerModule();
    if (this.$auth.isAuthenticated) {
      await this.moduleDispatch();
    }
    this.$auth.$on(events.AUTH_CHANGED, async isAuthenticated => {
      if (isAuthenticated) {
        await this.moduleDispatch();
      }
    });
  }
}));
;// CONCATENATED MODULE: ./src/components/SolutionCards/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SolutionCardsvue_type_script_lang_js_ = (SolutionCardsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SolutionCards/index.vue?vue&type=style&index=0&id=4266adb3&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/SolutionCards/index.vue?vue&type=style&index=0&id=4266adb3&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/SolutionCards/index.vue



;


/* normalize component */

var SolutionCards_component = normalizeComponent(
  components_SolutionCardsvue_type_script_lang_js_,
  SolutionCardsvue_type_template_id_4266adb3_scoped_true_render,
  SolutionCardsvue_type_template_id_4266adb3_scoped_true_staticRenderFns,
  false,
  null,
  "4266adb3",
  null
  
)

/* harmony default export */ var SolutionCards = (SolutionCards_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SolutionCards/SolutionCard/index.vue?vue&type=template&id=71cd4f08&scoped=true&
var SolutionCardvue_type_template_id_71cd4f08_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"solution-card"},[_c('v-card-title',{staticClass:"solution-header"},[_c('div',{staticClass:"solution-icon",style:(("background: " + _vm.iconColor))},[_c('v-icon',{attrs:{"medium":"","color":"white"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('div',{staticClass:"solution-title"},[_vm._v(_vm._s(_vm.$t(_vm.titleKey)))])]),_c('v-img',{staticClass:"solution-img",attrs:{"src":_vm.imgSrc}}),_c('v-card-text',{staticClass:"solution-links"},_vm._l((_vm.links),function(link,index){return _c('span',{key:link.order},[(link.meta.navigable)?_c('a',{attrs:{"href":("" + _vm.baseURL + (link.path)),"data-cy":("solution" + _vm.order + "-link" + index)}},[_c('v-btn',{staticClass:"solution-link white--text",attrs:{"color":"black"}},[_c('v-icon',{staticClass:"solution-link--icon"},[_vm._v(_vm._s(link.meta.icon))]),_c('span',[_vm._v(_vm._s(_vm.$t(link.meta.solutionTitle)))])],1)],1):_vm._e()])}),0)],1)}
var SolutionCardvue_type_template_id_71cd4f08_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SolutionCards/SolutionCard/index.vue?vue&type=script&lang=js&
const ROUTE_LOCATION = 'appswitcher';
/* harmony default export */ var SolutionCardvue_type_script_lang_js_ = (Vue.extend({
  name: 'SolutionCard',
  props: {
    applicationId: String,
    icon: String,
    iconColor: String,
    titleKey: String,
    imgSrc: String,
    order: Number,
    baseURL: String
  },
  computed: {
    links() {
      if (this.navigation !== null) {
        return this.navigation.filter(item => {
          var _item$meta, _item$meta$locations;
          return item.application_id === this.applicationId && (item === null || item === void 0 ? void 0 : (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : (_item$meta$locations = _item$meta.locations) === null || _item$meta$locations === void 0 ? void 0 : _item$meta$locations.includes(ROUTE_LOCATION));
        });
      }
      return [];
    },
    navigation() {
      var _this$$store$state, _this$$store$state$so;
      return (_this$$store$state = this.$store.state) === null || _this$$store$state === void 0 ? void 0 : (_this$$store$state$so = _this$$store$state.solutionCards) === null || _this$$store$state$so === void 0 ? void 0 : _this$$store$state$so.navigation;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/SolutionCards/SolutionCard/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var SolutionCards_SolutionCardvue_type_script_lang_js_ = (SolutionCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SolutionCards/SolutionCard/index.vue?vue&type=style&index=0&id=71cd4f08&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/SolutionCards/SolutionCard/index.vue?vue&type=style&index=0&id=71cd4f08&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/SolutionCards/SolutionCard/index.vue



;


/* normalize component */

var SolutionCard_component = normalizeComponent(
  SolutionCards_SolutionCardvue_type_script_lang_js_,
  SolutionCardvue_type_template_id_71cd4f08_scoped_true_render,
  SolutionCardvue_type_template_id_71cd4f08_scoped_true_staticRenderFns,
  false,
  null,
  "71cd4f08",
  null
  
)

/* harmony default export */ var SolutionCard = (SolutionCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PublicPage/index.vue?vue&type=template&id=7de6fb78&scoped=true&
var PublicPagevue_type_template_id_7de6fb78_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"background-image"}),_c('div',{staticClass:"welcome-container"},[_c('v-card',{staticClass:"welcome-card"},[_c('v-card-title',{staticClass:"justify-center align-center"},[_vm._v(_vm._s(_vm.$t('home.welcome.title')))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.$t('home.welcome.subtitle')))]),_c('v-btn',{staticClass:"loginButton",attrs:{"block":"","depressed":"","data-cy":"loginButton"},on:{"click":function($event){return _vm.login()}}},[_vm._v(_vm._s(_vm.$t('home.welcome.login')))]),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('home.welcome.content')))]),_c('v-btn',{staticClass:"createAccountButton",attrs:{"block":"","depressed":"","data-cy":"createAccountButton"},on:{"click":function($event){return _vm.createAccount()}}},[_vm._v(_vm._s(_vm.$t('home.welcome.createAccount')))]),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('home.welcome.learnMoreContent')))]),_c('v-btn',{staticClass:"learnMoreButton",attrs:{"block":"","data-cy":"learnMoreButton","outlined":""},on:{"click":function($event){return _vm.openLearnMore()}}},[_vm._v(_vm._s(_vm.$t('home.welcome.learnMore')))]),_c('v-btn',{staticClass:"tAndCButton",attrs:{"color":"primary","text":""}},[_c('a',{attrs:{"href":_vm.tAndCLink,"target":"_blank","rel":"help","data-cy":"tAndCLink"}},[_vm._v(_vm._s(_vm.$t('home.welcome.termsOfUseLink')))])])],1)],1)])}
var PublicPagevue_type_template_id_7de6fb78_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PublicPage/index.vue?vue&type=script&lang=js&
const T_AND_C_LINK = 'https://tsi.com/terms/';
/* harmony default export */ var PublicPagevue_type_script_lang_js_ = (Vue.extend({
  data() {
    return {
      tAndCLink: T_AND_C_LINK
    };
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    createAccount() {
      window.open(this.$components.createAccountLink);
    },
    openLearnMore() {
      window.open(this.$components.learnMoreLink);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/PublicPage/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PublicPagevue_type_script_lang_js_ = (PublicPagevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PublicPage/index.vue?vue&type=style&index=0&id=7de6fb78&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/PublicPage/index.vue?vue&type=style&index=0&id=7de6fb78&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/PublicPage/index.vue



;


/* normalize component */

var PublicPage_component = normalizeComponent(
  components_PublicPagevue_type_script_lang_js_,
  PublicPagevue_type_template_id_7de6fb78_scoped_true_render,
  PublicPagevue_type_template_id_7de6fb78_scoped_true_staticRenderFns,
  false,
  null,
  "7de6fb78",
  null
  
)

/* harmony default export */ var PublicPage = (PublicPage_component.exports);
;// CONCATENATED MODULE: ./src/components/FeatureFlags/module/actions.js

/* harmony default export */ var FeatureFlags_module_actions = ({
  async getAppFeatureFlags({
    commit
  }, {
    applicationsAPIHost,
    applicationID
  }) {
    const result = await axios.get(`${applicationsAPIHost}/applications/${applicationID}/features`);
    if (isOkResponse(result.status) && result.data) {
      commit('setAppFeatureFlags', result.data);
    }
  },
  setUserFeatureFlags({
    commit
  }, flags) {
    commit('setUserFeatureFlags', flags);
  }
});
;// CONCATENATED MODULE: ./src/components/FeatureFlags/module/getters.js
/* harmony default export */ var FeatureFlags_module_getters = ({
  getFeatureFlags: state => {
    return {
      ...state.appFlags,
      ...state.userFlags
    };
  },
  getFeatureFlagBySlug: state => slug => {
    return Object.keys(state.userFlags).includes(slug) ? state.userFlags[slug] : state.appFlags[slug];
  }
});
;// CONCATENATED MODULE: ./src/components/FeatureFlags/module/mutations.js
/* harmony default export */ var FeatureFlags_module_mutations = ({
  setAppFeatureFlags(state, features) {
    const flags = features.reduce((acc, feature) => {
      return {
        ...acc,
        [feature.slug]: feature.isEnabled
      };
    }, {});
    state.appFlags = flags;
  },
  setUserFeatureFlags(state, flags) {
    const userFlags = {};
    for (const [key, value] of Object.entries(flags)) {
      const hasFlag = Object.keys(state.appFlags).includes(key);
      if (hasFlag) {
        const boolValue = [true, 'true', '1'].includes(value);
        userFlags[key] = boolValue;
      }
    }
    state.userFlags = userFlags;
  }
});
;// CONCATENATED MODULE: ./src/components/FeatureFlags/module/state.js
/* harmony default export */ var FeatureFlags_module_state = ({
  appFlags: {},
  userFlags: {}
});
;// CONCATENATED MODULE: ./src/components/FeatureFlags/module/index.js




/* harmony default export */ var FeatureFlags_module = ({
  namespaced: true,
  state: FeatureFlags_module_state,
  getters: FeatureFlags_module_getters,
  mutations: FeatureFlags_module_mutations,
  actions: FeatureFlags_module_actions
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FeatureFlags/index.vue?vue&type=script&lang=js&

/* harmony default export */ var FeatureFlagsvue_type_script_lang_js_ = ({
  render: () => null,
  props: {
    user: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      registered: false
    };
  },
  computed: {
    flags() {
      return this.registered ? this.$store.getters['featureFlags/getFeatureFlags'] : undefined;
    }
  },
  methods: {
    registerFeatureFlagsModule() {
      const hasFeatureFlagsModule = this.$store.hasModule('featureFlags');
      if (!hasFeatureFlagsModule) {
        this.$store.registerModule('featureFlags', FeatureFlags_module);
      }
      this.registered = true;
    },
    async setFlags() {
      var _this$user, _this$user$metadataKe;
      const applicationsAPIHost = this.$components.applicationsAPIHost;
      const applicationID = this.$components.applicationID;
      // Get app feature flags from database
      await this.$store.dispatch('featureFlags/getAppFeatureFlags', {
        applicationsAPIHost,
        applicationID
      });
      // Get user feature flags from Auth0
      const metadataKey = 'https://tsi.com/app_metadata';
      const appMetadata = (_this$user = this.user) === null || _this$user === void 0 ? void 0 : (_this$user$metadataKe = _this$user[metadataKey]) === null || _this$user$metadataKe === void 0 ? void 0 : _this$user$metadataKe.applications;
      if (appMetadata) {
        var _appMetadata$find;
        const overrides = (_appMetadata$find = appMetadata.find(app => app.applicationId === applicationID)) === null || _appMetadata$find === void 0 ? void 0 : _appMetadata$find.featureFlags;
        if (overrides) {
          this.$store.dispatch('featureFlags/setUserFeatureFlags', overrides);
        }
      }
    }
  },
  watch: {
    user() {
      this.setFlags();
    }
  },
  async mounted() {
    this.registerFeatureFlagsModule();
    if (Object.keys(this.user).length > 0) {
      this.setFlags();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/FeatureFlags/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FeatureFlagsvue_type_script_lang_js_ = (FeatureFlagsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/FeatureFlags/index.vue
var FeatureFlags_render, FeatureFlags_staticRenderFns
;



/* normalize component */
;
var FeatureFlags_component = normalizeComponent(
  components_FeatureFlagsvue_type_script_lang_js_,
  FeatureFlags_render,
  FeatureFlags_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FeatureFlags = (FeatureFlags_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/BannerMessage/index.vue?vue&type=template&id=255b7f62&scoped=true&
var BannerMessagevue_type_template_id_255b7f62_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"banner-message-wrapper",attrs:{"data-cy":"bannerMessageWrapper"}},[_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"max-width":_vm.maxWidth,"min-width":_vm.minWidth,"width":"100%","vertical":_vm.vertical,"app":_vm.app,"color":"rgba(0, 0, 0, 0.85)"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"data-cy":"dismissBannerMessage","color":"#00aeef","small":_vm.$vuetify.breakpoint.xs},on:{"click":_vm.dismissMessage}},'v-btn',attrs,false),[_vm._v(_vm._s(_vm.$t('buttons.dismiss')))])]}}],null,false,2121795770),model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])],1):_vm._e()}
var BannerMessagevue_type_template_id_255b7f62_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/BannerMessage/helper.js
const CONSTANTS = {
  BANNER_MESSAGE_KEY: 'tsi.bannerMessage'
};
const getBannerMessageFromLocalStorage = () => {
  const bannerMessage = localStorage.getItem(CONSTANTS.BANNER_MESSAGE_KEY);
  if (bannerMessage) {
    return JSON.parse(bannerMessage);
  }
  return null;
};
const isAValidObject = object => {
  return object && typeof object === 'object';
};
const isVersionTheSame = (bannerMessage, savedBannerMessage) => {
  if (isAValidObject(bannerMessage) && isAValidObject(savedBannerMessage)) {
    return bannerMessage.version === savedBannerMessage.version;
  }
  return false;
};
const showMessage = bannerMessage => {
  // If the bannerMessage is null or not an object
  if (!isAValidObject(bannerMessage)) {
    return false;
  }

  // If the user has already dismissed the banner message
  const savedBannerMessage = getBannerMessageFromLocalStorage();
  if (isVersionTheSame(bannerMessage, savedBannerMessage)) {
    return false;
  }
  return true;
};
const formatMessage = message => {
  if (!message) {
    return {};
  }
  return {
    ...message,
    isActive: message.isActive && showMessage(message)
  };
};
;// CONCATENATED MODULE: ./src/components/BannerMessage/module/actions.js


/* harmony default export */ var BannerMessage_module_actions = ({
  async getAppBannerMessage({
    commit
  }, {
    applicationsAPIHost,
    applicationID
  }) {
    if (applicationsAPIHost && applicationID) {
      const result = await axios.get(`${applicationsAPIHost}/applications/${applicationID}/message`);
      if (isOkResponse(result.status) && result.data) {
        commit('setBannerMessage', formatMessage(result.data));
      }
    }
  },
  async dismissMessage({
    commit
  }) {
    commit('setIsActive', false);
  }
});
;// CONCATENATED MODULE: ./src/components/BannerMessage/module/getters.js
/* harmony default export */ var BannerMessage_module_getters = ({
  getBannerMessage: state => {
    return state.bannerMessage;
  }
});
;// CONCATENATED MODULE: ./src/components/BannerMessage/module/mutations.js
/* harmony default export */ var BannerMessage_module_mutations = ({
  setBannerMessage(state, bannerMessage) {
    state.bannerMessage = bannerMessage;
  },
  setIsActive(state, isActive) {
    state.bannerMessage = {
      ...state.bannerMessage,
      isActive
    };
  }
});
;// CONCATENATED MODULE: ./src/components/BannerMessage/module/state.js
/* harmony default export */ var BannerMessage_module_state = ({
  bannerMessage: {}
});
;// CONCATENATED MODULE: ./src/components/BannerMessage/module/index.js




/* harmony default export */ var BannerMessage_module = ({
  namespaced: true,
  state: BannerMessage_module_state,
  getters: BannerMessage_module_getters,
  mutations: BannerMessage_module_mutations,
  actions: BannerMessage_module_actions
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/BannerMessage/index.vue?vue&type=script&lang=js&


/* harmony default export */ var BannerMessagevue_type_script_lang_js_ = ({
  name: 'BannerMessage',
  props: {
    testMode: Boolean
  },
  data() {
    return {
      registered: false,
      timeout: -1,
      vertical: true,
      app: true,
      dismissed: false
    };
  },
  computed: {
    bannerMessage() {
      return this.registered ? this.$store.getters['bannerMessage/getBannerMessage'] : {};
    },
    isActive() {
      return this.showTest || this.bannerMessage && !!this.bannerMessage.isActive;
    },
    htmlContent() {
      return this.bannerMessage && this.bannerMessage.customMessage ? this.$sanitize(this.bannerMessage.customMessage) : this.$t('bannerMessage.defaultText');
    },
    showTest() {
      return !!this.testMode && !this.dismissed;
    },
    maxWidth() {
      return this.$vuetify.breakpoint.xl ? '90rem' : '';
    },
    minWidth() {
      return !this.$vuetify.breakpoint.xl ? '93%' : '';
    }
  },
  methods: {
    async getAppBannerMessage() {
      if (this.registered) {
        const applicationsAPIHost = this.$components.applicationsAPIHost;
        const applicationID = this.$components.applicationID;
        // Get app devops message from database
        await this.$store.dispatch('bannerMessage/getAppBannerMessage', {
          applicationsAPIHost,
          applicationID
        });
      }
    },
    saveDismissMessage() {
      if (!this.testMode) {
        localStorage.setItem(CONSTANTS.BANNER_MESSAGE_KEY, JSON.stringify({
          version: this.bannerMessage.version
        }));
      }
    },
    dismissMessage() {
      if (this.registered) {
        this.saveDismissMessage();
        this.dismissed = true;
        this.$store.dispatch('bannerMessage/dismissMessage');
      }
    },
    registerBannerMessageModule() {
      const isModuleRegistered = this.$store.hasModule('bannerMessage');
      if (!isModuleRegistered) {
        this.$store.registerModule('bannerMessage', BannerMessage_module);
      }
      this.registered = true;
    }
  },
  mounted() {
    this.registerBannerMessageModule();
    this.getAppBannerMessage();
  }
});
;// CONCATENATED MODULE: ./src/components/BannerMessage/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BannerMessagevue_type_script_lang_js_ = (BannerMessagevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/BannerMessage/index.vue?vue&type=style&index=0&id=255b7f62&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/BannerMessage/index.vue?vue&type=style&index=0&id=255b7f62&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/BannerMessage/index.vue



;


/* normalize component */

var BannerMessage_component = normalizeComponent(
  components_BannerMessagevue_type_script_lang_js_,
  BannerMessagevue_type_template_id_255b7f62_scoped_true_render,
  BannerMessagevue_type_template_id_255b7f62_scoped_true_staticRenderFns,
  false,
  null,
  "255b7f62",
  null
  
)

/* harmony default export */ var BannerMessage = (BannerMessage_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/non-verified.vue?vue&type=template&id=41bd97ac&
var non_verifiedvue_type_template_id_41bd97ac_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-space",attrs:{"justify":"center","align":"center","height":"100%"}},[_c('v-card',{staticClass:"floating-card",attrs:{"width":"500px"}},[_c('div',{staticClass:"image-header"},[_c('img',{attrs:{"src":"/img/logo-light-full.png","alt":"TSI Understanding Accelerated"}})]),_c('v-card-title',[(!_vm.emailResent)?_c('span',{staticClass:"headline",attrs:{"data-cy":"non-verified-title"}},[_vm._v(_vm._s(_vm.$t("nonVerified.title")))]):_vm._e(),(_vm.emailResent)?_c('span',{staticClass:"headline",attrs:{"data-cy":"resent-email-title"}},[_vm._v(_vm._s(_vm.$t("nonVerified.titleEmailResent")))]):_vm._e()]),(!_vm.emailResent)?_c('v-card-text',{attrs:{"data-cy":"non-verified-content"}},[_c('i18n',{attrs:{"path":"nonVerified.content","tag":"p"},scopedSlots:_vm._u([{key:"email",fn:function(){return [_c('strong',[_vm._v(_vm._s(_vm.email))])]},proxy:true}],null,false,3414808340)})],1):_vm._e(),(_vm.emailResent)?_c('v-card-text',{attrs:{"data-cy":"resent-email-content"}},[_c('i18n',{attrs:{"path":"nonVerified.contentEmailResent","tag":"p"},scopedSlots:_vm._u([{key:"email",fn:function(){return [_c('strong',[_vm._v(_vm._s(_vm.email))])]},proxy:true}],null,false,3414808340)})],1):_vm._e(),_c('v-card-actions',[(!_vm.emailResent)?_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"re-send-email"},on:{"click":_vm.resendEmail}},[_vm._v(_vm._s(_vm.$t("nonVerified.resendEmail")))]):_vm._e(),(_vm.emailResent)?_c('v-btn',{staticClass:"black--text",attrs:{"outlined":"","text":"","data-cy":"open-faq-link"},on:{"click":_vm.navigateFaq}},[_vm._v(_vm._s(_vm.$t("nonVerified.openFaq")))]):_vm._e(),_c('v-spacer'),_c('v-btn',{staticClass:"secondary white--text",attrs:{"text":""},on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.$t("buttons.done")))])],1)],1)],1)}
var non_verifiedvue_type_template_id_41bd97ac_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/non-verified.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const FAQ_LINK = 'https://tsi.com/resources/tsi-link-monitoring-and-research-faqs/';
/* harmony default export */ var non_verifiedvue_type_script_lang_js_ = ({
  data() {
    return {
      emailResent: false
    };
  },
  computed: {
    email: function () {
      return this.$auth.user.email;
    }
  },
  methods: {
    logout() {
      this.$auth.logout();
      setTimeout(() => {
        this.$auth.loginWithRedirect();
      }, 100);
    },
    async resendEmail() {
      try {
        const resp = await this.postResendVerification();
        if (isOkResponse(resp.status)) {
          this.emailResent = true;
        }
      } catch (error) {
        // Do not show resent email dialog
      }
    },
    async postResendVerification() {
      const accountId = await this.$auth.getAccountId();
      const userId = await this.$auth.getUserId();
      const url = `${this.$components.accountsAPIHost}/accounts/${accountId}/users/${userId}/verify`;
      return axios.post(url, null, {});
    },
    navigateFaq() {
      window.open(FAQ_LINK);
    }
  }
});
;// CONCATENATED MODULE: ./src/views/non-verified.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_non_verifiedvue_type_script_lang_js_ = (non_verifiedvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/non-verified.vue?vue&type=style&index=0&id=41bd97ac&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/views/non-verified.vue?vue&type=style&index=0&id=41bd97ac&prod&lang=scss&

;// CONCATENATED MODULE: ./src/views/non-verified.vue



;


/* normalize component */

var non_verified_component = normalizeComponent(
  views_non_verifiedvue_type_script_lang_js_,
  non_verifiedvue_type_template_id_41bd97ac_render,
  non_verifiedvue_type_template_id_41bd97ac_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var non_verified = (non_verified_component.exports);
;// CONCATENATED MODULE: ./src/assets/styles/global-colors.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var global_colors_module = ({"mainPrimary":"#00aeef","mainSecondary":"#1a1919","mainTertiary":"#fff","mainQuaternary":"#ec038a","accentPrimary":"#f48123","accentSuccess":"#4fb74a","accentError":"#fa1717","accentWarning":"#fadd17","contentPrimary":"#f48123","contentSecondary":"#4f124a","contentTertiary":"#fadd17","contentQuaternary":"#fa1717","dark100":"#000001","dark86":"rgba(0,0,0,.86)","dark76":"rgba(0,0,0,.76)","dark56":"rgba(0,0,0,.56)","dark36":"rgba(0,0,0,.36)","dark26":"rgba(0,0,0,.26)","dark16":"rgba(0,0,0,.16)","dark8":"rgba(0,0,0,.08)","dark4":"rgba(0,0,0,.04)","dark2":"rgba(0,0,0,.02)","light86":"rgba(255,255,255,.86)","light76":"rgba(255,255,255,.76)","light36":"rgba(255,255,255,.36)","light26":"rgba(255,255,255,.26)","light16":"rgba(255,255,255,.16)","light8":"rgba(255,255,255,.8)","light2":"rgba(255,255,255,.2)","backgroundGradient":"linear-gradient(180deg, white, #f2f2f2)","track":"#bdbdbd","textPrimary":"#1e1e1e","textSecondary":"rgba(0,0,0,.56)","textAlternate":"#fff","textDisabled":"rgba(0,0,0,.36)","textHint":"rgba(0,0,0,.36)","backgroundChip":"#e0e0e0","backgroundDefault":"#fff","backgroundPaper":"#fff"});
;// CONCATENATED MODULE: ./src/assets/styles/global-variables.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var global_variables_module = ({"paddingStandard":"1.6rem","deviceWidthSmall":"576px","deviceWidthMedium":"768px","deviceWidthLarge":"992px","deviceWidthXLarge":"1200px","deviceWidthXXLarge":"1400px"});
;// CONCATENATED MODULE: ./src/mixins/drawerManager.js
const manageDrawerMixin = {
  data: function () {
    return {
      drawer: {
        open: false,
        isMini: true
      }
    };
  },
  computed: {
    drawerPermanent() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    drawerClipped() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    drawerMini() {
      return (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.md) && this.drawer.isMini;
    }
  },
  methods: {
    drawerToggle() {
      if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg) {
        this.drawer.isMini = !this.drawer.isMini;
      } else {
        this.drawer.open = !this.drawer.open;
      }
    }
  }
};
;// CONCATENATED MODULE: ./src/mixins/navigation.js
const navigationMixin = {
  computed: {
    routes() {
      var _this$$router, _this$$router$options;
      return (_this$$router = this.$router) === null || _this$$router === void 0 ? void 0 : (_this$$router$options = _this$$router.options) === null || _this$$router$options === void 0 ? void 0 : _this$$router$options.routes;
    }
  },
  methods: {
    navigateHome() {
      window.open('/');
    },
    navigateTo(path) {
      this.$router.push(path).catch(() => {});
    },
    navigateBack() {
      this.$router.go(-1);
    }
  }
};
;// CONCATENATED MODULE: ./src/mixins/version.js
const versionMixin = {
  computed: {
    appVersion() {
      return "1.1.27-beta.1";
    }
  }
};
;// CONCATENATED MODULE: ./src/mixins/reactivateAccount.js
const reactivateAccountMixin = {
  data() {
    return {
      dialogs: {
        reactivateAccount: false
      }
    };
  },
  async mounted() {
    await this.checkReactivateAccount();
  },
  methods: {
    async checkReactivateAccount() {
      if (this.$store.state.userProfile) {
        await this.$store.dispatch('userProfile/getAccount', this.$components.accountsAPIHost);
        const account = this.$store.state.userProfile.account;
        if (account !== null && account !== void 0 && account.deletePendingOn) {
          this.dialogs.reactivateAccount = true;
        }
      }
    },
    closeReactivateAccount() {
      this.dialogs.reactivateAccount = false;
    }
  }
};
;// CONCATENATED MODULE: ./src/mixins/index.js





/* harmony default export */ var mixins = ({
  drawer: manageDrawerMixin,
  nav: navigationMixin,
  version: versionMixin,
  reactivateAccount: reactivateAccountMixin
});
;// CONCATENATED MODULE: ./src/library.js
// Custom TSI components


































// Custom TSI views






const PREFIX = 'fusion';
let components = null;
function getComponentsInstance() {
  return components;
}

/**
 * Install the library as a Vue plugin.
 * @param object The global Vue instance.
 */
function install(vue, options) {
  // Check for auth lib
  if (options.skipAuth || options.auth === undefined) {
    console.warn('Auth library not found, this may cause some components not to work correctly');
    vue.prototype.$auth = {};
  } else {
    vue.prototype.$auth = options.auth();
  }

  // Register VueScroll
  vue.prototype.$vuescrollConfig = {
    vuescroll: {},
    scrollPanel: {
      scrollingX: false
    },
    rail: {
      opacity: '0'
    },
    bar: {
      background: global_colors_module.dark100,
      keepShow: true,
      opacity: '.36'
    }
  };
  vue.component(`${PREFIX}-scroll`, vuescroll);

  // Register custom TSI components.
  vue.component(`${PREFIX}-appbar`, Appbar);
  vue.component(`${PREFIX}-sidebar`, Sidebar);
  vue.component(`${PREFIX}-snackbar`, Snackbar);
  vue.component(`${PREFIX}-account-management`, AccountManagement);
  vue.component(`${PREFIX}-account-menu`, AccountMenu);
  vue.component(`${PREFIX}-authenticator`, Authenticator);
  vue.component(`${PREFIX}-base-widget`, BaseWidget);
  vue.component(`${PREFIX}-base-graph`, BaseGraph);
  vue.component(`${PREFIX}-dashboard`, Dashboard);
  vue.component(`${PREFIX}-study-manager`, StudyManager);
  vue.component(`${PREFIX}-remove-warning-dialog`, RemoveWarningDialog);
  vue.component(`${PREFIX}-notification-settings`, NotificationSettings);
  vue.component(`${PREFIX}-unit-settings`, UnitSettings);
  vue.component(`${PREFIX}-account-details`, AccountDetails);
  vue.component(`${PREFIX}-password-reset`, PasswordReset);
  vue.component(`${PREFIX}-user-profile`, UserProfile);
  vue.component(`${PREFIX}-dialog`, Dialog);
  vue.component(`${PREFIX}-feedback`, FeedbackDialog);
  vue.component(`${PREFIX}-help-center`, HelpCenter);
  vue.component(`${PREFIX}-solutions-tab`, SolutionsTab);
  vue.component(`${PREFIX}-resources-tab`, ResourcesTab);
  vue.component(`${PREFIX}-terms-and-policies-tab`, TermsAndPoliciesTab);
  vue.component(`${PREFIX}-contact-support-tab`, ContactSupportTab);
  vue.component(`${PREFIX}-reactivate-account`, ReactivateAccountDialog);
  vue.component(`${PREFIX}-release-notes-history`, ReleaseNotesHistory);
  vue.component(`${PREFIX}-release-note-text`, ReleaseNoteText);
  vue.component(`${PREFIX}-latest-release-note-dialog`, LatestReleaseNoteDialog);
  vue.component(`${PREFIX}-latest-release-note-tab`, LatestReleaseNoteTab);
  vue.component(`${PREFIX}-solution-cards`, SolutionCards);
  vue.component(`${PREFIX}-solution-card`, SolutionCard);
  vue.component(`${PREFIX}-public-page`, PublicPage);
  vue.component(`${PREFIX}-feature-flags`, FeatureFlags);
  vue.component(`${PREFIX}-banner-message`, BannerMessage);

  // Register custom TSI views.
  vue.component(`${PREFIX}-non-verified`, non_verified);
  components = new Vue({
    data() {
      return {
        applicationID: options === null || options === void 0 ? void 0 : options.applicationID,
        clientID: options === null || options === void 0 ? void 0 : options.clientID,
        clientURL: options === null || options === void 0 ? void 0 : options.clientURL,
        accountsAPIHost: options === null || options === void 0 ? void 0 : options.accountsAPIHost,
        accountsAPIHostV2: options === null || options === void 0 ? void 0 : options.accountsAPIHostV2,
        applicationsAPIHost: options === null || options === void 0 ? void 0 : options.applicationsAPIHost,
        appPublicPath: options === null || options === void 0 ? void 0 : options.appPublicPath,
        createAccountLink: options === null || options === void 0 ? void 0 : options.createAccountLink,
        learnMoreLink: options === null || options === void 0 ? void 0 : options.learnMoreLink,
        studiesAPIHostV2: options === null || options === void 0 ? void 0 : options.studiesAPIHostV2,
        studiesAPIHostV3: options === null || options === void 0 ? void 0 : options.studiesAPIHostV3,
        devicesAPIHost: options === null || options === void 0 ? void 0 : options.devicesAPIHost
      };
    }
  });
  vue.prototype.$components = components;
}

/* harmony default export */ var library = ({
  Colors: global_colors_module,
  install,
  mixins: mixins,
  utils: utils,
  Variables: global_variables_module
});
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (library);


}();
module.exports = __webpack_exports__["default"];
/******/ })()
;
//# sourceMappingURL=fusion-saas-components.common.js.map